import React, { Component, useState } from 'react';
import ReactDataGrid from 'react-data-grid';
import _ from 'lodash';
import ReactDOM from 'react-dom';
import { Toolbar, Editors, Data } from 'react-data-grid-addons';
import { browserHistory, Link, withRouter } from 'react-router';
import { Field } from 'redux-form';
import { Translate, I18n } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';
import axios from 'axios';
import {
  Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb,
  Input, DropdownButton, MenuItem
} from 'react-bootstrap';
import Select from 'react-select';
import cloneDeep from 'lodash/cloneDeep';

import checkPermissionLocal from '../Common/permissions';
import ContentWrapper from '../Layout/ContentWrapper';
import { Selection, DisabledSelection, SelectionWithProps } from '../Common/selection';
import { InputField, DisabledInputField } from '../Common/inputField';
import Spinner from '../Widgets/spinner';
import { DatePicker, StartOfThisMonthDatePicker } from '../Common/datePicker';
import ConfirmActionModal from '../Common/confirmActionModal';
import SalesInventoryInfo from '../../containers/Sales/salesInventoryInfo';
import SalesShippingModal from '../../containers/Sales/salesShippingModal';
import { TaxSelectionModal } from '../Common/taxSelectionModal';
import { DiscountChangeModal } from '../Common/discountChangeModal';
import { WeightChangeModal } from '../Common/weightChangeModal';
import { OcmMultiBatch } from '../Common/ocmMultiBatch';
import ItemHistoryGrid from '../../components/Common/itemHistoryGrid';
import PurchaseHistoryGrid from '../../components/Common/purchaseHistoryGrid';
import MSOPaymentInfoContainer from '../../containers/Sales/MSOPaymentInfo';
import BoldTextFormatter from '../Common/boldTextFormatter';
import BoldCashFormatter from '../Common/boldCashFormatter';
import SalesOrderAutoSuggest from '../Common/SalesOrderAutoSuggest';
import FilterMultiKeyword from '../Common/filterMultiKeyword';
import { toFromDates } from '../Common/cleanDates';
import PrintIframe from '../Common/PrintIframe';
import DeliveryMethodModal from './DeliveryMethodModal';
import { calculateTax, calculateSavings, roundTo, roundToDecimals, normalizeFourDecimals, getObjectValue } from '../Common/NumberUtil';
import DropshipModal from './DropshipModal';
import CheckboxFormatter from '../Common/CheckboxFormatter';
import VerifyPasscodeModal from '../Common/VerifyPasscodeModal';
import ShippingInfoFormModal from './ShippingInfoFormModal';
import salesOrderModals from "../Common/modals/salesOrder";
import { CarrierInfoModal } from '../Common/carrierInfoModal';
import ShippingAddressEditmodal from '../Common/shippingInfoEditModal';
import CustomerCreateModal from '../Common/CustomerCreateModal';
import FBAAddressEditModal from '../Common/fbaAddressEditModal';
import ShippingInfoConfirmModal from '../Common/ShippingInfoConfirmModal';
import BatchesModal2 from '../Common/BatchesModal2';
import GenericSelection from '../Common/GenericSelection';
import SOConfirmationModal from '../Common/SOConfirmationModal';
import checkPermission from '../Common/permissions';
import ActionTimeline from '../Common/actionTimeline';
import { convertLocalDate, converTimeUTCToLocal } from '../Common/cleanDates';
import {
  ROOT_URL, ROOT_API_URL, companyCodeTitle, isGGI, isSH, isOCM, isSV, isLMH, isSDR, isCRW,
  isDAICHEONG, isLE, isHO, isJRC, isESC, isABBLE, isHMM, isSUN, isSKH, isCPG, isOLG,
  isLAP, isTU, isABCFF, isVAK, isMH, isTQ, isSW, isAGD, isEKC, isKM, isVIP, isCTP,
  isCCW, isGFD, isLMHST, isSC
} from '../../actions/root_url';
import { SALES_ORDER_PRODUCT_BY_ID_URL,SALES_ORDER_EXISTING_URL, SALES_CUSTOMER_URL } from '../../actions/url';
import { fetchPromotions } from '../../components/Common/modals/salesOrder/PromotionsModal';
import SetWeightModal from '../../containers/Dispatch/setWeightModal';
import { moveColumnToPosition } from '../../utils';
import { setQuoteReview, setQuoteApproval, setOrderApproval, setOrderReview, createSO, fetchOrderRequests } from '../../actions/sales_actions';
import OrderRequests from './components/OrderRequests';

const {
  DriverListModal, ISAEditModal, CTNEditModal, ShippingStatusEditModal, Notes,
  BatchesModal, PromotionAddingModal, PromotionsModal, ApplyPromotionsModal,
  ApplyPromotionsModal2, ApplyPromotionsModal3, UnqualifyProductPromotionModal
} = salesOrderModals;
const { DOM: { input } } = React;
const isBobaLife = ROOT_API_URL === 'https://premiumstella-scm.truckxi.com/api';
const isEcity = (ROOT_API_URL === 'https://ct-scm.truckxi.com/api/') || (ROOT_API_URL === 'https://ctstage-scm.truckxi.com/api/');
const isMyumyu = (ROOT_API_URL === 'https://mmstage-scm.truckxi.com/api/' || ROOT_API_URL === 'https://myumyu-scm.truckxi.com/api/');
const isRivera = (ROOT_API_URL === 'https://rivera-scm.truckxi.com/api/' || ROOT_URL === 'https://rvrstage-scm.truckxi.com/api/');
const isDHC = ROOT_API_URL === 'https://dhc-scm.truckxi.com/api/' || ROOT_URL === 'https://dhc-scm.truckxi.com/api/';
const isAFG = ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || ROOT_URL === 'https://afg-scm.truckxi.com/api/';
const isWecom = ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/' || ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/';
const isCO = ROOT_API_URL === 'https://co-scm.truckxi.com/api/' || ROOT_URL === 'https://co-scm.truckxi.com/api/';
const isAFM = ROOT_API_URL === 'https://afm-scm.truckxi.com/api/' || ROOT_URL === 'https://afm-scm.truckxi.com/api/';
const isTN = ROOT_API_URL === "https://tn-scm.truckxi.com/api/" || ROOT_URL === "https://tn-scm.truckxi.com/api/";
const isABC = ROOT_API_URL === 'https://abc-scm.truckxi.com/api/' || ROOT_URL === 'https://abc-scm.truckxi.com/api/';
const isAN = ROOT_API_URL === 'https://asian-scm.truckxi.com/api/' || ROOT_URL === 'https://asian-scm.truckxi.com/api/';
const isUSPride = ROOT_API_URL === 'https://uspride-scm.truckxi.com/api/' || ROOT_URL === 'https://uspride-scm.truckxi.com/api/';
const isChinaTown = ROOT_API_URL === 'https://erp.chinatown-supermarket.com/api/' || ROOT_URL === 'https://erp.chinatown-supermarket.com/api/';
const isJML = ROOT_API_URL === 'https://jml-scm.truckxi.com/api/'|| ROOT_URL === 'https://jml-scm.truckxi.com/api/';
const isDSQ = ROOT_API_URL === 'https://dsq-scm.truckxi.com/api/' || ROOT_URL === 'https://dsq-scm.truckxi.com/api/';
const isWIZ = ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || ROOT_URL === 'https://wiz-scm.truckxi.com/api/';
const isFJ = ROOT_API_URL === 'https://fj-scm.truckxi.com/api/' || ROOT_URL === 'https://fj-scm.truckxi.com/api/';
const isJTB = ROOT_API_URL === 'https://jtb-scm.truckxi.com/api/' || ROOT_URL === 'https://jtb-scm.truckxi.com/api/';
const isFung = ROOT_API_URL === 'https://fung-scm.truckxi.com/api/' || ROOT_URL === 'https://fung-scm.truckxi.com/api/';
const isMAG = ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || ROOT_URL === 'https://magna-scm.truckxi.com/api/';
const isNBT = ROOT_API_URL === 'https://nbt-scm.truckxi.com/api/' || ROOT_URL === 'https://nbt-scm.truckxi.com/api/';
const isMultiWH = true;
const DateFormatter = React.createClass({
  render() {
    return this.props.value ?
     <span>{converTimeUTCToLocal(this.props.value)}</span> : null
  },
});

var DropDownEditor = Editors.DropDownEditor;

const DateFormatterChina = React.createClass({
  render() {
    if (this.props.value) {
      let year = this.props.value.split('/')[2];
      if (year) {
        year = year.substring(2);
      }
      let date = this.props.value.split('/')[0] + '/' + this.props.value.split('/')[1] + '/' + year;
      return <span>{date}</span>;
    }
    return <span className="label label-danger">-</span>;
  },
});

const DateFormatter2 = React.createClass({
  render() {
    if (this.props.value) {
      const date = moment(this.props.value).format("MM-DD-YY");
      return <span>{date}</span>;
    }
    return <span className="label label-danger">-</span>;
  },
});

const isNumeric = function (n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

const Checkbox = props => {
  return (
    <input
      {...props.input}
      type="checkbox"
      value={!props.input.value ? "true" : "false"}
      checked={props.input.value === true || props.input.value === "true"}
      disabled={props.disabled}
    />
  );
}

class PriceFormatter extends Component {
  render() {
    const { dependentValues } = this.props;
    return <span style={{ 'font-weight': 'bold' }}>$ {
      dependentValues
    }</span>;
  }
}

class HMMPriceFormatter extends Component {
  render() {
    const { Quantity, UnitPrice, PackageSize_1, } = this.props.dependentValues;
    return <span style={{ 'font-weight': 'bold' }}>{
      (Quantity * UnitPrice * PackageSize_1).toFixed(2)
    }</span>;
  }
}

class SalesOrderForm extends Component {
    static contextTypes = {
      router: React.PropTypes.object,
    };
    constructor() {
      super();
      this.state = {
        tripleCount: 0,
        overdueAmount: null,
        overdueCheck: false,
        enteringPhone: null,
        overdueTime: null,
        SOExistingVisible: false,
        IsLowerThanLowestPrice: false,
        confirmLowerThanLowestPrice: false,
        IsOverCreditLimit: false,
        dropShipWarning: false,
        setWeightOpen: false,
        rowChosen: null,
        totalLoaded: null,
        editedRow: null,
        priceObj:[],
        // resellerTemp: null,
        containerSizeOptions: [
          {label: "20", value: "20"},
          {label: "40", value: "40"},
          {label: "45", value: "45"},
        ],
        stateOptions: [
          {label: "CA", value: "CA"},
          {label: "PA", value: "PA"},
        ],
        paymentTermOptions: [],
        typeOptions: [
          {label: "C: CALL-IN DIRECT FROM CUSTOMER", value: "C: CALL-IN DIRECT FROM CUSTOMER"},
          {label: "F: FAX-IN DIRECT FROM CUSTOMER", value: "F: FAX-IN DIRECT FROM CUSTOMER"},
          {label: "I: INTERNET ORDERS", value: "I: INTERNET ORDERS"},
          {label: "R: FAX/CALL IN DIRECT FROM REP", value: "R: FAX/CALL IN DIRECT FROM REP"},
          {label: "S: IN HOUSE SALES", value: "S: IN HOUSE SALES"},
          {label: "T: TRADE SHOW ORDERS", value: "T: TRADE SHOW ORDERS"},
        ],
        FJAgentOptions: [],
        FBAOptions: [],
        FBAOptions2: [],
        fjCarrierOptions: [],
        magStatusOptions: [
          {label: "NOT READY", value: "NOT_READY"},
          {label: 'DISCHARGE', value: "DISCHARGE"},
          {label: "HOLD NEED RELEASE", value: "HOLD_NEED_RELEASE"},
          {label: "LOAD READY FOR PICKUP", value: "LOAD_READY_FOR_PICKUP"},
          {label: 'LOAD OUT ON AND READY FOR DELIVERY', value: "LOAD_OUT_ON_AND_READY_FOR_DELIVERY"},
          {label: "LOAD DELIVERED ON", value: "LOAD_DELIVERED_ON"},
          {label: "EMPTY READY FOR PICKUP", value: "EMPTY_READY_FOR_PICKUP"},
          {label: 'EMPTY BACK TO', value: "EMPTY_BACK_TO"},
          {label: "EMPTY RETURNED ON", value: "EMPTY_RETURNED_ON"},
        ],
        magNoteOptions: [
          {label: "DRYRUN", value: "DRYRUN"},
          {label: "OVERWEIGHT", value: "OVERWEIGHT"},
          {label: "UTL", value: "UTL"},
          {label: "PORTWAITING", value: "PORTWAITING"},
          {label: 'OFFHIRE', value: "OFFHIRE"},
          {label: "EXTRA STOP", value: "EXTRA STOP"},
          {label: "NO APPT FOR EMPTY RETURN", value: "NO APPT FOR EMPTY RETURN"},
          {label: 'EXAM', value: "EXAM"},
          {label: "REJECTED", value: "REJECTED"},
          {label: "REDELIVERY", value: "REDELIVERY"},
          // {label: "OTHER", value: "OTHER"},
        ],
        magTerminalOptions: [
          {label: "EVERPORT", value: "EVERPORT"},
          {label: "LBCT", value: "LBCT"},
          {label: "shippers-MIDDLE", value: "shippers-MIDDLE"},
          {label: "SHIPPERS-ALAMEDA", value: "SHIPPERS-ALAMEDA"},
          {label: 'SHIPPERS-LONGBEACH', value: "SHIPPERS-LONGBEACH"},
          {label: "TRAPAC", value: "TRAPAC"},
          {label: "WBCT", value: "WBCT"},
          {label: 'PCT', value: "PCT"},
          {label: "ITS", value: "ITS"},
          {label: "APM", value: "APM"},
          {label: "C60-MATSON", value: "C60-MATSON"},
          {label: "TTI", value: "TTI"},
          {label: "YUSEN", value: "YUSEN"},
          {label: "FMS", value: "FMS"},
          {label: "PIER-A", value: "PIER-A"},
        ],
        magShippingLineOptions: [
          {label: "EVERGREEN", value: "EVERGREEN"},
          {label: "CAM", value: "CAM"},
          {label: "MATSON", value: "MATSON"},
          {label: "MSC", value: "MSC"},
          {label: 'MAERSK', value: "MAERSK"},
          {label: "CMA", value: "CMA"},
          {label: "YANGMING", value: "YANGMING"},
          {label: 'COSCO', value: "COSCO"},
          {label: "SM LINE", value: "SM LINE"},
          {label: "WANHAI", value: "WANHAI"},
          {label: "HYUNDAI", value: "HYUNDAI"},
          {label: "BAL", value: "BAL"},
          {label: "HAPAG ", value: "HAPAG "},
          {label: "LLOYD ", value: "LLOYD "},
          {label: "SUD ", value: "SUD "},
          {label: "ONE ", value: "ONE "},
          {label: "APL ", value: "APL "},
          {label: "ZIM ", value: "ZIM "},
        ],
        magSizeOptions: [
          {label: "40HC", value: "40HC"},
          {label: "45", value: "45"},
          {label: "40ST", value: "40ST"},
          {label: "20", value: "20"},
          {label: "40RF", value: "40RF"},
        ],
        creditAmount: 0,
        shareCreditAmount: 0,
        clickedInvoice: false,

        overdueSaveModalVisibility: false,
        overdueModalVisibility: false,
        selectedOverdue: null,
        overdueActivate: false,

        shippingInfoModalVisibility: false,
        ShippingMethod: '',
        cellSelectEnabled: true,
        firstFocus: true,
        useDefaultCustomerAddress: true,
        // Customer payment term
        paymentTerm: null,
        salesOrderNumber: null,
        customerPaymentTerm: null,
        productHistoryLabel: '',
        // Determine Modal visibility
        openOrderOpen: false,
        historyOpen: false,
        salesHistoryOpen: false,
        customerOpen: false,
        confirmOpen: false,
        showInventoryOpen: false,
        showShippingOpen: false,
        changeTaxOpen: false,
        changeDiscountOpen: false,
        SODiscount: 0,
        SOSavings: 0,
        finalPriceWithPromotion: 0,
        employeeNoteText: '',
        employeeNoteDisplay: '',
        changeEmployeeNoteOpen: false,
        deliveryFeeEdit: null,
        transFeeEdit: null,
        changeTransFeeOpen: false,

        handlingFeeEdit: null,
        changeHandlingFeeOpen: false,

        percentageFeeEdit: null,
        ccEdit: '',
        ccOrigin: '',
        ccFee: 0,
        changePercentageFeeOpen: false,
        changeCCOpen: false,

        changeWeightOpen: false,
        changeDeliveryFeeOpen: false,
        editSOPermissionOpen: false,
        confirmRefundOpen: false,
        deliveryMethodModalOpen: false,
        showCarrierButton: false,
        carrierInfoModalOpen: false,
        overdueCreditLimit: 0,
        isDropshipOpen: false,
        createBOLModalVisibility: false,
        verifyPasscodeOpen: false,
        verifyPasscodeOpenDiscount: false,
        // Tracks what error to display
        case: null,
        dirty: false,
        expAr:[],
        // Customer details
        Amount00_30: 0,
        Amount31_60: 0,
        Amount61_90: 0,
        Amount91: 0,
        // Determine expand state of panels
        favoriteItemsOpen: true,
        previousOrdersOpen: false,
        promotionsOpen: false,
        // Tracks information on customer currently chosen
        currentCustomer: null,
        currentCustomerName: null,
        // Variable used to determine which column to highlight prices
        currentPriceLevel: null,
        customersWithFavorites: [],
        salesItemHistory: [],
        // Keeps track of current item to be added to SO
        selectedItemName: '',
        selectedItemNumber: '',
        refPrice: null,
        defaultRefPrice: 0,
        // Order details
        totalPrice: 0,
        finalWeight: 0,
        finalNetWeight: 0,
        finalShippingWeight: 0,
        totalTax: 0,
        finalPrice: 0,
        totalCRV: 0,

        // Default tax value
        taxValue: 0,
        // Track tax rate to use
        taxRate: null,
        taxRateIndex: 0,

        // Tracks items in SO table
        rows: [],
        selectedRows: [],
        filteredRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
        inventoryInput: null,
        overduePasscode: "",
        alreadyCheckedPasscode: false,

        currentProdEkc: null,
        currentProdComboEkc: false,
        // Assorted objects holding items in respective tables
        inventories: {
          rows: [],
          allRows: [],
          currString: null,
          selectedRows: [],
          sortColumn: null,
          sortDirection: null,
        },
        favorites: {
          rows: [],
          selectedRows: [],
          sortColumn: null,
          sortDirection: null,
          selectedIndexes: [],
        },
        // Previous SOs, default time for 3 months
        days: '90',
        FromDate: undefined,
        ToDate: undefined,
        previousSOs: {
          rows: [],
          selectedRows: [],
          filters: {},
          sortColumn: null,
          sortDirection: null,
        },
        previousOrders: {
          rows: [],
          selectedRows: [],
          filters: {},
          sortColumn: null,
          sortDirection: null,
          selectedIndexes: [],
        },
        quickEntrySONum: '',
        smilingColor: '',
        quickEntryShowError: false,
        itemHistory: {
          rows: [],
          sortColumn: null,
          sortDirection: null,
        },
        frequentItems: {
          rows: [],
          selectedRows: [],
          sortColumn: null,
          sortDirection: null,
          selectedIndexes: [],
          selectedPK: [],
        },
        soExitList: {
          rows: [],
          selectedRows: [],
          sortColumn: null,
          sortDirection: null,
          selectedIndexes: [],
          selectedPK: [],
        },
        relatedComponentsList: {
          rows: [],
          selectedRows: [],
          sortColumn: null,
          sortDirection: null,
          selectedIndexes: [],
          selectedPK: [],
        },
        salesHistory: {
          rows: [],
          sortColumn: null,
          sortDirection: null,
          filters: {},
        },
        salesItemHistories: {
          rows: [],
          sortColumn: null,
          sortDirection: null,
          filters: {},
        },
        selectedInventoryRow: {},
        modified_by: null,
        updateTime: null,
        created_by: null,
        created_by2: null,
        creator: null,
        quantityZero: [],

        yourOrderTableHeight: (window.innerHeight < 930) ? 345 : 345,
        yourOrderKey: 1,
        inboundInfoKey: 1,
        fjInfoKey: 1,

        editSOPermission: true,
        paymentInfo: null,
        shouldPaymentInfoShow: false,
        refundAmount: 0.00,
        refundReason: '',
        CompanyName: '',
        Billing: {
          AddressName: '',
          Cellphone: '',
          City: '',
          CustomerDetail: '',
          Email: '',
          Fax: '',
          FirstName: '',
          IsDefault: null,
          IsDeleted: null,
          LastName: '',
          Note: '',
          Position: '',
          State: '',
          Telephone: '',
          Type: '',
          Zip: '',
          Notation: '',
        },
        ShipTo: {
          Address: '',
          Telephone: '',
          Name: '',
        },
        Shipping: {
          AddressName: '',
          Cellphone: '',
          City: '',
          CustomerDetail: '',
          Email: '',
          Fax: '',
          FirstName: '',
          IsDefault: null,
          IsDeleted: null,
          LastName: '',
          Note: '',
          Position: '',
          State: '',
          Telephone: '',
          Type: '',
          Zip: '',
          TimeSlot: '',
        },
        prevEstDate: false,
        prevOrderDate: false,
        Released: false,
        editing: false,
        suggestValue: '',

        magDryrun: false,
        magOffhire: false,
        magExtraStop: false,
        magExam: false,
        magExtraDelivery: false,
        magStorage: false,
        magBobtailFee: false,

        mag2FREIGHT_HOLD: false,
        mag2CUSTOM_HOLD: false,
        mag2PIERPASS_HOLD: false,
        mag2EXAM: false,
        mag2CLOSED_AREA: false,

        level1: 0,
        level2: 0,
        level3: 0,
        level4: 0,
        level5: 0,
        levelRefPrice: 0,

        shippingPdfFrameLoaded: true,
        pickingListPdfFrameLoaded: true,
        packingListPdfFrameLoaded: true,
        salesOrderPdfFrameLoaded: true,
        salesOrderSIPdfFrameLoaded: true,
        refundPDFFrameLoaded: true,

        // Specifically for the previous Order search
        searchSalesOrderNum: '',
        salesOrderIndexFromLast: 1,

        // CheckboxFormatter
        IsNoReduce: false,
        IsFBAAddress: false,
        Sales_User_id: undefined,
        Sales_User_id2: undefined,
        Picker_User_id: undefined,
        Packer_User_id: undefined,
        Creator_User_id: undefined,

        PaymentTermDesc: '',
        CreditLimit: '',
        delivery: 0,
        verifyPasscodeToCreateSOModalOpen: false,
        customerVerified: false,
        fee: 0,
        transFee: 0,
        handlingFee: 0,
        percentageFee: 0,

        shippingInfoEditModalVisibility: false,
        customerEditModalVisibility: false,
        customerNoteModalVisibility: false,
        fbaEditModalVisibility: false,
        shippingInfoConfirmModalVisibility: false,
        createModalVisibility: false,
        relatedComponentsModalVisibility: false,
        notationModalVisibility: false,
        notationModalInfo: {},
        doubleClickProductMainId: '',
        discountModified: false,

        shippingStatusEditModalVisible: false,
        isNotesModalVisibile: false,

        addingChild: false,
        addingChildQty: null,
        addingChildParent: null,
        comboQty: 1,

        // TQ, OCM
        companyOptions: [],
        warehouseOptions: [],
        // modal
        isBatchesModalVisible: false,
        isBatchesModal2Visible: false,
        isMultiBatchVisible: false,
        lineBatchId: null,
        lineBatchIdx: null,
        lineBatchRows: [],
        isPromotionsModalVisible: false,
        isApplyPromotionsModalVisible: false,
        promotions: null,

        promotionCheckProduct: '',
        isApplyPromotionsModal2Visible: false,
        isApplyPromotionsModal3Visible: false,
        isUnqualifiedPromotionModalVisible: false,
        isCustomerInformationPanelFolded: false,
        isProductInformationPanelFolded: false,
        applyPromotionList:[],
        // LE
        customerRoutes: [],
        isSaveToInvoice: false,
        // isSUN
        hideCol: false,
        // isLAP
        ETDate: null,
        // isGGI
        currentEditingProduct: null,
        // isVAK
        alertModalVisibility: false,
        isApproved: false,
        alertModalCase: 'save_with_review_and_approve',
        setReviewCallback: null,
        setApproveCallback: null,
        confirmModalVisibility: false,
        confirmModalCase: 'confirm_review',
        setConfirmCallback: null,
        setRejectCallback: null,
        setRecheckCallback: null,
        setCancelCallback: null,
        ShippingSubtotal: 0,
        EstimatedTax: 0,
        // isSH
        pkgTp: {value: 'BX', label: 'BX'},
        selectedValue: ''
      };
      this.openCustomer = this.openCustomer.bind(this);
      this.closeCustomer = this.closeCustomer.bind(this);
      this.openHistory = this.openHistory.bind(this);
      this.closeHistory = this.closeHistory.bind(this);
      this.moveToSO = this.moveToSO.bind(this);
      this.barcodeScan = this.barcodeScan.bind(this);
      this.handleUnitPriceChange = this.handleUnitPriceChange.bind(this);
      this.openConfirm = this.openConfirm.bind(this);
      this.closeConfirm = this.closeConfirm.bind(this);
      this.closeShowInventory = this.closeShowInventory.bind(this);
      this.selectInventoryInfo = this.selectInventoryInfo.bind(this);
      this.handleOnFocus = this.handleOnFocus.bind(this);
      this.openShowSOCreated = this.openShowSOCreated.bind(this);
      this.openEditSOPermission = this.openEditSOPermission.bind(this);
      this.closeEditSOPermission = this.closeEditSOPermission.bind(this);
      this.closeDropship = this.closeDropship.bind(this);
      this.openDropship = this.openDropship.bind(this);
      this.openShipping = this.openShipping.bind(this);
      this.openCreateBOLModal = this.openCreateBOLModal.bind(this);
      this.closeCreateBOLModal = this.closeCreateBOLModal.bind(this);
      this.closeShipping = this.closeShipping.bind(this);
      this.openChangeTax = this.openChangeTax.bind(this);
      this.closeChangeTax = this.closeChangeTax.bind(this);
      this.openEmployeeNote = this.openEmployeeNote.bind(this);
      this.closeEmployeeNote = this.closeEmployeeNote.bind(this);
      this.openOverdueModal = this.openOverdueModal.bind(this);
      this.closeOverdueModal = this.closeOverdueModal.bind(this);
      this.initializeSaveOverdue = this.initializeSaveOverdue.bind(this);
      this.closeSaveOverdueModal = this.closeSaveOverdueModal.bind(this);
      this.openDeliveryFee = this.openDeliveryFee.bind(this);
      this.closeDeliveryFee = this.closeDeliveryFee.bind(this);
      this.handleSelect = this.handleSelect.bind(this);
      this.handleSelect2 = this.handleSelect2.bind(this);
      this.handleSelect3 = this.handleSelect3.bind(this);
      this.handleDiscountChange = this.handleDiscountChange.bind(this);
      this.setAllProductQuantity = this.setAllProductQuantity.bind(this);
      this.openDeliveryMethodModal = this.openDeliveryMethodModal.bind(this);
      this.openCarrierInfoModal = this.openCarrierInfoModal.bind(this);
      this.closeCarrierInfoModal = this.closeCarrierInfoModal.bind(this);
      this.closeDeliveryMethodModal = this.closeDeliveryMethodModal.bind(this);
      this.handleUpdatePrice = this.handleUpdatePrice.bind(this);
      this.fetchPreviousSalesOrderByCustomer = this.fetchPreviousSalesOrderByCustomer.bind(this);
      this.fetchPreviousOrdersFromALLSalesOrder = this.fetchPreviousOrdersFromALLSalesOrder.bind(this);
      this.fetchPreviousOrderBySearch = this.fetchPreviousOrderBySearch.bind(this);
      this.onConfirmPercentageFee = this.onConfirmPercentageFee.bind(this);
      this.setProdNum = this.setProdNum.bind(this);
      this.setIsCombo = this.setIsCombo.bind(this);
      this.closeSetWeight = this.closeSetWeight.bind(this);
      this.searchType = (isSH || isEKC || isLMH || isSDR || isCRW || isSC) ? 'Name' : 'RefNum';
    }

    componentWillMount() {
      // if (isSV && this.props.currentSalesOrder && this.props.currentSalesOrder.EmployeeNote) {
      //   console.log('EmployeeNote: ', )
      // }
      if (isAFG && this.props.currentSalesOrder && this.props.currentSalesOrder.SONum && this.props.currentSalesOrder.SONum.charAt(0) !== 'M') {
        if (this.context.router.routes[1].path === 'mobileSalesOrders/:id' || this.context.router.routes[1].path === 'salesOrders/:id') {
          this.state.showCarrierButton = true;
        }
      }
      let fetchAllUser = true
      if (isSV) {
        this.props.fetchBaseUsers(false,true);
      } if (isEKC || isLMH || isSDR || isCRW || isSC) {
        this.props.fetchBaseUsers(false);
      } else {
        this.props.fetchBaseUsers(fetchAllUser);
      }

      if (isOCM || isOLG) {
        this.props.fetchPackers();
      }
      if(isGGI && this.props.Company_id) {
        this.props.fetchPackers(this.props.Company_id);
      }
      this.props.setValue('salesOrderForm', 'Pickup_Warehouse_id', null);
      this.props.setValue('salesOrderForm', 'Sales_User_id', null);
      this.props.setValue('salesOrderForm', 'Sales_User_id2', null);
      this.props.setValue('salesOrderForm', 'Picker_User_id', null);
      this.props.setValue('salesOrderForm', 'Packer_User_id', null);
      this.props.setValue('salesOrderForm', 'Creator_User_id', null);
      this.getCompanyOptions();
      let route = null;
      let currentSalesOrder;
      // https://ct-scm.truckxi.com/api/v1/sale/sales_order/?pk=56774
      if (this.props.currentSalesOrder) {
        const Released = (this.props.currentSalesOrder.SaleStatus === 'Released');
        this.setState({ Released });
        this.props.setValue('salesOrderForm', 'CustomerDetail_id', this.props.currentSalesOrder.Deliver_CustomerDetail_id);
      }
      if (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
        route = 'salesOrders';
      } else if (this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id') {
        route = 'mobileSalesOrders';
      }
      const { location: { pathname }, params: { id } } = this.props;
      if (!currentSalesOrder && !id) {
        if (pathname.includes('mobileSalesOrders/new')) {
          this.context.router.push('/mobileSalesOrders/');
        }
      }
      if (this.context.router.routes[1].path !== 'salesOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'mobileSalesOrders/new') {
        currentSalesOrder = this.props.currentSalesOrder;
      }

      this.props.fetchTaxRates(null, this.props.selectedCompany ? this.props.selectedCompany.value : '')
       .then(() => {
         const taxRateOptions = this.getTaxRateOptions();
         if ((isHMM || isHO || isJRC || isEKC || isLMH || isSDR || isCRW || isSC || isSUN || isCPG || isSH || isVIP) && taxRateOptions.length > 0) {
           this.handleTaxValueChange({
             value: taxRateOptions[0].value,
             label: taxRateOptions[0].label,
             index: 0
           })
         }
      })

      if (currentSalesOrder && this.context.router.routes[1].path !== 'salesOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'mobileSalesOrders/new') {
        this.setState({ currentCustomer: currentSalesOrder.Deliver_Customer_id, salesOrderNumber: currentSalesOrder.SONum });
        if(!(isDAICHEONG || isOLG)) {
          this.props.setValue('salesOrderForm', 'Deliver_Customer_id', currentSalesOrder.Deliver_Customer_id);
        }
        this.props.fetchCustomers()
          .then(() => {
            if (currentSalesOrder.Shipping_Customer && false) {
              if (isLE) {
                const success = (routes) => { this.setState({ customerRoutes: routes }); }
                this.props.fetchRoutesByCustomer(nextProps.customerChosen.value, success);
              }
              this.props.fetchSalesCustomerDetail(currentSalesOrder.Shipping_Customer, currentSalesOrder.SalesOrder_id, true);
            } else {
              if (isLE) {
                const success = (routes) => { this.setState({ customerRoutes: routes }); }
                this.props.fetchRoutesByCustomer(nextProps.customerChosen.value, success);
              }
              this.props.fetchSalesCustomerDetail(currentSalesOrder.Deliver_Customer_id, this.props.currentSalesOrder && this.props.currentSalesOrder.SalesOrder_id);
              let fjAgentTemp2 = [];
              if (isFJ) {
                this.props.fetchFJAgents(currentSalesOrder.Deliver_Customer_id)
                .then(response => {
                  if (response.data) {
                    response.data.map(r => {
                      fjAgentTemp2.push({label: r.name, value: r.id});
                    });
                    this.state.FJAgentOptions = fjAgentTemp2;
                  }
                }, err => {
                  if (err.status === 500 || err.status === 404) {
                    alert('error fetching agents');
                  }
                });
              }
            }
          })
          // .then(() => {
          //   this.props.fetchPromotions();
          // })
          .then(() => {
            // this.props.fetchCustomersWithFavorites();
            this.setState({ editSOPermission: false });
            // this.props.setDefaultSearchType('RefNum', 'salesOrderForm');
            this.props.initializeSalesOrderForm(this.searchType, 'salesOrderForm');
            this.props.fetchSalesOrderDetail(currentSalesOrder.SalesOrder_id, route);
          });
        // get 90 days sales order
        this.props.fetchPreviousSalesOrderByCustomer(currentSalesOrder.Deliver_Customer_id || (this.props.Deliver_CustomerDetail_id && this.props.Deliver_CustomerDetail_id.value || this.props.Deliver_CustomerDetail_id), this.state.fromDate, this.state.toDate, isOLG);
      } else {
        this.props.resetCurrentSalesOrder();
        // if (!isGGI) {
        this.props.fetchActiveCustomers();
        // }
        // this.props.fetchPromotions();
        this.props.fetchTaxRates(null, this.props.selectedCompany ? this.props.selectedCompany.value : '');
        // this.props.setDefaultSearchType('RefNum', 'salesOrderForm');
        this.props.initializeSalesOrderForm(this.searchType, 'salesOrderForm');
        this.setState({ Released: false });
      }
      // making a leaving hook to confirm leaving
      if (this.props.prevEstDate) { this.setState({ prevEstDate: this.props.prevEstDate }); } else {
        var currentDate = new Date();
        isEcity && currentDate.setDate(currentDate.getDate() + 1);
        // isMultiWH && currentDate.setDate(currentDate.getDate() + 2);
        // this.setState({ prevEstDate: currentDate });
        var lalaDate = new Date();
        if (!isCPG && !isLAP && !isMH && !isVIP) {
          if(isGGI || isSUN) {
            lalaDate.setDate(currentDate.getDate() + 1);
          } else {
            lalaDate.setDate(currentDate.getDate() + 2);
          }
        }
        this.setState({ prevEstDate: lalaDate, prevOrderDate: currentDate });
      }
      if (this.props.ETDate) {
        this.setState({ ETDate: this.props.ETDate})
      } else {
        this.setState({ ETDate: new Date()})
      }
      if (this.props.prevEstDateIsNeeded) { this.props.destroyEstDate(); }
      this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));

      if (this.props.currentSalesOrder) {
        if (!this.props.currentSalesOrder.FinalNetWeight) {
          this.props.currentSalesOrder.FinalNetWeight = 0.00;
        } else {
          this.props.currentSalesOrder.FinalNetWeight = this.props.currentSalesOrder.FinalNetWeight;
        }
        if (!this.props.currentSalesOrder.FinalShippingWeight && this.props.currentSalesOrder.FinalNetWeight) {
          this.props.currentSalesOrder.FinalShippingWeight = this.props.currentSalesOrder.FinalNetWeight;
          this.state.finalShippingWeight = this.props.currentSalesOrder.FinalNetWeight;
        } else {
          this.state.finalShippingWeight = this.props.currentSalesOrder.FinalShippingWeight;
        }
      }
      if (this.props && this.props.employeeNote) {
        this.state.employeeNoteText = this.props.employeeNote;
        this.state.employeeNoteDisplay = this.props.employeeNote;
      }

      let jmlTemp = [];
      if (isJML || isSV) {
        this.props.getPaymentTerms()
        .then(response => {
          if (response.data) {
            response.data.map(r => {
              jmlTemp.push({label: r.Name, value: r.PaymentTerm_id});
              // jmlTemp.push({label: r.Name, value: r.Name});
            });
            this.state.paymentTermOptions = jmlTemp;
          }
        }, err => {
          if (err.status === 500 || err.status === 404) {
            alert('error fetching payment terms');
          }
        });
      }

      if (isChinaTown) {
        this.props.setDefaultOfForm("ShippingMethod", "Delivery", "salesOrderForm");
      }

      if (isWIZ || isDSQ || isFJ || isJTB || isABCFF) {
        this.props.fetchInboundProducts();
      }
      if (isWIZ) {
        let fbaAdressTemp1 = [];
        let fbaAdressTemp2 = [];
          this.props.fetchFBAAddressOptions()
          .then(response => {
            if (response.data) {
              response.data.map(r => {
                fbaAdressTemp1.push({label: r.street+", "+r.city+", "+r.zipcode+", "+r.state, value: r.id});
                fbaAdressTemp2.push({label: r.name,  value: r.id});
              });
              this.state.FBAOptions = fbaAdressTemp1;
              this.state.FBAOptions2 = fbaAdressTemp2;
            }
          }, err => {
            if (err.status === 500 || err.status === 404) {
              alert('error fetching FBA address');
            }
          });
      }

      if (isFJ) {
        let fjCarrierTemp1 = [];
        // let fbaAdressTemp2 = [];
          this.props.fetchFJCarriers()
          .then(response => {
            if (response.data) {
              response.data.map(r => {
                fjCarrierTemp1.push({label: r.name, value: r.id});
                // fbaAdressTemp2.push({label: r.name,  value: r.id});
              });
              this.state.fjCarrierOptions = fjCarrierTemp1;
              // this.state.FBAOptions2 = fbaAdressTemp2;
            }
          }, err => {
            if (err.status === 500 || err.status === 404) {
              alert('error fetching carriers');
            }
          });
      }
      // if (isTQ) {
      //   this.props.setDefaultOfForm("Company_id", "Aibou Trading, Inc.", "salesOrderForm");
      // }
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.ShipVia !== this.props.ShipVia && nextProps.ShipVia) {
        const ShipVia = nextProps.ShipVia.value || nextProps.ShipVia;
        if (ShipVia === 'ggiDelivery' || ShipVia === '3rdPartyDelivery') {
          let PickAddress = '';
          _.forEach(this.state.warehouseOptions, warehouse => {
            if (warehouse.value === this.props.Pickup_Warehouse_id) {
              PickAddress = warehouse.address;
            }
          });
          this.setState({
            PickAddress,
          })
        } else {
          this.setState({
            PickAddress: '',
          })
        }
      }

      // if (nextProps.Company_id !== this.props.Company_id && isGGI) {
      //   this.props.fetchActiveCustomers(nextProps.Company_id);
      // }
      if (nextProps.selectedCompany !== this.props.selectedCompany) {
        this.props.fetchActiveCustomers();
        this.props.fetchTaxRates(null, nextProps.selectedCompany.value);
      }
      if (this.context.router.routes[1].path === 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/:id') {
        if (!this.state.SODiscount && !this.state.SOSavings) {
          this.setState({ SODiscount: nextProps.discount, SOSavings: nextProps.savings });
        } else {
          if (!this.state.discountModified) {
            this.setState({ SODiscount: nextProps.discount, SOSavings: nextProps.savings });
          }
        }
      }
      if ((this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'outboundOrders/new') && !this.state.discountModified) {
        this.setState({ SODiscount: 0, SOSavings: 0 });
      }
      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail != null && this.props.currentSalesOrder != null && nextProps.currentSalesOrderDetail.FinalNetWeight && nextProps.currentSalesOrderDetail.FinalShippingWeight) {
        this.props.currentSalesOrder.FinalNetWeight = nextProps.currentSalesOrderDetail.FinalNetWeight;
        this.props.currentSalesOrder.FinalShippingWeight = nextProps.currentSalesOrderDetail.FinalShippingWeight;
        this.state.finalShippingWeight = this.props.currentSalesOrder.FinalShippingWeight;
      }
      if((isDAICHEONG || isOLG) && nextProps.currentSalesOrderDetail != this.props.currentSalesOrderDetail && nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.Deliver_CustomerDetail_id && this.context.router.routes.length > 1
        && this.context.router.routes[1].path != 'salesOrders/new' && !this.props.Deliver_CustomerDetail_id) {
        this.props.setValue('salesOrderForm', 'Deliver_CustomerDetail_id', nextProps.currentSalesOrderDetail.Deliver_CustomerDetail_id);
      }
      if (nextProps.employeeNote) {
        this.state.employeeNoteText = nextProps.employeeNote;
        this.state.employeeNoteDisplay = nextProps.employeeNote;
      }
      if (nextProps.customerChosen !== this.props.customerChosen) {
        this.setState({
          customerVerified: false,
        })
      }

      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.SaleStatus && nextProps.currentSalesOrderDetail.SaleStatus === 'Released') {
        this.setState({ Released: true });
      }
      if(isOLG && !this.props.shippingMethod && !nextProps.shippingMethod) {
        this.props.setDefaultOfForm("ShippingMethod", "Pick up 提货", "salesOrderForm");
      }
      if(isVAK && !this.props.shippingMethod && !nextProps.shippingMethod) {
        this.props.setDefaultOfForm("ShippingMethod", "Delivery", "salesOrderForm");
      }
      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.ShippingMethod) {
        this.setState({ ShippingMethod: nextProps.currentSalesOrderDetail.ShippingMethod });
      }
      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.Billing) {
        this.setState({ Shipping: nextProps.currentSalesOrderDetail.Shipping, Billing: nextProps.currentSalesOrderDetail.Billing });
      }
      if (nextProps.salesCustomerDetails && nextProps.salesCustomerDetails.Billing) {
        this.setState({ Shipping: nextProps.salesCustomerDetails.Shipping, Billing: nextProps.salesCustomerDetails.Billing });
        if (nextProps.salesCustomerDetails.CustomerNum === 'EMP9999' && !nextProps.allShipping) {
          this.props.fetchAllShipping();
        }

        if (isSV && nextProps.salesCustomerDetails.Discount) {
          this.setState({ SODiscount: nextProps.salesCustomerDetails.Discount, SOSavings: 0 });
        }
      }

      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.ShipTo) {
        this.setState({ ShipTo: nextProps.currentSalesOrderDetail.ShipTo });
      }
      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.CompanyName) {
        this.setState({ CompanyName: nextProps.currentSalesOrderDetail.CompanyName });
      }

      if (nextProps.salesShippingCustomerDetails !== this.props.salesShippingCustomerDetails && nextProps.salesShippingCustomerDetails) {
        this.setState({ Shipping: nextProps.salesShippingCustomerDetails.Shipping });
        if (nextProps.salesShippingCustomerDetails.Shipping) {
          let defaultFound = false;
          const fieldName = (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'outboundOrders/new') ? 'CustomerDetail_id' : 'Deliver_CustomerDetail_id';
          if(!isGGI) {
            nextProps.salesShippingCustomerDetails.Shipping.map((ShippingInfo) => {
              if (ShippingInfo.IsDefault) {
                defaultFound = true;
                if(nextProps.Deliver_CustomerDetail_id) {
                  if(!(isDAICHEONG || isOLG) || ((isDAICHEONG || isOLG) && fieldName != 'Deliver_CustomerDetail_id')) {
                    this.props.setValue('salesOrderForm', fieldName, nextProps.Deliver_CustomerDetail_id);
                  }
                } else {
                  if (isHMM) {
                    this.props.setValue('salesOrderForm', fieldName, null);
                  } else {
                    if(!(isDAICHEONG || isOLG) || ((isDAICHEONG || isOLG) && fieldName != 'Deliver_CustomerDetail_id')) {
                      this.props.setValue('salesOrderForm', fieldName, ShippingInfo.CustomerDetail_id);
                    }
                    this.props.setValue('salesOrderForm', 'Email', ShippingInfo.Email);
                  }
                }
              }
            });
          } else {
            let index = _.findIndex(nextProps.salesShippingCustomerDetails.Shipping, {IsDefault: true});
            if(index != -1) {
              defaultFound = true;
              let ShippingInfo = nextProps.salesShippingCustomerDetails.Shipping[index];
              if(nextProps.Deliver_CustomerDetail_id) {
                this.props.setValue('salesOrderForm', fieldName, nextProps.Deliver_CustomerDetail_id);
              } else {
                  this.props.setValue('salesOrderForm', fieldName, ShippingInfo.CustomerDetail_id);
                  this.props.setValue('salesOrderForm', 'Email', ShippingInfo.Email);
              }
              if(this.context.router.routes[1].path === 'salesOrders/new') {
                  this.props.setValue('salesOrderForm', 'DispatchEndTime', ShippingInfo.Deliver_End)
                  this.props.setValue('salesOrderForm', 'DispatchStartTime', ShippingInfo.Deliver_Start)
              }
            }
            if(this.context.router.routes[1].path !== 'salesOrders/new') {
              this.props.setValue('salesOrderForm', 'DispatchEndTime', nextProps.salesShippingCustomerDetails.DispatchEndTime)
              this.props.setValue('salesOrderForm', 'DispatchStartTime', nextProps.salesShippingCustomerDetails.DispatchStartTime)
            }
          }

          if (defaultFound === false) {
            if(nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.Deliver_CustomerDetail_id) {
              if(!(isDAICHEONG || isOLG) || ((isDAICHEONG || isOLG) && fieldName != 'Deliver_CustomerDetail_id')) {
                this.props.setValue('salesOrderForm', 'Deliver_CustomerDetail_id', nextProps.currentSalesOrderDetail.Deliver_CustomerDetail_id);
              }
            } else {
              this.props.setValue('salesOrderForm', fieldName, null);
            }
          }
        }
      }

      if (nextProps.allShipping && nextProps.allShipping !== this.props.allShipping && nextProps.allShipping.length && nextProps.salesCustomerDetails && nextProps.salesCustomerDetails.CustomerNum === 'EMP9999') {
        this.setState({ Shipping: nextProps.allShipping });
      }
      if (nextProps.dirty !== this.props.dirty) {
        this.setState({
          dirty: nextProps.dirty,
        });
      }

      if (nextProps.salesOrderCreated && nextProps.salesOrderCreated !== this.props.salesOrderCreated) {
        if (isOLG) {
          this.setState({
            rows: this.state.rows.map(item => {
              return ({
                ...item,
                SalesOrderLine_id: nextProps.salesOrderCreated.Sales_Order_Lines && nextProps.salesOrderCreated.Sales_Order_Lines.filter(editItem => editItem.Product_id === item.Product_id)[0].SalesOrderLine_id
              })
            })
          }, () => {
            this.openShowSOCreated();
          })
        }else {
          this.openShowSOCreated();
        }
      }

      if (nextProps.salesOrderEdited && nextProps.salesOrderEdited !== this.props.salesOrderEdited) {
        if (isOLG) {
          this.setState({
            rows: this.state.rows.map(item => {
              return ({
                ...item,
                SalesOrderLine_id: nextProps.salesOrderEdited.Sales_Order_Lines && nextProps.salesOrderEdited.Sales_Order_Lines.filter(editItem => editItem.Product_id === item.Product_id)[0].SalesOrderLine_id
              })
            })
          }, () => {
            this.openShowSOCreated();
          })
        } else {
          this.openShowSOCreated();
        }
      }

      if (nextProps.productInfo && nextProps.productInfo !== this.props.productInfo) {
        const productInfo = nextProps.productInfo;
        this.setState({
          productInfo,
          inStock: nextProps.productInfo.InStock,
          inStockWarehouse: nextProps.productInfo.InStockWarehouse,
          inStockOnhand: isGGI ? nextProps.productInfo.Onhand : nextProps.productInfo.InStockOnhand,
          purchased: nextProps.productInfo.Purchased,
          presale: nextProps.productInfo.PreSale,
          net_weight: (isOLG || isLAP) ? nextProps.productInfo.NetWeight : nextProps.productInfo.ProductNum.NetWeight,
          ship_weight: (isOLG || isLAP) ? nextProps.productInfo.ShippingWeight : nextProps.productInfo.ProductNum.ShipWeight,
          total_weight: '',
          RefPrice: nextProps.productInfo.RefPrice, //ctn
          LowestSalePrice: nextProps.productInfo.LowestSalePrice,
          PriceLv1: nextProps.productInfo.PriceLv1,
          PriceLv2: nextProps.productInfo.PriceLv2,
          PriceLv3: nextProps.productInfo.PriceLv3,
          PriceLv4: nextProps.productInfo.PriceLv4,
          PriceLv5: nextProps.productInfo.PriceLv5,
        });
      }

      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail !== this.props.currentSalesOrderDetail) {
        const {
          PickAddress
        } = nextProps.currentSalesOrderDetail;
        this.setState({
          PickAddress,
        })
        const currentSalesOrderDetail = nextProps.currentSalesOrderDetail;
        if (currentSalesOrderDetail.Sales_Order_Lines != null) {
          let totalPrice = 0;
          let totalTax = 0;
          let finalPrice = 0;
          let finalWeight = 0;
          let totalCRV = 0;
          let delivery = 0;
          let ccFee = 0;
          let ccOrigin = 0;
          let ccEdit = 0;
          let relatedComponentsList = {}

          // let deliveryFeeEdit = 0;
          let index = currentSalesOrderDetail.Sales_Order_Lines.length;
          const discount = currentSalesOrderDetail.Discount || 0;
          const saving = currentSalesOrderDetail.Savings || 0;

          currentSalesOrderDetail.Sales_Order_Lines.map((row, idxx) => {
            if (isSV || isSUN || isOLG) {
              row.Index = idxx+1;
            } else {
              row.Index = index;
              index--;
            }
            if (row.IsTaxable === true) {
              if (isHMM) {
                totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(nextProps.currentSalesOrderDetail.TaxRate / 100);
              } else {
                if(isHO || isJRC || isVIP) {
                  if(row.IsAllTaxable === true || !this.props.salesCustomerDetails.Reseller) {
                    totalTax += parseFloat(row.TotalPrice) * parseFloat(nextProps.currentSalesOrderDetail.TaxRate / 100);
                  }
                } else {
                  totalTax += parseFloat(row.TotalPrice) * parseFloat(nextProps.currentSalesOrderDetail.TaxRate / 100);
                }
              }
            }
            if (isHMM) {
              totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
            } else {
              totalPrice += parseFloat(row.TotalPrice);
            }
            if (row.TotalNetWeight != null) {
              finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight);
            }
            if (row.CRV) {
              row.TotalCRV = +roundTo(parseFloat(row.CRV * row.Quantity), 2).toFixed(2);
            }
            if (row.TotalCRV) {
              totalCRV += row.TotalCRV;
            }
          });
          const { SODiscount, SOSavings } = this.state; // only one has value
          if (isHMM || isLMH || isSDR || isCRW || isSC || isSUN || isCPG) {
            if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
              totalTax = 0;
            } else {
              if (SODiscount) {
                totalTax = 0;
                currentSalesOrderDetail.Sales_Order_Lines.map((row, idxx) => {
                  if (row.IsTaxable === true) {
                    totalTax += ((parseFloat(row.TotalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)))) * parseFloat(this.state.taxValue / 100);
                  }
                });
              }
            }
          }
          if (isEKC || isSH) {
            if (isEKC && this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
              totalTax = 0;
            } else {
              if(isSH && discount) {
                totalTax = (parseFloat(totalPrice) * (1 - (discount / 100))) * parseFloat(nextProps.currentSalesOrderDetail.TaxRate / 100)
              } else {
                totalTax = (parseFloat(totalPrice) - Number(saving)) * parseFloat(nextProps.currentSalesOrderDetail.TaxRate / 100)
              }
            }
          }
          totalTax = +roundTo(totalTax, 2).toFixed(2);
          if(isSH) {
            finalPrice = (parseFloat(totalPrice) * (1 - (discount / 100))) + (parseFloat(totalTax) + parseFloat(totalCRV)) + (nextProps.currentSalesOrderDetail.Delivery || 0);
            ccEdit = currentSalesOrderDetail.CC || 0;
            ccOrigin = currentSalesOrderDetail.CC || 0;
            ccFee = +roundTo(finalPrice * (currentSalesOrderDetail.CC || 0), 2);
            finalPrice = finalPrice + ccFee;
          } else {
            finalPrice = (parseFloat(totalPrice) * (1 - (discount / 100))) + (parseFloat(totalTax) + parseFloat(totalCRV));
          }
          finalWeight = +roundTo(finalWeight, 2).toFixed(2);
          totalPrice = +roundToDecimals(totalPrice, 4).toFixed(4);
          finalPrice = +roundTo(finalPrice, 2).toFixed(2);
          delivery = nextProps.currentSalesOrderDetail.Delivery;
          // deliveryFeeEdit = nextProps.currentSalesOrderDetail.Delivery;
          let updateTime = new Date(currentSalesOrderDetail.UpdateTime);
          updateTime = this.updateTimeformatDate(updateTime).slice(0, 10);

          let magTempSplit = [];
          if (isMAG && currentSalesOrderDetail.mag_note) {
           magTempSplit = currentSalesOrderDetail.mag_note.split(',');
           magTempSplit.map(r=>{
            if (r === 'DRYRUN') {this.state.magDryrun = true;}
            if (r === 'OFFHIRE') {this.state.magOffhire = true;}
            if (r === 'EXTRA_STOP') {this.state.magExtraStop = true;}
            if (r === 'EXAM') {this.state.magExam = true;}
            if (r === 'EXTRA_DELIVERY') {this.state.magExtraDelivery = true;}
            if (r === 'STORAGE') {this.state.magStorage = true;}
            if (r === 'BOBTAIL_FEE') {this.state.magBobtailFee = true;}
           });
          }

          let mag2TempSpit = [];
          if (isMAG && currentSalesOrderDetail.DeliveryStatus) {
            mag2TempSpit = currentSalesOrderDetail.DeliveryStatus.split(',');
            mag2TempSpit.map(r=>{
             if (r === 'FREIGHT_HOLD') {this.state.mag2FREIGHT_HOLD = true;}
             if (r === 'CUSTOM_HOLD') {this.state.mag2CUSTOM_HOLD = true;}
             if (r === 'PIERPASS_HOLD') {this.state.mag2PIERPASS_HOLD = true;}
             if (r === 'EXAM') {this.state.mag2EXAM = true;}
             if (r === 'CLOSED_AREA') {this.state.mag2CLOSED_AREA = true;}
            });
           }

          this.setState({
            ...this.state,
            finalPrice,
            totalPrice,
            totalTax,
            finalWeight,
            discount,
            totalCRV: currentSalesOrderDetail.TotalCRV,
            updateTime,
            delivery,
            fee: currentSalesOrderDetail.Payment_Information ? currentSalesOrderDetail.Payment_Information.Fee : 0,
            handlingFee: currentSalesOrderDetail.HandlingFee ? currentSalesOrderDetail.HandlingFee : 0,
            percentageFee: currentSalesOrderDetail.PercentageFee ? currentSalesOrderDetail.PercentageFee : 0,
            transFee: currentSalesOrderDetail.TransFee ? currentSalesOrderDetail.TransFee : 0,

            taxValue: currentSalesOrderDetail.TaxRate,
            rows: currentSalesOrderDetail.Sales_Order_Lines,
            modified_by: currentSalesOrderDetail.Modifier_User_Name,
            created_by: currentSalesOrderDetail.Sales_User_id,
            created_by2: currentSalesOrderDetail.Sales_User_id2,
            creator: currentSalesOrderDetail.Creator_User_Name,
            currentCustomer: currentSalesOrderDetail.Deliver_Customer_id,
            paymentInfo: currentSalesOrderDetail.Payment_Information,
            chargeID: currentSalesOrderDetail.Charge_id,
            IsNoReduce: currentSalesOrderDetail.IsNoReduce,
            IsFBAAddress: currentSalesOrderDetail.IsFBAAddress,
            Sales_User_id: currentSalesOrderDetail.Sales_User_id,
            Sales_User_id2: currentSalesOrderDetail.Sales_User_id2,
            Picker_User_id: currentSalesOrderDetail.Picker_User_id,
            Packer_User_id: currentSalesOrderDetail.Packer_User_id,
            Creator_User_id: currentSalesOrderDetail.Creator_User_id,

            ShippingSubtotal: currentSalesOrderDetail.ShippingSubtotal,
            EstimatedTax: currentSalesOrderDetail.EstimatedTax,
            ccFee,
            ccOrigin,
            ccEdit,
          }, () => { this.handleDiscountChange(discount); });
        }

        if (nextProps.currentSalesOrderDetail.Shipping_Customer && false) {
          if (isLE) {
            const success = (routes) => { this.setState({ customerRoutes: routes }); }
            this.props.fetchRoutesByCustomer(nextProps.customerChosen.value, success);
          }
          this.props.setValue('salesOrderForm', 'receivingCustomer', nextProps.currentSalesOrderDetail.Shipping_Customer);
          this.props.fetchSalesCustomerDetail(nextProps.currentSalesOrderDetail.Shipping_Customer, null, true);
          this.setState({ useDefaultCustomerAddress: false });
        }
        if (nextProps.currentSalesOrderDetail.Deliver_Customer_id) {
          if (isLE) {
            const success = (routes) => { this.setState({ customerRoutes: routes }); }
            this.props.fetchRoutesByCustomer(nextProps.customerChosen.value, success);
          }
          this.props.setValue('salesOrderForm', 'receivingCustomer', nextProps.currentSalesOrderDetail.Deliver_Customer_id);
          this.props.fetchSalesCustomerDetail(nextProps.currentSalesOrderDetail.Deliver_Customer_id, null, true);
          if (isLAP) {
            this.props.fetchCustomerFrequent(nextProps.currentSalesOrderDetail.Deliver_Customer_id, nextProps.currentSalesOrderDetail.Company_id, nextProps.currentSalesOrderDetail.Pickup_Warehouse_id);
            this.props.fetchFavoriteList(nextProps.currentSalesOrderDetail.Deliver_Customer_id, nextProps.currentSalesOrderDetail.Company_id, nextProps.currentSalesOrderDetail.Pickup_Warehouse_id);
          }
          this.setState({ useDefaultCustomerAddress: false });
        }
        if (currentSalesOrderDetail.Shipping != null && currentSalesOrderDetail.CustomerNum !== 'EMP9999') {
          this.setState({
            shipping: currentSalesOrderDetail.Shipping,
          });
        }
        // this.props.setDefaultSearchType('RefNum', 'salesOrderForm');
        this.props.initializeSalesOrderForm(this.searchType, 'salesOrderForm');
      }

      if (nextProps.inventories && nextProps.inventories !== this.props.inventories) {
        const inventoryItems = [...nextProps.inventories];
        const tempVariable = [...nextProps.inventories];
        inventoryItems.map((item) => {
          const check = _.findIndex(this.state.rows, { ProductNum: item.ProductNum.ProductNum });
          if (check !== -1) {
            item.inList = true;
          }
          item.PriceLv1 = item.ProductNum__PriceLv1;
          item.PriceLv2 = item.ProductNum__PriceLv2;
          item.PriceLv3 = item.ProductNum__PriceLv3;
          item.PriceLv4 = item.ProductNum__PriceLv4;
          item.PriceLv5 = item.ProductNum__PriceLv5;
          item.Ordered = item.Purchased;
        });
        const inventories = { ...this.state.inventories, allRows: inventoryItems, rows: tempVariable };
        this.setState({ inventories });
      }

      if (nextProps.inventoryIdValue && nextProps.inventoryIdValue !== this.props.inventoryIdValue) {
        const filteredRows = this.state.inventories.allRows.filter((obj) => {
          const match = String(obj.ProductNum).includes(String(nextProps.inventoryIdValue));
          return match;
        });
        const inventories = { ...this.state.inventories, rows: filteredRows };
        this.setState({ inventories });
        const index = _.findIndex(filteredRows, { ProductNum: nextProps.inventoryIdValue });
        if (index > -1) {
          this.setState({
            selectedItemName: filteredRows[index].Name,
            selectedItemNumber: nextProps.inventoryIdValue,
          });
        }
      }

      if (nextProps.customersWithFavorites && nextProps.customersWithFavorites !== this.props.customersWithFavorites) {
        this.setState({ customersWithFavorites: nextProps.customersWithFavorites });
      }
      if (nextProps.previousSOs && nextProps.previousSOs !== this.props.previousSOs) {
        let previousSOs;
        if (isOLG && nextProps.previousSOs || !isOLG && nextProps.previousSOs.Orders) {
          previousSOs = {
            ...this.state.previousSOs,
            rows: isOLG ? nextProps.previousSOs : nextProps.previousSOs.Orders,
            selectedIndexes: [],
            sortColumn: null,
            sortDirection: null,
          };
        } else {
          previousSOs = {
            ...this.state.previousSOs, rows: [], selectedIndexes: [], sortCol: null, sortDirection: null,
          };
        }
        this.setState({ previousSOs });
      }

      if (nextProps.previousOrders && nextProps.previousOrders !== this.props.previousOrders) {
        let previousOrders;
        if (isOLG ? nextProps.previousOrders.Sales_Invoice_Lines : nextProps.previousOrders.Sales_Order_Lines) {
          previousOrders = {
            ...this.state.previousOrders,
            rows: isOLG ? nextProps.previousOrders.Sales_Invoice_Lines : nextProps.previousOrders.Sales_Order_Lines,
            selectedIndexes: [],
            sortColumn: null,
            sortDirection: null,
          };
        } else if (nextProps.previousOrders) {
          // when select to show all product from all previous SOs
          previousOrders = {
            ...this.state.previousOrders,
            rows: nextProps.previousOrders,
            selectedIndexes: [],
            sortColumn: null,
            sortDirection: null,
          };
        } else {
          previousOrders = {
            ...this.state.previousOrders, rows: [], selectedIndexes: [], sortCol: null, sortDirection: null,
          };
        }
        this.setState({ previousOrders });
      }
      if (nextProps.salesOrderDetailByNum && nextProps.salesOrderDetailByNum !== this.props.salesOrderDetailByNum) {
        let previousOrders;
        if (nextProps.salesOrderDetailByNum.Sales_Order_Lines) {
          previousOrders = {
            ...this.state.previousOrders,
            rows: nextProps.salesOrderDetailByNum.Sales_Order_Lines,
            selectedIndexes: [],
            sortColumn: null,
            sortDirection: null,
          };
        } else {
          previousOrders = {
            ...this.state.previousOrders, rows: [], selectedIndexes: [], sortCol: null, sortDirection: null,
          };
        }
        this.setState({ previousOrders });
      }
      // if (nextProps.promotions && nextProps.promotions !== this.props.promotions) {
      //   const promotions = { ...this.state.promotions, rows: nextProps.promotions };
      //   this.setState({ promotions });
      // }

      if (nextProps.customerChosen && nextProps.customerChosen.value && nextProps.customerChosen !== this.props.customerChosen) {
        if (isLE) {
          const success = (routes) => { this.setState({ customerRoutes: routes }); }
          this.props.fetchRoutesByCustomer(nextProps.customerChosen.value, success);
        }
        this.props.setValue('salesOrderForm', 'IsWholeDoor', {label: 'Yes', value: true});
        this.props.fetchSalesCustomerDetail(nextProps.customerChosen.value, this.props.currentSalesOrder && this.props.currentSalesOrder.SalesOrder_id);
        if (!isDSQ && !isWIZ && !isFJ && !isJTB && !isABCFF) {
          if (isLAP || isGGI) {
            this.props.fetchCustomerFrequent(nextProps.customerChosen.value, this.props.Company_id, this.props.Pickup_Warehouse_id);
          } else {
            this.props.fetchCustomerFrequent(nextProps.customerChosen.value);
          }
        }
        let fjAgentTemp = [];
        if (isFJ) {
          this.props.fetchFJAgents(nextProps.customerChosen.value)
          .then(response => {
            if (response.data) {
              response.data.map(r => {
                fjAgentTemp.push({label: r.name, value: r.id});
              });
              this.state.FJAgentOptions = fjAgentTemp;
            }
          }, err => {
            if (err.status === 500 || err.status === 404) {
              alert('error fetching agents');
            }
          });
        }
        if (isLAP || isGGI) {
          this.props.fetchFavoriteList(nextProps.customerChosen.value, this.props.Company_id, this.props.Pickup_Warehouse_id);
        } else {
          this.props.fetchFavoriteList(nextProps.customerChosen.value);
        }
        this.setState({
          currentCustomer: nextProps.customerChosen.value,
          useDefaultCustomerAddress: true,
          salesOrderIndexFromLast: 1,
          currentCustomerName: nextProps.customerChosen.label,
          previousOrders: {
            rows: [],
            selectedRows: [],
            sortColumn: null,
            sortDirection: null,
            selectedIndexes: [],
          },
        }, () => this.fetchPreviousSalesOrderByCustomer(isOLG));
        // ReactDOM.findDOMNode(this.refs.productSearch.getRenderedComponent().myInput.refs.input).focus();
      }

      if (nextProps.customerPrices && nextProps.customerPrices !== this.props.customerPrices) {
        const rows = JSON.parse(JSON.stringify(this.state.inventories.allRows));
        const customerPrices = JSON.parse(JSON.stringify(nextProps.customerPrices));
        const mergedList = _.map(rows, (i) => {
          const newList = _.merge(i, _.find(customerPrices, { Product_id: i.Product_id }));
          return newList;
        });
        const inventories = { ...this.state.inventories, rows: mergedList, allRows: mergedList };
        this.setState({ inventories });
      }

      if (nextProps.Company_id && nextProps.Company_id !== this.props.Company_id) {
        let warehouseOptions = [];
        const id = nextProps.Company_id;
        this.props.fetchWarehousesByCompany(id)
          .then(response => {
            response.data.map((warehousse) => {
              warehouseOptions.push({
                label: warehousse.Name,
                value: warehousse.Warehouse_id,
                isDefault: warehousse.IsDefault,
                address: `${warehousse.street} ${warehousse.City} ${warehousse.State} ${warehousse.zipcode}`,
              });
            });
            // set default warehouse, of no default set to the first one
            let default_warehouse = localStorage.getItem('default_warehouse');
            if(isGGI && this.props.selectedWarehouse && this.props.selectedWarehouse.value && this.props.selectedWarehouse.value != 0) {
              default_warehouse = this.props.selectedWarehouse.value;
            }
            const userDefultWarehouse = warehouseOptions.filter(warehouse => warehouse.value == default_warehouse);
            const salesorderPickUpWarehouse = this.props.initialValues && this.props.initialValues.Pickup_Warehouse_id;
            const systemDefaultWarehouse = warehouseOptions.filter(warehouse => warehouse.isDefault);
            this.setState({ warehouseOptions }, () => {
              if (salesorderPickUpWarehouse) {
                this.props.setValue('salesOrderForm', 'Pickup_Warehouse_id', salesorderPickUpWarehouse);
              } else if (userDefultWarehouse.length){
                this.props.setValue('salesOrderForm', 'Pickup_Warehouse_id', userDefultWarehouse[0].value);
              } else {
                this.props.setValue('salesOrderForm', 'Pickup_Warehouse_id', systemDefaultWarehouse[0].value);
              }
            });
          },
          (err) => {
            if (err.status === 500 || err.status === 404) {
              alert('error fetching company names');
            }
          }
        );
        this.props.fetchTaxRates(null, id);
        if(isGGI) {
          this.props.fetchPackers(id)
        }
      }

      if (nextProps.previousOrderFromDate && nextProps.previousOrderToDate && (nextProps.previousOrderFromDate !== this.props.previousOrderFromDate || nextProps.previousOrderToDate !== this.props.previousOrderToDate)) {
        const dates = toFromDates(-1, nextProps.previousOrderFromDate, nextProps.previousOrderToDate);
        if (this.state.currentCustomer) {
          this.props.fetchPreviousOrders(this.state.currentCustomer, dates.fromDate, dates.toDate);
        }
      }

      if (nextProps.salesCustomerDetails && nextProps.salesCustomerDetails !== this.props.salesCustomerDetails) {
        if (isSV) {
          this.props.setValue('salesOrderForm', 'Sales_User_id', nextProps.salesCustomerDetails.SalesRep1);
          this.props.setValue('salesOrderForm', 'Sales_User_id2', nextProps.salesCustomerDetails.SalesRep2);
          this.setState({created_by: nextProps.salesCustomerDetails.SalesRep1, created_by2: nextProps.salesCustomerDetails.SalesRep2});
          this.props.setValue('salesOrderForm', 'Commission', nextProps.salesCustomerDetails.Commission1);
          this.props.setValue('salesOrderForm', 'Commission2', nextProps.salesCustomerDetails.Commission2);
        } else {
          if((isDAICHEONG || isOLG) && this.context.router.routes[1].path === 'salesOrders/new' || !(isDAICHEONG || isOLG)) {
            this.setState({
              created_by: nextProps.salesCustomerDetails.Sales_User_id,
              created_by2: nextProps.salesCustomerDetails.Sales_User_id2,
            })
          }
          if (isSUN || isGGI) {
            this.props.setValue('salesOrderForm', 'Sales_User_id', nextProps.salesCustomerDetails.Sales_User_id);
          }
        }

        // this.setState({resellerTemp: nextProps.salesCustomerDetails.Reseller});
        if (isEcity && nextProps.salesCustomerDetails.open_orders) {
          if (nextProps.salesCustomerDetails.open_orders.length > 0 && this.context.router.routes[1].path === 'salesOrders/new') {
            // if it is ecity and has open orders -> popup show orders and can edit
            this.setState({ openOrderOpen : true })
          }
        }
        if(isGGI) {
          this.props.setValue('salesOrderForm', 'CustomerID', nextProps.salesCustomerDetails.CustomerID);
        }

        // for smilinghome, check if customer is reseller and set tax rate to null
        if (isSH) {
          if (nextProps.salesCustomerDetails.Reseller === null) {
            this.props.fetchTaxRates(null, this.props.selectedCompany ? this.props.selectedCompany.value : '')
             .then(() => {
               const taxRateOptions = this.getTaxRateOptions();
               if (taxRateOptions.length > 0 && this.context.router.routes[1].path === 'salesOrders/new') {
                 this.handleTaxValueChange({
                   value: taxRateOptions[0].value,
                   label: taxRateOptions[0].label,
                   index: 0
                 })
               }
            })
          } else {
            this.handleTaxValueChange(null);
          }
        }
        const details = { ...nextProps.salesCustomerDetails };
        if (details.Amount00_30 == null) details.Amount00_30 = 0;
        if (details.Amount61_90 == null) details.Amount61_90 = 0;
        if (details.Amount31_60 == null) details.Amount31_60 = 0;
        if (details.Amount91 == null) details.Amount91 = 0;

        // Set to the default shipping
        // this cause issue to set to default when there is other for current order
        if (nextProps.salesCustomerDetails.Shipping) {
          const fieldName = (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'outboundOrders/new') ? 'CustomerDetail_id' : 'Deliver_CustomerDetail_id';
          let defaultFound = false;
          nextProps.salesCustomerDetails.Shipping.map((ShippingInfo) => {
            if (ShippingInfo.IsDefault) {
              defaultFound = true;
              if (isHMM) {
                this.props.setValue('salesOrderForm', fieldName, null);
              } else {
                if(!(isDAICHEONG || isOLG || isSV) || ((isDAICHEONG || isOLG || isSV) && fieldName != 'Deliver_CustomerDetail_id')) {
                  this.props.setValue('salesOrderForm', fieldName, ShippingInfo.CustomerDetail_id);
                }
              }
            }
            if (ShippingInfo.IsDefault && this.props.params) {
              if (isHMM) {
                this.props.setValue('salesOrderForm', fieldName, null);
              } else {
                if(!(isDAICHEONG || isOLG || isSV) || ((isDAICHEONG || isOLG || isSV) && fieldName != 'Deliver_CustomerDetail_id')) {
                  this.props.setValue('salesOrderForm', fieldName, ShippingInfo.CustomerDetail_id);
                }
              }
            }
          });

          if (defaultFound === false) {
            if(!(isDAICHEONG || isOLG) || ((isDAICHEONG || isOLG) && fieldName != 'Deliver_CustomerDetail_id')) {
              this.props.setValue('salesOrderForm', fieldName, null);
            }
          }
        }

        this.props.setCredit(nextProps.salesCustomerDetails.CreditStatus);
        this.setState({
          Amount00_30: details.Amount00_30,
          Amount31_60: details.Amount31_60,
          Amount61_90: details.Amount61_90,
          Amount91: details.Amount91,
          customerPaymentTerm: nextProps.salesCustomerDetails.PaymentTerm,
          customerPriceLevel: nextProps.salesCustomerDetails.PriceLevel,
          PaymentTermDesc: nextProps.salesCustomerDetails.PaymentTermDesc,
          CreditLimit: nextProps.salesCustomerDetails.CreditLimit,
        });
        this.props.setValue('salesOrderForm', 'PaymentTerm_id', nextProps.salesCustomerDetails.PaymentTermId);
      }

      if(isGGI && nextProps.smallUnitPrice && nextProps.smallUnitPrice != this.props.smallUnitPrice) {
        this.props.setValue('salesOrderForm', 'UnitPrice', nextProps.smallUnitPrice * this.state.selectedInventoryRow.ConvertNum);
      }

      let total_weight = parseFloat(nextProps.quantityValue || 0) * parseFloat(this.state.selectedInventoryRow.NetWeight || 0);
      // if statement for instances where there is text in the quantity field from user input
      if (Number.isNaN(total_weight)) {
        total_weight = 0.00
      }
      total_weight = total_weight.toFixed(2);
      this.setState({ total_weight });

      if (nextProps.unitPrice && nextProps.unitPrice !== this.props.unitPrice) {
        // let subtotal = parseFloat(nextProps.unitPrice) * parseFloat(this.props.quantityValue);
        // this.props.setSubtotal(subtotal);
      }

      if (nextProps.customerFrequent && nextProps.customerFrequent !== this.props.customerFrequent) {
        let frequentItems = {};
        if (isWIZ || isDSQ || isFJ || isJTB || isABCFF) {
          frequentItems = { ...this.state.frequentItems, rows: nextProps.customerFrequent.record };
        } else {
          frequentItems = { ...this.state.frequentItems, rows: nextProps.customerFrequent.Frequents };
        }
        this.setState({ frequentItems });
      }

      if (nextProps.customerSalesHistory && nextProps.customerSalesHistory !== this.props.customerSalesHistory) {
        const salesHistory = { ...this.state.salesHistory, rows: nextProps.customerSalesHistory };
        this.setState({ salesHistory });
      }
      if ((isOLG || isGGI || isDAICHEONG) && nextProps.salesItemHistory && nextProps.salesItemHistory !== this.props.salesItemHistory) {
        const salesItemHistories = { ...this.state.salesItemHistories, rows: nextProps.salesItemHistory };
        this.setState({ salesItemHistories });
      }

      if (!nextProps.discount) {
        this.props.setValue('salesOrderForm', 'Discount', 0);
      }

      if ((nextProps.discount && nextProps.discount !== this.props.discount) || nextProps.discount === '') {
        let discount = nextProps.discount;
        if (discount.toString().indexOf('-') !== -1) {
          discount = discount.replace(/-/g, '');
        }
        this.setState({ discount });
        // this.props.setValue('salesOrderForm', 'Discount', discount);
        if (discount === '') {
          this.props.setValue('salesOrderForm', 'Discount', 0);
          this.handleDiscountChange(0);
        } else {
          this.handleDiscountChange(discount);
          if (parseFloat(nextProps.discount) > 100 || isNaN(nextProps.discount)) {
            this.setState({ discount: Math.abs(this.props.discount) });
            this.props.setValue('salesOrderForm', 'Discount', this.props.discount);
          }
        }
      }

      if (nextProps.favoriteList && nextProps.favoriteList !== this.props.favoriteList) {
        if (nextProps.favoriteList.Sales_FavoriteList_Lines) {
          const rows = [...nextProps.favoriteList.Sales_FavoriteList_Lines];
          const favorites = { ...this.state.favorites, rows };
          this.setState({ favorites });
        }
      }

      if (nextProps.checkPermissionSuccess && nextProps.checkPermissionSuccess !== this.props.checkPermissionSuccess) {
        if (nextProps.checkPermissionSuccess.manager) {
          this.closeEditSOPermission();
          this.setState({ editSOPermission: true });
        }
      }

      if (nextProps.salesOrderProduct && nextProps.salesOrderProduct !== this.props.salesOrderProduct) {
        if(isGGI || isVAK || isCTP) {
          this.props.setValue('salesOrderForm', 'SmallUnitPrice', nextProps.salesOrderProduct.SmallUnitPrice)
          this.setState({
            level1: nextProps.salesOrderProduct.PriceLv1 || 0,
            level2: nextProps.salesOrderProduct.PriceLv2 || 0,
            level3: nextProps.salesOrderProduct.PriceLv3 || 0,
            level4: nextProps.salesOrderProduct.PriceLv4 || 0,
            level5: nextProps.salesOrderProduct.PriceLv5 || 0,
            levelRefPrice: nextProps.salesOrderProduct.RefPrice || 0,
          })
        }
        this.selectInventoryInfo(nextProps.salesOrderProduct);
        let price = nextProps.salesOrderProduct.Price;
        const isInternal = this.props.salesShippingCustomerDetails ? this.props.salesShippingCustomerDetails.isInternal : false;
        if (isOCM && isInternal) {
          price = nextProps.salesOrderProduct.ArrivalPrice;
        }
        if (isGFD) {
          price = price * (nextProps.salesOrderProduct.ConvertNum ? nextProps.salesOrderProduct.ConvertNum : 1)
        }
        this.props.setSaleOrderProductValues(roundToDecimals(price, 4), 'salesOrderForm', nextProps.salesOrderProduct);
        if (isSV && nextProps.salesOrderProduct && nextProps.salesOrderProduct.MinOrderQty) {
            this.props.setValue('salesOrderForm', 'Quantity', nextProps.salesOrderProduct.MinOrderQty);
        }
        // ReactDOM.findDOMNode(this.refs['quantity'].getRenderedComponent().myInput.refs.input).focus();
      }

      if (nextProps.shipperChosen && nextProps.shipperChosen !== null && nextProps.shipperChosen !== this.props.shipperChosen) {
        const shipping_id = (typeof (nextProps.shipperChosen) === 'object') ? nextProps.shipperChosen.value : nextProps.shipperChosen;
        this.setState({ shipperChosen: shipping_id });

        if (isSV && this.props.salesCustomerDetails && this.props.salesCustomerDetails.Shipping) {
          this.props.salesCustomerDetails.Shipping.map((r,i) => {
            if (r.CustomerDetail_id === shipping_id) {
              this.props.setValue('salesOrderForm', 'ShipVia', r.ShipVia);
            }
          });
        }
        // this.props.setValue('salesOrderForm', 'CustomerDetail_id', shipping_id);
      }

      if (nextProps.shippingListPDF && nextProps.shippingListPDF !== this.props.shippingListPDF) {
        this.setState({ shippingPdfFrameLoaded: false });
      }

      if (nextProps.pickingListPDF && nextProps.pickingListPDF !== this.props.pickingListPDF) {
        this.setState({ pickingListPdfFrameLoaded: false });
      }

      if (nextProps.packingListPDF && nextProps.packingListPDF !== this.props.packingListPDF) {
        this.setState({ packingListPdfFrameLoaded: false });
      }

      if (nextProps.salesOrderPDF && nextProps.salesOrderPDF !== this.props.salesOrderPDF) {
        this.setState({ salesOrderPdfFrameLoaded: false });
      }

      if (nextProps.salesOrderSIPDF && nextProps.salesOrderSIPDF !== this.props.salesOrderSIPDF) {
        this.setState({ salesOrderSIPdfFrameLoaded: false });
      }

      if (nextProps.refundPDF && nextProps.refundPDF !== this.props.refundPDF) {
        this.setState({ refundPDFFrameLoaded: false });
      }

      if (nextProps.receivingCustomer && nextProps.receivingCustomer !== this.props.receivingCustomer) {
        this.setState({ useDefaultCustomerAddress: false });
        if (nextProps.receivingCustomer.value) {
          if (isLE) {
            const success = (routes) => { this.setState({ customerRoutes: routes }); }
            this.props.fetchRoutesByCustomer(nextProps.customerChosen.value, success);
          }
          this.props.fetchSalesCustomerDetail(nextProps.receivingCustomer.value);
        } else {
          if (isLE) {
            const success = (routes) => { this.setState({ customerRoutes: routes }); }
            this.props.fetchRoutesByCustomer(nextProps.customerChosen.value, success);
          }
          this.props.fetchSalesCustomerDetail(nextProps.receivingCustomer, null, true);
        }
      }

      if(nextProps.salesItemHistory) {
        this.setState({
          salesItemHistory: nextProps.salesItemHistory
        })
      }

      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.CreditAmount) {
        this.setState({
          creditAmount: Number(nextProps.currentSalesOrderDetail.CreditAmount)
        });
      }
      if (nextProps.currentSalesOrderDetail && nextProps.currentSalesOrderDetail.ShareCreditAmount) {
        this.setState({
          shareCreditAmount: Number(nextProps.currentSalesOrderDetail.ShareCreditAmount)
        });
      }

      if (isWIZ && (nextProps.BoxPerPallet || this.props.BoxPerPallet) && (nextProps.quantityValue || this.props.quantityValue)) {
        if (isNumeric(nextProps.quantityValue) && isNumeric(nextProps.BoxPerPallet)) {

          if ( !nextProps.PalletQuantity || (Math.ceil(Number(nextProps.quantityValue)/Number(nextProps.BoxPerPallet)) >= nextProps.PalletQuantity) ) {
            this.props.setValue('salesOrderForm', 'BillablePallets', Math.ceil(Number(nextProps.quantityValue)/Number(nextProps.BoxPerPallet)));
          } else {
            this.props.setValue('salesOrderForm', 'BillablePallets', nextProps.PalletQuantity);
          }
        }
      } else if (isWIZ && nextProps.PalletQuantity) {
        this.props.setValue('salesOrderForm', 'BillablePallets', nextProps.PalletQuantity);
      }
      if (isWIZ && !nextProps.BoxPerPallet && !nextProps.PalletQuantity) {
        this.props.setValue('salesOrderForm', 'BillablePallets', 0);
      } else if (isWIZ && !nextProps.BoxPerPallet && nextProps.PalletQuantity) {
        this.props.setValue('salesOrderForm', 'BillablePallets', nextProps.PalletQuantity);
      }

      if (this.props.shippingChosed_id !== nextProps.shippingChosed_id && nextProps.shippingChosed_id) {
        if (nextProps.salesShippingCustomerDetails && nextProps.salesShippingCustomerDetails.Shipping) {
          _.forEach(nextProps.salesShippingCustomerDetails.Shipping, shipping => {
            if (shipping.CustomerDetail_id === nextProps.shippingChosed_id) {
              this.props.setValue('salesOrderForm', 'Email', shipping.Email);
            }
          })
        }
      }

      if (isSV && (this.props.Deliver_CustomerDetail_id !== nextProps.Deliver_CustomerDetail_id) && nextProps.Deliver_CustomerDetail_id) {
        this.props.setValue('salesOrderForm', 'Deliver_CustomerDetail_id', nextProps.Deliver_CustomerDetail_id);
        const svtempid = (typeof (nextProps.Deliver_CustomerDetail_id) === 'object') ? nextProps.Deliver_CustomerDetail_id.value : nextProps.Deliver_CustomerDetail_id;
        if (!nextProps.ShipVia && this.props.salesCustomerDetails && this.props.salesCustomerDetails.Shipping) {
          this.props.salesCustomerDetails.Shipping.map((r,i) => {
            if (r.CustomerDetail_id === svtempid) {
              this.props.setValue('salesOrderForm', 'ShipVia', r.ShipVia);
            }
          });
        }
      }
      if (isVAK && (this.props.shipperChosen !== nextProps.shipperChosen && nextProps.shipperChosen)) {
          let taxRateOptions = [];
            if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Shipping) {
              this.props.salesCustomerDetails.Shipping.map((r, i) => {
                if (nextProps.shipperChosen === r.CustomerDetail_id || nextProps.shipperChosen.value === r.CustomerDetail_id) {
                  if (r.State === 'CA') {
                    this.props.fetchTaxRates(null, this.props.selectedCompany ? this.props.selectedCompany.value : '', r.Zip)
                    .then(() => {
                     taxRateOptions = this.getTaxRateOptions();
                    this.handleTaxValueChange({
                      value: taxRateOptions[0].value,
                      label: taxRateOptions[0].label,
                      index: 0
                    })
                  });
                  } else {
                    this.props.fetchTaxRates(null, this.props.selectedCompany ? this.props.selectedCompany.value : '')
                    .then(() => {
                     taxRateOptions = this.getTaxRateOptions();
                     this.handleTaxValueChange(null);
                    });
                  }
                }
              });
            }
      }
      if (isVAK && nextProps.IsSpare !== this.props.IsSpare) {
        if (nextProps.IsSpare === true) {
          this.props.setValue('salesOrderForm', 'UnitPrice', 0);
        }
      }
      if (isVAK && nextProps.currentProductRequests !== this.props.currentProductRequests) {
        const isChangeData = nextProps.activeIdx !== null && nextProps.activeIdx === this.props.activeIdx;
        if (isChangeData) {
          const newRows = this.state.rows;
          newRows[this.props.activeIdx].Specifications = nextProps.currentProductRequests;
          this.setState({
            rows: [...newRows]
          })
        }
      }
      if (isVAK && nextProps.currentProductImages !== this.props.currentProductImages) {
        const isChangeData = nextProps.activeIdx !== null && nextProps.activeIdx === this.props.activeIdx;
        if (isChangeData) {
          const newRows = this.state.rows;
          newRows[this.props.activeIdx].Technical_Image = nextProps.currentProductImages;
          this.setState({
            rows: [...newRows]
          })
        }
      }
      if (isVAK && nextProps.currentProductFiles !== this.props.currentProductFiles) {
        const isChangeData = nextProps.activeIdx !== null && nextProps.activeIdx === this.props.activeIdx;
        if (isChangeData) {
          const newRows = this.state.rows;
          newRows[this.props.activeIdx].Technical_Documents = nextProps.currentProductFiles;
          this.setState({
            rows: [...newRows]
          })
        }
      }
    }

    shouldComponentUpdate(nextProps, nextState) {
      if (nextState.shippingPdfFrameLoaded !== this.state.shippingPdfFrameLoaded && this.state.shippingPdfFrameLoaded == false) {
        return false;
      }
      if (nextState.pickingListPdfFrameLoaded !== this.state.pickingListPdfFrameLoaded && this.state.pickingListPdfFrameLoaded == false) {
        return false;
      }
      if (nextState.packingListPdfFrameLoaded !== this.state.packingListPdfFrameLoaded && this.state.packingListPdfFrameLoaded == false) {
        return false;
      }
      if (nextState.salesOrderPdfFrameLoaded !== this.state.salesOrderPdfFrameLoaded && this.state.salesOrderPdfFrameLoaded == false) {
        return false;
      }
      if (nextState.salesOrderSIPdfFrameLoaded !== this.state.salesOrderSIPdfFrameLoaded && this.state.salesOrderSIPdfFrameLoaded == false) {
        return false;
      }
      if (nextState.refundPDFFrameLoaded !== this.state.refundPDFFrameLoaded && this.state.refundPDFFrameLoaded == false) {
        return false;
      }

      return true;
    }

    // componentWillMount() {
    // }

    componentDidMount() {
      document.title = companyCodeTitle;
      if(!isOLG) {
        window.addEventListener('beforeunload', this.beforeunload.bind(this));
      }
      if (isMH) {
        this.setState({
          yourOrderTableHeight: 500
        });
        // this.props.setValue('salesOrderForm', 'IsWholeDoor', {label: 'Yes', value: true});
      }
      if(isSH) {
        this.props.fetchPackageTypes()
      }
    }

    unloadFunction() {
      let { salesOrders } = this.state;
      let salesOrderIds = [];
      let salesOrderIdsString = '';
      if (salesOrders && salesOrders.selectedRows.length >= 1) {
        salesOrders.selectedRows.map((row) => {
          salesOrderIds.push(row.SalesOrder_id);
        });
        salesOrderIdsString = salesOrderIds.join(',');
      }
      axios
      .post(
        `${ROOT_URL}v1/sale/test/${salesOrderIdsString}`,
        // formData,
        null,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              "token"
            )}`,
          },
        },
      )
      .then(
        (res) => {
          alert("Order CLOSED!");
        },
        (err) => {
          if (err.status === 500 || err.status === 404) {
            err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
          }
          alert(JSON.stringify(err.data));
        }
      );
    }

    checkPrevSODoneToday(value) {
      let getValue = value ? value.value : value
      axios({
        method: 'GET',
        url: `${SALES_ORDER_EXISTING_URL}/${getValue}`,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      })
        .then(res => {
          if(res.status === 200 && res.data.result.length > 0){
             this.setState({
              soExitList: {
                ...this.state.soExitList,
                rows: res.data.result,
              },
              SOExistingVisible: true,
            })
          }
        }, err => {
        })
    }

    beforeunload(e) {
      e.preventDefault();
      if (false) {
        this.unloadFunction();
      }
      e.returnValue = true;
    }

    componentDidUpdate(prevProps, prevState) {
      if (isOCM && prevProps.Company_id !== this.props.Company_id && this.props.Company_id) {
        this.props.fetchTruckCompanies(this.props.Company_id);
      }
      if (this.props.selectedCompany && (prevProps.selectedCompany !== this.props.selectedCompany)) {
        if (isEKC || isLMH || isSDR || isCRW || isSC || isSV) {
          this.props.fetchBaseUsers(false);
          return;
        }
        if (isOCM) {
          this.props.fetchPackers();
        }
      }
      if (!this.props.searchType) {
        // this.props.setDefaultSearchType('RefNum', 'salesOrderForm');
        this.props.initializeSalesOrderForm(this.searchType, 'salesOrderForm');
      }
      if (this.refs.customer_name && this.state.firstFocus) {
        // this.refs.customer_name.getRenderedComponent().refs.select.focus();
        // this.setState({ firstFocus: false });
      }
      if (prevProps.selectedCompany !== this.props.selectedCompany) {
        this.resetForm();
      }

      if (isSV || isEKC || isLMH || isSDR || isCRW || isSC) {
        if (prevProps.svLoading !== this.props.svLoading && this.props.svLoading === false && this.state.addingChild === true) {
          // this.setState({addingChild: false});
          this.checkMoveToSo();
        }
      }

    }

    componentWillUnmount() {
      if(!isOLG) {
        window.removeEventListener('beforeunload', this.beforeunload.bind(this));
      }
      // this.props.clearInventories();
      document.removeEventListener('keydown', this.handleKeyDown.bind(this));
      this.props.finishUnmount();
      // this.props.clearSalesCustomerDetails();
    }

    resetForm = () => {
      this.props.resetReduxForm();
    }

    updateTimeformatDate(date) {
      let formattedDate = `${date.getFullYear()}-`;
      const month = date.getMonth() + 1;
      if (month < 10) {
        formattedDate += `0${month}-`;
      } else {
        formattedDate += `${month}-`;
      }
      if (date.getDate() < 10) {
        formattedDate += `0${date.getDate()}`;
      } else {
        formattedDate += date.getDate();
      }
      return formattedDate;
    }

    formatSimpleDate(date) {
      let formattedDate = '';
      if ((date.getMonth() + 1) < 10) {
        formattedDate += `0${(date.getMonth() + 1)}`;
      } else {
        formattedDate += (date.getMonth() + 1).toString();
      }
      if (date.getDate() < 10) {
        formattedDate += `0${date.getDate()}`;
      } else {
        formattedDate += (date.getDate()).toString();
      }
      formattedDate += (date.getFullYear()).toString();
      return formattedDate;
    }
    routerWillLeave() {
      if (this.state.dirty) return <Translate value="work_not_saved_warning" />;
    }
    printForm() {
      this.props.fetchSalesOrderForm();
    }
    refreshPage(event) {
      if (event) {
        event.preventDefault();
      }
      // const currentSalesOrder = this.props.salesOrderCreated || this.props.currentSalesOrder;
      const currentSalesOrder = this.props.currentSalesOrder || this.props.salesOrderCreated;
      this.closeShowSOCreated();
      if (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
        this.props.fetchInboundProducts();
      }
      this.props.selectSalesOrder(currentSalesOrder);
      if (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id') {
        this.context.router.push(`/salesOrders/${currentSalesOrder.SalesOrder_id}`);
      } else if (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
        this.context.router.push(`/outboundOrders/${currentSalesOrder.SalesOrder_id}`);
      } else if (this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id') {
        this.context.router.push(`/mobileSalesOrders/${currentSalesOrder.SalesOrder_id}`);
      }
    }

    selectInventoryInfo(selectedInventoryRow, callback = () => {}) {
      this.setState({
        selectedInventoryRow,
        InStockCompany: selectedInventoryRow.InStockCompany,
        InStockMain: selectedInventoryRow.InStockMain,
        OrigUnitPrice: selectedInventoryRow.RefPrice,
        InStock: selectedInventoryRow.InStock,
        inStockOnhand: isGGI ? selectedInventoryRow.Onhand : selectedInventoryRow.InStockOnhand,
        purchased: selectedInventoryRow.Purchased,
        presale: selectedInventoryRow.PreSale,
        net_weight: selectedInventoryRow.NetWeight,
        ship_weight: selectedInventoryRow.NetWeight,
        product_type: selectedInventoryRow.ProductType,
        RefPrice: selectedInventoryRow.RefPrice, //ctn
        LowestSalePrice: selectedInventoryRow.LowestSalePrice,
        PriceLv1: selectedInventoryRow.PriceLv1,
        PriceLv2: selectedInventoryRow.PriceLv2,
        PriceLv3: selectedInventoryRow.PriceLv3,
        PriceLv4: selectedInventoryRow.PriceLv4,
        PriceLv5: selectedInventoryRow.PriceLv5,
      }, callback);
    }

    clearInventoryInfo = () => {
      this.setState({
        selectedInventoryRow: {},
        inStock: '',
        inStockWarehouse: '',
        inStockOnhand: '',
        purchased: '',
        presale: '',
        net_weight: '',
        ship_weight: '',
        product_type: '',
      });
    }

    // Helper function to pop up the add payment term function
    openCustomer() { this.setState({ customerOpen: true }); }
    closeCustomer() { this.setState({ customerOpen: false }); }
    openHistory() {
      this.props.fetchCustomerSalesHistory(this.state.currentCustomer);
      this.setState({ historyOpen: true });
    }

    handleCreateClick = () => {
      this.setState({
        createModalVisibility: true
      })
    }
    openSalesHistory() {
      if(!this.props.salesItemHistory || !this.state.salesItemHistories
        || !this.state.salesItemHistories.rows || this.state.salesItemHistories.rows.length == 0) {
        return
      }
      this.setState({ salesHistoryOpen: true });
    }
    setPromotionsModalVisibility = (isPromotionsModalVisible = false) => this.setState({ isPromotionsModalVisible });
    setApplyPromotionsModalVisibility = (isApplyPromotionsModalVisible = false) => {
      this.setState({ isApplyPromotionsModalVisible })
    };

    closeHistory() { this.setState({ historyOpen: false }); }
    closeSalesHistory() { this.setState({ salesHistoryOpen: false }); }
    openConfirm() { this.setState({ confirmOpen: true }); }
    openShowSOCreated() { this.setState({ showSOCreatedOpen: true }); }
    closeShowSOCreated = () => { this.setState({ showSOCreatedOpen: false }); }
    openEditSOPermission() {
      this.setState({ case: 'editSOPermission', editSOPermissionOpen: true });
    }
    closeEditSOPermission() {
      this.setState({ editSOPermissionOpen: false });
    }
    openConfirmRefund(props) {
      this.setState({ case: 'confirmRefund', confirmRefundOpen: true, ...props });
    }
    closeConfirmRefund() {
      this.setState({ confirmRefundOpen: false });
    }
    openVerifyPasscode = () => {
      this.setState({ verifyPasscodeOpen: true });
    }
    closeVerifyPasscode = () => {
      this.setState({ verifyPasscodeOpen: false });
    }
    openVerifyPasscodeDiscount = () => {
      this.setState({ verifyPasscodeOpenDiscount: true });
    }
    closeVerifyPasscodeDiscount = () => {
      this.setState({ verifyPasscodeOpenDiscount: false });
    }
    openDeliveryMethodModal() {
      this.setState({ deliveryMethodModalOpen: true });
    }
    closeDeliveryMethodModal() {
      this.setState({ deliveryMethodModalOpen: false });
    }
    openCarrierInfoModal() {
      this.setState({ carrierInfoModalOpen: true });
    }
    closeCarrierInfoModal() {
      this.setState({ carrierInfoModalOpen: false });
    }
    openShippingInfoEditModal = () => {
      this.setState({ shippingInfoEditModalVisibility: true });
    }
    closeShippingInfoEditModal = () => {
      this.setState({ shippingInfoEditModalVisibility: false });
    }

    openCustomerEditModal = () => {
      this.setState({ customerEditModalVisibility: true });
    }
    closeCustomerEditModal = () => {
      this.setState({ customerEditModalVisibility: false });
    }

    openCustomerNoteModal = () => {
      this.setState({ customerNoteModalVisibility: true });
    }
    closeCustomerNoteModal = () => {
      this.setState({ customerNoteModalVisibility: false });
    }

    openFBAEditModal = () => {
      this.setState({ fbaEditModalVisibility: true });
    }
    closeFBAEditModal = () => {
      this.setState({ fbaEditModalVisibility: false });
    }
    modalFetchFBA = () => {
      let fbaAdressTemp1 = [];
      let fbaAdressTemp2 = [];
        this.props.fetchFBAAddressOptions()
        .then(response => {
          if (response.data) {
            response.data.map(r => {
              fbaAdressTemp1.push({label: r.street+", "+r.city+", "+r.zipcode+", "+r.state, value: r.id});
              fbaAdressTemp2.push({label: r.name,  value: r.id});
            });
            this.setState({ FBAOptions: fbaAdressTemp1, FBAOptions2: fbaAdressTemp2 });
          }
        }, err => {
          if (err.status === 500 || err.status === 404) {
            alert('error fetching FBA address');
          }
        });
    }
    openDropship() {
      this.setState({ isDropshipOpen: true });
    }
    closeDropship() {
      this.setState({ isDropshipOpen: false });
    }

    openCreateBOLModal() {
      this.setState({ createBOLModalVisibility: true });
    }
    closeCreateBOLModal() {
      this.setState({ createBOLModalVisibility: false });
    }

    openShipping() {
      this.props.clearConvertingToInvoice();
      this.props.clearUpdateSalesInvoice();
      this.setState({ showShippingOpen: true });
    }
    closeShipping() {
      this.props.clearConvertingToInvoice();
      this.props.clearUpdateSalesInvoice();
      this.setState({ showShippingOpen: false });
      this.refreshPage();
    }

    closeSetWeight() {
      this.setState({setWeightOpen: false});
    }
    openSetWeight() {
      this.setState({setWeightOpen: true});
    }

    setShippingStatsEditModalVisibility = (shippingStatusEditModalVisible = false) => this.setState({ shippingStatusEditModalVisible })
    closeConfirm() {
      // this.props.resetFormInputs();
      this.setState({ case: null, confirmOpen: false, expAr:[], isMultiBatchVisible: false });
      // ReactDOM.findDOMNode(this.refs['quantity'].getRenderedComponent().myInput.refs.input).focus();
    }
    openChangeTax() {
      this.setState({ changeTaxOpen: true });
    }
    closeChangeTax() {
      this.setState({ changeTaxOpen: false });
    }

    openDiscountModal() {
      this.setState({ changeDiscountOpen: true });
    }
    closeDiscountModal() {
      this.setState({ changeDiscountOpen: false });
    }
    onDiscountSavingsConfirm = (discount, savings) => {
      const { totalTax, totalPrice, taxValue } = this.state;
      const rows = [...this.state.rows];

      let finalPriceTemp = 0;
      let tax = 0;

      if (isEKC || isLMH || isSDR || isCRW || isSC || isHMM || isSUN || isCPG || isVAK || isVIP) {
        if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
          tax = 0;
          finalPriceTemp = Number(this.state.totalPrice);
        } else if (isEKC || isLMH || isSDR || isCRW || isSC || isVAK) {
          if (discount) {
            tax = 0;
            rows.map((row, idxx) => {
              if (row.IsTaxable === true) {
                tax += ((parseFloat(row.TotalPrice) * (1 - ((discount ? discount : 0) / 100)))) * parseFloat(taxValue / 100);
              }
            });
          } else {
            tax = 0;
            rows.map((row, idxx) => {
              if (row.IsTaxable === true) {
                tax += (parseFloat(row.TotalPrice)) * parseFloat(taxValue / 100);
              }
            });
          }
          finalPriceTemp = (Number(this.state.totalPrice) - (Number(this.state.totalPrice)*(Number(discount ? discount : 0)/100))) - Number(savings ? savings : 0) + Number(tax);
        }
      } else {
        if (Number(discount) > 0) {
          tax = (totalTax-(totalTax*(Number(discount)/100)));
          finalPriceTemp = Number(this.state.totalPrice) - (Number(this.state.totalPrice)*(Number(discount)/100)) + tax;
        } else if (Number(discount) === 0 && Number(savings) > 0) {
          tax = totalTax;
          finalPriceTemp = Number(this.state.totalPrice) - Number(savings) + tax;
        } else {
          tax = totalTax;
          finalPriceTemp = Number(this.state.totalPrice) + Number(tax);
        }
      }
      if(this.state.ccOrigin) {
        finalPriceTemp = Number(finalPriceTemp) + roundTo(Number(finalPriceTemp * (this.state.ccOrigin || 0)), 2)
      }
      tax = roundTo(tax, 2).toFixed(2);
      finalPriceTemp = Number(finalPriceTemp).toFixed(2);

      this.setState({
        totalTax: tax,
        SODiscount: discount,
        SOSavings: savings,
        finalPriceWithPromotion: finalPriceTemp,
        changeDiscountOpen: false,
        discountModified: true,
      }, () => {
        if (isEKC || isLMH || isSDR || isCRW || isSC || isOLG || isVAK) { this.onConfirmPercentageFee(); }
      });
    }

    openEmployeeNote() {
      this.setState({ changeEmployeeNoteOpen: true });
    }
    closeEmployeeNote() {
      this.setState({ changeEmployeeNoteOpen: false });
    }
    onChangeEmployeeNote = (e) => {
      this.setState({ employeeNoteText: e.target.value });
    }
    onChangeNotation = (e) => {
      this.setState({ notationModalInfo: {...this.state.notationModalInfo, Remark: e.target.value} });
    }
    onSubmitEmployeeNote() {
      const currentSalesOrder = this.props.currentSalesOrder;
      if (!currentSalesOrder) {
        alert("Please create order first before editing Employee Note");
        return;
      }
      this.props.updateEmployeeNote(currentSalesOrder.SalesOrder_id, this.state.employeeNoteText).then((response) => {
        this.setState({ employeeNoteDisplay: this.state.employeeNoteText });
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          alert("Patch Employee Note Failed");
        }
      });
      this.setState({ changeEmployeeNoteOpen: false });
    }

    openDeliveryFee() {
      if (isGGI || isEKC || isLMH || isSDR || isCRW || isSC || isOLG || isSW || isVAK) {
        this.setState({ changeDeliveryFeeOpen: true, deliveryFeeEdit: this.state.delivery });
        return;
      }
      if (this.props.currentSalesOrder && (this.props.currentSalesOrder.SONum.charAt(0) !== 'M')) {
        this.setState({ changeDeliveryFeeOpen: true, deliveryFeeEdit: this.state.delivery });
      }
    }
    closeDeliveryFee() {
      this.setState({ changeDeliveryFeeOpen: false });
    }
    onChangeDeliveryFee = (e) => {
      e.preventDefault();
      this.setState({ deliveryFeeEdit: e.target.value });
    }
    onConfirmDeliveryFee() {
      this.setState({ delivery: Number(this.state.deliveryFeeEdit) },
      () => {
       if (isEKC || isLMH || isSDR || isCRW || isSC || isOLG || isVAK) { this.onConfirmPercentageFee(); }
     });
      this.closeDeliveryFee();
    }

    openTransFee() {
      if (isGGI || isEKC || isLMH || isSDR || isCRW || isSC || isOLG || isVAK) {
        this.setState({ changeTransFeeOpen: true, transFeeEdit: this.state.transFee });
        return;
      }
      if (this.props.currentSalesOrder && (this.props.currentSalesOrder.SONum.charAt(0) !== 'M')) {
        this.setState({ changeTransFeeOpen: true, transFeeEdit: this.state.transFee });
      }
    }
    closeTransFee() {
      this.setState({ changeTransFeeOpen: false });
    }
    onChangeTransFee = (e) => {
      e.preventDefault();
      this.setState({ transFeeEdit: e.target.value });
    }
    onConfirmTransFee() {
      this.setState({ transFee: Number(this.state.transFeeEdit) });
      this.closeTransFee();
    }

    openHandlingFee() {
      if (isGGI || isEKC || isLMH || isSDR || isCRW || isSC) {
        this.setState({ changeHandlingFeeOpen: true, handlingFeeEdit: this.state.handlingFee });
        return;
      }
      if (this.props.currentSalesOrder && (this.props.currentSalesOrder.SONum.charAt(0) !== 'M')) {
        this.setState({ changeHandlingFeeOpen: true, handlingFeeEdit: this.state.handlingFee });
      }
    }
    closeHandlingFee() {
      this.setState({ changeHandlingFeeOpen: false });
    }
    onChangeHandlingFee = (e) => {
      e.preventDefault();
      this.setState({ handlingFeeEdit: e.target.value });
    }
    onConfirmHandlingFee() {
      this.setState({ handlingFee: Number(this.state.handlingFeeEdit) },
      () => {
        if (isEKC || isLMH || isSDR || isCRW || isSC || isOLG || isVAK) { this.onConfirmPercentageFee(); }
      });
      this.closeHandlingFee();
    }

    openPercentageFee() {
      if (isGGI || isEKC || isLMH || isSDR || isCRW || isSC || isOLG || isVAK) {
        this.setState({ changePercentageFeeOpen: true, percentageFeeEdit: this.state.percentageFee });
        return;
      }
      if (this.props.currentSalesOrder && (this.props.currentSalesOrder.SONum.charAt(0) !== 'M')) {
        this.setState({ changePercentageFeeOpen: true, percentageFeeEdit: this.state.percentageFee });
      }
    }

    openCCFee() {
      if (this.props.currentSalesOrder && (this.props.currentSalesOrder.SONum.charAt(0) !== 'M')) {
        this.setState({ ccEdit: this.state.ccOrigin, changeCCOpen: true });
      }
    }
    closeCCFee() {
      this.setState({ changeCCOpen: false });
    }
    closePercentageFee() {
      this.setState({ changePercentageFeeOpen: false });
    }
    onChangePercentageFee = (e) => {
      e.preventDefault();
      this.setState({ percentageFeeEdit: e.target.value });
    }
    onConfirmPercentageFee() {
      if (isLMH || isSDR || isCRW || isSC) {
        // return;
      }
      const {
        totalPrice, totalTax, delivery, handlingFee, percentageFeeEdit,
        SODiscount, SOSavings
      } = this.state;

      let fee = 0;

      if (totalPrice && percentageFeeEdit) {
        if (isEKC || isLMH || isSDR || isCRW || isSC || isVAK || isOLG) {
          fee = (Number(totalPrice) + Number(totalTax) - (Number(totalPrice)* Number(SODiscount)/100) - Number(SOSavings)+Number(delivery)+Number(handlingFee)) * (Number(percentageFeeEdit)/100);
        } else {
          fee = Number(totalPrice) * (Number(percentageFeeEdit)/100);
        }
      }
      this.setState({ percentageFee: Number(percentageFeeEdit), transFee: fee });
      this.closePercentageFee();
    }

    onConfirmCcFee() {
      var checkedRadio = document.querySelector('input[name="ccFee"]:checked');
      if (checkedRadio) {
        const {
          totalPrice, totalTax, delivery,
          SODiscount, SOSavings
        } = this.state;
        let finalPriceTemp = 0;
        let tax = 0;
        let ccFee = 0;
        let finalPrice = 0;
        if(SODiscount > 0) {
          tax = (totalTax-(totalTax*(Number(SODiscount)/100)));
          finalPrice = Number(totalPrice) - (Number(totalPrice)*(Number(SODiscount)/100)) + tax + Number(delivery);
          ccFee = (finalPrice * Number(checkedRadio.value)).toFixed(2);
          finalPriceTemp = finalPrice + ccFee;
        } else {
          finalPrice = Number(totalPrice) - Number(SOSavings) + Number(totalTax) + Number(delivery);
          ccFee = (finalPrice * Number(checkedRadio.value)).toFixed(2);
          finalPriceTemp = finalPrice + ccFee;
        }
        this.setState({
          finalPriceWithPromotion: finalPriceTemp,
          ccFee,
          ccOrigin: checkedRadio.value,
          ccEdit: checkedRadio.value,
          changeCCOpen: false
        });
      }
    }

    openChangeWeight() {
      this.setState({ changeWeightOpen: true });
    }
    closeChangeWeight() {
      this.setState({ changeWeightOpen: false });
    }
    onChangeWeightSubmit() {
      if (this.state.finalShippingWeight < 0 || !this.state.finalShippingWeight) {
        alert('Invalid Weight Value!');
        return;
      }
      const currentSalesOrder = this.props.currentSalesOrder;
      this.props.currentSalesOrder.FinalShippingWeight = this.state.finalShippingWeight;
      this.props.updateShippingWeight(currentSalesOrder.SalesOrder_id, this.state.finalShippingWeight);
      this.setState({ changeWeightOpen: false });
    }
    onShippingWeightChange = (e) => {
      this.state.finalShippingWeight = e.target.value;
    }
    openShowInventory(event) {
      if (!this.props.searchValue || this.props.searchValue === '') {
        return;
      }
      switch (event.charCode) {
        case 13: // ENTER
          event.preventDefault();
          if (this.props.customerChosen) {
            this.setState({ showInventoryOpen: true });
            break;
          } else {
            this.setState({ case: 'noCustomerChosen', confirmOpen: true });
            break;
          }
        default:
          break;
      }
    }
    closeShowInventory(value) {
      this.handleAfterShowInventoryClose(value);
      this.setState({ showInventoryOpen: false });
    }

    keepLoaded = (oldLoaded) => {
    }
    handleKeyDown(event) {
      switch (event.keyCode) {
        case 27:
          this.closeShowInventory('productSearch');
          break;
        default:
          break;
      }
    }

    handleFocusAutoSuggest() {
      const autoSuggestField = document.getElementById('sales-auto-suggest');
      autoSuggestField.focus();
      autoSuggestField.select();
    }

    handleDiscountChange(nextDiscount) {
      const totalPrice = parseFloat(this.state.totalPrice) || 0;
      const discount = parseFloat(nextDiscount) || 0;
      const totalTax = parseFloat(this.state.totalTax) || 0;
      const totalCRV = parseFloat(this.state.totalCRV) || 0;
      let finalPrice = (totalPrice * (1 - (discount / 100))) + totalTax + totalCRV;
      if(isSH && this.state.ccOrigin) {
        let cFee = Number(finalPrice * this.state.ccOrigin).toFixed(2);
        finalPrice = Number(finalPrice) + parseFloat(cFee);
      }
      finalPrice = +roundTo(finalPrice, 2).toFixed(2);
      this.setState({ discount, finalPrice });
    }
    handleAfterShowInventoryClose(value) {
      ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
    }
    handleUnitPriceChange(event) {
      this.setState({ refPrice: event.target.value });
    }
    showShippingInfoConfirmModal = () => {
      this.setState({
        shippingInfoConfirmModalVisibility: true,
      })
    }
    closeShippinggInfoConfirmModal = () => {
      this.setState({
        shippingInfoConfirmModalVisibility: false,
      })
    }
    handleHMMFormSubmit = (formProps) => {
      this.showShippingInfoConfirmModal();
    }

    checkConvertProduct = () => {
      const {
        ProductNum,
        Product_id,
        PackageSize_1,
        InStockOnhand,
        IsOverSaleable,
      } = this.state.selectedInventoryRow
      const {
        currentSalesOrderDetail,
      } = this.props;
      //检查是否是小货
      const isSmallPC = ProductNum.slice(-1) === '1';
      const data = this.generateBatchRelatedInfo(ProductNum);
      const {
        batches,
        totalNeededQty,
      } = data;
      if (isSmallPC && ((totalNeededQty > InStockOnhand) || IsOverSaleable)) {
        const success = () => {
          this.props.fetchBachesByID(Product_id, this.props.Company_id, this.props.Pickup_Warehouse_id, () => {
            if (!isABCFF && !isSH && !isCCW) {
              this.setMultiBatchModalVisibility(true);
            }
          })
        }
        this.props.convertProduct(Product_id, totalNeededQty, this.props.Pickup_Warehouse_id, success)
      } else {
        if (!isABCFF && !isSH && !isCCW) {
          this.setMultiBatchModalVisibility(true);
        }
      }
    }

    returnTotalWeight(totalWeight, weights) {
    }

    setWeights = (currentRow, currentWeights, editedRow) => {
      let rows =  [...this.state.rows];
      let sumWeight = 0;
      let totalPrice = 0;
      let finalWeight = 0;
      let finalPrice = 0;
      let totalTax = 0;
      let totalCRV = 0;
      let weights = [];
      currentWeights.map((item)=>{
        let t = Number(parseFloat(item.Weight).toFixed(2));
        sumWeight += t;
        weights.push(t);
      })
      rows[currentRow].TotalNetWeight = parseFloat(sumWeight).toFixed(2);
      rows[currentRow].Weights = weights;
      rows[currentRow].Quantity = currentWeights.length;
      rows[currentRow].TotalPrice = +roundToDecimals(parseFloat(rows[currentRow].UnitPrice * rows[currentRow].TotalNetWeight), 4).toFixed(4);
      rows.map((row) => {
        totalPrice += parseFloat(row.TotalPrice);
        if(row.ProductType == 'Non-Fixed') {
          finalWeight += parseFloat(row.TotalNetWeight);
        } else {
          finalWeight += parseFloat(row.NetWeight * row.Quantity);
        }
        if (row.IsTaxable === true || row.IsTaxable === 'True') {
          totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
        }
        if (row.CRV) {
          if (this.props.salesShippingCustomerDetails && this.props.salesShippingCustomerDetails.HasCRV) {
            row.TotalCRV = +roundTo(parseFloat(row.CRV * row.Quantity), 2).toFixed(2)
          } else {
            row.TotalCRV = +roundTo(parseFloat(row.CRV * row.Quantity), 2).toFixed(2)
          }
        }
        if (row.TotalCRV) { totalCRV += row.TotalCRV; }
      });
      const discount = parseFloat(this.props.discount) || 0;
      const { SODiscount, SOSavings } = this.state; // only one has value
      totalTax = +roundTo(totalTax, 2).toFixed(2);
      finalPrice = parseFloat(totalPrice) * (1 - discount / 100) + parseFloat(totalTax) + parseFloat(totalCRV);
      finalWeight = +roundTo(finalWeight, 2).toFixed(2);
      totalPrice = +roundToDecimals(totalPrice, 4).toFixed(4);
      if(isSH && this.state.ccOrigin) {
        finalPrice = Number(finalPrice) + Number(finalPrice * (this.state.ccOrigin || 0)).toFixed(2)
      }
      finalPrice = +roundTo(finalPrice, 2).toFixed(2);
      this.setState({
        rows, totalPrice, finalWeight, finalPrice, totalTax, totalCRV,
      }, () => {
        const productId = this.state.rows[currentRow].Product_id;
        const productNum = this.state.rows[currentRow].ProductNum;
        if (!rows[currentRow].IsGift && !isLMH && !isSDR && !isCRW && !isSC) {
          this.props.fetchProductPromotion(productId, this.props.selectedCompany.value, null, () => this.checkForPromotions(productNum));
        }
        this.onConfirmPercentageFee();
      });
    }

    generateBatchRelatedInfo = (ProductNum) => {
      //Found products that are same as selectedInventoryRow on table
      const currentMatchingRows = this.state.rows.filter(row => row.ProductNum === ProductNum);

      // batch id and quantity pairs
      const currentMatchingRowsObject = _.reduce(currentMatchingRows, (acc, cur) => {
        let batchId = cur.Batch_id || cur.Batch_id_id;
        if (acc[batchId]) {
          acc[batchId] += parseInt(cur.Quantity);
        } else {
          acc[batchId] = parseInt(cur.Quantity);
        }
        return acc;
      }, {});
      // remove presales
      if (this.props.currentSalesOrderDetail && this.props.currentSalesOrderDetail.Sales_Order_Lines) {
        _.forEach(this.props.currentSalesOrderDetail.Sales_Order_Lines, line => {
          if (line.SalesOrderLine_id) {
            if (currentMatchingRowsObject[line.Batch_id_id]) {
              //originQty
              currentMatchingRowsObject[line.Batch_id_id] = currentMatchingRowsObject[line.Batch_id_id] - line.originQty;
            }
          }
        });
      };

      // remove negative quantity batches
      const validBatches = this.props.batchesInfo.batches.filter(batch => (batch.quantity > 0 || batch.is_initial_batch));

      // remove quantities that are newly added from batch
      const batches = _.map(validBatches, batch => {
        if (currentMatchingRowsObject[batch.id]) {
          return {
            ...batch,
            quantity: batch.quantity - currentMatchingRowsObject[batch.id]
          }
        }
        return batch
      });

      //check if product needs more convert GGI
      let totalNewAddedQty = _.reduce(currentMatchingRowsObject, (result, value, key) => {
        return result += parseInt(value);
      }, 0);

      let totalNeededQty = parseInt(this.props.quantityValue) + totalNewAddedQty;

      return {batches, totalNeededQty, currentMatchingRowsObject};
    }

    calculateLineMaxQty = (line, index) => {
      const {
        currentMatchingRowsObject, //new added quantity
      } = this.generateBatchRelatedInfo(line.ProductNum);
      const batchId = line.Batch_id || line.Batch_id_id;
      const batch = this.props.batchesInfo.batches.filter(batch => {
        return batch.id === batchId
      })[0];
      
      if (!batch) {
        return false;
      }
      const batchMaxQty = batch.quantity;
      const batchAvaliableQty = batchMaxQty - (currentMatchingRowsObject[batchId] || 0);
      return batchAvaliableQty;
    }

    setBatchesModalVisibility = (isBatchesModalVisible = false) => this.setState({ isBatchesModalVisible });
    setMultiBatchModalVisibility = (isMultiBatchVisible = false) => {
      let {
        inventories, inventoryIdValue, quantityValue, favorites, weight,
        available, inPurchase, preSale, salePrice, refPurchasePrice, unitPrice, smallUnitPrice, description, notation, itemNotation,
      } = this.props;
      const selectedInventoryRow = { ...this.state.selectedInventoryRow };

      if (isMultiBatchVisible === true) {
        // lalahaha
        if(isGGI) {
          if (smallUnitPrice < selectedInventoryRow.LowestSalePrice && !(isEKC || isLMH || isSDR || isCRW || isSC)) {
            this.setState({ case: 'belowLowestSalePrice', confirmOpen: true });
            return;
          }
        } else {
          if ((isVAK && !this.props.IsSpare) && unitPrice < selectedInventoryRow.LowestSalePrice && !(isEKC || isLMH || isSDR || isCRW || isSC)) {
            this.setState({ case: 'belowLowestSalePrice', confirmOpen: true });
            return;
          }
        }
        // let instock = selectedInventoryRow.InStock;
        // if (isGGI) {
        //   instock += selectedInventoryRow.Purchased;
        // }
        // if (((instock - (isHMM ? 0 : selectedInventoryRow.PreSale)) > 0 && (this.state.ocmQty ? this.state.ocmQty : quantityValue) <= (instock-(isHMM ? 0 : selectedInventoryRow.PreSale))) || selectedInventoryRow.IsOverSaleable === true || isHMM || isAFG) {
        //   this.setState({ isMultiBatchVisible });
        // } else {
        //   this.setState({
        //     case: 'itemOutOfStock',
        //     confirmOpen: true,
        //     selectedInventoryRow: {},
        //     inStock: '',
        //     inStockWarehouse: '',
        //     inStockOnhand: '',
        //     purchased: '',
        //     presale: '',
        //     net_weight: '',
        //     suggestValue: '',
        //   });
        //   this.props.resetFormInputs();
        //   return;
        // }
        this.setState({ isMultiBatchVisible });
      } else {
        this.setState({ isMultiBatchVisible });
      }
    }
    setBatchesModal2Visibility = (isBatchesModal2Visible = false) => this.setState({ isBatchesModal2Visible });
    onSelectedBatch = (Batch_id, BatchExpiredDate, BatchLocation) => {
      this.setBatchesModalVisibility();
      this.handleFocusAutoSuggest();
      this.setState({
        Batch_id,
        BatchExpiredDate,
        BatchLocation,
      }, this.checkMoveToSo)
    }
    // onSelectedMultiBatch = (Batch_id, BatchExpiredDate, selectedInventoryRows) => {
    //   // this.setMultiBatchModalVisibility();
    //   // this.handleFocusAutoSuggest();
    //   // this.state.selectedInventoryRow
    //   this.state.selectedInventoryRows = selectedInventoryRows;
    //   this.setState({
    //     Batch_id,
    //     BatchExpiredDate,
    //   }, this.checkMoveToSo)
    // }
    onSelectedMultiBatch = () => {
      let { selectedBatches } = this.state;
      let checkPass = false;
      let time = 0;
      if (isGGI || isVAK || isTU) {
        if (this.state.currentEditingProduct) {
          const {rows} = this.state;
          const idx = rows.findIndex(row => row.Product_id === this.state.currentEditingProduct.Product_id);
          if (idx !== -1) {
            rows.splice(idx, 1)
            this.setState({
              rows: [...rows],
              currentEditingProduct: null,
            })
          }
        }
      }
      selectedBatches.map((r, index) => {
        if (r.quantity > 0) {
          setTimeout(() => {
            this.setState({
              Batch_id: r.batchId,
              BatchExpiredDate: r.expire_datetime,
              BatchLocation: r.location,
              ocmQty: r.quantity,
              swBarcode: r.barcode,
            }, this.checkMoveToSo2);
          }, time);
          time = time + 50;
          checkPass = true;
        }
      });
      setTimeout(() => {
        let ProductNum = this.state.selectedInventoryRow.ProductNum;
        this.checkForPromotions(ProductNum);
        this.setState({
          selectedInventoryRow: {},
          inStock: '',
          inStockWarehouse: '',
          inStockOnhand: '',
          purchased: '',
          presale: '',
          net_weight: '',
          ship_weight: '',
          total_weight: '',
          suggestValue: '',
        });
        this.setMultiBatchModalVisibility();
        this.props.resetFormInputs();
        this.setAllProductQuantity(1);
        this.handleFocusAutoSuggest();
      }, selectedBatches.length * 51);
    }
    onEditBatch = (rows) => {
      this.setState({rows});
      this.setBatchesModal2Visibility();
    }

    submitPromotionCheck = (formProps, isQuote, isTransferOrder = false) => {
      if(isGGI && !this.props.Picker_User_id) {
        alert('Please select a picker')
        return
      }
      if(isGGI && !this.props.ShipVia) {
        alert('Please select a Ship Via')
        return
      }
      const checkSOPromotionProducts = ({ promotions }) => {
        const lines = Data.Selectors.getRows(this.state);
        let promotionAppliedLines = [...lines];
        const byQuantityPromotions = promotions.filter(promotion => promotion.Method === "ByQuantity");
        const productIdQuantityPair = {};
        _.forEach(lines, (line) => {
          const lineQuantity = parseInt(line.Quantity);
          if (isNaN(lineQuantity)) {
            alert(`Index: ${line.Index}  quantity is not an integer`);
          }
          if (productIdQuantityPair[line.Product_id]) {
            productIdQuantityPair[line.Product_id] = productIdQuantityPair[line.Product_id] + lineQuantity
          } else {
            productIdQuantityPair[line.Product_id] = lineQuantity;
          }
        });
        let soPromotable;
        const appliedPromotionIdxs = [];
        for (const Product_id in productIdQuantityPair) {
          let promotionIndex = undefined;
          let currentFromQty = undefined;
          _.forEach(byQuantityPromotions, (promotion, index) => {
            if (promotion.Product_id == Product_id) {
              if (currentFromQty === undefined && productIdQuantityPair[Product_id] >= promotion.FromQty) {
                currentFromQty = promotion.FromQty;
                promotionIndex = index;
              } else {
                if (promotion.FromQty > currentFromQty && (promotion.FromQty <= productIdQuantityPair[Product_id])) {
                  currentFromQty = promotion.FromQty;
                  promotionIndex = index;
                }
              }
            }
          });
          if (promotionIndex !== undefined) {
            appliedPromotionIdxs.push(promotionIndex);
            promotionAppliedLines = _.map(promotionAppliedLines, line => {
              if (line.Product_id == Product_id) {
                const productPromotion = byQuantityPromotions[promotionIndex];
                let promotedUnitPrice, TotalPrice;
                if (productPromotion.IsPercent) {
                  promotedUnitPrice = parseFloat(line.UnitPrice * (100 - productPromotion.Off)/100).toFixed(2);
                } else {
                  promotedUnitPrice = parseFloat(line.UnitPrice - productPromotion.Off).toFixed(2);
                }
                if (line.ProductType === 'Fixed' || line.ProductType === 'Non-Product') {
                  TotalPrice = promotedUnitPrice * line.Quantity;
                } else {
                  TotalPrice = promotedUnitPrice * line.Quantity * line.NetWeight;
                }
                return {
                  ...line,
                  UnitPrice: promotedUnitPrice,
                  TotalPrice,
                }
              } else {
                return line
              }
            })
            soPromotable = true;
          }
        }
        const appliablePromotions = [...new Set(appliedPromotionIdxs)].map((promotionIndex) => {
          return byQuantityPromotions[promotionIndex];
        })
        if (soPromotable) {
          this.setState({
            formProps,
            isQuote,
            isTransferOrder,
            promotionAppliedLines,
            appliablePromotions,
          }, () => {
            this.setApplyPromotionsModalVisibility(true);
          })
        } else {
          this.handleFormSubmit(formProps, isQuote, isTransferOrder)
        }
      }
      const fetchPromotionsFailed = () => {
      }
      if (this.props.currentSalesOrderDetail) {
        this.handleFormSubmit(formProps, isQuote, isTransferOrder);
      } else {
        this.handleFormSubmitCreate(checkSOPromotionProducts, fetchPromotionsFailed);
      }
    }

    submitOverdueCheck = (data) => {
      let {overdueSaveModalVisibility} = this.state;
      this.setState({overdueSaveModalVisibility: true, overdueData: data});
    }

    handleFormSubmitCreate = _.debounce((checkSOPromotionProducts, fetchPromotionsFailed) => {
      fetchPromotions(this.props.selectedCompany.value, checkSOPromotionProducts, fetchPromotionsFailed)
    }, 500);

    olgCalculateQtyOfPromotedProduct = (productNum, temp) => {
      let productTotalQty = _.reduce(this.state.rows, (acc, current) => {
        if ((current.ProductNum === productNum) && (!current.IsGift)) {
          return acc + parseFloat(current.Quantity)
        }
        return acc
      }, 0);
      const qty = parseInt(productTotalQty / temp.FromQty);
      return (qty * temp.RelatedQuantity || 0)
    }

    applyAndSave = () => {
      if (isOCM) {
        const promotionDetail = this.state.appliablePromotions[0];
        let unitPrice = 0;
        if (promotionDetail.IsPercent) {
          unitPrice = parseFloat(this.state.selectedInventoryRow.Price * ((100 - promotionDetail.Off)/100)).toFixed(2);
        } else {
          unitPrice = parseFloat(this.state.selectedInventoryRow.Price - promotionDetail.Off).toFixed(2);
        }
        this.setState({
          selectedInventoryRow: {
            ...this.state.selectedInventoryRow,
            promotionApplied: true,
          }
        })
        this.props.setValue('salesOrderForm', 'UnitPrice', unitPrice);
        // here to skip batch
        if (!isABCFF && !isSH && !isCCW) {
          this.setMultiBatchModalVisibility(true);
        }
        this.setApplyPromotionsModalVisibility();
        return;
      }
      this.setState({
        rows: this.state.promotionAppliedLines,
      }, () => {
        this.handleFormSubmit(this.state.formProps, this.state.isQuote, this.state.isTransferOrder);
      })
    }

    applyAndSave2 = () => {
      const {
        productPromotions,
        promotionCheckProduct,
      } = this.props;
      const ByQuantityPromotion = _.filter(productPromotions, promotion => promotion.Method === 'ByQuantity')[0];
      let UnitPrice = 0;
      if (ByQuantityPromotion.IsPercent) {
        UnitPrice = parseFloat(this.props.productInfo.Price * ((100 - ByQuantityPromotion.Off)/100)).toFixed(2);
      } else {
        UnitPrice = parseFloat(this.props.productInfo.Price - ByQuantityPromotion.Off).toFixed(2);
      }
      const appliedPromotionRows = _.map(this.state.rows, row => {
        if (row.ProductNum === this.state.promotionCheckProduct && row.UnitPrice && row.UnitPrice !== '0') {
          return {
            ...row,
            UnitPrice: UnitPrice,
            promotionApplied: true,
            TotalPrice: parseFloat(UnitPrice * row.Quantity).toFixed(2),
          }
        }
        return {
          ...row,
          // promotionApplied: true,
        }
      });
      this.setState({
        rows: appliedPromotionRows,
      }, () => {
        this.calculateSODetails()
      });
      this.setApplyPromotionsModalVisibility2()
    }

    applyPromotionOLG = () => {
      let appliedPromotionRows = [];
      let ByQuantityPromotion = null;
      let ByQuantityABPromotion = null;
      this.state.applyPromotionList.map(item => {
        if(item.Method == 'ByQuantity') {
          ByQuantityPromotion = item;
        }
        if(item.Method == 'BuyAGetB') {
          ByQuantityABPromotion = item;
        }
      })
      let UnitPrice = 0;
      // 类型1 byquantity(discount)
      if(ByQuantityPromotion != null) {
        if (ByQuantityPromotion.IsPercent) {
          UnitPrice = parseFloat(this.props.productInfo.Price * ((100 - ByQuantityPromotion.Off)/100)).toFixed(2);
        } else {
          UnitPrice = parseFloat(this.props.productInfo.Price - ByQuantityPromotion.Off).toFixed(2);
        }
      }
      appliedPromotionRows = _.map(this.state.rows, row => {
        if (row.ProductNum === this.state.promotionCheckProduct && row.UnitPrice && row.UnitPrice != 0) {
          return {
            ...row,
            UnitPrice: ByQuantityPromotion != null ? UnitPrice:row.UnitPrice,
            promotionApplied: true,
            TotalPrice: parseFloat(ByQuantityPromotion != null ? UnitPrice:row.UnitPrice * row.Quantity).toFixed(2),
          }
        }
        return {
          ...row,
        }
      });

      // 类型2 byquantity(product)
      if(ByQuantityABPromotion != null) {
        if(ByQuantityABPromotion.IsPercent) {
          if(ByQuantityABPromotion.Off == 100) {
            const promotedProductonTable = this.state.rows.filter(row => ((row.ProductNum === ByQuantityABPromotion.RelatedProductNum) && (row.IsGift)));
            const promotedProductQty = this.olgCalculateQtyOfPromotedProduct(this.state.promotionCheckProduct, ByQuantityABPromotion);
            const that = this;
            if (!promotedProductonTable[0]) {
              const customer = this.state.currentCustomer.value || this.state.currentCustomer;
              const {Company_id, Pickup_Warehouse_id} = this.props;
              const success = (productDetails) => {
                const gift = {
                  ...productDetails,
                  Quantity: promotedProductQty,
                  UnitPrice: '0',
                  TotalPrice: '0',
                  IsGift: true,
                };
                appliedPromotionRows.push(gift)
                that.setState({
                  rows:appliedPromotionRows,
                }, () => {
                  that.calculateSODetails()
                  that.setApplyPromotionsModalVisibility3()
                });
              }
              this.props.fetchProductDetail(ByQuantityABPromotion.RelatedProduct_id, customer, Company_id, Pickup_Warehouse_id, success);
            } else {
              if(promotedProductQty == 0) {
                let cpRows = [];
                appliedPromotionRows.map((item) => {
                  if(item.ProductNum != ByQuantityABPromotion.RelatedProductNum) {
                    cpRows.push(item);
                  } else {
                    if(item.UnitPrice != 0) {
                      cpRows.push(item);
                    }
                  }
                })
                this.setState({
                  rows: cpRows,
                }, ()=> {
                  that.calculateSODetails()
                  that.setApplyPromotionsModalVisibility3()
                })
                return
              }
              if (promotedProductonTable[0].Quantity != promotedProductQty) {
                const rows = _.map(appliedPromotionRows, row => {
                  if ((row.ProductNum === ByQuantityABPromotion.RelatedProductNum) && (row.IsGift)){
                    return {
                      ...row,
                      Quantity: promotedProductQty,
                    }
                  }
                  return row;
                });
                this.setState({
                  rows,
                }, ()=> {
                  that.calculateSODetails()
                  that.setApplyPromotionsModalVisibility3()
                })
              }
            }

          } else {
            appliedPromotionRows = _.map(appliedPromotionRows, row => {
              if (row.ProductNum === this.state.promotionCheckProduct && row.UnitPrice && row.UnitPrice != 0) {
                let qty = parseInt(row.Quantity / ByQuantityABPromotion.FromQty);
                return {
                  ...row,
                  promotionApplied: true,
                  TotalPrice: parseFloat(row.UnitPrice * row.Quantity - qty * ByQuantityABPromotion.RelatedQuantity * row.UnitPrice * ByQuantityABPromotion.Off / 100).toFixed(2),
                }
                //total  = FromQty * price - RelatedQuantity *(price* off / 100)
              }
              return {
                ...row,
              }
            });
            this.setState({
              rows: appliedPromotionRows,
            }, () => {
              this.calculateSODetails()
            });
            this.setApplyPromotionsModalVisibility3()
          }
        } else { // $$
          appliedPromotionRows = _.map(appliedPromotionRows, row => {
            if (row.ProductNum === this.state.promotionCheckProduct && row.UnitPrice && row.UnitPrice != 0) {
              let qty = parseInt(row.Quantity / ByQuantityABPromotion.FromQty);
              return {
                ...row,
                promotionApplied: true,
                TotalPrice: parseFloat(row.UnitPrice * row.Quantity - qty * ByQuantityABPromotion.RelatedQuantity * ByQuantityABPromotion.Off).toFixed(2),
              }
              //total  = FromQty * price - RelatedQuantity* Off
            }
            return {
              ...row,
            }
          });
          this.setState({
            rows: appliedPromotionRows,
          }, () => {
            this.calculateSODetails()
          });
          this.setApplyPromotionsModalVisibility3()
        }

      } else {
        this.setState({
          rows: appliedPromotionRows,
        }, () => {
          this.calculateSODetails()
        });
        this.setApplyPromotionsModalVisibility3()
      }
    }

    applyAndSave2ggi = () => {
      const {
        productPromotions,
        promotionCheckProduct,
      } = this.props;
      const ByQuantityPromotion = _.filter(productPromotions, promotion => promotion.Method === 'ByQuantity')[0];
      const currentRow =  _.filter(this.state.rows, row => row.ProductNum === this.state.promotionCheckProduct)[0];

      let UnitPrice = 0;
      let SmallUnitPrice = 0;
      if (ByQuantityPromotion.IsPercent) {
        SmallUnitPrice = parseFloat(currentRow.SmallUnitPrice * ((100 - ByQuantityPromotion.Off)/100)).toFixed(2);
        UnitPrice = parseFloat(currentRow.UnitPrice * ((100 - ByQuantityPromotion.Off)/100)).toFixed(2);
      } else {
        SmallUnitPrice = parseFloat(currentRow.SmallUnitPrice - ByQuantityPromotion.Off).toFixed(2);
        UnitPrice = parseFloat(currentRow.UnitPrice - ByQuantityPromotion.Off).toFixed(2);
      }
      const appliedPromotionRows = _.map(this.state.rows, row => {
        if (row.ProductNum === this.state.promotionCheckProduct && row.UnitPrice && row.UnitPrice !== '0') {
          return {
            ...row,
            SmallUnitPrice: SmallUnitPrice,
            UnitPrice: UnitPrice,
            promotionApplied: true,
            TotalPrice: parseFloat(UnitPrice * row.Quantity).toFixed(2),
            // promoApplied: true,
          }
        }
        return {
          ...row,
          // promotionApplied: true,
        }
      });
      this.setState({
        rows: appliedPromotionRows,
      }, () => {
        this.calculateSODetails()
      });
      this.setApplyPromotionsModalVisibility2()
    }

    applyAndSave2lmh = () => {
      const {
        productPromotions,
        promotionCheckProduct,
      } = this.props;
      const ByQuantityPromotion = _.filter(productPromotions, promotion => promotion.Method === 'ByQuantity')[0];
      const currentRow =  _.filter(this.state.rows, row => row.ProductNum === this.state.promotionCheckProduct)[0];

      let UnitPrice = 0;
      if (ByQuantityPromotion.IsPercent) {
        UnitPrice = parseFloat(currentRow.UnitPrice * ((100 - ByQuantityPromotion.Off)/100)).toFixed(2);
      } else {
        UnitPrice = parseFloat(currentRow.UnitPrice - ByQuantityPromotion.Off).toFixed(2);
      }
      const appliedPromotionRows = _.map(this.state.rows, row => {
        if (row.ProductNum === this.state.promotionCheckProduct && row.UnitPrice && row.UnitPrice !== '0') {
          return {
            ...row,
            UnitPrice: UnitPrice,
            promotionApplied: true,
            TotalPrice: parseFloat(UnitPrice * row.Quantity).toFixed(2),
          }
        }
        return {
          ...row,
          // promotionApplied: true,
        }
      });
      this.setState({
        rows: appliedPromotionRows,
      }, () => {
        this.calculateSODetails()
      });
      this.setApplyPromotionsModalVisibility2()
    }

    applyAndSave3 = () => {
      let rows = [...this.state.rows];
      rows = _.map(rows, row => {
        if (row.ProductNum === this.state.unqualifiedPromotionProduct && row.UnitPrice && row.UnitPrice !== '0') {
          return {
            ...row,
            UnitPrice: this.props.productInfo.Price,
            promotionApplied: false,
            TotalPrice: parseFloat(this.props.productInfo.Price * row.Quantity).toFixed(2),
          }
        }
        return {
          ...row,
          // promotionApplied: false,
        };
      });
      this.setState({
        rows,
      }, () => {
        this.calculateSODetails()
      })
      this.setUnqualifiedPromotionModalVisibility();
    }

    notApplyAndSave3 = () => {
      let rows = [...this.state.rows];
      rows = _.map(rows, row => ({
        ...row,
        promotionApplied: false,
      }));
      this.setState({
        rows,
      });
      this.setUnqualifiedPromotionModalVisibility();
    }

    notApplyAndSave2 = () => {
      let rows = [...this.state.rows];
      rows = _.map(rows, row => ({
        ...row,
        promotionApplied: false,
      }));
      this.setState({
        rows,
      })
      this.setApplyPromotionsModalVisibility2()
      this.setApplyPromotionsModalVisibility3();
    }

    notApplyAndSave = () => {
      if (isOCM) {
        this.setMultiBatchModalVisibility(true);
        this.setApplyPromotionsModalVisibility();
        return;
      }
      this.handleFormSubmit(this.state.formProps, this.state.isQuote, this.state.isTransferOrder);
    }

    handleFormSubmit = _.debounce((formProps, isQuote, isTransferOrder = false, additionalParams) => {
      if (!isDSQ && !isWIZ && !isFJ && !isJTB && !isABCFF) {
        if (!formProps.receivingCustomer && this.context.router.routes[1].path !== 'mobileSalesOrders/:id') {
          alert('Please select a receiving customer first.')
          return;
        }
      }
      if (isJTB && formProps.OrderType && (formProps.OrderType === "Drop Shipping" || formProps.OrderType.value === "Drop Shipping")) {
        if (!formProps.DropshipType || formProps.DropshipType === "") {
          alert('Please select drop shipping type.');
          this.setState({
            dropShipWarning: true,
          });
          return;
        }
      }
      const newOrder = { ...formProps };
      if(isOLG && this.state.Billing.CustomerDetail_id) {
        newOrder.Billing_CustomerDetail_id = this.state.Billing.CustomerDetail_id
      }
      if(isSH) {
        newOrder.CC = Number(this.state.ccOrigin) || 0;
      }
      const quantityZero = this.state.rows.filter((obj) => {
        const match = obj.Quantity === 0;
        return match;
      });
      if (quantityZero.length > 0 && !isFung && !isWIZ && !isDSQ && !isJTB && !isFJ && !isABCFF) {
        this.setState({ case: 'zeroQuantity', confirmOpen: true, quantityZero });
        return;
      }
      const {
        createSalesOrder, createSalesQuote, editSalesOrder, orderDate, dispatchDate, ETDate,
        dispatchStartTime, dispatchEndTime,salesCustomerDetails, shipByDate, channel,
      } = this.props;
      if (!newOrder.Notation && salesCustomerDetails && salesCustomerDetails.Notation) { newOrder.Notation = salesCustomerDetails.Notation; }

      const fieldName = (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'outboundOrders/new') ? 'CustomerDetail_id' : 'Deliver_CustomerDetail_id';
      if (!newOrder[fieldName] && isOCM) {
        alert('no shipping address selected!');
        return;
      }
      if (newOrder[fieldName] && newOrder[fieldName].value) {
        newOrder.Deliver_CustomerDetail_id = newOrder[fieldName].value;
      } else {
        newOrder.Deliver_CustomerDetail_id = newOrder[fieldName];
      }
      if (!newOrder.Deliver_CustomerDetail_id && !isRivera && !isABCFF && !isHMM && !isABC && !isDSQ && !isJTB && !isWIZ && !isFJ) {
        let customer_id = this.props.receivingCustomer;
        if (typeof this.props.receivingCustomer.detail_id !== 'object') {
          for (let i = 0; i < this.props.customers.length; i++) {
            if (this.props.customers[i].Customer_id === this.props.receivingCustomer) {
              customer_id = this.props.customers[i].CustomerDetail_id;
            }
          }
        }
        newOrder.Deliver_CustomerDetail_id = customer_id.detail_id || customer_id;
      }
      const weightsParam = {
        Weights: []
      }
      newOrder.Sales_Order_Lines = Data.Selectors.getRows(this.state).map(row => {
        const Components = {
          Components: row.Components,
        }
        return {
        ...row,
        CostPrice: isSV ? row.BaseCost : row.ProductCost,
        UnitPrice: isVAK ? row.UnitPrice ? Number(row.UnitPrice) : 0 : row.UnitPrice,
        LoadedQuantity: 0,
        PickupQuantity: 0,
        ...!isOLG && weightsParam,
        ...isLMHST && Components
      }});

      newOrder.IsWholesale = false;
      newOrder.TotalPrice = this.state.totalPrice;
      newOrder.FinalWeight = this.state.finalWeight;
      newOrder.FinalPrice = this.state.finalPrice;
      newOrder.TotalCRV = this.state.totalCRV;
      newOrder.TaxRate = this.state.taxValue;
      newOrder.TaxAmount = +roundTo(this.state.totalTax, 2).toFixed(2);
      newOrder.IsNoReduce = this.state.IsNoReduce;
      newOrder.IsFBAAddress = this.state.IsFBAAddress;

      let magNoteTemp = [];
      if (isMAG) {
        if (this.state.magDryrun) { magNoteTemp.push('DRYRUN')}
        if (this.state.magOffhire) { magNoteTemp.push('OFFHIRE')}
        if (this.state.magExtraStop) { magNoteTemp.push('EXTRA_STOP')}
        if (this.state.magExam) { magNoteTemp.push('EXAM')}
        if (this.state.magExtraDelivery) { magNoteTemp.push('EXTRA_DELIVERY')}
        if (this.state.magStorage) { magNoteTemp.push('STORAGE')}
        if (this.state.magBobtailFee) { magNoteTemp.push('BOBTAIL_FEE')}
        newOrder.mag_note = magNoteTemp.join(',');
      }

      let magHoldTemp = [];
      if (isMAG) {
        if (this.state.mag2FREIGHT_HOLD) { magHoldTemp.push('FREIGHT_HOLD')}
        if (this.state.mag2CUSTOM_HOLD) { magHoldTemp.push('CUSTOM_HOLD')}
        if (this.state.mag2PIERPASS_HOLD) { magHoldTemp.push('PIERPASS_HOLD')}
        if (this.state.mag2EXAM) { magHoldTemp.push('EXAM')}
        if (this.state.mag2CLOSED_AREA) { magHoldTemp.push('CLOSED_AREA')}
        newOrder.DeliveryStatus = magHoldTemp.join(',');
      }

      if (this.state.delivery) {
        newOrder.Delivery = this.state.delivery;
      } else {
        newOrder.Delivery = 0;
      }
      if (this.state.handlingFee) {
        newOrder.HandlingFee = this.state.handlingFee;
      }

      if (this.state.transFee || this.state.transFee === 0) {
        newOrder.TransFee = +roundTo(this.state.transFee, 2).toFixed(2);
      }
      if (this.state.percentageFee || this.state.percentageFee === 0) {
        newOrder.PercentageFee = this.state.percentageFee;
      }
      if (this.state.fee) {
        newOrder.Surcharge = this.state.fee;
      }
      if (!newOrder.Sales_User_id) {
        newOrder.Sales_User_id = null;
      } else if (this.props.Sales_User_id && this.props.Sales_User_id.value) {
        newOrder.Sales_User_id = this.props.Sales_User_id.value;
      }
      if (!newOrder.Sales_User_id2) {
        newOrder.Sales_User_id2 = null;
      } else if (this.props.Sales_User_id2 && this.props.Sales_User_id2.value) {
        newOrder.Sales_User_id2 = this.props.Sales_User_id2.value;
      }
      if (!newOrder.Creator_User_id) {
        newOrder.Creator_User_id = null;
      } else if (this.props.Creator_User_id.value) {
        newOrder.Creator_User_id = this.props.Creator_User_id.value;
      }
      if (!newOrder.Picker_User_id) {
        newOrder.Picker_User_id = null;
      } else if (this.props.Picker_User_id.value) {
        newOrder.Picker_User_id = this.props.Picker_User_id.value;
      }
      if (!newOrder.Packer_User_id) {
        newOrder.Packer_User_id = null;
      } else if (this.props.Packer_User_id.value) {
        newOrder.Packer_User_id = this.props.Packer_User_id.value;
      }
      if (!newOrder.Packer) {
        newOrder.Packer = null
      } else {
        if (this.props.Packer.value) {
          newOrder.Packer = this.props.Packer.value
        } else {
          newOrder.Packer = this.props.Packer
        }
      }
      if (dispatchDate) {
        newOrder.DispatchDate = dispatchDate;
      } else {
        newOrder.DispatchDate = this.state.prevEstDate;
      }
      if (ETDate) {
        newOrder.ETDate = ETDate;
      } else {
        newOrder.ETDate = this.state.ETDate;
      }
      if (true) {
        if (dispatchStartTime) {
          newOrder.DispatchStartTime = dispatchStartTime.value ? dispatchStartTime.value : dispatchStartTime;
        } else {
          newOrder.DispatchStartTime = null;
        }
        if (dispatchEndTime) {
          newOrder.DispatchEndTime = dispatchEndTime.value ? dispatchEndTime.value : dispatchEndTime;
        } else {
          newOrder.DispatchEndTime = null;
        }
      }

      if (isSKH) {
        if (channel) {
          newOrder.Channel = channel.value;
        } else {
          newOrder.Channel = null;
        }
      }

      if (shipByDate) {
        newOrder.ShipByDate = shipByDate;
      } else {
        newOrder.ShipByDate = this.state.prevEstDate;
      }
      if (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
        newOrder.Discount = Number(this.state.SODiscount);
        newOrder.Savings = Number(this.state.SOSavings);
        newOrder.FinalPrice = Number(this.state.finalPriceWithPromotion);
      }
      if ((isAFG || isMyumyu || isWecom || isAFM || isEcity ) && this.props.currentSalesOrder && this.props.currentSalesOrder.SONum && (this.props.currentSalesOrder.SONum.charAt(0) !== 'M') && (this.context.router.routes[1].path === 'mobileSalesOrders/:id')) {
        newOrder.FinalPrice = Number(this.state.finalPriceWithPromotion);
      }

      if (!this.props.currentSalesOrderDetail && isFJ) {
        console.log("add dummy here?", newOrder);
      }
      if (isDSQ || isWIZ || isFJ || isJTB || isABCFF) {
        if (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
          newOrder.IsOutbound = true;
        } else {
          newOrder.IsOutbound = false;
        }
      }

      if (isGGI) {
        newOrder.PickAddress = this.state.PickAddress;
        newOrder.IsLowerThanLowestPrice = this.state.IsLowerThanLowestPrice;
        if (!this.state.CreditLimit) {
          newOrder.IsOverCreditLimit = false;
        } else {
          if (this.state.totalPrice > this.state.CreditLimit) {
            newOrder.IsOverCreditLimit = true;
          } else {
            newOrder.IsOverCreditLimit = false;
          }
        }
      }
      if (isVAK && newOrder.ShippingMethod &&  newOrder.ShippingMethod.value) {
        newOrder.ShippingMethod = newOrder.ShippingMethod.value;
      }

      newOrder.Sales_User_id = this.state.created_by;
      newOrder.Sales_User_id2 = this.state.created_by2;
      this.setState({ dirty: false, editing: false, shouldDiscountInit: true });
      if (!this.props.currentSalesOrderDetail) {
        if (!isOCM) {
          newOrder.IsRelocation = isTransferOrder;
        }
        if (additionalParams === 'invoice') {
          this.state.clickedInvoice = true;
          additionalParams = null;
          isQuote ? createSalesQuote(newOrder, additionalParams, 'invoice') : createSalesOrder(newOrder, additionalParams, 'invoice');
        } else {
          if (isVAK) {
            if (isQuote) {
              createSalesOrder({...newOrder, SaleStatus: 'Quote'}, additionalParams);
            } else {
              newOrder.Review_User_id = newOrder.Req_Review_User_id;
              newOrder.Approve_User_id = newOrder.Req_Approve_User_id;
              createSalesOrder(newOrder, additionalParams);
            }
          } else {
            isQuote ? createSalesQuote(newOrder, additionalParams) : createSalesOrder(newOrder, additionalParams);
          }
        }
      } else {
        this.state.clickedInvoice = false;
        newOrder.IsRelocation = this.props.currentSalesOrderDetail.IsRelocation;
        if (additionalParams === 'invoice') {
          this.state.clickedInvoice = true;
          additionalParams = null;
          editSalesOrder(newOrder, this.props.currentSalesOrderDetail.SalesOrder_id, additionalParams, 'invoice');
        } else {
        editSalesOrder(newOrder, this.props.currentSalesOrderDetail.SalesOrder_id, additionalParams);
        }
      }
    }, 200);

    handleSaveDisable() {
      if (this.props.salesOrderIsCreating) return true;
      const { currentSalesOrderDetail } = this.props;
      if ((isEKC || isLMH || isSDR || isCRW || isCTP || isSC ) && (!currentSalesOrderDetail || !currentSalesOrderDetail.SaleStatus)) {
        return;
      }
      if (isABC && this.state.rows.length > 0 && !this.state.Released) {
        return false;
      }
      if ((isEKC || isLMH || isSDR || isCRW || isCTP || isSC) && this.state.rows.length > 0 && !this.state.Released &&
        currentSalesOrderDetail.SaleStatus !== 'Finalized' &&
        currentSalesOrderDetail.SaleStatus !== 'Refunded' &&
        currentSalesOrderDetail.SaleStatus !== 'Canceled') {
        return false;
      }
      if (isVAK) {
        if (currentSalesOrderDetail) {
          const { SaleStatus } = currentSalesOrderDetail;
          const isMobile = this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id';
          if (isMobile) {
            return this.state.rows.length === 0 || ['Packing', 'Released', 'Finalized', 'Refunded', 'Canceled'].includes(SaleStatus);
          }
          return this.state.rows.length === 0 || ['Open', 'Finalized', 'Refunded', 'Canceled'].includes(SaleStatus)
        }
      }
      if (isFung) { return false; }
      if (((this.state.rows.length === 0 && !isMAG) || (this.state.Released) || (this.props.salesOrderIsCreating) || (this.props.salesOrderIsEditing))) {
        return true;
      } else if (isRivera || isEcity || (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id')) {
        return false;
      } else if ((this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id') && (isAFG || isMyumyu || isWecom || isCO || isOLG || isSW || isCCW) && this.props.currentSalesOrder && this.props.currentSalesOrder.SONum && (this.props.currentSalesOrder.SONum.charAt(0) !== 'M')) {
        return false;
      } else {
        return true;
      }
    }
    handleCommercialInvoiceDisable() {
      const { currentSalesOrderDetail } = this.props;
        if (currentSalesOrderDetail) {
        const { SaleStatus } = currentSalesOrderDetail;
        // return ['Open', 'Released', 'Canceled'].includes(SaleStatus)
        return currentSalesOrderDetail.Approve_Status === 'Confirm'
        }
    }

    handleOnFocus(event) {
      event.target.select();
    }

    updateShipVia(e) {
      this.props.setValue('salesOrderForm', 'ShipVia', e.target.value);
    }

    handleUpdatePrice() {
      const rows = [...this.state.rows];
      let rowToEdit = {};
      let rowIndex = 0;
      let counter = 0;
      rows.map((row) => {
        if (row.Index === this.state.RowBeingEdited.Index) {
          rowToEdit = { ...row };
          rowIndex = counter;
        }
        counter++;
      });
      if(isGGI) {
        let conVertNum = rows[rowIndex].ConvertNum;
        rowToEdit.SmallUnitPrice = parseFloat(this.state.newPrice);
        rowToEdit.UnitPrice = rowToEdit.SmallUnitPrice * conVertNum;
      } else {
        rowToEdit.UnitPrice = parseFloat(this.state.newPrice);
      }
      if ((isEKC || isLMH) && this.state.currentProdEkc === '0101') {
        if (rowToEdit.ProductType === 'Fixed' || rowToEdit.ProductType === 'Non-Product') {
          rowToEdit.TotalPrice = +roundTo(parseFloat(rowToEdit.UnitPrice * (this.props.SqftPack ? this.props.SqftPack : 1) * parseFloat(rowToEdit.Quantity)), 2).toFixed(2);
        } else {
          rowToEdit.TotalPrice = +roundTo(parseFloat(rowToEdit.UnitPrice * (this.props.SqftPack ? this.props.SqftPack : 1) * parseFloat(rowToEdit.Quantity) * parseFloat(rowToEdit.NetWeight)), 2).toFixed(2);
        }
      } else {
      if (rowToEdit.ProductType === 'Fixed' || rowToEdit.ProductType === 'Non-Product') {
        rowToEdit.TotalPrice = +roundTo(parseFloat(rowToEdit.UnitPrice * parseFloat(rowToEdit.Quantity)), 2).toFixed(2);
      } else {
        if(isGGI) {
          rowToEdit.TotalPrice = +roundTo(parseFloat(rowToEdit.UnitPrice * parseFloat(rowToEdit.Quantity)), 2).toFixed(2);
        } else {
          rowToEdit.TotalPrice = +roundTo(parseFloat(rowToEdit.UnitPrice * parseFloat(rowToEdit.Quantity) * parseFloat(rowToEdit.NetWeight)), 2).toFixed(2);
        }
      }
      }
      rows[rowIndex] = rowToEdit;

      let totalPrice = 0;
      let finalWeight = 0;
      let finalPrice = 0;
      let totalTax = 0;
      let totalCRV = 0;
      const discount = parseFloat(this.props.discount) || 0;
      // if (totalPrice == null)
      //   totalPrice = 0;
      // if (finalWeight ==null)
      //   finalWeight = 0;
      rows.map((row) => {
        if(isHMM) {
          totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
        } else {
          totalPrice += parseFloat(row.TotalPrice);
        }
        finalWeight += parseFloat(row.NetWeight * row.Quantity);
        if (row.IsTaxable === true || row.IsTaxable === 'True') {
          if (isHMM) {
            totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(this.state.taxValue / 100);
          } else {
            if(isHO || isJRC || isVIP) {
              if(row.IsAllTaxable === true || !this.props.salesCustomerDetails.Reseller) {
                totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
              }
            } else {
              totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
            }
          }
        }
        if (row.CRV) {
          if (this.props.salesShippingCustomerDetails && this.props.salesShippingCustomerDetails.HasCRV) {
            row.TotalCRV = +roundTo(parseFloat(row.CRV * row.Quantity), 2).toFixed(2)
          } else {
            row.TotalCRV = +roundTo(parseFloat(row.CRV * row.Quantity), 2).toFixed(2)
          }
        }
        if (row.TotalCRV) { totalCRV += row.TotalCRV; }
      });

      const { SODiscount, SOSavings } = this.state; // only one has value
      if (isHMM || isLMH || isSDR || isCRW || isSUN || isCPG || isSC) {
        if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
          totalTax = 0;
        } else {
          if (SODiscount) {
            totalTax = 0;
            rows.map((row, idxx) => {
              if (row.IsTaxable === true) {
                totalTax += ((parseFloat(row.TotalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)))) * parseFloat(this.state.taxValue / 100);
              }
            });
          }
        }
      }
      if ((isEKC || isSH)) {
        if (isEKC && this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
          totalTax = 0;
        } else {
          totalTax = ((parseFloat(totalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)) - Number(SOSavings ? SOSavings : 0))) * parseFloat(this.state.taxValue / 100);
        }
      }

      totalTax = +roundTo(totalTax, 2).toFixed(2);
      finalPrice = parseFloat(totalPrice) * (1 - discount / 100) + parseFloat(totalTax) + parseFloat(totalCRV);
      if(isSH && this.state.ccOrigin) {
        finalPrice = Number(finalPrice) + Number(finalPrice * (this.state.ccOrigin || 0)).toFixed(2);
      }
      finalWeight = +roundTo(finalWeight, 2).toFixed(2);
      totalPrice = +roundToDecimals(totalPrice, 4).toFixed(4);
      finalPrice = +roundTo(finalPrice, 2).toFixed(2);

      this.setState({
        rows, totalPrice, finalWeight, finalPrice, totalTax, totalCRV,
      }, () => {
        if ((isEKC || isLMH || isSDR || isCRW || isOLG || isVAK || isSH || isSC)) { this.onConfirmPercentageFee(); }
      });
    }

    calculateSODetails = () => {
      const rows = [...this.state.rows];
      let totalPrice = 0;
      let finalWeight = 0;
      let finalPrice = 0;
      let totalTax = 0;
      let totalCRV = 0;
      const discount = parseFloat(this.props.discount) || 0;

      rows.map((row) => {
        if(isHMM) {
          totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
        } else {
          totalPrice += parseFloat(row.TotalPrice);
        }
        finalWeight += parseFloat(row.NetWeight * row.Quantity);
        if (row.IsTaxable === true || row.IsTaxable === 'True') {
          if(isHMM) {
            totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(this.state.taxValue / 100);
          } else {
            totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
          }
        }
        if (row.CRV) {
          if (this.props.salesShippingCustomerDetails && this.props.salesShippingCustomerDetails.HasCRV) {
            row.TotalCRV = +roundTo(parseFloat(row.CRV * row.Quantity), 2).toFixed(2)
          } else {
            row.TotalCRV = +roundTo(parseFloat(row.CRV * row.Quantity), 2).toFixed(2)
          }
        }
        if (row.TotalCRV) { totalCRV += row.TotalCRV; }
      });

      const { SODiscount, SOSavings } = this.state;
      if (isHMM || isLMH || isSDR || isCRW || isSC || isSUN || isCPG) {
        if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
          totalTax = 0;
        } else {
          if (SODiscount) {
            totalTax = 0;
            rows.map((row, idxx) => {
              if (row.IsTaxable === true) {
                totalTax += ((parseFloat(row.TotalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)))) * parseFloat(this.state.taxValue / 100);
              }
            });
          }

        }
      }
      if ((isEKC || isSH)) {
        if (isEKC && this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
          totalTax = 0;
        } else {
          totalTax = ((parseFloat(totalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)) - Number(SOSavings ? SOSavings : 0))) * parseFloat(this.state.taxValue / 100);
        }
      }

      totalTax = +roundTo(totalTax, 2).toFixed(2);
      finalPrice = parseFloat(totalPrice) * (1 - discount / 100) + parseFloat(totalTax) + parseFloat(totalCRV);
      if(isSH && this.state.ccOrigin) {
        finalPrice = Number(finalPrice) + Number(finalPrice * (this.state.ccOrigin || 0)).toFixed(2);
      }
      finalWeight = +roundTo(finalWeight, 2).toFixed(2);
      totalPrice = +roundToDecimals(totalPrice, 4).toFixed(4);
      finalPrice = +roundTo(finalPrice, 2).toFixed(2);

      this.setState({
        rows, totalPrice, finalWeight, finalPrice, totalTax, totalCRV,
      });
    }

    handleTaxValueChange2 = (e) => {
      this.handleTaxValueChange(e);
      setTimeout(() => {
        this.handleTaxValueChange(e);
      }, 500);
    }

    handleTaxValueChange = (e) => {
      let taxValue = 0;
      if (e == null) {
        this.setState({ taxValue: 0 });
      } else {
        this.setState({ taxValue: e.value });
        taxValue = e.value;
      }

      let totalPrice = 0;
      let finalWeight = 0;
      let finalPrice = 0;
      let totalTax = 0;
      let totalCRV = 0;
      // let taxRateIndex = this.state.taxRateIndex;
      const discount = parseFloat(this.props.discount) || 0;
      const rows = [...this.state.rows];

      rows.map((row) => {
        if(isHMM) {
          totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
        } else {
          totalPrice += parseFloat(row.TotalPrice);
        }
        finalWeight += parseFloat(row.NetWeight * row.Quantity);
        if (row.IsTaxable === true || row.IsTaxable === 'True') {
          if(isHMM) {
            totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(taxValue / 100);
          } else {
            if(isHO || isJRC || isVIP) {
              if(row.IsAllTaxable === true || !this.props.salesCustomerDetails.Reseller) {
                totalTax += parseFloat(row.TotalPrice) * parseFloat(taxValue / 100);
              }
            } else {
              totalTax += parseFloat(row.TotalPrice) * parseFloat(taxValue / 100);
            }
          }
        }
        if (row.CRV) {
          if (this.props.salesShippingCustomerDetails && this.props.salesShippingCustomerDetails.HasCRV) {
            row.TotalCRV = +roundTo(parseFloat(row.CRV * row.Quantity), 2).toFixed(2);
          } else {
            row.TotalCRV = +roundTo(parseFloat(row.CRV * row.Quantity), 2).toFixed(2);
          }
        }
        if (row.TotalCRV) {
          totalCRV += row.TotalCRV;
        }
      });
      if (isHMM || isLMH || isSDR || isCRW || isSC || isSUN || isCPG || isVAK) {
        if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
          totalTax = 0;
        } else {
          if (SODiscount) {
            totalTax = 0;
            rows.map((row, idxx) => {
              if (row.IsTaxable === true) {
                totalTax += ((parseFloat(row.TotalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)))) * parseFloat(taxValue / 100);
              }
            });
          }

         }
      }

      const { SODiscount, SOSavings, delivery } = this.state;
      if (isEKC) {
        if (isEKC && this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
          totalTax = 0;
        } else {
          totalTax = ((parseFloat(totalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)) - Number(SOSavings ? SOSavings : 0))) * parseFloat(taxValue / 100);
        }
      }

      totalTax = +roundTo(totalTax, 2).toFixed(2);
      finalPrice = (parseFloat(totalPrice) * (1 - (discount / 100))) + (parseFloat(totalTax) + parseFloat(totalCRV));
      let cFee = 0;
      if(isSH && this.state.ccOrigin) {
        finalPrice = Number(finalPrice) + Number(finalPrice * (this.state.ccOrigin || 0)) + Number(delivery || 0);
        if(this.state.ccOrigin) {
          cFee =  +roundTo(Number(finalPrice * this.state.ccOrigin), 2);
        }
      }
      finalWeight = +roundTo(finalWeight, 2).toFixed(2);
      totalPrice = +roundToDecimals(totalPrice, 4).toFixed(4);
      finalPrice = +roundTo(finalPrice, 2).toFixed(2);

      this.setState({
        rows, totalPrice, finalWeight, finalPrice, totalTax, totalCRV, ccFee: cFee,
      }, () => {
        if ((isEKC || isLMH || isSDR || isCRW || isSC || isOLG || isVAK || isSH)) { this.onConfirmPercentageFee(); }
      });
    }

    removeRowChild(Index, ProductNum) {
    }
    
    removeRow(Index, ProductNum) {
      let rows = [...this.state.rows];
      let totalPrice = 0;
      let finalWeight = 0;
      let totalTax = 0;
      let totalCRV = 0;
      let index = 0;
      const discount = parseFloat(this.props.discount) || 0;
      
      const product = rows.filter(r => r.Index === Index);
      // IsCabinet
      
      if (isCRW || isSC) {
        // CRW if is child, cant delete
        if (product[0].ParentRefNum) {
          alert("Cannot delete child product");
          return;
        }
      }
      
      // CRW if is parent, delete child
      if (isCRW || isSC) {
        rows = rows.filter((obj) => {
          const match = (obj.Index !== Index) && ( (isCRW || isSC) && obj.ParentRefNum !== product[0].RefNum);
          return match;
        });
      } else {
        if(isLMHST) {
          let cpRows = [];
          rows.map((match)=>{
            if(match.Index != Index) {
              if(product[0].IsCabinet)  {
                if(match.Pid == product[0].MainId) {
                  cpRows.push({...match, Pid: -1})
                } else {
                  cpRows.push({...match});
                }
              } else {
                if(product[0].Pid && match.MainId == product[0].Pid) {
                  let cpComponents = match.Components && match.Components != null  ? JSON.parse(match.Components): [];
                  let filterComs = cpComponents.filter(com => com.MainId != product[0].MainId);
                  if(filterComs.length == 0) {
                    filterComs = null;
                  } else {
                    filterComs = JSON.stringify(filterComs);
                  }
                  cpRows.push({...match, Components:filterComs}); 
                } else {
                  cpRows.push({...match}); 
                }
              }
            }
          })
          rows = [...cpRows];
        } else {
          rows = rows.filter((obj) => {
            const match = (obj.Index !== Index);
            return match;
          });
        }
      }

      index = rows.length;
      
      if (isVAK) {
        this.props.fetchOrderRequests(null, {});
      }
      rows.map((row, idxx) => {
        if (isSV || isSUN || isOLG) {
          row.Index = idxx+1;
        } else {
          row.Index = index;
          index--;
        }
        
        if (row.IsTaxable === true || row.IsTaxable === 'true') {
          if(isHMM) {
            totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(this.state.taxValue / 100);
          } else {
            if(isHO || isJRC || isVIP) {
              if(row.IsAllTaxable === true || !this.props.salesCustomerDetails.Reseller) {
                totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
              }
            } else {
              totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
            }
          }
        }
        if(isHMM) {
          totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
        } else {
          totalPrice += parseFloat(row.TotalPrice);
        }
        if (row.Weight != null) {
          finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight);
        }
        if (row.CRV && this.props.salesShippingCustomerDetails && this.props.salesShippingCustomerDetails.HasCRV) {
          totalCRV += +roundTo(parseFloat(row.CRV * row.Quantity), 2).toFixed(2);
        } else {
          totalCRV += +roundTo(parseFloat(row.CRV * row.Quantity), 2).toFixed(2);
        }
      });

      if (isHMM || isLMH || isSDR || isCRW || isSC || isSUN || isCPG) {
        if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
          totalTax = 0;
        } else {
          if (SODiscount) {
            totalTax = 0;
            rows.map((row, idxx) => {
              if (row.IsTaxable === true) {
                totalTax += ((parseFloat(row.TotalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)))) * parseFloat(this.state.taxValue / 100);
              }
            });
          }

        }
      }
      const { SODiscount, SOSavings } = this.state; // only one has value
      if ((isEKC || isSH)) {
        if (isEKC && this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
          totalTax = 0;
        } else {
          totalTax = ((parseFloat(totalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)) - Number(SOSavings ? SOSavings : 0))) * parseFloat(this.state.taxValue / 100);
        }
      }

      totalTax = +roundTo(totalTax, 2).toFixed(2);
      totalPrice = +roundToDecimals(totalPrice, 4).toFixed(4);
      let finalPrice = +roundTo((totalPrice * (1 - (discount / 100))) + totalTax + totalCRV, 2).toFixed(2);
      if(isSH && this.state.ccOrigin) {
        finalPrice = Number(finalPrice) + Number(finalPrice * (this.state.ccOrigin || 0)).toFixed(2);
      }
      
      this.setState({
        rows, finalPrice, totalPrice, totalTax, finalWeight, totalCRV,
      }, () => {
        if (!isLMH) { this.checkForPromotions(ProductNum); }
        if ((isEKC || isLMH || isSDR || isCRW || isSC || isOLG || isVAK || isSH)) { this.onConfirmPercentageFee(); }
      });
    }
    
    title() {
      if (!this.props.currentSalesOrder) {
        return <h3><Translate value="create_a_new_sales_order" /></h3>;
      }
      return <h3><Translate value="edit_sales_order" /> {this.props.currentSalesOrder.SONum}</h3>;
    }

    setAllProductQuantity(quantity) {
      this.props.setValue('salesOrderForm', 'Quantity', quantity);
    }

    getCustomerNameOptions() {
      const customerOptions = [];
      if(isGGI) {
        this.props.customers.map((customer) => {
          let label = customer.Name;
          if(customer.CustomerID && customer.CustomerID != null) {
            label = label +  " " + customer.CustomerID
          }
          customerOptions.push({ value: customer.Customer_id, label, detail_id: customer.CustomerDetail_id });
        });
      } else {
        this.props.customers.map((customer) => {
          customerOptions.push({ value: customer.Customer_id, label: customer.Name, detail_id: customer.CustomerDetail_id });
        });
      }
      return customerOptions;
    }
    getCustomerNumOptions() {
      const customerOptions = [];
      this.props.customers.map((customer) => {
        customerOptions.push({ value: customer.Customer_id, label: customer.CustomerNum });
      });
      return customerOptions;
    }
    getCustomerPhoneOptions() {
      const customerOptions = [];
      this.props.customers.map((customer) => {
        customerOptions.push({ value: customer.Customer_id, label: customer.Telephone });
      });
      return customerOptions;
    }
    getShippingContactOptions() {
      const contactOption = [];
      if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Shipping && this.props.salesCustomerDetails.CustomerNum !== 'EMP9999') {
        this.props.salesCustomerDetails.Shipping.map((ShippingInfo) => {
          contactOption.push({ value: ShippingInfo.CustomerDetail_id, label: `${ShippingInfo.FirstName} ${ShippingInfo.LastName}` });
        });
      } else if (this.props.salesCustomerDetails && this.props.allShipping && this.props.allShipping.length && this.props.salesCustomerDetails.CustomerNum === 'EMP9999') {
        this.props.allShipping.map((ShippingInfo) => {
          contactOption.push({ value: ShippingInfo.CustomerDetail_id, id: ShippingInfo.Customer_id, label: `${ShippingInfo.CustomerName}` });
        });
      }
      return contactOption;
    }
    getShippingPhoneOptions() {
      const phoneOptions = [];
      if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Shipping && this.props.salesCustomerDetails.CustomerNum !== 'EMP9999') {
        if (!this.state.useDefaultCustomerAddress && this.props.salesShippingCustomerDetails && this.props.salesShippingCustomerDetails.Shipping) {
          this.props.salesShippingCustomerDetails.Shipping.map((ShippingInfo) => {
            phoneOptions.push({ value: ShippingInfo.CustomerDetail_id, label: `${ShippingInfo.Telephone}` });
          });
        } else {
          this.props.salesCustomerDetails.Shipping.map((ShippingInfo) => {
            phoneOptions.push({ value: ShippingInfo.CustomerDetail_id, label: `${ShippingInfo.Telephone}` });
          });
        }
      } else if (this.props.salesCustomerDetails && this.props.allShipping && this.props.allShipping.length && this.props.salesCustomerDetails.CustomerNum === 'EMP9999') {
        this.props.allShipping.map((ShippingInfo) => {
          phoneOptions.push({ value: ShippingInfo.CustomerDetail_id, id: ShippingInfo.Customer_id, label: `${ShippingInfo.Telephone}` });
        });
      }
      return phoneOptions;
    }
    getShippingNameOptions = () => {
      const phoneOptions = [];
      if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Shipping && this.props.salesCustomerDetails.CustomerNum !== 'EMP9999') {
        if (!this.state.useDefaultCustomerAddress && this.props.salesShippingCustomerDetails && this.props.salesShippingCustomerDetails.Shipping) {
          this.props.salesShippingCustomerDetails.Shipping.map((ShippingInfo) => {
            phoneOptions.push({ value: ShippingInfo.CustomerDetail_id, label: `${ShippingInfo.AddressName}` });
          });
        } else {
          this.props.salesCustomerDetails.Shipping.map((ShippingInfo) => {
            phoneOptions.push({ value: ShippingInfo.CustomerDetail_id, label: `${ShippingInfo.AddressName}` });
          });
        }
      } else if (this.props.salesCustomerDetails && this.props.allShipping && this.props.allShipping.length && this.props.salesCustomerDetails.CustomerNum === 'EMP9999') {
        this.props.allShipping.map((ShippingInfo) => {
          phoneOptions.push({ value: ShippingInfo.CustomerDetail_id, id: ShippingInfo.Customer_id, label: `${ShippingInfo.Telephone}` });
        });
      }
      return phoneOptions;
    }
    getAddressOptions() {
      const addressOptions = [];
      if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Shipping && this.props.salesCustomerDetails.CustomerNum !== 'EMP9999') {
        if (!this.state.useDefaultCustomerAddress && this.props.salesShippingCustomerDetails && this.props.salesShippingCustomerDetails.Shipping) {
          this.props.salesShippingCustomerDetails.Shipping.map((ShippingInfo) => {
            addressOptions.push({ value: ShippingInfo.CustomerDetail_id, label: `${ShippingInfo.Street} ${ShippingInfo.City}, ${ShippingInfo.State}` });
          });
        } else {
          this.props.salesCustomerDetails.Shipping.map((ShippingInfo) => {
            addressOptions.push({ value: ShippingInfo.CustomerDetail_id, label: `${ShippingInfo.Street} ${ShippingInfo.City}, ${ShippingInfo.State}` });
          });
        }
      } else if (this.props.salesCustomerDetails && this.props.allShipping && this.props.allShipping.length && this.props.salesCustomerDetails.CustomerNum === 'EMP9999') {
        this.props.allShipping.map((ShippingInfo) => {
          addressOptions.push({ value: ShippingInfo.CustomerDetail_id, id: ShippingInfo.Customer_id, label: `${ShippingInfo.Street} ${ShippingInfo.City}, ${ShippingInfo.State}` });
        });
      }
      return addressOptions;
    }

    getZipOptions() {
      const zipOptions = [];
      if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Shipping && this.props.salesCustomerDetails.CustomerNum !== 'EMP9999') {
        if (!this.state.useDefaultCustomerAddress && this.props.salesShippingCustomerDetails && this.props.salesShippingCustomerDetails.Shipping) {
          this.props.salesShippingCustomerDetails.Shipping.map((ShippingInfo) => {
            zipOptions.push({ value: ShippingInfo.CustomerDetail_id, label: `${ShippingInfo.Zip}` });
          });
        } else {
          this.props.salesCustomerDetails.Shipping.map((ShippingInfo) => {
            zipOptions.push({ value: ShippingInfo.CustomerDetail_id, label: `${ShippingInfo.Zip}` });
          });
        }
      } else if (this.props.salesCustomerDetails && this.props.allShipping && this.props.allShipping.length && this.props.salesCustomerDetails.CustomerNum === 'EMP9999') {
        this.props.allShipping.map((ShippingInfo) => {
          zipOptions.push({ value: ShippingInfo.CustomerDetail_id, id: ShippingInfo.Customer_id, label: `${ShippingInfo.Zip}` });
        });
      }
      return zipOptions;
    }

    getTaxRateOptions() {
      const taxRateOptions = [];
      if (this.props.taxRates) {
        let index = 0;
        this.props.taxRates.map((taxRate) => {
          taxRateOptions.push({ value: taxRate.Rate, label: taxRate.Rate, index });
          index++;
        });
      }
      return taxRateOptions;
    }
    // for OCM only
    getCompanyOptions() {
      let companyOptions = [];
      this.props.fetchCompany()
        .then(response => {
          response.data.map((company) => {
            // ocm company filter by permission
            if (false) {
              const permission_name = company.permission_name;
              if (checkPermissionLocal(permission_name)) {
                companyOptions.push({ label: company.Name, value: company.id, isDefault: company.IsDefault });
              }
            } else {
              companyOptions.push({ label: company.Name, value: company.id, IsDefault: company.IsDefault });
            }
          });
            // set default company, if no set the first one
          let default_company = localStorage.getItem('default_company');
          if(isGGI && this.props.selectedCompany && this.props.selectedCompany.value) {
            default_company = this.props.selectedCompany.value;
          }
          const userDefaultCompany = companyOptions.filter(company => company.value == default_company);

          const defultCompany = companyOptions.filter(company => company.IsDefault);
          this.setState({ companyOptions }, () => {
            if (this.context.router.location.pathname === "/salesOrders/new") {
              if (userDefaultCompany.length) {
                setTimeout(() => {
                  this.props.setValue('salesOrderForm', 'Company_id', userDefaultCompany[0].value);
                }, 1000);
              } else {
                this.props.setValue('salesOrderForm', 'Company_id', defultCompany[0].value);
              }
            }
          });
        },
        (err) => {
          if (err.status === 500 || err.status === 404) {
            alert('error fetching company names');
          }
        }
      );
    }

    favoriteItemsHeader() {
      return (
        <div onClick={() => this.setState({ favoriteItemsOpen: !this.state.favoriteItemsOpen })}>
          <label style={{ cursor: 'pointer' }} >
            <Translate value="favorite_items" />
          </label>
        </div>
      );
    }
    previousOrdersHeader() {
      return (
        <div>
          <Row>
            <Col xs={6}>
              <label
                style={{ cursor: 'pointer' }}
                onClick={() => this.setState({ previousOrdersOpen: !this.state.previousOrdersOpen, promotionsOpen: false })}
              >
                <Translate value="previous_order" />
              </label>
            </Col>
            <Col xs={6}>
              <Field name="PreviousOrderDate" component={DatePicker} />
            </Col>
          </Row>
        </div>
      );
    }

    promotionsHeader() {
      return (
        <div onClick={() => this.setState({ promotionsOpen: !this.state.promotionsOpen, previousOrdersOpen: false })} >
          <label style={{ cursor: 'pointer' }} ><Translate value="promotions" /></label>
        </div>
      );
    }

    renderInboundProducts() {
      if (this.props.customerFrequentIsLoading && !this.props.customerFrequentError) return <Spinner />;
      else if (this.props.customerFrequentError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.customerFrequentError)}</div></ContentWrapper>;

      // Parameters of the react-data-grid
      const getRows = () => Data.Selectors.getRows(this.state.frequentItems);
      const getSize = () => getRows().length;
      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };
      const onRowsSelected = (rows) => {
        const newRows = getRows();
        const selectedIndexes = this.state.frequentItems.selectedIndexes.concat(rows.map(r => r.rowIdx));

        let selectedPK = [];
        if (isABCFF) {
          selectedPK = this.state.frequentItems.selectedPK.concat(rows.map(r => r.row.pk));
        }
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = true;
        });
        const frequentItems = { ...this.state.frequentItems, rows: newRows, selectedIndexes };
        this.setState({ frequentItems });
      };
      const onRowsDeselected = (rows) => {
        const rowIndexes = rows.map(r => r.rowIdx);
        // this.state.frequentItems.rows = this.props.customerFrequent.record;
        const newRows = [...this.state.frequentItems.rows];
        const selectedIndexes = this.state.frequentItems.selectedIndexes.filter(i => rowIndexes.indexOf(i) === -1);

        let rowPKs = [];
        let selectedPK = this.state.frequentItems.selectedPK;
        if (isABCFF) {
          rowPKs = rows.map(r => r.row.pk);
          rowPKs.map(r => {
            selectedPK.map((j, index) => {
              if (r === j) {
                selectedPK.splice(index, 1);
              }
            })
          });
        }
        if (isABCFF) {
          newRows.map((r, index) => {
            if (selectedPK && selectedPK.length > 0) {
              selectedPK.map((j)=> {
                if (r.pk === j) {
                  newRows[index].isSelected = true;
                } else {
                  newRows[index].isSelected = false;
                }
              });
            } else {
              newRows[index].isSelected = false;
            }
          });
        } else {
          rows.map((r) => {
            newRows[r.rowIdx].isSelected = false;
          });
        }

        rows.map((r) => {
          newRows[r.rowIdx].isSelected = false;
        });

        const frequentItems = { ...this.state.frequentItems, rows: newRows, selectedIndexes, selectedPK };
        this.setState({ frequentItems });
      };

      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        const frequentItems = { ...this.state.frequentItems, sortColumn, sortDirection };
        this.setState({ frequentItems });
      };
      const handleFilterChange = (filter) => {
        this.state.frequentItems.rows = this.props.customerFrequent.record;
        const newFilters = Object.assign({}, this.state.frequentItems.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const frequentItems = { ...this.state.frequentItems, filters: newFilters };
        this.setState({ frequentItems });
      };

      // all filters removed
      const onClearFilters = () => {
        const frequentItems = { ...this.state.frequentItems, filters: {} };
        this.setState({ frequentItems });
      };
      // const onRowSelect = rows => {
      //     var previousOrderes = {...this.state.frequentItems, selectedRows: rows};
      //     this.setState({frequentItems});
      // }
      const onRowClick = (rowIdx, row) => {
        if (rowIdx > -1) {
          if (this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') {
          this.props.fetchItemSalesHistory(this.state.currentCustomer, row.Product_id);
          }
          this.selectInventoryInfo(row);
          // this.props.fetchProductInfo(row.Product_id);
        }
      };
      // Custom Formatter component
      const IsEnabledFormatter = React.createClass({
        render() {
          if (this.props.value) return <span className="label label-success"><Translate value="enabled" /></span>;
          return <span className="label label-danger"><Translate value="disable" /></span>;
        },
      });

      const showProductCost = () => {
        if (!(isEKC || isLMH || isSDR || isCRW || isSC) && checkPermissionLocal('no_show_product_cost')) {
          return false;
        }
        if ((isEKC || isLMH || isSDR || isCRW || isSC) && checkPermissionLocal('no_show_sales_order_cost')) {
          return false;
        }
        return true;
      };
      // Column definition
      const columns = [
        {
          key: 'ContainerNum',
          name: <Translate value="container" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        ...isOLG ? []:[
          {
            key: 'ProductNum',
            name: <Translate value="prod_num" />,
            resizable: true,
            sortable: true,
            width: 100,
            filterable: true,
          }
        ],
        {
          key: 'RefNum',
          name: isWIZ ?  <Translate value="sku" /> : <Translate value={isOLG ? "item_no" : "ref_num"} />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: 150,
        },
        {
          key: 'DispatchType',
          name: <Translate value="dispatch" />,
          resizable: true,
          sortable: true,
          width: 80,
        },
        {
          key: 'AvailableQuantity',
          name: <Translate value="available" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'FulfilledQuantity',
          name: <Translate value="fulfilled" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'InboundTotalQuantity',
          name: <Translate value="total_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'PickupDate',
          name: <Translate value="pickup_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter2,
        },
        {
          key: 'DropoffDate',
          name: <Translate value="dropoff_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter2,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        },
        ...showProductCost() ? [{
          key: 'CostPrice',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="unit_weight" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        },
      ];

      const abcffFreqColumns = [
        {
          key: 'ContainerNum',
          name: <Translate value="container" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'RefNum',
          name: <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        },
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        },
        {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 150,
        },
        {
          key: 'Location',
          name: <Translate value="location" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        },
        {
          key: 'TrackingNum',
          name: <Translate value="tracking_num" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        },
        {
          key: 'FBARoute',
          name: <Translate value="fba_route" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        },
        {
          key: 'DispatchType',
          name: <Translate value="dispatch" />,
          resizable: true,
          sortable: true,
          width: 80,
        },
        {
          key: 'AvailableQuantity',
          name: <Translate value="available_box" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'FulfilledQuantity',
          name: <Translate value="fulfilled_box" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          // key: 'Quantity',
          key: 'InboundTotalQuantity',
          name: <Translate value="total_qty_box" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'InboundTotalPallets',
          name: <Translate value="total_qty_plt" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'PickupDate',
          name: <Translate value="pickup_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter2,
        },
        {
          key: 'DropoffDate',
          name: <Translate value="dropoff_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter2,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        },
        ...showProductCost() ? [{
          key: 'CostPrice',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="unit_weight" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        },
      ];

      const wizFreqColumns = [
        {
          key: 'ContainerNum',
          name: <Translate value="container" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'RefNum',
          name: isWIZ ?  <Translate value="sku" /> : <Translate value={isOLG ? "item_no" : "ref_num"} />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: 150,
        },
        {
          key: 'DispatchType',
          name: <Translate value="dispatch" />,
          resizable: true,
          sortable: true,
          width: 80,
        },
        {
          key: 'AvailableQuantity',
          name: <Translate value="available" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'FulfilledQuantity',
          name: <Translate value="fulfilled" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          // key: 'Quantity',
          key: 'InboundTotalQuantity',
          name: <Translate value="total_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'Location',
          name: <Translate value="location" />,
          resizable: true,
          sortable: true,
          width: 80,
        },
        {
          key: 'InboundCustomer',
          name: <Translate value="customer" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'PickupDate',
          name: <Translate value="pickup_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter2,
        },
        {
          key: 'DropoffDate',
          name: <Translate value="dropoff_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter2,
        },
        {
          key: 'InboundDate',
          name: <Translate value="inbound_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter2,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        },
        ...showProductCost() ? [{
          key: 'CostPrice',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="unit_weight" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        },
      ];

      const dsqFreqColumns = [
        {
          key: 'ContainerNum',
          name: <Translate value="container" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'RefNum',
          name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        },
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: 150,
        },
        {
          key: 'FBARoute',
          name: <Translate value="fba_route" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        },
        {
          key: 'DispatchType',
          name: <Translate value="dispatch" />,
          resizable: true,
          sortable: true,
          width: 80,
        },
        {
          key: 'AvailableQuantity',
          name: <Translate value="available_box" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'FulfilledQuantity',
          name: <Translate value="fulfilled_box" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          // key: 'Quantity',
          key: 'InboundTotalQuantity',
          name: <Translate value="total_qty_box" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'AvailablePallets',
          name: <Translate value="available_plt" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'FulfilledPallets',
          name: <Translate value="fulfilled_plt" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'InboundTotalPallets',
          name: <Translate value="total_qty_plt" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'PickupDate',
          name: <Translate value="pickup_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter2,
        },
        {
          key: 'DropoffDate',
          name: <Translate value="dropoff_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          formatter: DateFormatter2,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        },
        ...showProductCost() ? [{
          key: 'CostPrice',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="unit_weight" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        },
      ];

      const jtbFreqColumns = [
        {
          key: 'ContainerNum',
          name: <Translate value="container" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'RefNum',
          name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        },
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: 150,
        },
        {
          key: 'AvailableQuantity',
          name: <Translate value="available" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'FulfilledQuantity',
          name: <Translate value="fulfilled" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          // key: 'Quantity',
          key: 'InboundTotalQuantity',
          name: <Translate value="total_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        },
        ...showProductCost() ? [{
          key: 'CostPrice',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="unit_weight" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        },
      ];

      const generateFreqColumns = () => {
        if (isJTB) {
          return jtbFreqColumns;
        }
        if (isDSQ) {
          return dsqFreqColumns;
        }
        if (isWIZ) {
          return wizFreqColumns;
        }
        if (isABCFF) {
          return abcffFreqColumns;
        }
        return columns
      }
      return (
        <Row>
          <Col xs={12} style={{ marginTop: '-30px' }}>
            <div className="react-table-customizer" id="SalesOrderForm-dataGrid1">
              <ReactDataGrid
                rowKey="Product_id"
                onGridSort={handleGridSort}
                columns={generateFreqColumns()}
                rowHeight={25}
                headerRowHeight={45}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                enableRowSelect="multi"
                toolbar={<Toolbar enableFilter />}
                onAddFilter={handleFilterChange}
                onClearFilters={onClearFilters}
                minHeight={220}
                onRowUpdated={this.handleRowUpdated}
                onRowClick={onRowClick}
                rowSelection={{
                  showCheckbox: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
              />
            {/* <Row id="inventory-details">
                <Col xs={1}>
                  <label className="inventory-label"><Translate value="inventory" />:</label>
                </Col>
                <Col xs={5}>
                  <Row>
                    <Col xs={4}>
                      <label className="col-xs-6 inlineLabel"><Translate value="in_stock" /><span className="colon">:</span></label>
                      <span className="col-xs-6 inventory-highlight"> {this.state.inStock}</span>
                    </Col>
                    <Col xs={4}>
                      <label className="col-xs-7 inlineLabel"><Translate value="purchased" /><span className="colon">:</span></label>
                      <span className="col-xs-5 inventory-highlight"> {this.state.purchased}</span>
                    </Col>
                    <Col xs={4}>
                      <label className="col-xs-6 inlineLabel"><Translate value="presale" /><span className="colon">:</span></label>
                      <span className="col-xs-6 inventory-highlight"> {this.state.presale}</span>
                    </Col>
                  </Row>
                </Col>
                <Col xs={6}>
                  <Col xs={4}>
                    <label className="col-xs-5 inlineLabel"><Translate value="net_wt" /><span className="colon">:</span></label>
                    <span className="col-xs-6 inventory-highlight"> {this.state.net_weight}</span>
                  </Col>
                  <Col xs={4}>
                    <label className="col-xs-5 inlineLabel"><Translate value="ship_wt" /><span className="colon">:</span></label>
                    <span className="col-xs-6 inventory-highlight"> {this.state.ship_weight}</span>
                  </Col>
                  <Col xs={4}>
                    <label className="col-xs-5 inlineLabel"><Translate value="total_wt" /><span className="colon">:</span></label>
                    <span className="col-xs-6 inventory-highlight"> {this.state.total_weight}</span>
                  </Col>
                </Col>
              </Row> */}
            </div>
          </Col>
        </Row>
      );
    }

    renderFrequent() {
      if (this.props.customerFrequentIsLoading && !this.props.customerFrequentError) return <Spinner />;
      else if (this.props.customerFrequentError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.customerFrequentError)}</div></ContentWrapper>;

      // Parameters of the react-data-grid
      const getRows = () => Data.Selectors.getRows(this.state.frequentItems);
      const getSize = () => getRows().length;
      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };
      const onRowsSelected = (rows) => {
        const newRows = getRows();
        const selectedIndexes = this.state.frequentItems.selectedIndexes.concat(rows.map(r => r.rowIdx));
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = true;
        });
        const frequentItems = { ...this.state.frequentItems, rows: newRows, selectedIndexes };
        this.setState({ frequentItems });
      };
      const onRowsDeselected = (rows) => {
        const rowIndexes = rows.map(r => r.rowIdx);
        const newRows = [...this.state.frequentItems.rows];
        const selectedIndexes = this.state.frequentItems.selectedIndexes.filter(i => rowIndexes.indexOf(i) === -1);
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = false;
        });
        const frequentItems = { ...this.state.frequentItems, rows: newRows, selectedIndexes };
        this.setState({ frequentItems });
      };
      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        const frequentItems = { ...this.state.frequentItems, sortColumn, sortDirection };
        this.setState({ frequentItems });
      };

      const handleRowUpdated = e => {
        let rows = this.state.frequentItems.rows.slice(0);
        Object.assign(rows[e.rowIdx], e.updated);
        let frequentItems = { ...this.state.frequentItems, rows: rows }
        this.setState({ frequentItems });
      }
      // const onRowSelect = rows => {
      //     var previousOrderes = {...this.state.frequentItems, selectedRows: rows};
      //     this.setState({frequentItems});
      // }
      const onRowClick = (rowIdx, row) => {
        if (rowIdx > -1) {
          if (this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') {
          this.props.fetchItemSalesHistory(this.state.currentCustomer, row.Product_id);
          }
          if (isOLG || isLAP) {
            this.props.fetchSalesOrderProductByID(row.Product_id, this.state.currentCustomer, this.props.Company_id, this.props.Pickup_Warehouse_id);
          } else {
            this.selectInventoryInfo(row);
          }
          // this.props.fetchProductInfo(row.Product_id);
        }
      };
      // Custom Formatter component
      const IsEnabledFormatter = React.createClass({
        render() {
          if (this.props.value) return <span className="label label-success"><Translate value="enabled" /></span>;
          return <span className="label label-danger"><Translate value="disable" /></span>;
        },
      });

      const showProductCost = () => {
        if (!(isEKC || isLMH || isSDR || isCRW || isSC) && checkPermissionLocal('no_show_product_cost')) {
          return false;
        }
        if ((isEKC || isLMH || isSDR || isCRW || isSC) && checkPermissionLocal('no_show_sales_order_cost')) {
          return false;
        }
        return true;
      };
      // Column definition
      const columns = [
        ...isOLG ? [] : [
          {
            key: 'ProductNum',
            name: <Translate value="prod_num" />,
            resizable: true,
            sortable: true,
            width: 100,
            filterable: true,
          }
        ],
        {
          key: 'RefNum',
          name: <Translate value={isOLG ? "item_no" : isVAK ? "sku" : "ref_num"} />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        },
        ...isOLG ? [] : [{
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: isLAP ? 300 : 250,
          filterable: true,
        }],
        ...isLAP ? [] : [{
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: isOLG ? 300 : 200,
        }],
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        ...isGGI?[
          {
            key: 'SmallUnitPrice',
            name: <Translate value="small_pr" />,
            resizable: true,
            sortable: true,
            width: 80,
            filterable: true,
            editable: true,
          },
        ]:[],
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          // editable: true,
        },
        ...showProductCost() ? [{
          key: 'CostPrice',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          // editable: true,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="unit_weight" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          // editable: true,
        },
        ...isLAP ? [{
          key: 'Quantity',
          name: <Translate value="quantity" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
        }] : [],
      ];
      if (isLAP && showProductCost()) {
        const costIndex = columns.findIndex(item => item.key === 'CostPrice');
        if (costIndex !== -1) {
          columns.splice(costIndex, 1, {
            key: 'CurrentCost',
            name: <Translate value="product_cost" />,
            resizable: true,
            sortable: true,
            width: 80,
            filterable: true,
            editable: true,
          });
        }
      }
      if(isGGI) {
        columns.push({
          key: 'TotalQuantity',
          name: <Translate value="total_qty" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        });
        columns.push({
          key: 'QrderQuantity',
          name: <Translate value="order_qty" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        });
      }
      return (
        <Row>
          <Col xs={12}>
            <div className="react-table-customizer" id="SalesOrderForm-dataGrid1">
              <ReactDataGrid
                rowKey="Product_id"
                enableCellSelect
                onGridSort={handleGridSort}
                columns={columns}
                rowHeight={25}
                headerRowHeight={45}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                enableRowSelect="multi"
                minHeight={isLAP ? 350 : 202}
                onRowUpdated={handleRowUpdated}
                onRowClick={onRowClick}
                rowSelection={{
                  showCheckbox: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
              />
              {
                !isChinaTown &&
                this.renderInventoryRow()
              }
              {
                isChinaTown &&
                <Row id="inventory-details" style={{fontSize: '15px'}}>
                  <Col xs={1}>
                   <label className="inventory-label-china"><Translate value="inventory" />:</label>
                  </Col>
                  <Col xs={5}>
                    <Row>
                      <Col xs={4} className="pr1">
                        <label className="col-xs-6 inlineLabel"><Translate value="in_stock" /><span className="colon">:</span></label>
                        <span className="col-xs-6 inventory-highlight-china"> {this.state.inStock}</span>
                      </Col>
                      <Col xs={4} className="pr1">
                        <label className="col-xs-7 inlineLabel"><Translate value="purchased" /><span className="colon">:</span></label>
                        <span className="col-xs-5 inventory-highlight-china"> {this.state.purchased}</span>
                      </Col>
                      <Col xs={4} className="pr1">
                        <label className="col-xs-6 inlineLabel"><Translate value="presale" /><span className="colon">:</span></label>
                        <span className="col-xs-6 inventory-highlight-china"> {this.state.presale}</span>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={6}>
                    <Col xs={4} className="pr1">
                      <label className="col-xs-5 inlineLabel"><Translate value="net_wt" /><span className="colon">:</span></label>
                      <span className="col-xs-6 inventory-highlight-china"> {this.state.net_weight}</span>
                    </Col>
                    <Col xs={4} className="pr1">
                      <label className="col-xs-5 inlineLabel"><Translate value="ship_wt" /><span className="colon">:</span></label>
                      <span className="col-xs-6 inventory-highlight-china"> {this.state.ship_weight}</span>
                    </Col>
                    <Col xs={4} className="pr1">
                      <label className="col-xs-5 inlineLabel"><Translate value="total_wt" /><span className="colon">:</span></label>
                      <span className="col-xs-6 inventory-highlight-china"> {this.state.total_weight}</span>
                    </Col>
                  </Col>
                </Row>
              }
            </div>
          </Col>
        </Row>
      );
    }

    handleShowAll = () => {
      this.fetchPreviousOrdersFromALLSalesOrder();
    }

    handleSelectAll = () => {
      const newRows = [...this.state.previousOrders.rows];
      const selectedRows = [...this.state.previousOrders.selectedRows];
      const selectedIndexes = [];
      let index = 0;
      newRows.map((r) => {
        r.isSelected = true;
        selectedIndexes.push(index);
        selectedRows.push(r);
        index++;
      });
      const previousOrders = { ...this.state.previousOrders, rows: newRows, selectedIndexes, selectedRows };
      this.setState({ previousOrders });
    }

    handleDeselectAll = () => {
      const newRows = [...this.state.previousOrders.rows];
      const selectedIndexes = [];
      const selectedRows = [];
      let index = 0;
      newRows.map((r) => {
        r.isSelected = false;
      });
      const previousOrders = { ...this.state.previousOrders, rows: newRows, selectedIndexes, selectedRows };
      this.setState({ previousOrders });
    }

    handleToSODetail = (e) => {
      let id = this.state.soExitList.selectedRows[0].row.SalesOrder_id;
      this.setState({SOExistingVisible: false});
      this.props.fetchSalesOrderDetail(id, 'salesOrders')
      .then(() => {
        this.props.selectSalesOrder(this.props.currentSalesOrderDetail);
        this.context.router.push(`/salesOrders/${id}`);
      })
    }

    handleSOexistCancel = () => {
      this.setState({
        SOExistingVisible: false,
        soExitList:{
          rows: [],
          selectedRows: [],
          sortColumn: null,
          sortDirection: null,
          selectedIndexes: [],
          selectedPK: [],
        }
      })
    }

    renderOpenOrder() {
      const { salesCustomerDetails, salesOrderCreated, currentSalesOrder } = this.props;
      const salesOrder = salesOrderCreated || currentSalesOrder;
      let orders = [];
      let orderlist = '';
      let route = '';
      if (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
        route = 'salesOrders';
      } else if (this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id') {
        route = 'mobileSalesOrders';
      }
      if (salesCustomerDetails && salesCustomerDetails.open_orders) {
        orders = salesCustomerDetails.open_orders;
        orderlist = salesCustomerDetails.open_orders.map((order) =>
          <li style={{fontSize: '20px', listStyleType: 'none' }}>
            <Translate value="sales_orders" /> : {order.SONum}
            <Button
              bsStyle="danger"
              type="button"
              onClick={() => {
                this.props.fetchSalesOrderDetail(order.SalesOrder_id, route)
                .then(() => {
                  this.props.selectSalesOrder(this.props.currentSalesOrderDetail);
                  this.context.router.push(`/salesOrders/${order.SalesOrder_id}`);
                })
              }}
            >
              <em className="fa fa-edit" /> <Translate value="edit" />
            </Button>
          </li>
        );
      }

      return (
        <div>
          <ul>{orderlist}</ul>
        </div>
      );
    }

    renderSOExistListModal() {
      if(this.state.soExitList.rows.length == 0) return

      // Parameters of the react-data-grid
      const getRows = () => Data.Selectors.getRows(this.state.soExitList);

      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      const handleGridSort = (sortColumn, sortDirection) => {
        const soExitList = { ...this.state.soExitList, sortColumn, sortDirection };
        this.setState({ soExitList });
      };

      const onRowsSelected = (rows) => {
        const newRows = getRows();
        const selectedIndexes = this.state.soExitList.selectedIndexes.concat(rows.map(r => r.rowIdx));
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = true;
        });
        let selectedRows = [...this.state.soExitList.selectedRows];
        let isHave = false;
        selectedRows.map(item => {
          if(item.row.SalesOrder_id == rows[0].row.SalesOrder_id) {
            isHave = true;
          }
        })
        if(!isHave) {
          selectedRows.push(rows[0]);
        }
        const soExitList = { ...this.state.soExitList, rows: newRows, selectedIndexes, selectedRows };
        this.setState({ soExitList });
      };
      const onRowsDeselected = (rows) => {
        const rowIndexes = rows.map(r => r.rowIdx);
        const newRows = [...this.state.soExitList.rows];
        const selectedIndexes = this.state.soExitList.selectedIndexes.filter(i => rowIndexes.indexOf(i) === -1);
        let selectedPK = this.state.soExitList.selectedPK;
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = false;
        });
        let cpRows = [...this.state.soExitList.selectedRows];
        let selectedRows = [];
        cpRows.map(item => {
          if(item.row.SalesOrder_id != rows[0].row.SalesOrder_id) {
            selectedRows.push(item);
          }
        })
        const soExitList = { ...this.state.soExitList, rows: newRows, selectedIndexes, selectedPK, selectedRows };
        this.setState({ soExitList });
      };

      const columns = [
        {
          key: 'SONum',
          name: <Translate value="so_no" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'SaleStatus',
          name: <Translate value="status" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
      ];
      return (
        <div  style={{marginTop: 20, marginBottom:10}}>
          <div className='tab-content'>
            <Row>
              <Col xs={12}>
                <div className="react-table-customizer" id="SalesOrderForm-dataGrid1">
                  <ReactDataGrid
                  rowKey="SO_EXIST_ID"
                  onGridSort={handleGridSort}
                  columns={columns}
                  rowHeight={25}
                  headerRowHeight={45}
                  rowGetter={rowGetter}
                  rowsCount={getSize()}
                  enableRowSelect="multi"
                  toolbar={<Toolbar enableFilter />}
                  minHeight={220}
                  rowSelection={{
                    showCheckbox: true,
                    onRowsSelected,
                    onRowsDeselected,
                    selectBy: {
                      isSelectedKey: 'isSelected',
                    },
                  }}
                  />
                </div>
              </Col>
            </Row>
          </div>
          <div style={{display: 'flex',flexDirection:'row', justifyContent:'flex-end', alignItems:'center', marginTop: 6, width: '100%'}}>
            <button
            className="btn btn-primary"
            disabled={this.state.soExitList.selectedRows.length != 1 || (this.state.soExitList.selectedRows[0].row.SaleStatus != 'Open' && this.state.soExitList.selectedRows[0].row.SaleStatus != 'Packing')}
            onClick={(event)=>{this.handleToSODetail(event)}}
            style={{marginRight: '10px'}}
            >
              <i className="fa fa-check" />
              <Translate value="confirm" />
            </button>
            <button
              className="btn btn-danger"
              onClick={this.handleSOexistCancel}
              >
                <i className="fa fa-close" />
                <Translate value="cancel" />
            </button>
          </div>
        </div>
      );
    }

    renderHistory() {
      if ((this.props.customerSalesHistoryIsLoading && !this.props.customerSalesHistoryError)) return <Spinner />;
      else if (this.props.customerSalesHistoryError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.customerSalesHistoryError)}</div></ContentWrapper>;

      // Parameters of the react-data-grid
      const getRows = () => Data.Selectors.getRows(this.state.salesHistory);

      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      const handleFilterChange = (filter) => {
        const newFilters = Object.assign({}, this.state.salesHistory.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const salesHistory = { ...this.state.salesHistory, filters: newFilters };
        this.setState({ salesHistory });
      };

      const onClearFilters = () => {
        const salesHistory = { ...this.state.salesHistory, filters: {} };
        this.setState({ salesHistory });
      };

      const HighlightFormatter = React.createClass({
        render() {
          const rows = this.props.state.rows;
          if (rows.some((e) => e.ProductNum === this.props.value)) {
            return (
              <div style={{ backgroundColor: '#5CB85C' }}>{this.props.value}</div>
            );
          }
          return (
            <div>{this.props.value}</div>
          );
        },
      });

      const columns = [
        ...isOLG ? [] : [
          {
            key: 'productNum',
            name: <Translate value="prod_num" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 110,
            formatter: <HighlightFormatter state={this.state} />,
          }
        ],
        ...isOLG ? [
          {
            key: 'ItemNum',
            name: <Translate value="item_no" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 110,
          }
        ] : [
          {
            key: 'name',
            name: <Translate value="prod_name" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 110,
          }
        ],
        {
          key: 'description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 110,
        },
        {
          key: isGGI ? 'quantity2' : 'quantity',
          name: <Translate value="qty" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 110,
          formatter: BoldTextFormatter,
        },
        {
          key: 'totalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 110,
          formatter: BoldCashFormatter,
        },
      ];

      return (
        <div>
          <Row>
            <Col xs={12}>
              <div id="salesOrders-dataGrid1">
                <ReactDataGrid
                  rowKey="SalesOrder_id"
                  columns={columns}
                  rowHeight={25}
                  headerRowHeight={45}
                  rowGetter={rowGetter}
                  rowsCount={getSize()}
                  minHeight={270}
                  toolbar={<Toolbar enableFilter />}
                  onAddFilter={handleFilterChange}
                  onClearFilters={onClearFilters}
                />
              </div>
            </Col>
          </Row>
        </div>
      );
    }
    renderRelatedComponents() {
      if (!isLMHST) return
      const { relatedComponentsList } = this.state
      if(this.state.relatedComponentsList.rows.length == 0) return
      // Parameters of the react-data-grid
      const getRows = () => Data.Selectors.getRows(relatedComponentsList);

      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return Object.assign({ Idx: rowIdx + 1 }, rows[rowIdx]);
      };

      const handleGridSort = (sortColumn, sortDirection) => {
        const relatedComponentsList = { ...this.state.relatedComponentsList, sortColumn, sortDirection };
        this.setState({ relatedComponentsList });
      };

      const onRowsSelected = (rows) => {
        
        const newRows = getRows();
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = true;
        });
        let selectedRows = [...this.state.relatedComponentsList.selectedRows];
        let isHave = false;
        
        selectedRows.map(item => {
          if((item.row || item).MainId == rows[0].row.MainId) {
            isHave = true;
          }
        })
        if(!isHave) {
          selectedRows.push(rows[0].row);
        }
        const relatedComponentsList = { ...this.state.relatedComponentsList, rows: newRows, selectedRows };
        this.setState({ relatedComponentsList });
      };
      const onRowsDeselected = (rows) => {
        const newRows = [...this.state.relatedComponentsList.rows];
        let selectedPK = this.state.relatedComponentsList.selectedPK;
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = false;
        });
        let cpRows = [...this.state.relatedComponentsList.selectedRows];
        let selectedRows = [];
        cpRows.map(item => {
          if((item.row || item).MainId != rows[0].row.MainId) {
            selectedRows.push(item);
          }
        })
        const relatedComponentsList = { ...this.state.relatedComponentsList, rows: newRows, selectedPK, selectedRows };
        this.setState({ relatedComponentsList });
      };

      const columns = [
        {
          key: 'Idx',
          name: <Translate value="idx" />,
          width: 35,
          resizable: true,
          sortable: true,
        },
        {
          key: 'RefNum',
          name: <Translate value="sku" />,
          resizable: true,
          sortable: true,
          width: 180,
          filterable: true,
        },
        {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          width: 395,
        },
      ];
      return (
        <div  style={{marginTop: 20, marginBottom:10}}>
          <div>
            <Row>
              <Col xs={12}>
                <div className="react-table-customizer" id="SalesOrderForm-modalDataGrid1">
                  <ReactDataGrid
                  rowKey="SalesOrder_related_component_id"
                  onGridSort={handleGridSort}
                  columns={columns}
                  rowHeight={25}
                  headerRowHeight={45}
                  rowGetter={rowGetter}
                  rowsCount={getSize()}
                  enableRowSelect="multi"
                  minHeight={290}
                  rowSelection={{
                    showCheckbox: true,
                    onRowsSelected,
                    onRowsDeselected,
                    selectBy: {
                      isSelectedKey: 'isSelected',
                    },
                  }}
                  />
                </div>
              </Col>
            </Row>
          </div>
          <div style={{display: 'flex',flexDirection:'row', justifyContent:'flex-end', alignItems:'center', marginTop: 6, width: '100%'}}>
            <button
            className="btn btn-primary"
            onClick={(event)=>{
              let { rows, doubleClickProductMainId, relatedComponentsList }= this.state
              let choseProductItem = []
              relatedComponentsList.selectedRows.map(item => {
                choseProductItem.push({
                  SKU: (item.row || item).RefNum,
                  Color: (item.row || item).Color || '',
                  Remark: (item.row || item).Remark || '',
                  MainId: (item.row || item).MainId || '',
                })
              })
              let rowsData = []
              rows.map(item => {
                if (item.MainId === doubleClickProductMainId) {
                  rowsData.push({
                    ...item, 
                    Components: choseProductItem.length > 0 ? JSON.stringify(choseProductItem) : '',
                  });
                } else {
                  if(relatedComponentsList.selectedRows.findIndex(choseItem => (choseItem.row || choseItem).MainId == item.MainId) != -1) {
                    rowsData.push({...item, Pid: doubleClickProductMainId });
                  } else if(item.Pid) {
                    if(relatedComponentsList.rows.findIndex(row => row.MainId == item.MainId) != -1) {
                      rowsData.push({...item, Pid: -1});
                    } else {
                      rowsData.push({...item});
                    }
                  } else {
                    rowsData.push({...item, Pid: -1});
                  }
                }
              })
              this.setState({
                rows: rowsData,
              })
              this.closeRelatedComponents()
            }}
            style={{marginRight: '10px'}}
            >
              <i className="fa fa-check" />
              <Translate value="confirm" />
            </button>
            <button
              className="btn btn-danger"
              onClick={this.closeRelatedComponents}
            >
              <i className="fa fa-close" />
              <Translate value="cancel" />
            </button>
          </div>
        </div>
      );
    }

    renderNotation() {
      let {notationModalInfo} = this.state
      return(
        <div className='notationInfoContainer'>
          <div><span className='notationModalLabel'><Translate value="prod_num" />:</span> {notationModalInfo ?notationModalInfo.ProductNum : ''}</div>
          <div><span className='notationModalLabel'><Translate value="ref_num" />:</span> {notationModalInfo ? notationModalInfo.RefNum : ''}</div>
          <div><span className='notationModalLabel'><Translate value="prod_name" />:</span> {notationModalInfo ? notationModalInfo.Name : ''}</div>
          <div><span className='notationModalLabel'><Translate value="color" />:</span> {notationModalInfo ? notationModalInfo.Color : ''}</div>
          <Input
            style={{marginTop: '5px'}}
            type="textarea"
            rows={6}
            onChange={this.onChangeNotation}
            value={notationModalInfo ? notationModalInfo.Remark : ''}
          />
          <div style={{display: 'flex',flexDirection:'row', justifyContent:'flex-end', alignItems:'center', marginTop: 10, width: '100%', gap: '10px'}}>
            <button
              className="btn btn-warning"
              onClick={() => {
                let { rows, notationModalInfo }= this.state
                let idx = rows.length - notationModalInfo.Index - 1
                this.setState({
                  notationModalInfo: rows[idx]
                })
              }}
              disabled={this.state.notationModalInfo.Index === this.state.rows.length}
            >
              <Translate value="notation_modal_previous" />
            </button>
            <button
              className="btn btn-warning"
              onClick={() => {
                let { rows, notationModalInfo }= this.state
                let idx = rows.length - notationModalInfo.Index + 1
                this.setState({
                  notationModalInfo: rows[idx]
                })
              }}
              disabled={this.state.notationModalInfo.Index === 1}
            >
              <Translate value="notation_modal_next" />
            </button>
            <button
            className="btn btn-primary"
            onClick={()=>{
              let { rows, notationModalInfo }= this.state
              let idx = rows.length - notationModalInfo.Index
              rows[idx].Remark = notationModalInfo.Remark
              this.setState({
                rows
              })
              this.closeNotationModal()
            }}
            >
              <Translate value="confirm" />
            </button>
            <button
              className="btn btn-danger"
              onClick={this.closeNotationModal}
            >
              <Translate value="cancel" />
            </button>
          </div>
        </div>
      )
    }

    renderSalesHistory() {
      if ((this.props.salesItemHistoryIsLoading && !this.props.salesItemHistoryError)) return <Spinner />;
      else if (this.props.salesItemHistoryError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.salesItemHistoryError)}</div></ContentWrapper>;
      const getRows = () => Data.Selectors.getRows(this.state.salesItemHistories);
      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      const handleFilterChange = (filter) => {
        const newFilters = Object.assign({}, this.state.salesItemHistories.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const salesItemHistories = { ...this.state.salesItemHistories, filters: newFilters };
        this.setState({ salesItemHistories });
      };

      const onClearFilters = () => {
        const salesItemHistories = { ...this.state.salesItemHistories, filters: {} };
        this.setState({ salesItemHistories });
      };
      const columns = [
        {
          key: 'Quantity',
          name: <Translate value="qty" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 40,
        },
        ...isGGI ? [
          {
            key: 'SmallUnitPrice',
            name: <Translate value="small_unit_price" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 120,
          }
        ]: [],
        {
          key: 'UnitPrice',
          name: <Translate value="so_dollarsign" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 50,
        },
        {
          key: 'SIUnitPrice',
          name: <Translate value="si_dollarsign" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 50,
        },
        {
          key: isOLG ? 'OrderDate' : 'Date',
          name: <Translate value="date" />,
          resizable: true,
          sortable: true,
          width: 85,
          formatter: isOLG ? DateFormatter : DateFormatterChina,
        },
      ];
      return(
        <div>
          <Row>
            <Col xs={12}>
              <div id="salesOrders-dataGrid1">
                <ReactDataGrid
                  rowKey="SalesOrder_history_id"
                  columns={columns}
                  rowHeight={25}
                  headerRowHeight={45}
                  rowGetter={rowGetter}
                  rowsCount={getSize()}
                  minHeight={270}
                  toolbar={<Toolbar enableFilter />}
                  onAddFilter={handleFilterChange}
                  onClearFilters={onClearFilters}
                />
              </div>
            </Col>
          </Row>
        </div>
      )
    }

    renderPreviousSOs() {
      if ((this.props.previousOrdersIsLoading && !this.props.previousOrdersError) || (this.props.detailByNumIsLoading && !this.props.detailByNumError)) return <Spinner />;
      else if (this.props.previousOrdersError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.previousOrdersError)}</div></ContentWrapper>;

      // Parameters of the react-data-grid
      const getRows = () => Data.Selectors.getRows(this.state.previousSOs);

      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      // Handle the row select function
      const onRowClick = (rowIdx, row) => {
        if (rowIdx !== -1) {
          const rows = getRows();

          /* Single row select on row click */
          rows.map((r) => {
            r.isSelected = false;
          });
          const selectedRows = [rows[rowIdx]];
          rows[rowIdx].isSelected = true;

          const previousSOs = { ...this.state.previousSOs, rows, selectedRows };
          this.setState({ previousSOs });
          if (isLAP || isGGI) {
            this.props.fetchPreviousOrderById(row.SalesOrder_id, this.props.Company_id, this.props.Pickup_Warehouse_id);
          } else {
            this.props.fetchPreviousOrderById(isOLG ? row.SalesInvoice_id : row.SalesOrder_id, '', '', isOLG);
          }
        }
      };

      const onRowSelect = (rows) => {
        const previousSOs = { ...this.state.previousSOs, selectedRows: rows };
        this.setState({ previousSOs });
      };

      const onRowsSelected = (rows) => {
        const newRows = getRows();
        newRows.map((r) => {
          r.isSelected = false;
        });
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = true;
        });
        const previousSOs = { ...this.state.previousSOs, rows: newRows, selectedRows: [rows[0].row] };
        this.props.fetchPreviousOrderById(isOLG ? rows[0].row.SalesInvoice_id : rows[0].row.SalesOrder_id, '', '', isOLG);
        this.setState({ previousSOs });
      };

      const onRowsDeselected = (rows) => {
        const newRows = getRows();
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = false;
        });
        const previousSOs = { ...this.state.previousSOs, rows: newRows, selectedRows: [] };
        this.setState({ previousSOs });
      };
      const handleGridSort = (sortColumn, sortDirection) => {
        const previousSOs = { ...this.state.previousSOs, sortColumn, sortDirection };
        this.setState({ previousSOs });
      };

      const columns = [
        ...isSV ? [{
          key: "PONum",
          name: <Translate value="CPO" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        }] : [],
        ...!isOLG ? [{
          key: 'SONum',
          name: <Translate value="so_no" />,
          resizable: true,
          sortable: true,
          filterable: false,
          width: 110,
        }] : [],
        ...isOLG ? [{
          key: 'InvoiceNum',
          name: <Translate value="invoice_no" />,
          resizable: true,
          sortable: true,
          filterable: false,
          width: 110,
        }, {
          key: "CreateTime",
          name: <Translate value={"si_date"} />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
          formatter: DateFormatter
        }, {
          key: 'OrderNum',
          name: <Translate value="so_no" />,
          resizable: true,
          sortable: true,
          filterable: false,
          width: 110,
        },] : [],
      ];

      return (
        <div>
          <Row>
            <Col xs={12}>
              <div id="salesOrders-dataGrid1">
                <ReactDataGrid
                  rowKey="SalesOrder_id"
                  columns={columns}
                  rowHeight={25}
                  headerRowHeight={45}
                  rowGetter={rowGetter}
                  rowsCount={getSize()}
                  minHeight={221}
                  enableRowSelect="single"
                  onRowSelect={onRowSelect}
                  onRowClick={onRowClick}
                  rowSelection={{
                    showCheckbox: true,
                    onRowsSelected,
                    onRowsDeselected,
                    selectBy: {
                      isSelectedKey: 'isSelected',
                    },
                  }}
                  onGridSort={handleGridSort}
                />
              </div>
            </Col>
          </Row>
        </div>
      );
    }

    renderPreviousOrders() {
      if ((this.props.previousOrdersIsLoading && !this.props.previousOrdersError) || (this.props.detailByNumIsLoading && !this.props.detailByNumError)) return <Spinner />;
      else if (this.props.previousOrdersError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.previousOrdersError)}</div></ContentWrapper>;
      // Parameters of the react-data-grid
      const getRows = () => Data.Selectors.getRows(this.state.previousOrders);
      const getSize = () => getRows().length;
      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };
      const onRowsSelected = (rows) => {
        const newRows = getRows();
        const ordersRows = [...this.state.previousOrders.rows];
        const selectedRows = [...this.state.previousOrders.selectedRows];
        const selectedIndexes = this.state.previousOrders.selectedIndexes.concat(rows.map(r => r.rowIdx));
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = true;
          selectedRows.push(r.row);
          if(isOLG) {
            const success = (response) => {
              if(response && response.data) {
                this.setState({priceObj:[{price:response.data.Price,id:r.row.Product_id}]})
              }
            }
            this.props.fetchSalesOrderProductByIDSuccess(r.row.Product_id, this.state.currentCustomer, this.props.Company_id, this.props.Pickup_Warehouse_id, success);
          }
        });
        const previousOrders = { ...this.state.previousOrders, rows: ordersRows, selectedIndexes, selectedRows };
        this.setState({ previousOrders });
      };
      const onRowsDeselected = (rows) => {
        const rowIndexes = rows.map(r => r.rowIdx);
        const newRows = [...this.state.previousOrders.rows];
        const selectedIndexes = this.state.previousOrders.selectedIndexes.filter(i => rowIndexes.indexOf(i) === -1);
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = false;
        });
        const previousOrders = { ...this.state.previousOrders, rows: newRows, selectedIndexes };
        this.setState({ previousOrders });
      };
      const onRowClick = (rowIdx, row) => {
        if (rowIdx > -1) {
          if (this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') {
          this.props.fetchItemSalesHistory(this.state.currentCustomer, row.Product_id);
          }
          // this.props.fetchProductInfo(row.Product_id);
          if (isOLG || isLAP) {
            this.props.fetchSalesOrderProductByID(row.Product_id, this.state.currentCustomer, this.props.Company_id, this.props.Pickup_Warehouse_id);
          }
        }
      };
      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        const previousOrders = { ...this.state.previousOrders, sortColumn, sortDirection };
        this.setState({ previousOrders });
      };
      const onRowSelect = (rows) => {
        const previousOrderes = { ...this.state.previousOrders, selectedRows: rows };
        this.setState({ previousOrders });
      };
      // Custom Formatter component
      const IsEnabledFormatter = React.createClass({
        render() {
          if (this.props.value) return <span className="label label-success"><Translate value="enabled" /></span>;
          return <span className="label label-danger"><Translate value="disable" /></span>;
        },
      });

      const handleFilterChange = (filter) => {
        const newFilters = Object.assign({}, this.state.previousOrders.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const previousOrders = { ...this.state.previousOrders, filters: newFilters };
        this.setState({ previousOrders });
      };

      // all filters removed
      const onClearFilters = () => {
        const previousOrders = { ...this.state.previousOrders, filters: {} };
        this.setState({ previousOrders });
      };


      const showProductCost = () => {
        if (!(isEKC || isLMH || isSDR || isCRW || isSC) && checkPermissionLocal('no_show_product_cost')) {
          return false;
        }
        if ((isEKC || isLMH || isSDR || isCRW || isSC) && checkPermissionLocal('no_show_sales_order_cost')) {
          return false;
        }
        return true;
      };

      // Column difinition
      const columns = [
        ...isOLG? [] : [
          {
            key: 'ProductNum',
            name: <Translate value="product_num" />,
            resizable: true,
            sortable: true,
            width: 90,
            filterable: true,
          }
        ],
        {
          key: 'RefNum',
          name: <Translate value={isOLG ? "item_no" : isVAK ? "sku" : "ref_num"} />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 170,
          filterable: true,
          filterRenderer: FilterMultiKeyword,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          filterable: true,
          filterRenderer: FilterMultiKeyword,
          width: 100,
        },
        {
          key: 'Quantity',
          name: <Translate value="qty" />,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
          formatter: BoldTextFormatter,
        },
        ...isGGI?[
          {
            key: 'SmallUnitPrice',
            name: <Translate value="small_pr" />,
            resizable: true,
            sortable: true,
            width: 80,
            filterable: true,
            editable: true,
          },
        ]:[],
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 65,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: isOLG ? 'ArrivalPrice' : 'CostPrice',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 75,
          filterable: true,
          // formatter: BoldCashFormatter,
        }] : [],
        {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 55,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'TotalNetWeight',
          name: <Translate value="total_wt" />,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
        },
      ];
      return (
      // Previous Orders Table
        <Row>
          <Col xs={12} style={{ marginTop: '-22px' }}>
            <div className="PreviousOrders-dataGrid" style={{ maxWidth: '99%' }}>
              <ReactDataGrid
                rowKey="Product_id"
                onGridSort={handleGridSort}
                columns={columns}
                rowHeight={25}
                headerRowHeight={45}
                minHeight={221}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                enableRowSelect="single"
                toolbar={<Toolbar enableFilter />}
                onAddFilter={handleFilterChange}
                onClearFilters={onClearFilters}
                onRowUpdated={this.handleRowUpdated}
                onRowSelect={onRowSelect}
                onRowClick={onRowClick}
                rowSelection={{
                  showCheckbox: true,
                  enableShiftSelect: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
              />
            </div>
          </Col>
        </Row>
      );
    }
    renderItemHistory() {
      // Column difinition
      const columns = [
        {
          key: 'Quantity',
          name: <Translate value="qty" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: isChinaTown ? 45 : 40,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="so_dollarsign" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 50,
        },
        {
          key: 'SIUnitPrice',
          name: <Translate value="si_dollarsign" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: isChinaTown ? 60 : 50,
        },
        {
          key: isOLG ? 'OrderDate' : 'Date',
          name: <Translate value="date" />,
          resizable: true,
          sortable: true,
          width: 85,
          formatter: (isOLG || isLAP) ? DateFormatter : DateFormatterChina,
        },
        ...isSH && [{
          key: 'OrderQuantity',
          name: <Translate value="total" />,
          resizable: true,
          sortable: true,
          width: 80,
        }],
      ];

      if (isChinaTown) {
        const index1 = _.findIndex(columns, { key: "UnitPrice" });
        columns.splice(index1, 1);
      }
      if (isGGI) {
        const small = {
          key: 'SmallUnitPrice',
          name: <Translate value="small_un" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 50,
        }
        const index = _.findIndex(columns, { key: "UnitPrice" });
        columns.splice(index, 0, small);
      }

      // let minHeight = isChinaTown ? 385 : 70; //chinatest
      let minHeight = isOCM || isCPG || isVIP ? 130 : 70; //chinatest
      return (
        <ItemHistoryGrid
          columns={columns}
          rowHeight={25}
          minHeight={minHeight}
        />
      );
    }
    renderPurchaseHistory() {
      const columns = [
        {
          key: 'unit_price',
          name: <Translate value="receive$" />,
          resizable: true,
          sortable: true,
          width: 100,
          formatter: ({ value }) => (<div style={{textAlign: 'center'}}>{value}</div>),
          getRowMetaData: row => row,
        },
        {
          key: 'create_time',
          name: <Translate value="date" />,
          resizable: true,
          sortable: true,
          width: 85,
          formatter: DateFormatter
        },
      ];
      let minHeight = 70;
      return (
        <PurchaseHistoryGrid
          columns={columns}
          rowHeight={25}
          minHeight={minHeight}
        />
      );
    }

    renderLapPrice2 ({value}) {
        return (
          <span style={{ 'font-weight': 'bold' }}>
            {
              (value !== null && !isNaN(value) && `$${Math.round(value * 100)/100}`)
            }
          </span>
        );
    }

    renderTable() {
      const that = this;
      // Parameters of the react-data-grid
      const allRows = Data.Selectors.getRows(this.state);
      if (isHMM) {
        allRows.sort((valueA, valueB) => parseFloat(valueA.Order) <= parseFloat(valueB.Order) ? -1 : 1)
      }
      const getRows = () => allRows;
      const getSize = () => getRows().length;
      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return Object.assign({ Idx: rowIdx + 1 }, rows[rowIdx]);
      };
      const onRowsSelected = (rows) => {
        const newRows = this.state.rows;
        newRows.map((r) => {
          r.isSelected = false;
        });
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = true;
        });
        this.setState({ ...this.state, rows: newRows });
      };
      const onRowsDeselected = (rows) => {
        const newRows = this.state.rows;
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = false;
        });
        this.setState({ ...this.state, rows: newRows });
      };

      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        const state = Object.assign({}, this.state, { sortColumn, sortDirection });
        this.setState(state);
      };
      const handleFilterChange = (filter) => {
        let filteredRows = [...this.state.rows];
        const newFilters = Object.assign({}, this.state.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        for (var property in newFilters) {
          if (newFilters.hasOwnProperty(property)) {
            filteredRows = filteredRows.filter((obj) => {
              if (obj[property]) {
                return String((obj[property]).toUpperCase()).includes((newFilters[property].filterTerm).toUpperCase());
              }
              return false;
            });
          }
        }
        this.setState({ filters: newFilters, filteredRows });
      };
      const onClearFilters = () => {
        // all filters removed
        this.setState({ filters: {} });
      };

      const isNumeric = (str) => {
        if (typeof str !== "string") return false; // we only process strings!
        return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
               !isNaN(parseFloat(str)); // ...and ensure strings of whitespace fail
      }

      // for ABCFF to set received case qty [ReceivedCaseQty] = case qty [Quantity]
      const autoLoad = () => {
        const rows = getRows();
        let newRows = [...this.state.rows];
        newRows.map((row, rowIdx) => {
          row.ReceivedCaseQty = row.Quantity;
          const e = {
            cellKey: "autoLoad",
            key: undefined,
            rowIdx: rowIdx,
            updated: {ReceivedCaseQty: String(row.Quantity)}
          }
          handleRowUpdated(e);
        });
        this.setState({ rows: newRows });
      };

      // here
      const handleRowUpdated = (e) => {
        if (isHMM) {
          if (e.cellKey === 'Order') {
            if (!isNumeric(e.updated.Order)) {
              return;
            }
            const rows = this.state.rows;
            let positionIndexExsited = false;
            rows.forEach((row, idx)=> {
              if (e.updated.Order === row.Order && e.rowIdx !== idx) {
                positionIndexExsited = true;
                alert('Position Index has been taken');
                // return;
              }
            });
            if (positionIndexExsited) {
              return;
            }
          }
        }
        const rows = getRows();
        const filteredRows = this.state.filteredRows;
        let index;

        let recalcTemp1 = 0
        if (isLMH && e.updated.LineDiscount) {
          recalcTemp1 = Number(rows[e.rowIdx].OriginalPrice) * (1-(Number(e.updated.LineDiscount)*0.01));
          Object.assign(rows[e.rowIdx], {
            TotalPrice: +roundToDecimals(parseFloat(recalcTemp1 * rows[e.rowIdx].Quantity), 2).toFixed(2),
            UnitPrice: +roundToDecimals(parseFloat(recalcTemp1), 2).toFixed(2)
          });
        }

        let recalcTemp2 = 0;
        if (isLMH && e.updated.UnitPrice) {
          recalcTemp2 = (Number(rows[e.rowIdx].OriginalPrice)-Number(e.updated.UnitPrice))/Number(rows[e.rowIdx].OriginalPrice);
          recalcTemp2 = recalcTemp2*100;
          Object.assign(rows[e.rowIdx], {
            LineDiscount: +roundToDecimals(parseFloat(recalcTemp2), 2).toFixed(2),
          });
        }

        if ((e.updated.PalletQuantity != null) && isDSQ && isABCFF) {
          if (isNaN(e.updated.PalletQuantity)) {
            return;
          }
          if ((this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && rows[e.rowIdx].AvailablePallets && (e.updated.PalletQuantity > rows[e.rowIdx].AvailablePallets)) {
            alert("Cannot exceed available pallet quantity: " + rows[e.rowIdx].AvailablePallets);
            return;
          }
        }

        // if ((e.updated.Sqft != null) && rows[e.rowIdx].SqftPack && isEKC) {
        //   if (isNaN(e.updated.Sqft) || isNaN(rows[e.rowIdx].SqftPack)) {
        //     return;
        //   } else {
        //     rows[e.rowIdx].Quantity = Math.ceil(Number(e.updated.Sqft)/Number(rows[e.rowIdx].SqftPack));
        //   }
        // }

        if (e.updated.Quantity != null) {
          if (isNaN(e.updated.Quantity)) {
            return;
          }
          
          // crw can't edit child product
          if ((isCRW || isSC)&& rows[e.rowIdx].ParentRefNum) {
            alert("Cannot edit child product");
            return;
          }

          if(isSH && Number(e.updated.Quantity || 0) < Number(rows[e.rowIdx].PickedQuantity || 0)) {
            alert("The order quantity cannot be less than the picked qty");
            return
          }
          // if (isSV && rows[e.rowIdx].MinOrderQty && (e.updated.Quantity < rows[e.rowIdx].MinOrderQty)) {
          //   alert("Cannot be lower than Minimum Order Quantity: " + rows[e.rowIdx].MinOrderQty);
          //   return;
          // }

          if (isOCM) {
            const result = e.updated.Quantity / this.props.productInfo.MultipleQuantityPerOrder;
            if (this.props.productInfo.MultipleQuantityPerOrder && !Number.isInteger(result)) {
              alert(`Multiple Qty/Order is ${this.props.productInfo.MultipleQuantityPerOrder}`);
              // return;
            }
          }
          if (!isSV && !isDAICHEONG && !isHO && !isJRC && !isEKC && !isLMH && !isSDR && !isCRW && !isSC && !isLAP && !isCPG && !isOLG && !isMH && !isTQ && !isVIP && !isGFD) {
            if ((this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') && rows[e.rowIdx].AvailableQuantity && (e.updated.Quantity > rows[e.rowIdx].AvailableQuantity)) {
              alert("Cannot exceed available quantity: " + rows[e.rowIdx].AvailableQuantity);
              return;
            }
            if (isGGI || isVAK || isTU) {
              const row = rows[e.rowIdx];
              if(!this.props.SmallUnitPrice && row.SmallUnitPrice) {
                this.props.setValue('salesOrderForm', 'SmallUnitPrice', row.SmallUnitPrice)
              }
              if (!row.Batch_id && !row.Batch_id_id) {
                if (row.InStockOnhand === undefined && this.props.productInfo) {
                  if (row.Product_id === this.props.productInfo.Product_id) {
                    row.InStockOnhand = this.props.productInfo.InStockOnhand;
                  }
                }
                if (row.IsOverSaleable === undefined && this.props.productInfo) {
                  if (row.Product_id === this.props.productInfo.Product_id) {
                    row.IsOverSaleable = this.props.productInfo.IsOverSaleable;
                  }
                }
                //set selected inventory row
                this.selectInventoryInfo(row, () => {
                  this.setConvertedMaxStock(this.props.productInfo.InStock);
                  const price = row.UnitPrice
                  //set form values
                  this.props.setSaleOrderProductValues(roundToDecimals(price, 4), 'salesOrderForm', {
                    ProductCost: row.CostPrice,
                    NetWeight: row.NetWeight,
                    PackageSize_1: row.PackageSize_1,
                  });
                  this.props.setValue('salesOrderForm', 'Quantity', e.updated.Quantity);
                  this.setState({currentEditingProduct: row}, () => this.handleNotationEnter({charCode: 13}));
                });
                return;
              }
            }

            // here to skip batch check
            if (!isABCFF && !isSH && !isCCW && !isCTP) {
              const batchAvaliableQty = this.calculateLineMaxQty(rows[e.rowIdx]);
              const quantityAdded = parseInt(e.updated.Quantity) - parseInt(rows[e.rowIdx].Quantity);
              if (!isABCFF && batchAvaliableQty === false) {
                alert('batch not found');
                return;
              }
              const currentBatch = _.find(this.props.batchesInfo.batches, (batch) => (batch.id === rows[e.rowIdx].Batch_id) || (batch.id === rows[e.rowIdx].Batch_id_id));
              const canBeOversale = currentBatch.is_initial_batch && this.props.productInfo.IsOverSaleable;
              if (!isHMM && !canBeOversale && (quantityAdded > batchAvaliableQty)) {
                alert("Batch quantity left: " + batchAvaliableQty);
                return;
              }
            }
          }
          if (parseFloat(e.updated.Quantity) < 0) {
            alert("Quantity is not allowed to be negative");
            return;
          }
          if (rows[e.rowIdx].ProductType == 'Fixed' || rows[e.rowIdx].ProductType == 'Non-Product') { Object.assign(rows[e.rowIdx], { TotalPrice: +roundToDecimals(parseFloat(e.updated.Quantity * rows[e.rowIdx].UnitPrice), 4).toFixed(4) }); }
          else {
            if(isGGI) {
              Object.assign(rows[e.rowIdx], { TotalPrice: +roundToDecimals(parseFloat(e.updated.Quantity * rows[e.rowIdx].SmallUnitPrice * rows[e.rowIdx][!isJML ? 'NetWeight' : 'PackageSize_1']), 4).toFixed(4) });
            } else {
              if(isOLG && rows[e.rowIdx].ProductType == 'Non-Fixed') {
                let currentWeights = rows[e.rowIdx].Weights ? [...rows[e.rowIdx].Weights] :[];
                if(currentWeights.length == 0) {
                  for(let i= 0; i< e.updated.Quantity; i++) {
                    currentWeights.push(0)
                  }
                } else {
                  if(currentWeights.length > e.updated.Quantity) {
                    let replace = [];
                    for(let i= 0; i< e.updated.Quantity; i++) {
                      replace.push(currentWeights[i]);
                    }
                    currentWeights = [...replace];
                  } else {
                    for(let i= currentWeights.length; i< e.updated.Quantity; i++) {
                      currentWeights.push(0);
                    }
                  }
                }
                this.setState({editedRow: rows[e.rowIdx], rowChosen:e.rowIdx, totalLoaded:e.updated.Quantity,currentWeights},()=>{
                  this.openSetWeight()
                })
                return
              } else {
                Object.assign(rows[e.rowIdx], { TotalPrice: +roundToDecimals(parseFloat(e.updated.Quantity * rows[e.rowIdx].UnitPrice * rows[e.rowIdx][!isJML ? 'NetWeight' : 'PackageSize_1']), 4).toFixed(4) });
              }
            }
          }
          let Profit1 = 0;
          let SalesMargin1 = 0;
          if(isLAP) {
            // sum line product cost
            let lineTotalCost = 0;
            let totalPrice = 0;
            if(rows[e.rowIdx].ProductType === 'Non-Fixed' || rows[e.rowIdx].ProductType === 'Per-Pound') {
              totalPrice = roundTo(parseFloat(rows[e.rowIdx].UnitPrice * (rows[e.rowIdx].NetWeight || 0) * e.updated.Quantity), 2);
            } else {
              totalPrice = roundTo(parseFloat(e.updated.Quantity * rows[e.rowIdx].UnitPrice), 2);
            }

            if(rows[e.rowIdx].ProductType == 'Non-Fixed' || rows[e.rowIdx].ProductType == 'Per-Pound') {
              lineTotalCost = (rows[e.rowIdx].ProductCost || rows[e.rowIdx].CurrentCost || rows[e.rowIdx].CostPrice || 0) * (rows[e.rowIdx].NetWeight || 0) * (e.updated.Quantity || 0);
            } else {
              lineTotalCost = (rows[e.rowIdx].ProductCost || rows[e.rowIdx].CurrentCost || 0) * (e.updated.Quantity || 0);
            }
            if(e.updated.Quantity == 0) {
              Profit1 = 0;
              SalesMargin1 = 0;
            } else {
              Profit1 = roundTo(parseFloat(totalPrice) - lineTotalCost, 2);
              SalesMargin1 = roundTo((parseFloat(totalPrice) - lineTotalCost) / parseFloat(totalPrice) * 100, 2);
            }
          }

          // handleRowUpdated child product
          if ((isCRW || isSC) && rows[e.rowIdx].IsCombo === true) {
            rows.map((r, i) => {
              if (r.ParentRefNum === rows[e.rowIdx].RefNum) {
                const child = rows[e.rowIdx].ChildProducts2.filter(p => (p.RefNum === r.RefNum));
                setTimeout(() => {
                  handleRowUpdateChild({
                    cellKey: "Quantity",
                    key: "Enter",
                    rowIdx: i,
                    updated: {Quantity: child[0].child_qty * e.updated.Quantity}
                  });
                }, 10*i);
              }
            });
          }
          Object.assign(rows[e.rowIdx], { TotalNetWeight: roundTo(e.updated.Quantity * rows[e.rowIdx].NetWeight, 2), Profit1, SalesMargin1 });
          if (rows[e.rowIdx].CRV) { Object.assign(rows[e.rowIdx], { TotalCRV: +roundTo(parseFloat(e.updated.Quantity * rows[e.rowIdx].CRV), 2).toFixed(2) }); }
        }
        if(isSH && e.updated.PickedQuantity != null) {
          let pickedQty = Number(e.updated.PickedQuantity || 0) > Number(rows[e.rowIdx].Quantity) ? Number(rows[e.rowIdx].Quantity) : e.updated.PickedQuantity;
          Object.assign(rows[e.rowIdx], { PickedQuantity: pickedQty });
        }
        if (isABCFF && e.updated.ReceivedCaseQty != null) {
          if (!isNumeric(e.updated.ReceivedCaseQty)) {
            return;
          }
          Object.assign(rows[e.rowIdx], { ReceivedQuantity: e.updated.ReceivedCaseQty*rows[e.rowIdx].PerBoxQty });
        }

        if (e.updated.UnitPrice != null) {
          if (isNaN(e.updated.UnitPrice)) {
            return;
          }
          if (parseFloat(e.updated.UnitPrice) > 0  && e.updated.UnitPrice < rows[e.rowIdx].LowestSalePrice) {
            if (!isSV && isSH) {
              this.setState({
                case: 'belowRefPrice', confirmOpen: true, RowBeingEdited: { ...rows[e.rowIdx] }, newPrice: e.updated.UnitPrice,
                // case: 'belowLowestSalePrice', confirmOpen: true, RowBeingEdited: { ...rows[e.rowIdx] }, newPrice: e.updated.UnitPrice,
              });
              return;
            }
          }
          if (parseFloat(e.updated.UnitPrice) < 0) {
            alert("Unit Price is not allowed to be negative");
            return;
          }
          let Profit1 = 0;
          let SalesMargin1 = 0;
          if(isLAP) {
            // sum line product cost
            let lineTotalCost = 0;
            let totalPrice = 0;
            if(rows[e.rowIdx].ProductType === 'Non-Fixed' || rows[e.rowIdx].ProductType === 'Per-Pound') {
              totalPrice = roundTo(parseFloat(e.updated.UnitPrice * (rows[e.rowIdx].NetWeight || 0) * rows[e.rowIdx].Quantity), 2);
            } else {
              totalPrice = roundTo(parseFloat(rows[e.rowIdx].Quantity * e.updated.UnitPrice), 2);
            }

            if(rows[e.rowIdx].ProductType == 'Non-Fixed' || rows[e.rowIdx].ProductType == 'Per-Pound') {
              lineTotalCost = (rows[e.rowIdx].ProductCost || rows[e.rowIdx].CurrentCost || rows[e.rowIdx].CostPrice || 0) * (rows[e.rowIdx].NetWeight || 0) * (rows[e.rowIdx].Quantity || 0);
            } else {
              lineTotalCost = (rows[e.rowIdx].ProductCost || rows[e.rowIdx].CurrentCost || 0) * (rows[e.rowIdx].Quantity || 0);
            }
            if(rows[e.rowIdx].Quantity == 0) {
              Profit1 = 0;
              SalesMargin1 = 0;
            } else {
              Profit1 = roundTo(parseFloat(totalPrice) - lineTotalCost, 2);
              SalesMargin1 = roundTo((parseFloat(totalPrice) - lineTotalCost) / parseFloat(totalPrice) * 100, 2);
            }
          }
          if (rows[e.rowIdx].ProductType === 'Fixed' || rows[e.rowIdx].ProductType === 'Non-Product') { Object.assign(rows[e.rowIdx], { TotalPrice: +roundToDecimals(parseFloat(e.updated.UnitPrice * rows[e.rowIdx].Quantity), 4).toFixed(4), Profit1, SalesMargin1 }); } else { Object.assign(rows[e.rowIdx], { TotalPrice: +roundToDecimals(parseFloat(e.updated.UnitPrice * rows[e.rowIdx].NetWeight * rows[e.rowIdx].Quantity), 4).toFixed(4), Profit1, SalesMargin1 }); }

        }
        if (e.updated.SmallUnitPrice != null && isGGI) {
          if (isNaN(e.updated.SmallUnitPrice)) {
            return;
          }
          if (parseFloat(e.updated.SmallUnitPrice) > 0 && e.updated.SmallUnitPrice < rows[e.rowIdx].LowestSalePrice) {
            this.setState({
              case: 'belowRefPrice', confirmOpen: true, RowBeingEdited: { ...rows[e.rowIdx] }, newPrice: e.updated.SmallUnitPrice,
              // case: 'belowLowestSalePrice', confirmOpen: true, RowBeingEdited: { ...rows[e.rowIdx] }, newPrice: e.updated.UnitPrice,
            });
            return;
          }
          if (parseFloat(e.updated.SmallUnitPrice) < 0) {
            alert("Small Unit Price is not allowed to be negative");
            return;
          }
          Object.assign(rows[e.rowIdx], {
            TotalPrice: +roundToDecimals(parseFloat(e.updated.SmallUnitPrice * rows[e.rowIdx].Quantity * rows[e.rowIdx].ConvertNum), 4).toFixed(4),
            UnitPrice: +roundToDecimals(parseFloat(e.updated.SmallUnitPrice * rows[e.rowIdx].ConvertNum), 4).toFixed(4)
          });
        }
        if (e.updated.Remark != null) {
          if(isLMHST) {
            if(!rows[e.rowIdx].IsCabinet && rows[e.rowIdx].Pid != -1) {
              let pidIndex = rows.findIndex(row => row.MainId == rows[e.rowIdx].Pid);
              if(pidIndex != -1) {
                let cpComponents = JSON.parse(rows[pidIndex].Components);
                let coms = cpComponents.map(com => {
                  if(com.MainId == rows[e.rowIdx].MainId) {
                    return {...com, Remark: e.updated.Remark};
                  }
                  return {...com};
                })
                Object.assign(rows[pidIndex], {Components: JSON.stringify(coms)});
              }
            }
          }
          Object.assign(rows[e.rowIdx], { Remark: e.updated.Remark });
        }
        if (isHMM && e.cellKey === 'Order') {
          Object.assign(rows[e.rowIdx], { Order: parseFloat(e.updated.Order)});
        } else {
          Object.assign(rows[e.rowIdx], e.updated);
        }
        if (e.updated.NetWeight != null) {
          if(isOLG) {
            if(rows[e.rowIdx].ProductType == 'Non-Fixed' || rows[e.rowIdx].ProductType == 'Per-Pound') {
              if(rows[e.rowIdx].Quantity > 0 && rows[e.rowIdx].ProductType == 'Non-Fixed') {
                let weights = [];
                for(let i=0;i<rows[e.rowIdx].Quantity; i++) {
                  weights.push(roundTo(rows[e.rowIdx].NetWeight));
                }
                Object.assign(rows[e.rowIdx], {
                  Weights: weights,
                });
              }
              Object.assign(rows[e.rowIdx], {
                    NetWeight: e.updated.NetWeight,
                    TotalNetWeight: roundTo(rows[e.rowIdx].NetWeight * rows[e.rowIdx].Quantity, 2),
                  });
                }
          } else {
            Object.assign(rows[e.rowIdx], {
              NetWeight: e.updated.NetWeight,
              TotalNetWeight: roundTo(rows[e.rowIdx].NetWeight * rows[e.rowIdx].Quantity, 2),
            });
          }
        }
        // this.setState({ rows });
        // }
        // CODE FOR UPDATING TOTALS
        let totalPrice = 0;
        let finalWeight = 0;
        let finalPrice = 0;
        let totalTax = 0;
        let totalCRV = 0;
        const discount = parseFloat(this.props.discount) || 0;
        // if (totalPrice == null)
        //   totalPrice = 0;
        // if (finalWeight ==null)
        //   finalWeight = 0;
        rows.map((row) => {
          if(isHMM) {
            totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
          } else {
            totalPrice += parseFloat(row.TotalPrice);
          }
          finalWeight += parseFloat(row.NetWeight * row.Quantity);
          if (row.IsTaxable === true || row.IsTaxable === 'True') {
            if (isHMM) {
              totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(this.state.taxValue / 100);
            } else {
              if(isHO || isJRC || isVIP) {
                if(row.IsAllTaxable === true || !this.props.salesCustomerDetails.Reseller) {
                  totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
                }
              } else {
                totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
              }
            }
          }

          if (row.CRV) {
            if (this.props.salesShippingCustomerDetails && this.props.salesShippingCustomerDetails.HasCRV) {
              row.TotalCRV = +roundTo(parseFloat(row.CRV * row.Quantity), 2).toFixed(2)
            } else {
              row.TotalCRV = +roundTo(parseFloat(row.CRV * row.Quantity), 2).toFixed(2)
            }
          }
          if (row.TotalCRV) { totalCRV += row.TotalCRV; }
        });

        if (isHMM || isLMH || isSDR || isCRW || isSC || isSUN || isCPG) {
          if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
            totalTax = 0;
          } else {
            if (SODiscount) {
              totalTax = 0;
              rows.map((row, idxx) => {
                if (row.IsTaxable === true) {
                  totalTax += ((parseFloat(row.TotalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)))) * parseFloat(this.state.taxValue / 100);
                }
              });
            }
          }
        }
        const { SODiscount, SOSavings } = this.state; // only one has value
        if ((isEKC || isSH)) {
          if (isEKC && this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
            totalTax = 0;
          } else {
            totalTax = ((parseFloat(totalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)) - Number(SOSavings ? SOSavings : 0))) * parseFloat(this.state.taxValue / 100);
          }
        }

        totalTax = +roundTo(totalTax, 2).toFixed(2);
        finalPrice = parseFloat(totalPrice) * (1 - discount / 100) + parseFloat(totalTax) + parseFloat(totalCRV);
        if(isSH && this.state.ccOrigin) {
          finalPrice = Number(finalPrice) + Number(finalPrice * (this.state.ccOrigin || 0)).toFixed(2);
        }
        finalWeight = +roundTo(finalWeight, 2).toFixed(2);
        totalPrice = +roundToDecimals(totalPrice, 4).toFixed(4);
        finalPrice = +roundTo(finalPrice, 2).toFixed(2);
        this.setState({
          rows, totalPrice, finalWeight, finalPrice, totalTax, totalCRV,
        }, () => {
          const productId = this.state.rows[e.rowIdx].Product_id;
          const productNum = this.state.rows[e.rowIdx].ProductNum;
          if (!rows[e.rowIdx].IsGift && !isLMH && !isSDR && !isCRW && !isSC) {
            this.props.fetchProductPromotion(productId, this.props.selectedCompany.value, null, () => this.checkForPromotions(productNum));
          }
          if ((isEKC || isLMH || isSDR || isCRW || isSC || isOLG || isVAK || isSH)) { this.onConfirmPercentageFee(); }
          // this.checkForPromotions();
        });
      };
      
      // CRW
      const handleRowUpdateChild = (e) => {
        const rows = getRows();
        const filteredRows = this.state.filteredRows;
        let index;

        if (e.updated.Quantity != null) {
          if (isNaN(e.updated.Quantity)) {
            return;
          }

          if (parseFloat(e.updated.Quantity) < 0) {
            alert("Quantity is not allowed to be negative");
            return;
          }
          if (rows[e.rowIdx].ProductType == 'Fixed' || rows[e.rowIdx].ProductType == 'Non-Product') { 
            Object.assign(rows[e.rowIdx], { TotalPrice: +roundToDecimals(parseFloat(e.updated.Quantity * rows[e.rowIdx].UnitPrice), 4).toFixed(4) }); 
          } else {
            Object.assign(rows[e.rowIdx], { TotalPrice: +roundToDecimals(parseFloat(e.updated.Quantity * rows[e.rowIdx].UnitPrice * rows[e.rowIdx][!isJML ? 'NetWeight' : 'PackageSize_1']), 4).toFixed(4) });
          }
          let Profit1 = 0;
          let SalesMargin1 = 0;

          Object.assign(rows[e.rowIdx], { TotalNetWeight: roundTo(e.updated.Quantity * rows[e.rowIdx].NetWeight, 2), Profit1, SalesMargin1 });
          if (rows[e.rowIdx].CRV) { Object.assign(rows[e.rowIdx], { TotalCRV: +roundTo(parseFloat(e.updated.Quantity * rows[e.rowIdx].CRV), 2).toFixed(2) }); }
        }

        if (e.updated.UnitPrice != null) {
          if (isNaN(e.updated.UnitPrice)) {
            return;
          }
          if (parseFloat(e.updated.UnitPrice) > 0  && e.updated.UnitPrice < rows[e.rowIdx].LowestSalePrice) {
            if (!isSV && isSH) {
              this.setState({
                case: 'belowRefPrice', confirmOpen: true, RowBeingEdited: { ...rows[e.rowIdx] }, newPrice: e.updated.UnitPrice,
                // case: 'belowLowestSalePrice', confirmOpen: true, RowBeingEdited: { ...rows[e.rowIdx] }, newPrice: e.updated.UnitPrice,
              });
              return;
            }
          }
          if (parseFloat(e.updated.UnitPrice) < 0) {
            alert("Unit Price is not allowed to be negative");
            return;
          }
          let Profit1 = 0;
          let SalesMargin1 = 0;
          if(isLAP) {
            // sum line product cost
            let lineTotalCost = 0;
            let totalPrice = 0;
            if(rows[e.rowIdx].ProductType === 'Non-Fixed' || rows[e.rowIdx].ProductType === 'Per-Pound') {
              totalPrice = roundTo(parseFloat(e.updated.UnitPrice * (rows[e.rowIdx].NetWeight || 0) * rows[e.rowIdx].Quantity), 2);
            } else {
              totalPrice = roundTo(parseFloat(rows[e.rowIdx].Quantity * e.updated.UnitPrice), 2);
            }

            if(rows[e.rowIdx].ProductType == 'Non-Fixed' || rows[e.rowIdx].ProductType == 'Per-Pound') {
              lineTotalCost = (rows[e.rowIdx].ProductCost || rows[e.rowIdx].CurrentCost || rows[e.rowIdx].CostPrice || 0) * (rows[e.rowIdx].NetWeight || 0) * (rows[e.rowIdx].Quantity || 0);
            } else {
              lineTotalCost = (rows[e.rowIdx].ProductCost || rows[e.rowIdx].CurrentCost || 0) * (rows[e.rowIdx].Quantity || 0);
            }
            if(rows[e.rowIdx].Quantity == 0) {
              Profit1 = 0;
              SalesMargin1 = 0;
            } else {
              Profit1 = roundTo(parseFloat(totalPrice) - lineTotalCost, 2);
              SalesMargin1 = roundTo((parseFloat(totalPrice) - lineTotalCost) / parseFloat(totalPrice) * 100, 2);
            }
          }
          if (rows[e.rowIdx].ProductType === 'Fixed' || rows[e.rowIdx].ProductType === 'Non-Product') { Object.assign(rows[e.rowIdx], { TotalPrice: +roundToDecimals(parseFloat(e.updated.UnitPrice * rows[e.rowIdx].Quantity), 4).toFixed(4), Profit1, SalesMargin1 }); } else { Object.assign(rows[e.rowIdx], { TotalPrice: +roundToDecimals(parseFloat(e.updated.UnitPrice * rows[e.rowIdx].NetWeight * rows[e.rowIdx].Quantity), 4).toFixed(4), Profit1, SalesMargin1 }); }

        }
        if (e.updated.SmallUnitPrice != null && isGGI) {
          if (isNaN(e.updated.SmallUnitPrice)) {
            return;
          }
          if (parseFloat(e.updated.SmallUnitPrice) > 0 && e.updated.SmallUnitPrice < rows[e.rowIdx].LowestSalePrice) {
            this.setState({
              case: 'belowRefPrice', confirmOpen: true, RowBeingEdited: { ...rows[e.rowIdx] }, newPrice: e.updated.SmallUnitPrice,
              // case: 'belowLowestSalePrice', confirmOpen: true, RowBeingEdited: { ...rows[e.rowIdx] }, newPrice: e.updated.UnitPrice,
            });
            return;
          }
          if (parseFloat(e.updated.SmallUnitPrice) < 0) {
            alert("Small Unit Price is not allowed to be negative");
            return;
          }
          Object.assign(rows[e.rowIdx], {
            TotalPrice: +roundToDecimals(parseFloat(e.updated.SmallUnitPrice * rows[e.rowIdx].Quantity * rows[e.rowIdx].ConvertNum), 4).toFixed(4),
            UnitPrice: +roundToDecimals(parseFloat(e.updated.SmallUnitPrice * rows[e.rowIdx].ConvertNum), 4).toFixed(4)
          });
        }
        if (e.updated.Remark != null) {
          Object.assign(rows[e.rowIdx], { Remark: e.updated.Remark });
        }
        Object.assign(rows[e.rowIdx], e.updated);
        if (e.updated.NetWeight != null) {
          Object.assign(rows[e.rowIdx], {
            NetWeight: e.updated.NetWeight,
            TotalNetWeight: roundTo(rows[e.rowIdx].NetWeight * rows[e.rowIdx].Quantity, 2),
          });
        }
      
        // CODE FOR UPDATING TOTALS
        let totalPrice = 0;
        let finalWeight = 0;
        let finalPrice = 0;
        let totalTax = 0;
        let totalCRV = 0;
        const discount = parseFloat(this.props.discount) || 0;
        rows.map((row) => {
          totalPrice += parseFloat(row.TotalPrice);
          finalWeight += parseFloat(row.NetWeight * row.Quantity);
          if (row.IsTaxable === true || row.IsTaxable === 'True') {
            totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
          }

          if (row.CRV) {
            if (this.props.salesShippingCustomerDetails && this.props.salesShippingCustomerDetails.HasCRV) {
              row.TotalCRV = +roundTo(parseFloat(row.CRV * row.Quantity), 2).toFixed(2)
            } else {
              row.TotalCRV = +roundTo(parseFloat(row.CRV * row.Quantity), 2).toFixed(2)
            }
          }
          if (row.TotalCRV) { totalCRV += row.TotalCRV; }
        });

        if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
          totalTax = 0;
        } else {
          if (SODiscount) {
            totalTax = 0;
            rows.map((row, idxx) => {
              if (row.IsTaxable === true) {
                totalTax += ((parseFloat(row.TotalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)))) * parseFloat(this.state.taxValue / 100);
              }
            });
          }
        }
        const { SODiscount, SOSavings } = this.state; // only one has value

        totalTax = +roundTo(totalTax, 2).toFixed(2);
        finalPrice = parseFloat(totalPrice) * (1 - discount / 100) + parseFloat(totalTax) + parseFloat(totalCRV);
        finalWeight = +roundTo(finalWeight, 2).toFixed(2);
        totalPrice = +roundToDecimals(totalPrice, 4).toFixed(4);
        finalPrice = +roundTo(finalPrice, 2).toFixed(2);
        this.setState({
          rows, totalPrice, finalWeight, finalPrice, totalTax, totalCRV,
        }, () => {
          const productId = this.state.rows[e.rowIdx].Product_id;
          const productNum = this.state.rows[e.rowIdx].ProductNum;
          if (!rows[e.rowIdx].IsGift && !isLMH && !isSDR && !isCRW && !isSC) {
            this.props.fetchProductPromotion(productId, this.props.selectedCompany.value, null, () => this.checkForPromotions(productNum));
          }
          if ((isEKC || isLMH || isSDR || isCRW || isSC || isOLG || isVAK || isSH)) { this.onConfirmPercentageFee(); }
        });
      };


      const onRowClick = (rowIdx, row) => {
        if (rowIdx > -1) {
          this.props.fetchBachesByID(row.Product_id, this.props.Company_id, this.props.Pickup_Warehouse_id);
          this.props.fetchProductInfo2(row.Product_id, this.props.Company_id, this.props.Pickup_Warehouse_id, this.state.currentCustomer);
          if (this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') {
          this.props.fetchItemSalesHistory(this.state.currentCustomer, row.Product_id);
          }
          // if (this.state.yourOrderKey === 1) {
            // this.props.fetchProductInfo2(row.Product_id, this.props.selectedCompany ? this.props.selectedCompany.value : null);
          // }
        }
        if (isVAK) {
          this.props.fetchOrderRequests(rowIdx, row)
        }
        if (isLAP) {
          this.props.fetchItemPurchaseHistory(this.props.Pickup_Warehouse_id, row.Product_id);
        }
      };

      const IsVariableFormatter = React.createClass({
        render() {
          return (
            <span>
              <Button
                bsStyle="danger"
                className="textAlignStyle"
                style={{ height: '23px', width: '39px', padding: '0px' }}
                onClick={(evt) => {
                  evt.stopPropagation();
                  const ProductNum = this.props.dependentValues.ProductNum;
                  const Index = this.props.dependentValues.Index;
                  that.removeRow(Index, ProductNum);
                }}
              >X
              </Button>
            </span>
          );
        },
      });
        // Column difinition
      const showProductCost = () => {
        if (isHMM || isJML) {
          return false
        }
        if (!(isEKC || isLMH || isSDR || isCRW || isSC) && checkPermissionLocal('no_show_product_cost')) {
          return false;
        }
        if ((isEKC || isLMH || isSDR || isCRW || isSC) && checkPermissionLocal('no_show_sales_order_cost')) {
          return false;
        }
        return true;
      };

      const boolOptions = [
        'true',
        'false',
      ];

      let netWeightName = <Translate value="net_wt" />;
      let totalWeightName = <Translate value="total_wt" />;

      const columns = [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        },
        ...isHMM ? [{
          key: 'Order',
          name: <Translate value="positionIndex" />,
          resizable: true,
          sortable: true,
          editable: true,
          width: 70,
          filterable: true,
          // formatter: BoldCashFormatter,
        }] : [{
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        }],
        ...!(isSV || isOLG) ? [{
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }] : [],
        ...isABC ? [{
          key: 'RefNo',
          name: <Translate value="FBA_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PoNo',
          name: <Translate value="pro_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }]: [],
        ...(isEKC || isSDR || isCRW) ? [] : [{
          key: 'RefNum',
          name: isSV ? <Translate value="item_num" /> : <Translate value={isOLG ? "item_no" : isVAK ? "sku" : "ref_num"} />,
          resizable: true,
          sortable: true,
          width: (isSV || isLMH) ? 120 : 70,
          filterable: true,
        }],
        ...isAFM ? [{
          key: 'Brand',
          name: <Translate value="brand" />,
          resizable: true,
          sortable: true,
          width: 100,
        }]: [],
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: (isEKC || isLMH || isSDR || isCRW || isSC) ? 150 : 200,
          filterable: true,
        },
        ...(isSUN && this.state.hideCol) ? [] : [{
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: isEKC ? 250 : isOLG ? 300 : 85,
        }],
        ...(isEKC || isLMH) ? [{
          key: 'SqftTotal',
          name: <Translate value='total_sqft' />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: false,
        }, {
          key: 'SqftPack',
          name: <Translate value='sqft/pk' />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: false,
        }] : [],
        ...(isEKC || isLMH || isSDR || isCRW || isSC || isSV || (isSUN && this.state.hideCol)) ? [] : [
          {
            key: 'PackageSize',
            name: <Translate value="package_size" />,
            resizable: true,
            sortable: true,
            width: 80,
            filterable: true,
          }
        ],
        ...(isSUN && this.state.hideCol) ? [] : [{
          key: 'Quantity',
          name: !isJML ? <Translate value="qty" /> : <Translate value='box' />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          editable: row => (!(isEKC || isLMH) || ((isEKC || isLMH) && row.ProductNum.slice(0,4) !== '0101')),
          getRowMetaData: row => row,
          formatter: BoldTextFormatter,
        }],
        ...isLMH ? [{
          key: 'Color',
          name: <Translate value='color' />,
          resizable: true,
          sortable: true,
          width: 110,
          filterable: true,
          editable: false,
        }, 
        ] : [],
        ...isLMHST ? [
          {
            key: 'Components',
            name: <Translate value='components' />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 165,
            getRowMetaData: row => row,
            formatter: ({ value, dependentValues }) => {
              let parseComponents = [];
              let showValue = '';
              if(value && value != null) {
                parseComponents = [...JSON.parse(value)];
                showValue = parseComponents.map(com => com.SKU).join(',');
              } 
              return <div
                style={{ display:'list-item',width: '100%', height: '100%'}}
                onDoubleClick={() => {
                  let selectedRows =[];
                  let cpRows =[];
                  if(dependentValues.IsCabinet) {
                    this.state.rows.map(item => {
                      if(!item.IsCabinet) {
                        if(item.Pid == -1) {
                          cpRows.push({
                            ...item,
                            isSelected:false,
                          })
                        } else if(dependentValues.MainId == item.Pid){
                          cpRows.push({
                            ...item,
                            isSelected:true,
                          })
                          selectedRows.push({...item, isSelected: true});
                        }            
                      }
                    })
                    let relatedComponentsList = { ...relatedComponentsList, rows: cpRows, selectedRows };
                    this.setState({
                      relatedComponentsList,
                      doubleClickProductMainId: dependentValues.MainId,
                      relatedComponentsModalVisibility: true,
                    }) 
                  }
                }}
              >
                { showValue }
              </div>
            },
          }
        ]:[],
        ...isABBLE ? [{
          key: 'ConvertUnit',
          name: <Translate value='convert_quantity' />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          editable: true,
        }] : [],
        ...isJML ? [{
          key: 'PackageSize_1',
          name: <Translate value='pcs/box' />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          // editable: this.state.editSOPermission,
          editable: true,
          formatter: BoldTextFormatter,
        }] : [],
        ...isSV ? [{
          key: 'PickupQuantity',
          name: <Translate value='shipped_qty' />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        }] : [],
        ...(isSV || isCRW || isSC) ? [{
          key: 'IsCombo',
          name: <Translate value="combo_prod" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          formatter: ({ value }) => (
            <div style={{color: (value === true || value === "true") ? "green": "black"}}>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
          getRowMetaData: row => row,
        } , {
          key: "IsChild",
          name: <Translate value="child_prod" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          formatter: ({ value }) => (
            <div style={{color: (value === true || value === "true") ? "green": "black"}}>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
          getRowMetaData: row => row,
        }, {
          key: 'ParentRefNum',
          name: <Translate value="parent" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        }] : [],
        ...(!isSV && !isEKC && !isLMH && !isSDR && !isCRW && !isSC && !isTQ && !(isSUN && this.state.hideCol)) ? [{
          key: "IsNoReturn",
          name: <Translate value="no_return" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          // editable: true,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
          getRowMetaData: row => row,
        }] : [],
        ...(isVAK) ? [{
          key: 'IsSpare',
          name: <Translate value="is_spare"/>,
          resizable: true,
          sortable: true,
          filterable: false,
          width: 100,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
          getRowMetaData: row => row,
        }] : [],
        ...(isEKC || isLMH || isSDR || isCRW || isSC || isSV || (isSUN && this.state.hideCol)) ? [] : [{
          key: 'BatchExpiredDate',
          name: <Translate value="expired" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          getRowMetaData: row => row,
          formatter: ({ value, dependentValues }) => {
            // if (value) {
              const date = value ? new Date(value).toLocaleString().split(',')[0] : "N/A";
              return (
                <div onDoubleClick={()=>{
                  // this.props.fetchBachesByID(dependentValues.Product_id, this.props.Company_id, this.props.Pickup_Warehouse_id);
                  // this.setState({lineBatchId: dependentValues.Batch_id_id, lineBatchRows: allRows, lineBatchIdx: dependentValues.SalesOrderLine_id });
                  this.setState({lineBatchId: dependentValues.Batch_id_id ? dependentValues.Batch_id_id : dependentValues.Batch_id, lineBatchRows: this.state.rows, lineBatchIdx: dependentValues.Index });
                  this.setBatchesModal2Visibility(true);
                }}>
                 {date}
                </div>)
          }
        }],
        ...(isSUN && this.state.hideCol) ? [] : [{
          key: 'BatchLocation',
          name: <Translate value="location" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        },
        ...(isLMH) ? [{
          key: 'OriginalPrice',
          name: <Translate value="orig_price" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          getRowMetaData: row => row,
          formatter: BoldCashFormatter,
        }] : [],
        ...(isLMH) ? [{
          key: 'LineDiscount',
          name: <Translate value="discount_p" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: row => (((isEKC || isLMH) && row.ProductNum.slice(0,4) !== '0101')),
          getRowMetaData: row => row,
          // formatter: BoldCashFormatter,
        }] : [],
        ...(isEKC || isLMH) ? [{
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: row => (((isEKC || isLMH) && row.ProductNum.slice(0,4) !== '0101')),
          getRowMetaData: row => row,
          formatter: BoldCashFormatter,
        }] : [{
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: (
            (isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false :
            (
              ((isSUN && !checkPermissionLocal('edit_order_line_price') || isGGI || isSDR || isCRW || isSC) ? false : true)
            )),
          getRowMetaData: row => row,
          formatter: ({ value }) => {
              return (
                <span style={{ 'font-weight': 'bold' }}>
            {
              (value !== null && !isNaN(value) && `$${Math.round(value * 100)/100}`)
            }
          </span>)
          },
        }],
        {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: ({ value }) => {
            return (
              <span style={{ 'font-weight': 'bold' }}>
          {
            (value !== null && !isNaN(value) && `$${Math.round(value * 100)/100}`)
          }
        </span>)
        },
        }],
        ...(isLMH || isSDR || isCRW || isSC) ? [{
          key: 'IsTaxable',
          name: <Translate value="taxable" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: ({ value }) => (
            <div style={{color: (value === true || value === "true") ? "green": "red"}}>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        }] : [],
        ...(isEKC || isLMH || isSDR || isCRW || isSC || isSV) ? [] : [{
          key: "IsGift",
          name: <Translate value="gift" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          // editable: true,
          // editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "Yes" : "No" }
            </div>
          ),
          getRowMetaData: row => row,
        }],
        ...(showProductCost() && !isEKC && !isLMH && !isSDR && !isCRW && !isSC && !isSV) ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        ...(isEKC || isLMH || isSDR || isCRW || isSC || isSUN || isSV || isLAP || isOLG) ? [] : [{
          key: 'NetWeight',
          name: netWeightName,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
        }],
        ...(isSUN || isLAP || isOLG) ? [{
          key: 'NetWeight',
          name: netWeightName,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
          editable: true,
        }] : [],
        ...(isEKC || isLMH || isSDR || isCRW || isSC || isSV) ? [] : [{
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'TotalNetWeight',
          name: totalWeightName,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }],
        {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 250,
          filterable: true,
          editable: isLMHST ? false : true,
          getRowMetaData: row => row,
          formatter: ({ value, dependentValues }) => {
            return isLMHST ? <div style={{height: '19px'}} onDoubleClick={() => {
                this.setState({
                  notationModalInfo: dependentValues,
                  doubleClickProductMainId: dependentValues && dependentValues.MainId,
                  notationModalVisibility: true,
                }) 
            }}>{value}</div> : <div>{value}</div>;
          },
        },
      ];

      const lapColumn = [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        }, {
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        },  {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'RefNum',
          name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
          resizable: true,
          sortable: true,
          width: isSV ? 120 : 70,
          filterable: true,
        }, {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        }, {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: "Prop12",
          name: <Translate value="prop_12" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 70,
          editable: row => row.prop12_edit,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === "true") ? "true" : "false" }
            </div>
          ),
          getRowMetaData: row => row,
        }, {
          key: 'Quantity',
          name: <Translate value="qty" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          // editable: this.state.editSOPermission,
          editable: row => (!(isEKC || isLMH) || ((isEKC || isLMH) && row.ProductNum.slice(0,4) !== '0101')),
          getRowMetaData: row => row,
          formatter: BoldTextFormatter,
        }, {
          key: 'UnitPrice',
          name: <Translate value="unit_price" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: (
            isHMM ? false : true
          ),
          getRowMetaData: row => row,
          formatter: ({ value }) => {
            return (
              <span style={{ 'font-weight': 'bold'}}>
                {
                  (value !== null && !isNaN(value) && `$${Math.round(value * 100)/100}`)
                }
              </span>
            )
          },
        }, {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: ({ value }) => {
            return (
              <span style={{ 'font-weight': 'bold' }}>
                {(value !== null && !isNaN(value) && `$${Math.round(value * 100)/100}`)}
              </span>
            )
          },
        }, {
          key: 'cost',
          name: <Translate value="last_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }, {
          key: 'NetWeight',
          name: netWeightName,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
        },  {
          key: 'TotalNetWeight',
          name: totalWeightName,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: "IsNoReturn",
          name: <Translate value="no_return" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
          getRowMetaData: row => row,
        }, {
          key: 'BatchExpiredDate',
          name: <Translate value="expired" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          getRowMetaData: row => row,
          formatter: ({ value, dependentValues }) => {
            const date = value ? new Date(value).toLocaleString().split(',')[0] : "N/A";
            return (
              <div onDoubleClick={()=>{
                // this.props.fetchBachesByID(dependentValues.Product_id, this.props.Company_id, this.props.Pickup_Warehouse_id);
                // this.setState({lineBatchId: dependentValues.Batch_id_id, lineBatchRows: allRows, lineBatchIdx: dependentValues.SalesOrderLine_id });
                this.setState({lineBatchId: dependentValues.Batch_id_id ? dependentValues.Batch_id_id : dependentValues.Batch_id, lineBatchRows: this.state.rows, lineBatchIdx: dependentValues.Index });
                this.setBatchesModal2Visibility(true);
              }}>
                {date}
              </div>)
          }
        }, {
          key: 'BatchLocation',
          name: <Translate value="location" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        }, {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 250,
          filterable: true,
          editable: true,
        },
        {
          key: "Profit1",
          name: <Translate value="profit" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          formatter:({value}) => (
            <span>${Math.round(value * 100) / 100}</span>
          )
        },
        {
          key: "SalesMargin1",
          name: <Translate value="sales_margin" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          formatter:({value}) => (
            <span>{Math.round(value * 100) / 100}%</span>
          )
        }
      ];

      const abcffColumn = (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') ? [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        }, {
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        }, {
          key: "UnitQuantity",
          name: <Translate value="unit_qty" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: 'Quantity',
          name: <Translate value="case_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true, // editSOPermission
          formatter: BoldTextFormatter,
        }, {
          key: "PerBoxQty",
          name: <Translate value="unit/box" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: 'PalletQuantity',
          name: <Translate value="plt_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true, // editSOPermission
          formatter: BoldTextFormatter,
        }, {
          key: 'RepackedPalletQuantity',
          name: <Translate value="repack_plt_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        }, {
          key: 'AvailableQuantity',
          name: <Translate value="available_box" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        }, {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'RefNum',
          name: isTN ? <Translate value="sku" /> : <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        }, {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        }, {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: 120,
        }, {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        }, {
          key: 'InnerLabelQty',
          name: <Translate value="inner_label" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true, // editSOPermission
          formatter: BoldTextFormatter,
        }, {
          key: 'OuterLabelQty',
          name: <Translate value="outer_label" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true, // editSOPermission
          formatter: BoldTextFormatter,
        }, {
          key: "FBACode",
          name: <Translate value="FBA-Code" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "FBARoute",
          name: <Translate value="FBA-Route" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "TrailerNum",
          name: <Translate value="trailer" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "POList",
          name: <Translate value="po_list" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "POD",
          name: <Translate value="pod" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        }, {
          key: "DimUnit",
          name: <Translate value="dim_unit" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "WeightUnit",
          name: <Translate value="weight_unit" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "BoxLength",
          name: <Translate value="box_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxWidth",
          name: <Translate value="box_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxHeight",
          name: <Translate value="box_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxVol",
          name: <Translate value="box_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "BoxWeight",
          name: <Translate value="box_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "PalletLength",
          name: <Translate value="plt_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletWidth",
          name: <Translate value="plt_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletHeight",
          name: <Translate value="plt_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletVol",
          name: <Translate value="plt_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "PalletWeight",
          name: <Translate value="pallet_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "UnitLength",
          name: <Translate value="unit_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "UnitWidth",
          name: <Translate value="unit_w" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "UnitHeight",
          name: <Translate value="unit_h" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "UnitVol",
          name: <Translate value="unit_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "Location",
          name: <Translate value="location" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          formatter: ({ value, dependentValues }) => (
            <div
              style={{ width: "100%", height: "100%", textAlign: "center" }}
              onDoubleClick={() => {
                this.openZBLModal(value, dependentValues);
              }}
            >
              {value}
            </div>
          ),
          getRowMetaData: (row) => row,
        }, {
          key: "PalletStackable",
          name: <Translate value="stackable" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        }, {
          key: "StoreReady",
          name: <Translate value="store_ready" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        }, {
          key: "Preticketed",
          name: <Translate value="preticketed" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 120,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        }, {
          key: "CantonNum",
          name: <Translate value="canton" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "OriginCountry",
          name: <Translate value="country" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "VendorStyleNum",
          name: <Translate value="vendor_style" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        }, {
          key: "TJXStyleNum",
          name: <Translate value="tjx_style" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        }, {
          key: "UPC",
          name: <Translate value="upc" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        }, {
          key: "Color",
          name: <Translate value="color" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        }, {
          key: "Size",
          name: <Translate value="size_ratio" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        }, {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: ((isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false : true),
          formatter: BoldCashFormatter,
        }, {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ] : [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        }, {
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        }, {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'RefNum',
          name: isTN ? <Translate value="sku" /> : <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        }, {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        }, {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: 120,
        }, {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        }, {
          key: 'UnitQuantity',
          name: <Translate value="unit_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true, // editSOPermission
          formatter: BoldTextFormatter,
        }, {
          key: 'Quantity',
          name: <Translate value="case_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true, // editSOPermission
          formatter: BoldTextFormatter,
        }, {
          key: "PerBoxQty",
          name: <Translate value="unit_case" />,
          resizable: true,
          width: 80,
          sortable: true,
        }, {
          //
          key: "ReceivedCaseQty",
          name: <Translate value="received_case_qty" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          getRowMetaData: (row) => row,
          formatter: ({ value, dependentValues }) => (
            <div>
              {dependentValues.PerBoxQty ? dependentValues.ReceivedQuantity / dependentValues.PerBoxQty : ""}
            </div>
          ),
          editable: true,
          // user use this to change ReceivedQuantity
          // received_case_qty = received_unit_qty / PerBoxQty
        }, {
          key: "ReceivedQuantity",
          name: <Translate value="received_unit_qty" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
        }, {
          key: 'PalletQuantity',
          name: <Translate value="plt_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          editable: true, // editSOPermission
          formatter: BoldTextFormatter,
        }, {
          key: "Location",
          name: <Translate value="location" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          formatter: ({ value, dependentValues }) => (
            <div
              style={{ width: "100%", height: "100%", textAlign: "center" }}
              onDoubleClick={() => {
                this.openZBLModal(value, dependentValues);
              }}
            >
              {value}
            </div>
          ),
          getRowMetaData: (row) => row,
        }, {
          key: "FBACode",
          name: <Translate value="fba_code" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "FBARoute",
          name: <Translate value="fba_route" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "TrailerNum",
          name: <Translate value="trailer" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "POList",
          name: <Translate value="po_list" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "POD",
          name: <Translate value="pod" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        }, {
          key: "DimUnit",
          name: <Translate value="dim_unit" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "WeightUnit",
          name: <Translate value="weight_unit" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "BoxLength",
          name: <Translate value="box_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxWidth",
          name: <Translate value="box_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxHeight",
          name: <Translate value="box_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "BoxVol",
          name: <Translate value="box_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "BoxWeight",
          name: <Translate value="box_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "PalletLength",
          name: <Translate value="plt_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletWidth",
          name: <Translate value="plt_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletHeight",
          name: <Translate value="plt_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "PalletVol",
          name: <Translate value="pallet_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "UnitLength",
          name: <Translate value="unit_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "UnitWidth",
          name: <Translate value="unit_w" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "UnitHeight",
          name: <Translate value="unit_h" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        }, {
          key: "UnitVol",
          name: <Translate value="unit_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: "PalletStackable",
          name: <Translate value="stackable" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        }, {
          key: "StoreReady",
          name: <Translate value="store_ready" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        }, {
          key: "Preticketed",
          name: <Translate value="preticketed" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 120,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        }, {
          key: "CantonNum",
          name: <Translate value="canton" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "OriginCountry",
          name: <Translate value="country" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        }, {
          key: "VendorStyleNum",
          name: <Translate value="vendor_style" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        }, {
          key: "TJXStyleNum",
          name: <Translate value="tjx_style" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        }, {
          key: "UPC",
          name: <Translate value="upc" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        }, {
          key: "Color",
          name: <Translate value="color" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        }, {
          key: "Size",
          name: <Translate value="size_ratio" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        }, {
          key: "PalletWeight",
          name: <Translate value="pallet_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        }, {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: ((isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false : true),
          formatter: BoldCashFormatter,
        }, {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
      ];

      if (isCPG|| isVIP) {
        const BatchExpiredDate = {
          key: 'BatchExpiredDate',
          name: <Translate value="expired" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          getRowMetaData: row => row,
          formatter: ({ value, dependentValues }) => {
            // if (value) {
              const date = value ? new Date(value).toLocaleString().split(',')[0] : "N/A";
              return (
                <div onDoubleClick={()=>{
                  // this.props.fetchBachesByID(dependentValues.Product_id, this.props.Company_id, this.props.Pickup_Warehouse_id);
                  // this.setState({lineBatchId: dependentValues.Batch_id_id, lineBatchRows: allRows, lineBatchIdx: dependentValues.SalesOrderLine_id });
                  this.setState({lineBatchId: dependentValues.Batch_id_id ? dependentValues.Batch_id_id : dependentValues.Batch_id, lineBatchRows: this.state.rows, lineBatchIdx: dependentValues.Index });
                  this.setBatchesModal2Visibility(true);
                }}>
                 {date}
                </div>)
          }
        }
        const productCost = {
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }
        const BatchExpiredDateIndex = _.findIndex(columns, { key: 'BatchExpiredDate' });
        const productCostIndex = _.findIndex(columns, { key: 'cost' });
        columns.splice(BatchExpiredDateIndex, 1, productCost);
        columns.splice(productCostIndex, 1, BatchExpiredDate);
      }
      if (isGGI) {
        const col = {
          key: 'SmallUnitPrice',
          name: <Translate value="small_unit_price" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          getRowMetaData: row => row,
          editable:isGGI,
          formatter: ({ dependentValues }) => {
            // const smallUnitPrice = roundTo(dependentValues.UnitPrice / dependentValues.PackageSize_1, 2);
            if (isNaN(dependentValues.SmallUnitPrice)) return <span>NaN</span>;
            return <span>${dependentValues.SmallUnitPrice}</span>
          },
        };
        const index1 = _.findIndex(columns, { key: "UnitPrice" });
        columns.splice(index1, 0, col);
      }

      if (isJML) {
        const index1 = _.findIndex(columns, { key: "NetWeight" });
        columns.splice(index1, 1);
        const index2 = _.findIndex(columns, { key: "TotalNetWeight" });
        columns.splice(index2, 1);
      }

      if (false) {
        let temp = {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: HMMPriceFormatter,
          getRowMetaData: row => row,
        };
        columns.splice(8, 1, temp);
      }

      const dsqColumn = (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') ? [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        },
        {
          key: 'Quantity',
          name: <Translate value="box_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          // editable: this.state.editSOPermission,
          editable: true,
          formatter: BoldTextFormatter,
        },
        {
          key: 'PalletQuantity',
          name: <Translate value="plt_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          // editable: this.state.editSOPermission,
          editable: true,
          formatter: BoldTextFormatter,
        },
        {
          key: 'AvailableQuantity',
          name: <Translate value="available_box" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        },
        {
          key: 'AvailablePallets',
          name: <Translate value="available_plt" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        },
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'RefNum',
          name: isTN ? <Translate value="sku" /> : <Translate value={"ref_num"} />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        },
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: 120,
        },
        {
          key: 'InnerLabelQty',
          name: <Translate value="inner_label" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          // editable: this.state.editSOPermission,
          editable: true,
          formatter: BoldTextFormatter,
        },
        {
          key: 'OuterLabelQty',
          name: <Translate value="outer_label" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          // editable: this.state.editSOPermission,
          editable: true,
          formatter: BoldTextFormatter,
        },
        {
          key: "FBACode",
          name: <Translate value="FBA-Code" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        },
        {
          key: "FBARoute",
          name: <Translate value="FBA-Route" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        },
        {
          key: "TrailerNum",
          name: <Translate value="trailer" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        },
        {
          key: "POList",
          name: <Translate value="po_list" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        },
        {
          key: "POD",
          name: <Translate value="pod" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        },
        {
          key: "DimUnit",
          name: <Translate value="dim_unit" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        },
        {
          key: "WeightUnit",
          name: <Translate value="weight_unit" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        },
        {
          key: "BoxLength",
          name: <Translate value="box_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        },
        {
          key: "BoxWidth",
          name: <Translate value="box_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        },
        {
          key: "BoxHeight",
          name: <Translate value="box_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        },
        {
          key: "BoxVol",
          name: <Translate value="box_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "BoxWeight",
          name: <Translate value="box_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "PalletLength",
          name: <Translate value="plt_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        },
        {
          key: "PalletWidth",
          name: <Translate value="plt_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        },
        {
          key: "PalletHeight",
          name: <Translate value="plt_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        },
        {
          key: "PalletVol",
          name: <Translate value="plt_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "PalletWeight",
          name: <Translate value="pallet_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: (
            (isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false :
            (
              (isSUN && !checkPermissionLocal('edit_order_line_price') ? false : true)
            )),
          formatter: BoldCashFormatter,
        },
        {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ] : [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        },
        ...isOLG ? []:[
          {
            key: 'ProductNum',
            name: <Translate value="prod_num" />,
            resizable: true,
            sortable: true,
            width: 80,
            filterable: true,
          }
        ],
        {
          key: 'RefNum',
          name: isTN ? <Translate value="sku" /> : <Translate value={isOLG ? "item_no" : "ref_num"} />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        },
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: 120,
        },
        {
          key: "ReceivedQuantity",
          name: <Translate value="received_qty" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "FBACode",
          name: <Translate value="fba_code" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        },
        {
          key: "FBARoute",
          name: <Translate value="fba_route" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        },
        {
          key: "TrailerNum",
          name: <Translate value="trailer" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        },
        {
          key: "POList",
          name: <Translate value="po_list" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        },
        {
          key: "POD",
          name: <Translate value="pod" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
        },
        {
          key: "DimUnit",
          name: <Translate value="dim_unit" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        },
        {
          key: "WeightUnit",
          name: <Translate value="weight_unit" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        },
        {
          key: 'Quantity',
          name: <Translate value="box_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          // editable: this.state.editSOPermission,
          editable: true,
          formatter: BoldTextFormatter,
        },
        {
          key: "BoxLength",
          name: <Translate value="box_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        },
        {
          key: "BoxWidth",
          name: <Translate value="box_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        },
        {
          key: "BoxHeight",
          name: <Translate value="box_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        },
        {
          key: "BoxVol",
          name: <Translate value="box_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "BoxWeight",
          name: <Translate value="box_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: 'PalletQuantity',
          name: <Translate value="plt_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          // editable: this.state.editSOPermission,
          editable: true,
          formatter: BoldTextFormatter,
        },
        {
          key: "PalletLength",
          name: <Translate value="plt_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        },
        {
          key: "PalletWidth",
          name: <Translate value="plt_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        },
        {
          key: "PalletHeight",
          name: <Translate value="plt_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        },
        {
          key: "PalletVol",
          name: <Translate value="pallet_cbm" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "PalletWeight",
          name: <Translate value="pallet_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: (
            (isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false :
            (
              (isSUN && !checkPermissionLocal('edit_order_line_price') ? false : true)
            )),
          formatter: BoldCashFormatter,
        },
        {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ];

      const wizColumn = (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') ? [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        },
        {
          key: 'Quantity',
          name: <Translate value="shipped_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          // editable: this.state.editSOPermission,
          editable: true,
          formatter: BoldTextFormatter,
        },
        {
          key: 'AvailableQuantity',
          name: <Translate value="available" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        },
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'RefNum',
          name: <Translate value="sku" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        },
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: 120,
        },

        {
          key: "FBACode",
          name: <Translate value="FBA" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
          editable: true,
        },
        {
          key: "CustomerBoxQty",
          // name: <Translate value="received_qty" />,
          name: <Translate value="customer_box" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "OutsideLabelQty",
          // name: <Translate value="received_qty" />,
          name: <Translate value="outside_label" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "InsideLabelQty",
          // name: <Translate value="received_qty" />,
          name: <Translate value="inside_label" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "SpecialHandling",
          // name: <Translate value="received_qty" />,
          name: <Translate value="special_handling" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "CustomerNote",
          // name: <Translate value="received_qty" />,
          name: <Translate value="customer_note" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 150,
          editable: true,
        },
        {
          key: "ReceivedQuantity",
          // name: <Translate value="received_qty" />,
          name: <Translate value="customer_qty" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "ShipmentID",
          name: <Translate value="shipment_id" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "BillablePallets",
          name: <Translate value="billable_pallets" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          // editable: true,
        },
        {
          key: "PalletQuantity",
          name: <Translate value="real_pallets" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "BoxPerPallet",
          name: <Translate value="box_per_plt" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "DispatchType",
          name: <Translate value="dispatch_type" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "BoxLength",
          name: <Translate value="box_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        },
        {
          key: "BoxWidth",
          name: <Translate value="box_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        },
        {
          key: "BoxHeight",
          name: <Translate value="box_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        },
        {
          key: "BoxVol",
          name: <Translate value="box_vol" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "BoxWeight",
          name: <Translate value="box_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "PalletWeight",
          name: <Translate value="pallet_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "PortDray",
          name: <Translate value="port_dray" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "Location",
          name: <Translate value="location" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: (
            (isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false :
            (
              (isSUN && !checkPermissionLocal('edit_order_line_price') ? false : true)
            )),
          formatter: BoldCashFormatter,
        },
        {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="net_wt" />,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
        },
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'TotalNetWeight',
          name: <Translate value="total_wt" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ] : [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        },
        {
          key: 'Quantity',
          name: <Translate value="rcvd_qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          // editable: this.state.editSOPermission,
          editable: true,
          formatter: BoldTextFormatter,
        },
        ...isOLG ? [] : [
          {
            key: 'ProductNum',
            name: <Translate value="prod_num" />,
            resizable: true,
            sortable: true,
            width: 80,
            filterable: true,
          }
        ],
        {
          key: "Location",
          name: <Translate value="location" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: 'RefNum',
          name: <Translate value="sku" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        },
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: 120,
        },
        {
          key: "ReceivedQuantity",
          name: <Translate value="customer_qty" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "ShipmentID",
          name: <Translate value="customer_note" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "BillablePallets",
          name: <Translate value="billable_pallets" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          // editable: true,
        },
        {
          key: "PalletQuantity",
          name: <Translate value="real_pallets" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "BoxPerPallet",
          name: <Translate value="box_per_plt" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "DispatchType",
          name: <Translate value="warehouse_note" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "BoxLength",
          name: <Translate value="box_L" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        },
        {
          key: "BoxWidth",
          name: <Translate value="box_W" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        },
        {
          key: "BoxHeight",
          name: <Translate value="box_H" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          editable: true,
        },
        {
          key: "BoxVol",
          name: <Translate value="box_vol" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "BoxWeight",
          name: <Translate value="box_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "PalletWeight",
          name: <Translate value="pallet_weight" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "PortDray",
          name: <Translate value="port_dray" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: "DrayageTrucker",
          name: <Translate value="drayage_trucker" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editable: true,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: (
            (isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false :
            (
              (isSUN && !checkPermissionLocal('edit_order_line_price') ? false : true)
            )),
          formatter: BoldCashFormatter,
        },
        {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="net_wt" />,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
        },
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'TotalNetWeight',
          name: <Translate value="total_wt" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ];

      const jtbColumn = (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') ? [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        },
        ...isHMM ? [{
          key: 'Order',
          name: <Translate value="positionIndex" />,
          resizable: true,
          sortable: true,
          editable: true,
          width: 70,
          filterable: true,
          // formatter: BoldCashFormatter,
        }] : [{
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        }],
        {
          key: 'Quantity',
          name: <Translate value="qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          // editable: this.state.editSOPermission,
          editable: true,
          formatter: BoldTextFormatter,
        },
        {
          key: 'AvailableQuantity',
          name: <Translate value="available" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        },
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        ...isABC ? [{
          key: 'RefNo',
          name: <Translate value="FBA_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PoNo',
          name: <Translate value="pro_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }]: [],
        {
          key: 'RefNum',
          name: isTN ? <Translate value="sku" /> : <Translate value={isOLG ? "item_no" : "ref_num"} />,
          resizable: true,
          sortable: true,
          width: isJML ? 200 : 70,
          filterable: true,
        },
        ...isAFM ? [{
          key: 'Brand',
          name: <Translate value="brand" />,
          resizable: true,
          sortable: true,
          width: 100,
        }]: [],
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: isChinaTown ? 200 : 85,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: (
            (isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false :
            (
              (isSUN && !checkPermissionLocal('edit_order_line_price') ? false : true)
            )),
          formatter: BoldCashFormatter,
        },
        {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'TotalNetWeight',
          name: <Translate value="total_wt" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ] : [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        },
        ...isHMM ? [{
          key: 'Order',
          name: <Translate value="positionIndex" />,
          resizable: true,
          sortable: true,
          editable: true,
          width: 70,
          filterable: true,
          // formatter: BoldCashFormatter,
        }] : [{
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        }],
        ...isOLG ? [] : [
          {
            key: 'ProductNum',
            name: <Translate value="prod_num" />,
            resizable: true,
            sortable: true,
            width: 80,
            filterable: true,
          }
        ],
        ...isABC ? [{
          key: 'RefNo',
          name: <Translate value="FBA_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PoNo',
          name: <Translate value="pro_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }]: [],
        {
          key: 'RefNum',
          name: isTN ? <Translate value="sku" /> : <Translate value={isOLG ? "item_no" : "ref_num"} />,
          resizable: true,
          sortable: true,
          width: isJML ? 200 : 70,
          filterable: true,
        },
        ...isAFM ? [{
          key: 'Brand',
          name: <Translate value="brand" />,
          resizable: true,
          sortable: true,
          width: 100,
        }]: [],
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: isChinaTown ? 200 : 85,
        },
        {
          key: 'Quantity',
          name: <Translate value="qty" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          // editable: this.state.editSOPermission,
          editable: true,
          formatter: BoldTextFormatter,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: (
            (isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false :
            (
              (isSUN && !checkPermissionLocal('edit_order_line_price') ? false : true)
            )),
          formatter: BoldCashFormatter,
        },
        {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="net_wt" />,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
        },
        {
          key: 'TotalNetWeight',
          name: <Translate value="total_wt" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ];

      const fjColumn = (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') ? [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        },
        {
          key: 'Quantity',
          name: <Translate value="qty" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          // editable: this.state.editSOPermission,
          editable: true,
          formatter: BoldTextFormatter,
        },
        {
          key: 'AvailableQuantity',
          name: <Translate value="available" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        },
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        ...isABC ? [{
          key: 'RefNo',
          name: <Translate value="FBA_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PoNo',
          name: <Translate value="pro_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }]: [],
        {
          key: 'RefNum',
          name: isTN ? <Translate value="sku" /> : <Translate value={isOLG ? "item_no" : "ref_num"} />,
          resizable: true,
          sortable: true,
          width: isJML ? 200 : 70,
          filterable: true,
        },
        ...isAFM ? [{
          key: 'Brand',
          name: <Translate value="brand" />,
          resizable: true,
          sortable: true,
          width: 100,
        }]: [],
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: isChinaTown ? 200 : 85,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: (
            (isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false :
            (
              (isSUN && !checkPermissionLocal('edit_order_line_price') ? false : true)
            )),
          formatter: BoldCashFormatter,
        },
        {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="net_wt" />,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
        },
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'TotalNetWeight',
          name: <Translate value="total_wt" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ] : [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        },
        ...isHMM ? [{
          key: 'Order',
          name: <Translate value="positionIndex" />,
          resizable: true,
          sortable: true,
          editable: true,
          width: 70,
          filterable: true,
          // formatter: BoldCashFormatter,
        }] : [{
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        }],
       ...isOLG ? [] : [
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }
       ],
        ...isABC ? [{
          key: 'RefNo',
          name: <Translate value="FBA_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }, {
          key: 'PoNo',
          name: <Translate value="pro_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }]: [],
        {
          key: 'RefNum',
          name: isTN ? <Translate value="sku" /> : <Translate value={isOLG ? "item_no" : "ref_num"} />,
          resizable: true,
          sortable: true,
          width: isJML ? 200 : 70,
          filterable: true,
        },
        ...isAFM ? [{
          key: 'Brand',
          name: <Translate value="brand" />,
          resizable: true,
          sortable: true,
          width: 100,
        }]: [],
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: isChinaTown ? 200 : 85,
        },
        {
          key: 'Quantity',
          name: <Translate value="qty" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: (
            (isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) ? false :
            (
              (isSUN && !checkPermissionLocal('edit_order_line_price') ? false : true)
            )),
          formatter: BoldCashFormatter,
        },
        {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="net_wt" />,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
        },
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'TotalNetWeight',
          name: <Translate value="total_wt" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ];

      const smColumn = [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        },
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'RefNum',
          name: <Translate value={"ref_num"} />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: 200,
          editable: true,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'Quantity',
          name: <Translate value="qty" />,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        },
        {
          key: 'PickedQuantity',
          name: <Translate value="picked_qty" />,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
          editable: true,
          getRowMetaData: row => row,
          formatter:({ value, dependentValues }) => {
            let color = Number(dependentValues.Quantity || 0) == Number(value || 0) ? 'yellow' : 'red';
            return (
              <span style={{backgroundColor: color, display:'inline-block', width:'100%', textAlign:'center'}}>
                {value}
              </span>)
          }
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
          formatter: BoldCashFormatter,
        },
        {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
      ];

      const ocmColumn = [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        },
        {
          key: 'RefNum',
          name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
          resizable: true,
          sortable: true,
          width: isSV ? 120 : 70,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: isChinaTown ? 200 : 85,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'Quantity',
          name: <Translate value="qty" />,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
          editable: true,
          formatter: BoldTextFormatter,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
          formatter: BoldCashFormatter,
        },
        {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          editable: true,
        },
        {
          key: 'BatchExpiredDate',
          name: <Translate value="expired" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          getRowMetaData: row => row,
          formatter: ({ value, dependentValues }) => {
            const date = value ? new Date(value).toLocaleString().split(',')[0] : "N/A";
            return (
              <div onDoubleClick={()=>{
                this.setState({lineBatchId: dependentValues.Batch_id_id ? dependentValues.Batch_id_id : dependentValues.Batch_id, lineBatchRows: this.state.rows, lineBatchIdx: dependentValues.Index });
                this.setBatchesModal2Visibility(true);
              }}>
                {date}
              </div>)
          }
        },
        {
          key: 'BatchLocation',
          name: <Translate value="location" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        },
        {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: BoldCashFormatter,
        },
        {
          key: 'TotalNetWeight',
          name: <Translate value="total_net_weight" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'TotalShippingWeight',
          name: <Translate value="total_ship_weight" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'ProductNum',
          name: <Translate value="pro_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        },
        {
          key: "IsGift",
          name: <Translate value="gift" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          // editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "Yes" : "No" }
            </div>
          ),
          getRowMetaData: row => row,
        },
        ...showProductCost() ? [{
          key: 'cost',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: PriceFormatter,
          getRowMetaData: row => row.ProductCost || typeof row.ProductCost === 'number' ? row.ProductCost : row.CostPrice,
        }] : [],
        {
          key: 'NetWeight',
          name: netWeightName,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
        },
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'IsNoReturn',
          name: <Translate value="no_return" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        }
      ];

      const olgColumn = [
        {
          name: <Translate value="del" />,
          width: 50,
          formatter: IsVariableFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'Index',
          name: <Translate value="idx" />,
          width: 35,
          resizable: false,
          sortable: true,
        },
        {
          key: 'RefNum',
          name: <Translate value={"item_no"} />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="desc" />,
          resizable: true,
          sortable: true,
          width: 300,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'Quantity',
          name: <Translate value="qty" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          editable: true,
          getRowMetaData: row => row,
          formatter: BoldTextFormatter,
        },
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        ...(!isOLG) ? [{
          key: 'OriginalPrice',
          name: <Translate value="orig_price" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          getRowMetaData: row => row,
          formatter: BoldCashFormatter,
        }] : [],
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          editable: true,
          getRowMetaData: row => row,
          formatter: ({ value }) => {
              return (
                <span style={{ 'font-weight': 'bold' }}>
            {
              (value !== null && !isNaN(value) && `$${Math.round(value * 100)/100}`)
            }
          </span>)
          },
        },
        {
          key: 'TotalNetWeight',
          name: totalWeightName,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'TotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          formatter: ({ value }) => {
            return (
              <span style={{ 'font-weight': 'bold' }}>
              {
                (value !== null && !isNaN(value) && `$${Math.round(value * 100)/100}`)
              }
            </span>)
          },
        },
        {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 250,
          filterable: true,
          editable: true,
        },
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
        },
        ...(isOLG) ? [{
          key: 'OriginalPrice',
          name: <Translate value="orig_price" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          getRowMetaData: row => row,
          formatter: BoldCashFormatter,
        }] : [],
        {
          key: 'NetWeight',
          name: netWeightName,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
          editable: true,
        },
        {
          key: 'BatchLocation',
          name: <Translate value="location" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        },
        {
          key: "IsNoReturn",
          name: <Translate value="no_return" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          editor: <DropDownEditor options={boolOptions}/>,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "true" : "false" }
            </div>
          ),
          getRowMetaData: row => row,
        },
        {
          key: 'BatchExpiredDate',
          name: <Translate value="expired" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          getRowMetaData: row => row,
          formatter: ({ value, dependentValues }) => {
            // if (value) {
              const date = value ? new Date(value).toLocaleString().split(',')[0] : "N/A";
              return (
                <div onDoubleClick={()=>{
                  this.setState({lineBatchId: dependentValues.Batch_id_id ? dependentValues.Batch_id_id : dependentValues.Batch_id, lineBatchRows: this.state.rows, lineBatchIdx: dependentValues.Index });
                  this.setBatchesModal2Visibility(true);
                }}>
                 {date}
                </div>)
          }
        },
        {
          key: "IsGift",
          name: <Translate value="gift" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          formatter: ({ value }) => (
            <div>
              { (value === true || value === 'true') ? "Yes" : "No" }
            </div>
          ),
          getRowMetaData: row => row,
        },
      ];

      if (isSW) {
        const refNoCol = _.findIndex(columns, { key: 'RefNum' });
        const barcode = {
          key: "Barcodes",
          name: <Translate value="barcode" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          formatter: ({ value, dependentValues }) => {
            return  <div>
            {value || dependentValues.barcode}
          </div>
          },
          getRowMetaData: row => row,
        }
        columns.splice(refNoCol, 1, barcode);
      }

      if (isGFD) {
        const QuantityCol = _.findIndex(columns, { key: 'Quantity' });
        const UnitPriceCol = _.findIndex(columns, { key: 'UnitPrice' });

        columns[QuantityCol].name = <Translate value="case_qty" />;
        columns[UnitPriceCol].name = <Translate value="case_price" />;

        const converNumCol = {
          key: "ConvertNum",
          name: <Translate value="unit_per_case" />,
          resizable: true,
          sortable: true,
          filterable: true,
          // width: 100,
          // formatter: ({ value, dependentValues }) => {
          //   return  <div>
          //   {value || dependentValues.barcode}
          // </div>
          // },
          // getRowMetaData: row => row,
        }
        const totalUnit = {
          key: "totalUnits",
          name: <Translate value="total_units" />,
          resizable: true,
          sortable: true,
          filterable: true,
          // width: 100,
          formatter: ({ value, dependentValues }) => {
            return  <div>
            {dependentValues.ConvertNum * dependentValues.Quantity}
          </div>
          },
          getRowMetaData: row => row,
        }
        columns.splice(QuantityCol + 1, 0, totalUnit);
        columns.splice(QuantityCol + 1, 0, converNumCol);
      }
      const generateColumns = () => {
        if (isDSQ) {
          return dsqColumn;
        }
        if (isWIZ) {
          return wizColumn;
        }
        if (isJTB) {
          return jtbColumn;
        }
        if (isFJ) {
          return fjColumn;
        }
        if (isSH) {
          return smColumn;
        }
        if (isOCM) {
          return ocmColumn
        }
        if (isABCFF) {
          return abcffColumn;
        }
        if (isOLG) {
          return olgColumn;
        }
        if (isLAP) {
          return lapColumn;
        }
        return columns
      }
      // Your Sales Order Table
      return (
        <Row>
          {(isEcity) &&
          <Col xs={12}>
            <div className="react-customizer" id="SalesOrderForm-dataGrid3">
              <ReactDataGrid
                rowKey="ProductNum"
                enableCellSelect
                onGridSort={handleGridSort}
                // columns={columns}
                columns={generateColumns()}
                rowHeight={isWIZ ? 40 : 25}
                headerRowHeight={45}
                minHeight={this.state.yourOrderTableHeight}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                onRowClick={onRowClick}
                onRowUpdated={handleRowUpdated}
                enableRowSelect="single"
                rowSelection={{
                  showCheckbox: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
              />
            </div>
          </Col>
          }
          {(!isChinaTown && !isFJ && !isEcity) &&
          <Col xs={12}>
            {
              (isABCFF && this.context.router.routes[1].path === 'salesOrders/:id') &&
              <ButtonToolbar style={{float: 'right'}}>
                <Button
                  bsStyle="primary"
                  onClick={autoLoad}
                >
                  <Translate value="auto_load" />
                </Button>
              </ButtonToolbar>
            }
            <div className="react-customizer" id="SalesOrderForm-dataGrid3">
              <ReactDataGrid
                ref={(gridRef) => {this.gridRef = gridRef}}
                rowKey="ProductNum"
                enableCellSelect
                onGridSort={handleGridSort}
                // columns={columns}
                columns={generateColumns()}
                rowHeight={40}
                headerRowHeight={45}
                minHeight={this.state.yourOrderTableHeight}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                onRowClick={onRowClick}
                // scrollToRow={this.state.scrollIdx}
                onRowUpdated={handleRowUpdated}
              />
            </div>
          </Col>
          }
          {isChinaTown &&
          <Col xs={12}>
            <div className="react-customizer" id="SalesOrderForm-dataGrid3China">
              <ReactDataGrid
                rowKey="ProductNum"
                enableCellSelect
                onGridSort={handleGridSort}
                columns={columns}
                rowHeight={40}
                headerRowHeight={45}
                minHeight={this.state.yourOrderTableHeight}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                onRowClick={onRowClick}
                onRowUpdated={handleRowUpdated}
              />
            </div>
          </Col>
          }
          {isFJ &&
          <Col xs={12}>
            <div className="react-customizer" id="SalesOrderForm-dataGrid3">
              <ReactDataGrid
                rowKey="ProductNum"
                enableCellSelect
                onGridSort={handleGridSort}
                // columns={columns}
                columns={generateColumns()}
                rowHeight={25}
                headerRowHeight={45}
                minHeight={150}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                onRowClick={onRowClick}
                onRowUpdated={handleRowUpdated}
              />
            </div>
          </Col>
          }
        </Row>
      );
    }
    moveFavoritesToSO() {
      const {
        inventories, inventoryIdValue, quantityValue, favorites,
        available, inPurchase, preSale, salePrice, refPurchasePrice, unitPrice, description,
      } = this.props;
      const updatedInventories = [...this.state.inventories.allRows];
      const updatedFavorites = JSON.parse(JSON.stringify(this.state.favorites.rows));
      const rowsToAdd = JSON.parse(JSON.stringify(this.state.favorites.rows));
      const newRows = JSON.parse(JSON.stringify(this.state.rows));
      rowsToAdd.map((row) => {
        if (row.isSelected) {
          const check = _.findIndex(this.state.rows, { ProductNum: row.ProductNum });
          if (check == -1) {
            let index = _.findIndex(updatedInventories, { ProductNum: row.ProductNum });
            if (index > -1) {
              if (updatedInventories[index].InStock > 0 || selectedInventory.IsOverSaleable == true) {
                updatedInventories[index].inList = true;
              }
            }
            index = _.findIndex(updatedFavorites, { ProductNum: row.ProductNum });
            if (index > -1) {
              if (updatedFavorites[index].InStock > 0 || updatedFavorites[index].IsOverSaleable == true) {
                updatedFavorites[index].inList = true;
              }
            }
            if (row.InStock > 0 || row.IsOverSaleable == true || isHMM) {
              row.Quantity = 0;
              row.UnitPrice = row.RefPurchasingPrice;
              row.TotalPrice = 0;
              row.isSelected = false;
              row.TotalNetWeight = 0;
              row.Name = row.ProductName;
              const pos = _.findIndex(this.state.inventories.allRows, { Product_id: row.Product_id });
              if (pos > -1) {
                row.Weight = this.state.inventories.allRows[pos].Weight;
              }
              newRows.push(row);
              const favorites = { ...this.state.favorites, rows: updatedFavorites };
              const inventories = { ...this.state.inventories, allRows: updatedInventories };
              this.setState({ inventories, favorites, rows: newRows });
            } else {
              this.setState({ case: 'itemOutOfStock', confirmOpen: true });
            }
          } else {
            this.setState({ case: 'addingDuplicate', confirmOpen: true });
          }
        }
      });
    }

    barcodeScan() {
      const selectedInventoryRow = { ...this.state.selectedInventoryRow };
      const check = _.findIndex(this.state.rows, { ProductNum: selectedInventoryRow.ProductNum });
      if (check === -1) {
        // add product by scaning barcode
        this.moveToSO();
      } else {
        // update existing product
        let rows = [...this.state.rows];
        rows.map((row) => {
          if (row.ProductNum === selectedInventoryRow.ProductNum) {
            const addQty = +(row.Quantity) + 1;
            // more than product in stock
            if (addQty <= row.InStock || row.IsOverSaleable === true || isHMM) {
              row.Quantity = addQty;
              row.TotalNetWeight = roundTo(row.NetWeight * row.Quantity, 2);
              if (row.ProductType === 'Fixed' || row.ProductType === 'Non-Product') {
                row.TotalPrice = +roundToDecimals(row.UnitPrice * row.Quantity, 4).toFixed(4);
              } else {
                // row.TotalPrice = +roundToDecimals(row.unitPrice * weight * row.Quantity, 4).toFixed(4);
                row.TotalPrice = +roundToDecimals(row.UnitPrice * row.Quantity, 4).toFixed(4);
              }
              row.TotalCRV = +roundTo(parseFloat(row.Quantity) * parseFloat(row.CRV), 2).toFixed(2);
              row.TotalNetWeight = roundTo(row.NetWeight * row.Quantity, 2);
            } else {
              this.setState({
                case: 'itemOutOfStock',
                confirmOpen: true,
                selectedInventoryRow: {},
                inStock: '',
                inStockWarehouse: '',
                inStockOnhand: '',
                purchased: '',
                presale: '',
                net_weight: '',
                suggestValue: '',
              });
              this.props.resetFormInputs();
              return;
            }
          }
        });
        this.setState({ rows });

        // update so detail
        let totalPrice = 0;
        let finalWeight = 0;
        let totalTax = 0;
        let totalCRV = 0;
        let index = 0;
        const discount = parseFloat(this.props.discount) || 0;
        rows = [...this.state.rows];
        index = rows.length;
        rows.map((row, idxx) => {
          if (isSV || isSUN || isOLG) {
            row.Index = idxx+1;
          } else {
            row.Index = index;
            index--;
          }
          totalCRV = (parseFloat(row.TotalCRV) || 0) + (+roundTo(parseFloat(totalCRV), 2).toFixed(2));
          if (row.IsTaxable === true) {
            if (isHMM) {
              totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(this.state.taxValue / 100);
            } else {
              if(isHO || isJRC || isVIP) {
                if(row.IsAllTaxable === true || !this.props.salesCustomerDetails.Reseller) {
                  totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
                }
              } else {
                totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
              }
            }
          }
          if (isHMM) {
            totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
          } else {
            totalPrice += parseFloat(row.TotalPrice);
          }
          if (row.TotalNetWeight != null) {
            finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight);
          }
          finalWeight = Math.round(0.00001 + finalWeight * 100) / 100;
        });

        if (isHMM || isLMH || isSDR || isCRW || isSC || isSUN || isCPG) {
          if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
            totalTax = 0;
          } else {
            if (SODiscount) {
              totalTax = 0;
              rows.map((row, idxx) => {
                if (row.IsTaxable === true) {
                  totalTax += ((parseFloat(row.TotalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)))) * parseFloat(this.state.taxValue / 100);
                }
              });
            }
             }
        }
        const { SODiscount, SOSavings } = this.state; // only one has value
        if ((isEKC || isSH)) {
          if (isEKC && this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
            totalTax = 0;
          } else {
            totalTax = ((parseFloat(totalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)) - Number(SOSavings ? SOSavings : 0))) * parseFloat(this.state.taxValue / 100);
          }
        }

        finalWeight = Math.round(0.00001 + finalWeight * 100) / 100;
        totalPrice = +roundToDecimals(totalPrice, 4).toFixed(4);
        totalTax = +roundTo(totalTax, 2).toFixed(2);
        totalCRV = +roundTo(totalCRV, 2).toFixed(2);
        let finalPrice = +roundTo(totalPrice * (1 - discount / 100) + totalTax + totalCRV, 2).toFixed(2);
        // finalPrice = Math.round(0.00001 + finalPrice * 100) / 100;
        if(isSH && this.state.ccOrigin) {
          finalPrice = Number(finalPrice) + Number(finalPrice * (this.state.ccOrigin || 0)).toFixed(2);
        }
        this.setState({
          rows,
          editing: true,
          finalPrice,
          totalPrice,
          totalTax,
          totalCRV,
          finalWeight,
          selectedInventoryRow: {},
          inStock: '',
          purchased: '',
          presale: '',
          net_weight: '',
          ship_weight: '',
          total_weight: '',
          suggestValue: '',
        }, () => {
          if ((isEKC || isLMH || isSDR || isCRW || isSC || isOLG || isVAK || isSH)) { this.onConfirmPercentageFee(); }
        });
        this.props.resetFormInputs();
        this.setAllProductQuantity(1);
      }
    }

    handleVerifyPasscodeClose = (confirmed) => {
      this.closeVerifyPasscode();
      if(!confirmed) {
        return;
      }
      this.moveToSO('move', confirmed);
    }

    handleVerifyPasscodeCloseDiscount = (confirmed) => {
      this.closeVerifyPasscodeDiscount();
      if (!confirmed) {
        return;
      }
      this.openDiscountModal();
    }

    checkForPromotions = (productNum) => {
      // Check if the editing product is qualified for promotion
      const {
        productPromotions,
      } = this.props;
      if (isOCM) {
        // find editing product with different batch on table
        const productBatchesOnTable = _.filter(this.state.rows, product => (product.ProductNum === productNum && product.UnitPrice));
        const ByQuantityPromotion = _.filter(productPromotions, promotion => promotion.Method === 'ByQuantity')[0];
        if (ByQuantityPromotion) {
          // if there is a ByQuantity promotion, calculate total product quantity to see if its qualified
          let totalQuantity = 0;
          _.forEach(productBatchesOnTable, row => {
            totalQuantity += parseInt(row.Quantity);
          });
          if (totalQuantity >= ByQuantityPromotion.FromQty && productBatchesOnTable.length && !productBatchesOnTable[0].promotionApplied) {
            // promotion qualified, and promotion has not been applied to this product, asking user to apply
            this.setState({
              promotionCheckProduct: productNum,
            }, () => {
              this.setApplyPromotionsModalVisibility2(true)
            });
            return;
          }
          if (totalQuantity < ByQuantityPromotion.FromQty && productBatchesOnTable.length && productBatchesOnTable[0].promotionApplied) {
            this.setState({
              unqualifiedPromotionProduct: productNum,
            }, () => {
              this.setUnqualifiedPromotionModalVisibility(true);
            })
          }
        }
        return;
      }
      if (isLMH || isOLG) {
        // find editing product with different batch on table
        const productBatchesOnTable = _.filter(this.state.rows, product => (product.ProductNum === productNum && (!isOLG && product.UnitPrice || isOLG && product.UnitPrice!= 0)));
        const ByQuantityPromotion = _.filter(productPromotions, promotion => promotion.Method === 'ByQuantity')[0];
        // 第二种优惠   IsPercent  true %  false $  Off 10 百分比或者免费的值
        let filterdPromotions = productPromotions.filter(p => p.Method === "BuyAGetB");
        let totalQuantity = 0;
        _.forEach(productBatchesOnTable, row => {
          totalQuantity += parseInt(row.Quantity);
        });
        let buyAGetBPromotion = this.getBuyAGetBPromotion(totalQuantity, filterdPromotions);
        if(isOLG && ByQuantityPromotion && buyAGetBPromotion != null) { // 两种折扣都存在
          if(totalQuantity >= ByQuantityPromotion.FromQty || totalQuantity >= buyAGetBPromotion.FromQty) {
            this.setState({
              applyPromotionList: [ByQuantityPromotion, buyAGetBPromotion],
              promotionCheckProduct: productNum,
            }, () => {
              this.setApplyPromotionsModalVisibility3(true)
            })
          }
          if(totalQuantity == 0) {
            this.modifyOLGExsitingPromotion(productNum, buyAGetBPromotion);
          }
          return
        }

        if (ByQuantityPromotion) {
          // if there is a ByQuantity promotion, calculate total product quantity to see if its qualified
          if (totalQuantity >= ByQuantityPromotion.FromQty && productBatchesOnTable.length && !productBatchesOnTable[0].promotionApplied) {
            // promotion qualified, and promotion has not been applied to this product, asking user to apply
            this.setState({
              promotionCheckProduct: productNum,
            }, () => {
              this.setApplyPromotionsModalVisibility2(true)
            });
            return;
          }
          if (totalQuantity < ByQuantityPromotion.FromQty && productBatchesOnTable.length && productBatchesOnTable[0].promotionApplied) {
            this.setState({
              unqualifiedPromotionProduct: productNum,
            }, () => {
              this.setUnqualifiedPromotionModalVisibility(true);
            })
          }
          return;
        }

        if(isOLG && buyAGetBPromotion) {
          // 是否已添加  IsPercent true  Off 赠送产品 列表改变
          if(buyAGetBPromotion.IsPercent) { // %
            if(buyAGetBPromotion.Off == 100) {
              const promotedProductonTable = this.state.rows.filter(row => ((row.ProductNum == buyAGetBPromotion.RelatedProductNum) && (row.IsGift)));
              if (!promotedProductonTable[0] && totalQuantity != 0) {
                // check and add promoted product to the list
                this.setState({
                  applyPromotionList:[buyAGetBPromotion],
                  promotionCheckProduct: productNum,
                }, () => {
                  this.setApplyPromotionsModalVisibility3(true);
                })
              } else {
                // if is already added, adjust promoted product qty
                this.modifyOLGExsitingPromotion(productNum, buyAGetBPromotion);
              }
            } else { //  FromQty * price - RelatedQuantity* Off
              if(totalQuantity >= buyAGetBPromotion.FromQty) {
                this.setState({
                  applyPromotionList:[buyAGetBPromotion],
                  promotionCheckProduct: productNum,
                }, () => {
                  this.setApplyPromotionsModalVisibility3(true);
                })
              } else {

              }
            }
          } else { // $
           if(totalQuantity < buyAGetBPromotion.FromQty) return
            this.setState({
              applyPromotionList:[buyAGetBPromotion],
              promotionCheckProduct: productNum,
            }, () => {
              this.setApplyPromotionsModalVisibility3(true);
            })
          }
          return;
        }
      }

      if (isGGI) {
        // find editing product with different batch on table
        const productBatchesOnTable = _.filter(this.state.rows, product => (product.ProductNum === productNum && product.UnitPrice));
        const ByQuantityPromotion = _.filter(productPromotions, promotion => promotion.Method === 'ByQuantity')[0];
        if (ByQuantityPromotion) {
          // if there is a ByQuantity promotion, calculate total product quantity to see if its qualified
          let totalQuantity = 0;
          _.forEach(productBatchesOnTable, row => {
            totalQuantity += parseInt(row.Quantity);
          });
          if (totalQuantity >= ByQuantityPromotion.FromQty && productBatchesOnTable.length && !productBatchesOnTable[0].promotionApplied) {
            // promotion qualified, and promotion has not been applied to this product, asking user to apply
            this.setState({
              promotionCheckProduct: productNum,
            }, () => {
              this.setApplyPromotionsModalVisibility2(true)
            });
            return;
          }
          if (totalQuantity < ByQuantityPromotion.FromQty && productBatchesOnTable.length && productBatchesOnTable[0].promotionApplied) {
            this.setState({
              unqualifiedPromotionProduct: productNum,
            }, () => {
              this.setUnqualifiedPromotionModalVisibility(true);
            })
          }
        }

        let filterdPromotion = productPromotions.filter(p => p.Method === "BuyAGetB" && p.IsPercent && p.Off === 100);
        if (!filterdPromotion || !filterdPromotion[0]) return;
        const promotedProductonTable = this.state.rows.filter(row => ((row.ProductNum === filterdPromotion[0].RelatedProductNum) && (row.IsGift)));
        if (!promotedProductonTable[0]) {
          // check and add promoted product to the list
          this.checkToAddPromotedProduct(productNum)
        } else {
          // if is already added, adjust promoted product qty
          this.modifyExsitingPromotion(productNum);
        }
        return;
      }

      return;
      let filterdPromotion = productPromotions.filter(p => p.Method === "BuyAGetB" && p.IsPercent && p.Off === 100);
      if (!filterdPromotion || !filterdPromotion[0]) return;
      const promotedProductonTable = this.state.rows.filter(row => ((row.ProductNum === filterdPromotion[0].RelatedProductNum) && (row.IsGift)));
      if (!promotedProductonTable[0]) {
        // check and add promoted product to the list
        this.checkToAddPromotedProduct(productNum)
      } else {
        // if is already added, adjust promoted product qty
        this.modifyExsitingPromotion(productNum);
      }
    }

    getBuyAGetBPromotion = (totalQty, filterPromotions) => {
      // 筛选折扣 第二种优惠   IsPercent  true %  false $  Off 10 百分比或者免费的值
      // todo 正确计算方式 计算价格然后判断哪种最优惠， 目前时间有限先和web保持一致
      // let buyPromotion = [];
      // let percets = []; // %
      // let noPercets = []; // $
      // filterPromotions.map(item => {
      //   if(item.IsPercent) {
      //     percets.push(item);
      //   } else {
      //     noPercets.push(item);
      //   }
      // })
      // let perOff = 0;
      // let perIdx = -1;
      // if(percets.length > 0) { // % 优惠最大
      //   percets.map((item, index) => {
      //     if(item.Off > perOff) {
      //       perOff = item.Off
      //       perIdx = index;
      //     }
      //   })
      // }
      // let perItem = null;
      // if(perIdx != -1) {
      //   perItem = percets[perIdx];
      // }
      // let noPerOff = 0;
      // let noPerIdx = -1;
      // if(noPercets.length > 0) { // $ 优惠最大
      //   noPercets.map((item, index) => {
      //     if(item.Off > noPerOff) {
      //       noPerOff = item.Off
      //       noPerIdx = index;
      //     }
      //   })
      // }
      // let noPerItem = null;
      // if(noPerIdx != -1) {
      //   noPerItem = noPercets[noPerIdx];
      // }

      let off = 0;
      let offIdx = -1;
      filterPromotions.map((item, index) => {
        if(item.Off >= off) {
          off = item.Off;
          offIdx = index;
        }
      })
      if(offIdx != -1) {
        return filterPromotions[offIdx];
      }
      return null;
    }

    setApplyPromotionsModalVisibility2 = (isApplyPromotionsModal2Visible = false) => this.setState({ isApplyPromotionsModal2Visible });
    setUnqualifiedPromotionModalVisibility = (isUnqualifiedPromotionModalVisible = false) => this.setState({ isUnqualifiedPromotionModalVisible });

    setApplyPromotionsModalVisibility3 = (isApplyPromotionsModal3Visible = false) => this.setState({ isApplyPromotionsModal3Visible });

    // isSV
    addChildProducts = (parent) => {
      if (parent.ChildProducts2 && parent.ChildProducts2.length > 0) {
        parent.ChildProducts2.map((r, i) => {
          setTimeout(() => {
            // this.props.setSaleOrderProductValues(roundToDecimals(r.PriceLv1, 4), 'salesOrderForm', r);
            // this.props.resetFormInputs();
            // this.state.selectedInventoryRow = r;
            // this.state.addingChildQty = 5;
            // this.state.addingChild = true;
            // this.state.addingChildParent = parent.RefNum;
            this.setState({addingChild: true, addingChildQty: r.child_qty, addingChildParent: parent.RefNum, selectedInventoryRow: r}); //r.child_qty
            this.checkMoveToSoChild(r);
          }, 10*i);
        });
      } else {
        alert("No Child Products Found!");
      }

      // if (parent.ChildProducts && parent.ChildProducts.length > 0) {
      // parent.ChildProducts.map((r, i) => {
      //     setTimeout(() => {
      //       this.setState({addingChild: true, addingChildQty: r.child_qty, addingChildParent: parent.RefNum});
      //       this.props.fetchSalesOrderProductByID(r.child_id, this.state.currentCustomer, this.props.Company_id, this.props.Pickup_Warehouse_id);
      //     }, 1000*i);
      //   });
      // } else {
      //   alert("No Child Products Found!");
      // }
    }

    // addChildProductsEkc & addChildProduct looks similar (isEKC || isLMH || isSDR || isCRW || isSC)
    addChildProductsEkc = (parent) => {
      if (parent.ChildProducts2 && parent.ChildProducts2.length > 0) {
        parent.ChildProducts2.map((r, i) => {
            setTimeout(() => {
              // this.props.setSaleOrderProductValues(roundToDecimals(r.PriceLv1, 4), 'salesOrderForm', r);
              // this.props.resetFormInputs();
              // this.state.selectedInventoryRow = r;
              // this.state.addingChildQty = 5;
              // this.state.addingChild = true;
              // this.state.addingChildParent = parent.RefNum;
              this.setState({addingChild: true, addingChildQty: r.child_qty, addingChildParent: parent.RefNum, selectedInventoryRow: r}); //r.child_qty
              this.checkMoveToSoChild(r);
            }, 10*i);
          });
        } else {
          alert("No Combo Products Found!");
        }
      // if (parent.ChildProducts && parent.ChildProducts.length > 0) {
      // parent.ChildProducts.map((r, i) => {
      //     setTimeout(() => {
      //       this.setState({addingChild: true, addingChildQty: r.child_qty, addingChildParent: parent.RefNum});
      //       this.props.fetchSalesOrderProductByID(r.child_id, this.state.currentCustomer, this.props.Company_id, this.props.Pickup_Warehouse_id);
      //     }, 1000*i);
      //   });
      // } else {
      //   alert("No Child Products Found!");
      // }
    }

    modifyExsitingPromotion = (productNum) => {
      const {
        productPromotions,
      } = this.props;

      let filterdPromotion = productPromotions.filter(p => p.Method === "BuyAGetB" && p.IsPercent && p.Off === 100);

      const promotedProductonTable = this.state.rows.filter(row => ((row.ProductNum === filterdPromotion[0].RelatedProductNum) && (row.UnitPrice == 0)));
      const promotedProductQty = this.calculateQtyOfPromotedProduct(productNum);
      if(promotedProductQty == 0 && isOLG) {
        let cpRows = [];
        this.state.rows.map((item) => {
          if(item.ProductNum != filterdPromotion[0].RelatedProductNum) {
            cpRows.push(item);
          } else {
            if(item.UnitPrice != 0) {
              cpRows.push(item);
            }
          }
        })
        this.setState({
          rows: cpRows,
        })
        return
      }
      if (promotedProductonTable[0].Quantity != promotedProductQty) {
        const rows = _.map(this.state.rows, row => {
          if ((row.ProductNum === filterdPromotion[0].RelatedProductNum) && (row.IsGift)){
            return {
              ...row,
              Quantity: promotedProductQty,
            }
          }
          return row;
        });
        this.setState({
          rows,
        })
      }

    }

    modifyOLGExsitingPromotion = (productNum, filterdPromotion) => {

      const promotedProductonTable = this.state.rows.filter(row => ((row.ProductNum === filterdPromotion.RelatedProductNum) && (row.UnitPrice == 0)));
      const promotedProductQty = this.calculateQtyOfPromotedProduct(productNum);
      if(promotedProductQty == 0) {
        let cpRows = [];
        this.state.rows.map((item) => {
          if(item.ProductNum != filterdPromotion.RelatedProductNum || (item.UnitPrice != 0 && !item.IsGift)) {
            cpRows.push(item);
          }
        })

        this.setState({
          rows: cpRows,
        })
        return
      }
      if (promotedProductonTable[0].Quantity != promotedProductQty) {
        const rows = _.map(this.state.rows, row => {
          if ((row.ProductNum === filterdPromotion.RelatedProductNum) && (row.IsGift)){
            return {
              ...row,
              Quantity: promotedProductQty,
            }
          }
          return row;
        });
        this.setState({
          rows,
        })
      }

    }

    calculateQtyOfPromotedProduct = (productNum) => {
      const {
        productPromotions,
      } = this.props;
      let productTotalQty = _.reduce(this.state.rows, (acc, current) => {
        if ((current.ProductNum === productNum) && (!current.IsGift)) {
          return acc + parseFloat(current.Quantity)
        }
        return acc
      }, 0);
      let filterdPromotion = productPromotions.filter(p => p.Method === "BuyAGetB" && p.IsPercent && p.Off === 100);
      const temp = filterdPromotion.sort((a, b) => a.FromQty > b.FromQty ? -1 : 1);
      const promotedProductQty = _.reduce(temp, (acc, current) => {
        const qty = parseInt(productTotalQty / current.FromQty);
        productTotalQty = productTotalQty - qty * current.FromQty
        return acc + qty * current.RelatedQuantity;
      }, 0);
      return promotedProductQty
    }

    checkToAddPromotedProduct = (productNum) => {
      const promotedProductQty = this.calculateQtyOfPromotedProduct(productNum);
      if (promotedProductQty) {
        this.setPromotionAddingAlertModalVisibility(true);
      }
    }

    setPromotionAddingAlertModalVisibility = (isPromotionAddingAlertModalVisible = false) => this.setState({ isPromotionAddingAlertModalVisible });
    handlePromotionAddConfirmClick = () => {
      const {
        productPromotions,
        Company_id,
        Pickup_Warehouse_id,
      } = this.props;
      let filterdPromotion = productPromotions.filter(p => p.Method === "BuyAGetB" && p.IsPercent && p.Off === 100);

      const promotedProductQty = this.calculateQtyOfPromotedProduct(filterdPromotion[0].ProductNum);
      const customer = this.state.currentCustomer.value || this.state.currentCustomer;
        const RelatedProduct_id = filterdPromotion[0].RelatedProduct_id;
        const success = (productDetails) => {
          const rows = [...this.state.rows];
          const gift = {
            ...productDetails,
            Quantity: promotedProductQty,
            UnitPrice: '0',
            TotalPrice: '0',
            IsGift: true,
          };
          rows.push(gift);
          this.setState({
            rows,
          });
        }
        this.props.fetchProductDetail(RelatedProduct_id, customer, Company_id, Pickup_Warehouse_id, success);
    }

    handlePromotionAddConfirmClickGGI = () => {
      const {
        productPromotions,
        Company_id,
        Pickup_Warehouse_id,
      } = this.props;
      let filterdPromotion = productPromotions.filter(p => p.Method === "BuyAGetB" && p.IsPercent && p.Off === 100);

      const promotedProductQty = this.calculateQtyOfPromotedProduct(filterdPromotion[0].ProductNum);
      const customer = this.state.currentCustomer.value || this.state.currentCustomer;
        const RelatedProduct_id = filterdPromotion[0].RelatedProduct_id;
        const success = (productDetails) => {
          const rows = [...this.state.rows];
          const gift = {
            ...productDetails,
            Quantity: promotedProductQty,
            SmallUnitPrice: '0',
            UnitPrice: '0',
            TotalPrice: '0',
            IsGift: true,
          };
          rows.push(gift);
          this.setState({
            rows,
          });
        }
        this.props.fetchProductDetail(RelatedProduct_id, customer, Company_id, Pickup_Warehouse_id, success);
    }

    checkMoveToSo() {
      const selectedInventoryRow = { ...this.state.selectedInventoryRow };
      const check = _.findIndex(this.state.rows, { ProductNum: selectedInventoryRow.ProductNum });
      if (isSV) {
        if (check === -1) {
          this.moveToSO();
        } else {
          let { unitPrice } = this.props;
          const selectedInventoryRow = { ...this.state.selectedInventoryRow };
          // if ( isMultiWH && unitPrice < selectedInventoryRow.LowestSalePrice ) {
          //   this.setState({ case: 'belowLowestSalePriceAndDuplicate', confirmOpen: true });
          // } else {
            this.setState({ case: 'addingDuplicate', confirmOpen: true });
          // }
        }
      } else {
        if (check === -1 || (!(isHO || isJRC))) {
          this.moveToSO();
        } else {
          let { unitPrice, smallUnitPrice } = this.props;
          const selectedInventoryRow = { ...this.state.selectedInventoryRow };
          // if ( isMultiWH && unitPrice < selectedInventoryRow.LowestSalePrice ) {
          //   this.setState({ case: 'belowLowestSalePriceAndDuplicate', confirmOpen: true });
          // } else {
            this.setState({ case: 'addingDuplicate', confirmOpen: true });
          // }
        }
      }
    }

    moveToSO() {
      let {quantityValue} = this.props;
      if ((isEcity || isHO || isJRC) && this.state.case === 'addingDuplicate' ) {
        this.findDuplicate(quantityValue);
      } else {
        const eCityItemPriceTrick = (row) => {
          let priceDisplay = 0;
          switch(this.state.customerPriceLevel) {
            case 1:
              priceDisplay = row.RefPrice;
              break;
            case 2:
              priceDisplay = row.PriceLv1;
              break;
            case 3:
              priceDisplay = row.PriceLv2;
              break;
          }
          return priceDisplay;
        }
        if (this.state.selectedInventoryRow.Product_id == null) {
          this.setState({ case: 'chooseProduct', confirmOpen: true});
          return;
        }
        
        let {
          inventories, inventoryIdValue, favorites, weight,
          available, inPurchase, preSale, salePrice, refPurchasePrice, unitPrice,smallUnitPrice, description, notation, itemNotation,
        } = this.props;
        const selectedInventoryRow = { ...this.state.selectedInventoryRow };
        if (!isJTB && !isSV && !isSH && (isGGI && smallUnitPrice < selectedInventoryRow.LowestSalePrice || unitPrice < selectedInventoryRow.LowestSalePrice) && arguments[0] !== 'move' && !this.state.confirmLowerThanLowestPrice) {
          this.setState({ case: 'belowLowestSalePrice', confirmOpen: true });
          return;
        }
        if((isHMM) && unitPrice < selectedInventoryRow.LowestSalePrice && arguments[0] === 'move' && !arguments[1]) {
          this.openVerifyPasscode();
          return;
        }

        let totalPrice = 0;
        let finalWeight = 0;
        let totalTax = 0;
        let totalCRV = 0;
        let index = 0;
        const discount = parseFloat(this.props.discount) || 0;
        // const check = _.findIndex(this.state.rows, { ProductNum: selectedInventoryRow.ProductNum });
        if (quantityValue === undefined) { quantityValue = 0; }
        if (isSV && !this.state.addingChild && quantityValue < selectedInventoryRow.MinOrderQty) {
          // alert("Cannot be lower than Minimum Order Quantity: " + selectedInventoryRow.MinOrderQty);
          // return;
        }
        // if (check == -1) {
        if (isHMM || (
          (selectedInventoryRow.InStock - selectedInventoryRow.PreSale) > 0 &&
          quantityValue <= (selectedInventoryRow.InStock - selectedInventoryRow.PreSale)
          ) || selectedInventoryRow.IsOverSaleable === true || isAFG) {

          selectedInventoryRow.Quantity = quantityValue;

          if ((isSV || isEKC || isLMH || isSDR || isCRW || isSC) && selectedInventoryRow.IsCombo) {
            const check = _.findIndex(this.state.rows, { ProductNum: selectedInventoryRow.ProductNum });
            // CRW, cant add product if parent and is added already
            if (isCRW && check !== -1) {
              alert("You are adding a duplicate combo item");
              return;
            }
            this.setState({addingChild: false, comboQty: quantityValue});
          }

          selectedInventoryRow.IsChild = this.props.IsChild;
          if ((isSV || isEKC || isLMH || isSDR || isCRW || isSC) && this.state.addingChild === true) {
            selectedInventoryRow.Quantity = this.state.comboQty * this.state.addingChildQty;
            selectedInventoryRow.IsChild = true;
            selectedInventoryRow.ParentRefNum = this.state.addingChildParent;
            this.setState({addingChild: false, addingChildQty: null, addingChildParent: null});
            // get rid of unit price here??
          }

          if (isGGI) {
            selectedInventoryRow.SmallUnitPrice = smallUnitPrice;
          }
          selectedInventoryRow.UnitPrice = this.props.unitPrice;
        
          if (isSV || ((isEKC || isLMH) && this.state.currentProdEkc !== '0101')) {
            if (selectedInventoryRow.ProductType === 'Fixed' || selectedInventoryRow.ProductType === 'Non-Product') {
              selectedInventoryRow.TotalPrice = +roundToDecimals(selectedInventoryRow.IsChild ? 0 : this.props.unitPrice * quantityValue, 4).toFixed(4);
            } else {
              selectedInventoryRow.TotalPrice = +roundToDecimals(selectedInventoryRow.IsChild ? 0 : this.props.unitPrice * (!isJML ? weight : selectedInventoryRow.PackageSize_1) * quantityValue, 4).toFixed(4);
            }
          } else if ((isEKC || isLMH) && this.state.currentProdEkc === '0101') {
            if (selectedInventoryRow.ProductType === 'Fixed' || selectedInventoryRow.ProductType === 'Non-Product') {
              selectedInventoryRow.TotalPrice = +roundToDecimals(this.props.unitPrice * quantityValue * (this.props.SqftPack ? this.props.SqftPack : 1), 4).toFixed(4);
            } else {
              selectedInventoryRow.TotalPrice = +roundToDecimals(this.props.unitPrice * (!isJML ? weight : selectedInventoryRow.PackageSize_1) * quantityValue, 4).toFixed(4);
            }
          } else {
            if (selectedInventoryRow.ProductType === 'Fixed' || selectedInventoryRow.ProductType === 'Non-Product') {
              selectedInventoryRow.TotalPrice = +roundToDecimals(this.props.unitPrice * quantityValue, 4).toFixed(4);
            } else {
              selectedInventoryRow.TotalPrice = +roundToDecimals(this.props.unitPrice * (!isJML ? weight : selectedInventoryRow.PackageSize_1) * quantityValue, 4).toFixed(4);
            }
          }
          selectedInventoryRow.TotalCRV = +roundTo(parseFloat(selectedInventoryRow.Quantity) * parseFloat(selectedInventoryRow.CRV), 2).toFixed(2);
          selectedInventoryRow.Weight = +this.props.weight;
          if (isSH || isSUN || isLAP || isOLG) {
            selectedInventoryRow.NetWeight = +this.props.weight;
          }
          selectedInventoryRow.TotalNetWeight = roundTo(selectedInventoryRow.NetWeight * selectedInventoryRow.Quantity, 2);
          selectedInventoryRow.Remark = itemNotation;
          // if (isWIZ) {
          if (this.props) {
            selectedInventoryRow.ReceivedQuantity = this.props.ReceivedQuantity;
            selectedInventoryRow.ShipmentID = this.props.ShipmentID;
            if (isLMH || isSDR || isCRW || isSC || isOLG) {
              selectedInventoryRow.OriginalPrice = selectedInventoryRow.RefPrice;
            }
            if (isLMH) {
              selectedInventoryRow.LineDiscount = this.props.LineDiscount ? this.props.LineDiscount : 0;
              selectedInventoryRow.MainId = new Date().getTime();
              selectedInventoryRow.Pid = -1;
            }
            selectedInventoryRow.BillablePallets = this.props.BillablePallets;
            selectedInventoryRow.RealPallets = this.props.RealPallets;
            selectedInventoryRow.BoxPerPallet = this.props.BoxPerPallet;
            selectedInventoryRow.DispatchType = this.props.DispatchType;
            selectedInventoryRow.BoxVol = this.props.BoxVol;
            selectedInventoryRow.BoxHeight = this.props.BoxHeight;
            selectedInventoryRow.BoxWidth = this.props.BoxWidth;
            selectedInventoryRow.InnerLabelQty = this.props.InnerLabelQty;
            selectedInventoryRow.OuterLabelQty = this.props.OuterLabelQty;
            selectedInventoryRow.BoxLength = this.props.BoxLength;
            selectedInventoryRow.BoxWeight = this.props.BoxWeight;
            selectedInventoryRow.PalletHeight = this.props.PalletHeight;
            selectedInventoryRow.PalletWidth = this.props.PalletWidth;
            selectedInventoryRow.PalletLength = this.props.PalletLength;
            selectedInventoryRow.PalletVol = this.props.PalletVol;
            selectedInventoryRow.PalletWeight = this.props.PalletWeight;
            selectedInventoryRow.IsOversize = this.props.IsOversize;
            selectedInventoryRow.IsOverweight = this.props.IsOverweight;
            selectedInventoryRow.PortDray = this.props.PortDray;
            selectedInventoryRow.DrayageTrucker = this.props.DrayageTrucker;
            selectedInventoryRow.Location = this.props.Location;
            selectedInventoryRow.FBACode = this.props.FBACode;
            selectedInventoryRow.PalletQuantity = this.props.PalletQuantity;

            selectedInventoryRow.Sqft = this.props.Sqft;
            selectedInventoryRow.SqftPack = this.props.SqftPack;
            selectedInventoryRow.SqftTotal = (this.props.SqftPack ? this.props.SqftPack : 0) * quantityValue;
            if (selectedInventoryRow && selectedInventoryRow.SqftTotal) {
              selectedInventoryRow.SqftTotal = selectedInventoryRow.SqftTotal.toFixed(3);
            }

            selectedInventoryRow.BoxQuantity = this.props.BoxQuantity;
            selectedInventoryRow.PieceQuantity = this.props.PieceQuantity;
            selectedInventoryRow.TotalShippingWeight = this.props.TotalShippingWeight;
            selectedInventoryRow.FBARoute = this.props.FBARoute;
            selectedInventoryRow.DimUnit = this.props.DimUnit;
            selectedInventoryRow.IsNoReturn = this.props.IsNoReturn;
            if (isVAK) {
              selectedInventoryRow.IsSpare = this.props.IsSpare;
            }
            // selectedInventoryRow.IsCombo = this.props.IsCombo;

            selectedInventoryRow.CustomerBoxQty = this.props.CustomerBoxQty;
            selectedInventoryRow.OutsideLabelQty = this.props.OutsideLabelQty;
            selectedInventoryRow.InsideLabelQty = this.props.InsideLabelQty;
            selectedInventoryRow.SpecialHandling = this.props.SpecialHandling;
            selectedInventoryRow.CustomerNote = this.props.CustomerNote;

            selectedInventoryRow.WeightUnit = this.props.WeightUnit;
            selectedInventoryRow.TrailerNum = this.props.TrailerNum;
            selectedInventoryRow.POList = this.props.POList;
            selectedInventoryRow.POD = this.props.POD;
            // ?
            if (true) {
              selectedInventoryRow.Batch_id = this.state.Batch_id;
              selectedInventoryRow.BatchExpiredDate = this.state.BatchExpiredDate;
              selectedInventoryRow.BatchLocation = this.state.BatchLocation;
            }
            // selectedInventoryRow.ContainerNum = this.props.ContainerNum;
            }
          // }
          if (isEcity) selectedInventoryRow.ProductCost = eCityItemPriceTrick(selectedInventoryRow);
        } else {
          this.setState({
            case: 'itemOutOfStock',
            confirmOpen: true,
            selectedInventoryRow: {},
            inStock: '',
            inStockWarehouse: '',
            inStockOnhand: '',
            purchased: '',
            presale: '',
            net_weight: '',
            suggestValue: '',
          });
          this.props.resetFormInputs();
          return;
        }
        const rows = [...this.state.rows];
        // if (isHMM) {
        //   let maxPosition = 0;
        //   rows.forEach((row) => {
        //     if (row.Order > maxPosition) {
        //       maxPosition = row.Order;
        //     }
        //   });
        //   rows.push({ ...selectedInventoryRow, Order: maxPosition + 1 });
        // } else {

        if ((isEKC || isLMH || isSDR) && selectedInventoryRow.IsCombo) {
          // rows.unshift(selectedInventoryRow);
        } else if ((isCRW || isSC) && selectedInventoryRow.IsCombo) {
          rows.push(selectedInventoryRow);
        } else {
          if (isSV || isSUN || isOLG) {
            rows.push(selectedInventoryRow);
          } else {
            rows.unshift(selectedInventoryRow);
          }
        }
        // }
        // rows.unshift(selectedInventoryRow);
        index = rows.length;
        rows.map((row, idxx) => {
          if (isSV || isSUN || isOLG) {
            row.Index = idxx+1;
          } else {
            row.Index = index;
            index--;
          }
          totalCRV = (parseFloat(row.TotalCRV) || 0) + (+roundTo(parseFloat(totalCRV), 2).toFixed(2));
          if (row.IsTaxable === true) {
            if(isHMM) {
              totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(this.state.taxValue / 100);
            } else {
              if(isHO || isJRC || isVIP) {
                if(row.IsAllTaxable === true || !this.props.salesCustomerDetails.Reseller) {
                  totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
                }
              } else {
                totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
              }
            }
          }
          if(isLAP) {
            // sum line product cost
            let lineTotalCost = 0;
            let totalPrices = parseFloat(row.TotalPrice);
            if(!totalPrices || totalPrices == 0) {
              if(row.ProductType === 'Non-Fixed' || row.ProductType === 'Per-Pound') {
                row.TotalPrice = roundTo(parseFloat(row.UnitPrice * (row.NetWeight || 0) * (row.Quantity || 0)), 2);
              } else {
                row.TotalPrice = roundTo(parseFloat((row.Quantity || 0) * row.UnitPrice), 2);
              }
            }
            if(row.ProductType == 'Non-Fixed' || row.ProductType == 'Per-Pound') {
              lineTotalCost = (row.ProductCost || row.CurrentCost || row.CostPrice || 0) * (row.NetWeight || 0) * row.Quantity;
            } else {
              lineTotalCost = (row.ProductCost || row.CurrentCost || 0) * row.Quantity;
            }
            if(row.Quantity == 0) {
              row.Profit1 = 0;
              row.SalesMargin1 = 0;
            } else {
              row.Profit1 = roundTo(parseFloat(row.TotalPrice) - lineTotalCost, 2);
              row.SalesMargin1 = roundTo((parseFloat(row.TotalPrice) - lineTotalCost) / parseFloat(row.TotalPrice) * 100, 2);
            }
          }
          if(isHMM) {
            totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
          } else {
            totalPrice += parseFloat(row.TotalPrice);
          }
          if (row.TotalNetWeight != null) {
            finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight);
          }
          finalWeight = Math.round(0.00001 + finalWeight * 100) / 100;
        });

        const { SODiscount, SOSavings } = this.state; // only one has value
        if (isEKC || isLMH || isSDR || isCRW || isSC || isHMM || isSUN || isCPG || isSH) {
          if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
            totalTax = 0;
          } else {
            if (SODiscount) {
              totalTax = 0;
              rows.map((row, idxx) => {
                if (row.IsTaxable === true) {
                  totalTax += ((parseFloat(row.TotalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)))) * parseFloat(this.state.taxValue / 100);
                }
              });
            }
             }
        }

        finalWeight = Math.round(0.00001 + finalWeight * 100) / 100;
        totalPrice = +roundToDecimals(totalPrice, 4).toFixed(4);
        totalTax = +roundTo(totalTax, 2).toFixed(2);
        totalCRV = +roundTo(totalCRV, 2).toFixed(2);
        let finalPrice = +roundTo(totalPrice * (1 - discount / 100) + totalTax + totalCRV, 2).toFixed(2);
        // finalPrice = Math.round(0.00001 + finalPrice * 100) / 100;
        if(isSH && this.state.ccOrigin) {
          finalPrice = Number(finalPrice) + Number(finalPrice * (this.state.ccOrigin || 0)).toFixed(2);
        }
        this.setState({
          rows,
          editing: true,
          finalPrice,
          totalPrice,
          totalTax,
          totalCRV,
          finalWeight,
          selectedInventoryRow: {},
          inStock: '',
          inStockWarehouse: '',
          inStockOnhand: '',
          purchased: '',
          presale: '',
          net_weight: '',
          ship_weight: '',
          total_weight: '',
          suggestValue: '',
        }, () => {
          this.checkForPromotions(selectedInventoryRow.ProductNum);
          if ((isEKC || isLMH || isSDR || isCRW || isSC || isOLG || isVAK)) { this.onConfirmPercentageFee(); }
          if (isSV && selectedInventoryRow.IsCombo === true) {
            this.addChildProducts(selectedInventoryRow);
          }
          if ((isEKC || isLMH || isSDR || isCRW || isSC) && selectedInventoryRow.IsCombo === true) {
            this.addChildProductsEkc(selectedInventoryRow);
          }
          if(isOLG) {
            let list = document.querySelector('#SalesOrderForm-dataGrid3 .react-grid-Canvas');
            list.scrollTop = list.scrollHeight
          }
        });
        // }
        this.props.resetFormInputs();
        this.setAllProductQuantity(1);
      }
    }

    checkMoveToSoChild(child) {
      const selectedInventoryRow = { ...this.state.selectedInventoryRow };
      const check = _.findIndex(this.state.rows, { ProductNum: selectedInventoryRow.ProductNum });
      if (check === -1 || true) {
        if (isEKC || isLMH || isSDR || isCRW || isSC) {
          this.moveToSOChildEkc(child);
        } else {
          this.moveToSOChild(child);
        }
      } else {
        let { unitPrice } = this.props;
        const selectedInventoryRow = { ...this.state.selectedInventoryRow };
        if ( isMultiWH && unitPrice < selectedInventoryRow.LowestSalePrice ) {
          this.setState({ case: 'belowLowestSalePriceAndDuplicate', confirmOpen: true });
        } else {
          this.setState({ case: 'addingDuplicate', confirmOpen: true });
        }
      }
    }
  
    // moveToSOChildEkc and moveToSOChild looks similar (isEKC || isLMH || isSDR || isCRW || isSC)
    moveToSOChildEkc(child) {
      if (this.state.selectedInventoryRow.Product_id == null) {
        this.setState({ case: 'chooseProduct', confirmOpen: true});
        return;
      }
      // let {
      //   inventories, inventoryIdValue, quantityValue, favorites, weight,
      //   available, inPurchase, preSale, salePrice, refPurchasePrice, unitPrice, description, notation, itemNotation,
      // } = this.props;
      let quantityValue = 1;
      let weight = child.NetWeight;
      // DO VARIABLE PRICING HERE??
      let unitPrice = child.PriceLv1;
      let itemNotation = "";

      const selectedInventoryRow = { ...this.state.selectedInventoryRow };
      if (unitPrice < selectedInventoryRow.LowestSalePrice && arguments[0] !== 'move' && !this.state.confirmLowerThanLowestPrice) {
        this.setState({ case: 'belowLowestSalePrice', confirmOpen: true });
        return;
      }
      let totalPrice = 0;
      let finalWeight = 0;
      let totalTax = 0;
      let totalCRV = 0;
      let index = 0;
      const discount = parseFloat(this.props.discount) || 0;
      // const check = _.findIndex(this.state.rows, { ProductNum: selectedInventoryRow.ProductNum });
      if (quantityValue === undefined) { quantityValue = 1; }
      // if (isSV && !this.state.addingChild && quantityValue < selectedInventoryRow.MinOrderQty) {
      //   alert("Cannot be lower than Minimum Order Quantity: " + selectedInventoryRow.MinOrderQty);
      //   return;
      // }
      // if (check == -1) {
      if (((selectedInventoryRow.InStock - (isHMM ? 0 : selectedInventoryRow.PreSale)) > 0 && quantityValue <= (selectedInventoryRow.InStock-(isHMM ? 0 : selectedInventoryRow.PreSale))) || selectedInventoryRow.IsOverSaleable === true || isHMM || isAFG) {
        selectedInventoryRow.Quantity = quantityValue;

        // if (isSV && selectedInventoryRow.IsCombo) {
        //   this.setState({addingChild: false, comboQty: quantityValue});
        // }

        selectedInventoryRow.IsChild = this.props.IsChild;
        if ((isEKC || isLMH || isSDR || isCRW || isSC) && this.state.addingChild === true) {
          selectedInventoryRow.Quantity = this.state.comboQty * this.state.addingChildQty;
          // selectedInventoryRow.IsChild = true;
          selectedInventoryRow.ParentRefNum = this.state.addingChildParent;
          this.setState({addingChild: false, addingChildQty: null, addingChildParent: null});
          // get rid of unit price here??
        }

        selectedInventoryRow.UnitPrice = unitPrice;
        if (isCRW || isSC) {
          selectedInventoryRow.IsChild = true;
          // selectedInventoryRow.ParentRefNum = this.state.addingChildParent;
          selectedInventoryRow.UnitPrice = 0;
          selectedInventoryRow.RefPrice = 0;
          unitPrice = 0;
        }
        
        if (isSV || isEKC || isLMH || isSDR || isCRW || isSC) {
          if (selectedInventoryRow.ProductType === 'Fixed' || selectedInventoryRow.ProductType === 'Non-Product') {
            selectedInventoryRow.TotalPrice = +roundToDecimals(unitPrice * selectedInventoryRow.Quantity, 4).toFixed(4);
          } else {
            selectedInventoryRow.TotalPrice = +roundToDecimals(unitPrice * (!isJML ? weight : selectedInventoryRow.PackageSize_1) * selectedInventoryRow.Quantity, 4).toFixed(4);
          }
        }

        selectedInventoryRow.TotalCRV = +roundTo(parseFloat(selectedInventoryRow.Quantity) * parseFloat(selectedInventoryRow.CRV), 2).toFixed(2);
        selectedInventoryRow.Weight = +weight;
        if(isSH || isSUN || isLAP) {
          selectedInventoryRow.NetWeight = +weight;
        }
        selectedInventoryRow.TotalNetWeight = roundTo(selectedInventoryRow.NetWeight * selectedInventoryRow.Quantity, 2);
        selectedInventoryRow.Remark = itemNotation;
        if (this.props) {
          selectedInventoryRow.ReceivedQuantity = this.props.ReceivedQuantity;
          selectedInventoryRow.ShipmentID = this.props.ShipmentID;
          selectedInventoryRow.BillablePallets = this.props.BillablePallets;
          selectedInventoryRow.RealPallets = this.props.RealPallets;
          selectedInventoryRow.BoxPerPallet = this.props.BoxPerPallet;
          selectedInventoryRow.DispatchType = this.props.DispatchType;
          selectedInventoryRow.BoxVol = this.props.BoxVol;
          selectedInventoryRow.BoxHeight = this.props.BoxHeight;
          selectedInventoryRow.BoxWidth = this.props.BoxWidth;
          selectedInventoryRow.InnerLabelQty = this.props.InnerLabelQty;
          selectedInventoryRow.OuterLabelQty = this.props.OuterLabelQty;
          selectedInventoryRow.BoxLength = this.props.BoxLength;
          selectedInventoryRow.BoxWeight = this.props.BoxWeight;
          selectedInventoryRow.PalletHeight = this.props.PalletHeight;
          selectedInventoryRow.PalletWidth = this.props.PalletWidth;
          selectedInventoryRow.PalletLength = this.props.PalletLength;
          selectedInventoryRow.PalletVol = this.props.PalletVol;
          selectedInventoryRow.PalletWeight = this.props.PalletWeight;
          selectedInventoryRow.IsOversize = this.props.IsOversize;
          selectedInventoryRow.IsOverweight = this.props.IsOverweight;
          selectedInventoryRow.PortDray = this.props.PortDray;
          selectedInventoryRow.DrayageTrucker = this.props.DrayageTrucker;
          selectedInventoryRow.Location = this.props.Location;
          selectedInventoryRow.FBACode = this.props.FBACode;
          selectedInventoryRow.PalletQuantity = this.props.PalletQuantity;

          selectedInventoryRow.Sqft = this.props.Sqft;
          selectedInventoryRow.SqftPack = this.props.SqftPack;
          selectedInventoryRow.SqftTotal = (this.props.SqftPack ? this.props.SqftPack : 0) * quantityValue;
          if (selectedInventoryRow && selectedInventoryRow.SqftTotal) {
            selectedInventoryRow.SqftTotal = selectedInventoryRow.SqftTotal.toFixed(3);
          }

          selectedInventoryRow.BoxQuantity = this.props.BoxQuantity;
          selectedInventoryRow.PieceQuantity = this.props.PieceQuantity;
          selectedInventoryRow.TotalShippingWeight = this.props.TotalShippingWeight;
          selectedInventoryRow.FBARoute = this.props.FBARoute;
          selectedInventoryRow.DimUnit = this.props.DimUnit;
          selectedInventoryRow.IsNoReturn = this.props.IsNoReturn;
          // selectedInventoryRow.IsCombo = this.props.IsCombo;

          selectedInventoryRow.CustomerBoxQty = this.props.CustomerBoxQty;
          selectedInventoryRow.OutsideLabelQty = this.props.OutsideLabelQty;
          selectedInventoryRow.InsideLabelQty = this.props.InsideLabelQty;
          selectedInventoryRow.SpecialHandling = this.props.SpecialHandling;
          selectedInventoryRow.CustomerNote = this.props.CustomerNote;

          selectedInventoryRow.WeightUnit = this.props.WeightUnit;
          selectedInventoryRow.TrailerNum = this.props.TrailerNum;
          selectedInventoryRow.POList = this.props.POList;
          selectedInventoryRow.POD = this.props.POD;
          if (true) {
            selectedInventoryRow.Batch_id = this.state.Batch_id;
            selectedInventoryRow.BatchExpiredDate = this.state.BatchExpiredDate;
            selectedInventoryRow.BatchLocation = this.state.BatchLocation;
          }
          // selectedInventoryRow.ContainerNum = this.props.ContainerNum;
        }
      } else {
        this.setState({
          case: 'itemOutOfStock',
          confirmOpen: true,
          selectedInventoryRow: {},
          inStock: '',
          inStockWarehouse: '',
          inStockOnhand: '',
          purchased: '',
          presale: '',
          net_weight: '',
          suggestValue: '',
        });
        this.props.resetFormInputs();
        return;
      }
      const rows = [...this.state.rows];
      if (isHMM) {
        let maxPosition = 0;
        rows.forEach((row) => {
          if (row.Order > maxPosition) {
            maxPosition = row.Order;
          }
        });
        rows.push({ ...selectedInventoryRow, Order: maxPosition + 1 });
      } else {
        rows.unshift(selectedInventoryRow);
      }
      index = rows.length;
      rows.map((row, idxx) => {
        if (isSV || isSUN) {
          row.Index = idxx+1;
        } else {
          row.Index = index;
          index--;
        }
        totalCRV = (parseFloat(row.TotalCRV) || 0) + (+roundTo(parseFloat(totalCRV), 2).toFixed(2));
        if (row.IsTaxable === true) {
          if(isHMM) {
            totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(this.state.taxValue / 100);
          } else {
            totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
          }
        }
        if(isHMM) {
          totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
        } else {
          totalPrice += parseFloat(row.TotalPrice);
        }
        if (row.TotalNetWeight != null) {
          finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight);
        }
        finalWeight = Math.round(0.00001 + finalWeight * 100) / 100;
      });

      if (isHMM || isLMH || isSDR || isCRW || isSC || isSUN || isCPG) {
        if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
          totalTax = 0;
        }  else {
          if (SODiscount) {
            totalTax = 0;
            rows.map((row, idxx) => {
              if (row.IsTaxable === true) {
                totalTax += ((parseFloat(row.TotalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)))) * parseFloat(this.state.taxValue / 100);
              }
            });
          }
           }
      }
      const { SODiscount, SOSavings } = this.state; // only one has value
      if ((isEKC || isSH)) {
        if (isEKC && this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
          totalTax = 0;
        } else {
          totalTax = ((parseFloat(totalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)) - Number(SOSavings ? SOSavings : 0))) * parseFloat(this.state.taxValue / 100);
        }
      }

      finalWeight = Math.round(0.00001 + finalWeight * 100) / 100;
      totalPrice = +roundToDecimals(totalPrice, 4).toFixed(4);
      totalTax = +roundTo(totalTax, 2).toFixed(2);
      totalCRV = +roundTo(totalCRV, 2).toFixed(2);
      let finalPrice = +roundTo(totalPrice * (1 - discount / 100) + totalTax + totalCRV, 2).toFixed(2);
      this.setState({
        rows,
        editing: true,
        finalPrice,
        totalPrice,
        totalTax,
        totalCRV,
        finalWeight,
        selectedInventoryRow: {},
        inStock: '',
        inStockWarehouse: '',
        inStockOnhand: '',
        purchased: '',
        presale: '',
        net_weight: '',
        ship_weight: '',
        total_weight: '',
        suggestValue: '',
      }, () => {
        this.checkForPromotions(selectedInventoryRow.ProductNum);
        if (isSV && selectedInventoryRow.IsCombo === true) {
          this.addChildProducts(selectedInventoryRow);
        }
      });
      // }
      // this.props.resetFormInputs();
      // this.setAllProductQuantity(1);
    }

    // isSV
    moveToSOChild(child) {
      if (this.state.selectedInventoryRow.Product_id == null) {
        this.setState({ case: 'chooseProduct', confirmOpen: true});
        return;
      }
      // let {
      //   inventories, inventoryIdValue, quantityValue, favorites, weight,
      //   available, inPurchase, preSale, salePrice, refPurchasePrice, unitPrice, description, notation, itemNotation,
      // } = this.props;

      let quantityValue = 1;
      let weight = child.NetWeight;
      // DO VARIABLE PRICING HERE??
      let unitPrice = child.PriceLv1;
      let itemNotation = "";

      const selectedInventoryRow = { ...this.state.selectedInventoryRow };
      if ((!isSV && !isSH) && unitPrice < selectedInventoryRow.LowestSalePrice && arguments[0] !== 'move' && !this.state.confirmLowerThanLowestPrice) {
        this.setState({ case: 'belowLowestSalePrice', confirmOpen: true });
        return;
      }
      let totalPrice = 0;
      let finalWeight = 0;
      let totalTax = 0;
      let totalCRV = 0;
      let index = 0;
      const discount = parseFloat(this.props.discount) || 0;
      // const check = _.findIndex(this.state.rows, { ProductNum: selectedInventoryRow.ProductNum });
      if (quantityValue === undefined) { quantityValue = 1; }
      // if (isSV && !this.state.addingChild && quantityValue < selectedInventoryRow.MinOrderQty) {
      //   alert("Cannot be lower than Minimum Order Quantity: " + selectedInventoryRow.MinOrderQty);
      //   return;
      // }
      // if (check == -1) {
      if (((selectedInventoryRow.InStock - (isHMM ? 0 : selectedInventoryRow.PreSale)) > 0 && quantityValue <= (selectedInventoryRow.InStock-(isHMM ? 0 : selectedInventoryRow.PreSale))) || selectedInventoryRow.IsOverSaleable === true || isHMM || isAFG) {
        selectedInventoryRow.Quantity = quantityValue;

        // if (isSV && selectedInventoryRow.IsCombo) {
        //   this.setState({addingChild: false, comboQty: quantityValue});
        // }

        selectedInventoryRow.IsChild = this.props.IsChild;
        if ((isSV || isEKC || isLMH || isSDR || isCRW || isSC) && this.state.addingChild === true) {
          selectedInventoryRow.Quantity = this.state.comboQty * this.state.addingChildQty;
          selectedInventoryRow.IsChild = true;
          selectedInventoryRow.ParentRefNum = this.state.addingChildParent;
          this.setState({addingChild: false, addingChildQty: null, addingChildParent: null});
          // get rid of unit price here??
        }

        selectedInventoryRow.UnitPrice = unitPrice;
        
        if (isSV) {
          if (selectedInventoryRow.ProductType === 'Fixed' || selectedInventoryRow.ProductType === 'Non-Product') {
            selectedInventoryRow.TotalPrice = +roundToDecimals(selectedInventoryRow.IsChild ? 0 : unitPrice * quantityValue, 4).toFixed(4);
          } else {
            selectedInventoryRow.TotalPrice = +roundToDecimals(selectedInventoryRow.IsChild ? 0 : unitPrice * (!isJML ? weight : selectedInventoryRow.PackageSize_1) * quantityValue, 4).toFixed(4);
          }
        }

        selectedInventoryRow.TotalCRV = +roundTo(parseFloat(selectedInventoryRow.Quantity) * parseFloat(selectedInventoryRow.CRV), 2).toFixed(2);
        selectedInventoryRow.Weight = +weight;
        if(isSH || isSUN || isLAP) {
          selectedInventoryRow.NetWeight = +weight;
        }
        selectedInventoryRow.TotalNetWeight = roundTo(selectedInventoryRow.NetWeight * selectedInventoryRow.Quantity, 2);
        selectedInventoryRow.Remark = itemNotation;
        if (this.props) {
          selectedInventoryRow.ReceivedQuantity = this.props.ReceivedQuantity;
          selectedInventoryRow.ShipmentID = this.props.ShipmentID;
          selectedInventoryRow.BillablePallets = this.props.BillablePallets;
          selectedInventoryRow.RealPallets = this.props.RealPallets;
          selectedInventoryRow.BoxPerPallet = this.props.BoxPerPallet;
          selectedInventoryRow.DispatchType = this.props.DispatchType;
          selectedInventoryRow.BoxVol = this.props.BoxVol;
          selectedInventoryRow.BoxHeight = this.props.BoxHeight;
          selectedInventoryRow.BoxWidth = this.props.BoxWidth;
          selectedInventoryRow.InnerLabelQty = this.props.InnerLabelQty;
          selectedInventoryRow.OuterLabelQty = this.props.OuterLabelQty;
          selectedInventoryRow.BoxLength = this.props.BoxLength;
          selectedInventoryRow.BoxWeight = this.props.BoxWeight;
          selectedInventoryRow.PalletHeight = this.props.PalletHeight;
          selectedInventoryRow.PalletWidth = this.props.PalletWidth;
          selectedInventoryRow.PalletLength = this.props.PalletLength;
          selectedInventoryRow.PalletVol = this.props.PalletVol;
          selectedInventoryRow.PalletWeight = this.props.PalletWeight;
          selectedInventoryRow.IsOversize = this.props.IsOversize;
          selectedInventoryRow.IsOverweight = this.props.IsOverweight;
          selectedInventoryRow.PortDray = this.props.PortDray;
          selectedInventoryRow.DrayageTrucker = this.props.DrayageTrucker;
          selectedInventoryRow.Location = this.props.Location;
          selectedInventoryRow.FBACode = this.props.FBACode;
          selectedInventoryRow.PalletQuantity = this.props.PalletQuantity;

          selectedInventoryRow.Sqft = this.props.Sqft;
          selectedInventoryRow.SqftPack = this.props.SqftPack;
          selectedInventoryRow.SqftTotal = (this.props.SqftPack ? this.props.SqftPack : 0) * quantityValue;
          if (selectedInventoryRow && selectedInventoryRow.SqftTotal) {
            selectedInventoryRow.SqftTotal = selectedInventoryRow.SqftTotal.toFixed(3);
          }

          selectedInventoryRow.BoxQuantity = this.props.BoxQuantity;
          selectedInventoryRow.PieceQuantity = this.props.PieceQuantity;
          selectedInventoryRow.TotalShippingWeight = this.props.TotalShippingWeight;
          selectedInventoryRow.FBARoute = this.props.FBARoute;
          selectedInventoryRow.DimUnit = this.props.DimUnit;
          selectedInventoryRow.IsNoReturn = this.props.IsNoReturn;
          // selectedInventoryRow.IsCombo = this.props.IsCombo;

          selectedInventoryRow.CustomerBoxQty = this.props.CustomerBoxQty;
          selectedInventoryRow.OutsideLabelQty = this.props.OutsideLabelQty;
          selectedInventoryRow.InsideLabelQty = this.props.InsideLabelQty;
          selectedInventoryRow.SpecialHandling = this.props.SpecialHandling;
          selectedInventoryRow.CustomerNote = this.props.CustomerNote;

          selectedInventoryRow.WeightUnit = this.props.WeightUnit;
          selectedInventoryRow.TrailerNum = this.props.TrailerNum;
          selectedInventoryRow.POList = this.props.POList;
          selectedInventoryRow.POD = this.props.POD;
          if (true) {
            selectedInventoryRow.Batch_id = this.state.Batch_id;
            selectedInventoryRow.BatchExpiredDate = this.state.BatchExpiredDate;
            selectedInventoryRow.BatchLocation = this.state.BatchLocation;
          }
          // selectedInventoryRow.ContainerNum = this.props.ContainerNum;
          }
        } else {
          this.setState({
            case: 'itemOutOfStock',
            confirmOpen: true,
            selectedInventoryRow: {},
            inStock: '',
            inStockWarehouse: '',
            inStockOnhand: '',
            purchased: '',
            presale: '',
            net_weight: '',
            suggestValue: '',
          });
          this.props.resetFormInputs();
          return;
        }
        const rows = [...this.state.rows];
        if (isHMM) {
          let maxPosition = 0;
          rows.forEach((row) => {
            if (row.Order > maxPosition) {
              maxPosition = row.Order;
            }
          });
          rows.push({ ...selectedInventoryRow, Order: maxPosition + 1 });
        } else {
          if (isSV || isSUN || isOLG) {
            rows.push(selectedInventoryRow);
          } else {
            rows.unshift(selectedInventoryRow);
          }
        }
        // rows.unshift(selectedInventoryRow);
        index = rows.length;
        rows.map((row, idxx) => {
          if (isSV || isSUN || isOLG) {
            row.Index = idxx+1;
          } else {
            row.Index = index;
            index--;
          }
          totalCRV = (parseFloat(row.TotalCRV) || 0) + (+roundTo(parseFloat(totalCRV), 2).toFixed(2));
          if (row.IsTaxable === true) {
            if(isHMM) {
              totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(this.state.taxValue / 100);
            } else {
              totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
            }
          }
          if(isHMM) {
            totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
          } else {
            totalPrice += parseFloat(row.TotalPrice);
          }
          if (row.TotalNetWeight != null) {
            finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight);
          }
          finalWeight = Math.round(0.00001 + finalWeight * 100) / 100;
        });

        if (isHMM || isLMH || isSDR || isCRW || isSC || isSUN || isCPG) {
          if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
            totalTax = 0;
          }  else {
            if (SODiscount) {
              totalTax = 0;
              rows.map((row, idxx) => {
                if (row.IsTaxable === true) {
                  totalTax += ((parseFloat(row.TotalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)))) * parseFloat(this.state.taxValue / 100);
                }
              });
            }
             }
        }
        const { SODiscount, SOSavings } = this.state; // only one has value
        if ((isEKC || isSH)) {
          if (isEKC && this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
            totalTax = 0;
          } else {
            totalTax = ((parseFloat(totalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)) - Number(SOSavings ? SOSavings : 0))) * parseFloat(this.state.taxValue / 100);
          }
        }

        finalWeight = Math.round(0.00001 + finalWeight * 100) / 100;
        totalPrice = +roundToDecimals(totalPrice, 4).toFixed(4);
        totalTax = +roundTo(totalTax, 2).toFixed(2);
        totalCRV = +roundTo(totalCRV, 2).toFixed(2);
        const finalPrice = +roundTo(totalPrice * (1 - discount / 100) + totalTax + totalCRV, 2).toFixed(2);
        // finalPrice = Math.round(0.00001 + finalPrice * 100) / 100;
        this.setState({
          rows,
          editing: true,
          finalPrice,
          totalPrice,
          totalTax,
          totalCRV,
          finalWeight,
          selectedInventoryRow: {},
          inStock: '',
          inStockWarehouse: '',
          inStockOnhand: '',
          purchased: '',
          presale: '',
          net_weight: '',
          ship_weight: '',
          total_weight: '',
          suggestValue: '',
        }, () => {
          this.checkForPromotions(selectedInventoryRow.ProductNum);
          if (isSV && selectedInventoryRow.IsCombo === true) {
            this.addChildProducts(selectedInventoryRow);
          }
        });
        // }
        // this.props.resetFormInputs();
        // this.setAllProductQuantity(1);
    }

    checkMoveToSo2() {
      const selectedInventoryRow = { ...this.state.selectedInventoryRow };
      const check = _.findIndex(this.state.rows, { ProductNum: selectedInventoryRow.ProductNum });

      // if (check === -1) {
        this.moveToSO2();
      // } else {
      //   let { unitPrice } = this.props;
      //   const selectedInventoryRow = { ...this.state.selectedInventoryRow };
      //   if ( isMultiWH && unitPrice < selectedInventoryRow.LowestSalePrice ) {
      //     this.setState({ case: 'belowLowestSalePriceAndDuplicate', confirmOpen: true, IsLowerThanLowestPrice: true });
      //   } else {
      //     this.setState({ case: 'addingDuplicate', confirmOpen: true });
      //   }
      // }
    }

    handleMultiBatchSelectConfirm = (rows) => {
      this.setState({
        selectedBatches: rows,
      }, () => {
        let { unitPrice, smallUnitPrice } = this.props;
        const selectedInventoryRow = { ...this.state.selectedInventoryRow };
        const check = _.findIndex(this.state.rows, { ProductNum: selectedInventoryRow.ProductNum });
        if(isGGI && rows && rows.length > 0) { // 筛选过期批次批次号
          let expAr = [];
          rows.map(r => {
            if(r.quantity > 0 && r.is_expired) {
              expAr.push(r.batch_num);
            }
          })
          if(expAr.length > 0) {
            this.setState({expAr, case: 'expired_batches', confirmOpen: true });
            return
          }
          if(this.state.expAr.length > 0) {
            this.setState({expAr:[]})
          }
        }
        if (
          (isGGI && smallUnitPrice < selectedInventoryRow.LowestSalePrice)
          || (isVAK && !this.props.IsSpare && unitPrice < selectedInventoryRow.LowestSalePrice)
          || (!(isGGI || isVAK) && unitPrice < selectedInventoryRow.LowestSalePrice)
        ) {
          this.setState({ case: 'belowLowestSalePriceAndDuplicate', confirmOpen: true });
        } else if (check !== -1 && (isSUN || isTU)) {
          this.setState({ case: 'addingDuplicate', confirmOpen: true });
        } else {
          // this.setState({ case: 'addingDuplicate', confirmOpen: true });
          this.onSelectedMultiBatch();
        }
      })
    }

    handleGGIOpenModal = () => {
      this.setState({expAr:[]})
      this.onSelectedMultiBatch();
    }

    handleOcmOpenModal = () => {
      // here to skip batch
      if(isDAICHEONG || isEKC || isLMH || isSDR || isCRW || isSC || isSKH || isCPG ||
        isLAP || isOLG || isMH || isTQ || isVIP || isABCFF || isSH || isCCW ||
        isGFD ) {
        this.setState({
          confirmLowerThanLowestPrice: true,
        }, () => {
          this.checkMoveToSo();
          this.setState({
            confirmLowerThanLowestPrice: false
          });
          this.handleFocusAutoSuggest();
        })
      } else {
        this.setState({ isMultiBatchVisible: true });
      }
    }

    handleConfirmLowestSalesPrice = () => {
      this.setState({
        IsLowerThanLowestPrice: true,
      })
      // here to skip batch
      if (!isABCFF && !isSH && !isCCW) {
        this.onSelectedMultiBatch();
      }
    }

    handleDuplicateConfirm = () => {
      // here to skip batch
      if (!isABCFF && !isSH && !isCCW ) {
        this.onSelectedMultiBatch();
      }
    }

    moveToSO2() {
      if (isEcity && this.state.case === 'addingDuplicate' ) {
        this.findDuplicate();
      } else {
        const eCityItemPriceTrick = (row) => {
          let priceDisplay = 0;
          switch(this.state.customerPriceLevel) {
            case 1:
              priceDisplay = row.RefPrice;
              break;
            case 2:
              priceDisplay = row.PriceLv1;
              break;
            case 3:
              priceDisplay = row.PriceLv2;
              break;
          }
          return priceDisplay;
        }
        if (this.state.selectedInventoryRow.Product_id == null) {
          this.setState({ case: 'chooseProduct', confirmOpen: true});
          return;
        }
        let {
          inventories, inventoryIdValue, quantityValue, favorites, weight,
          available, inPurchase, preSale, salePrice, refPurchasePrice, unitPrice, smallUnitPrice, description, notation, itemNotation,
        } = this.props;
        const selectedInventoryRow = { ...this.state.selectedInventoryRow };
        // if (!isJTB && unitPrice < selectedInventoryRow.LowestSalePrice && arguments[0] !== 'move') {
        //   this.setState({ case: 'belowLowestSalePrice', confirmOpen: true });
        //   return;
        // }
        if((isHMM) && unitPrice < selectedInventoryRow.LowestSalePrice && arguments[0] === 'move' && !arguments[1]) {
          this.openVerifyPasscode();
          return;
        }
        // if(isEcity && !this.props.salesCustomerDetails.GoodCredit && !this.state.customerVerified) {
        //   if(!arguments[2]) {
        //     this.openVerifyPasscodeToCreaterSO();
        //     return
        //   }
        // }
        let totalPrice = 0;
        let finalWeight = 0;
        let totalTax = 0;
        let totalCRV = 0;
        let index = 0;
        const discount = parseFloat(this.props.discount) || 0;
        // const check = _.findIndex(this.state.rows, { ProductNum: selectedInventoryRow.ProductNum });
        if (quantityValue === undefined) { quantityValue = 0; }
        // if (check == -1) {
        let totalInventory = selectedInventoryRow.InStock;
        if (isGGI) {
          totalInventory += selectedInventoryRow.Purchased;
        }
        // if (((totalInventory - (isHMM ? 0 : selectedInventoryRow.PreSale)) > 0 && (this.state.ocmQty ? this.state.ocmQty : quantityValue) <= (selectedInventoryRow.InStock-(isHMM ? 0 : selectedInventoryRow.PreSale))) || selectedInventoryRow.IsOverSaleable === true || isHMM || isAFG) {
          selectedInventoryRow.Quantity = this.state.ocmQty;
          // selectedInventoryRow.Quantity = quantityValue;
          selectedInventoryRow.UnitPrice = this.props.unitPrice;
          selectedInventoryRow.RefPrice = 10
        if (isMH && selectedInventoryRow.isGate) {
          selectedInventoryRow.UnitPrice = selectedInventoryRow.Price
        }

          if(isGGI) {
            selectedInventoryRow.SmallUnitPrice = this.props.smallUnitPrice;
          }
          if(isSW) {
            selectedInventoryRow.barcode = this.state.swBarcode;
          }
          if (selectedInventoryRow.UnitPrice === '0' || !selectedInventoryRow.UnitPrice) {
            // selectedInventoryRow.IsGift = true;
            selectedInventoryRow.IsGift = false;
          } else {
            selectedInventoryRow.IsGift = false;
          }
          if ((isEKC || isLMH) && this.state.currentProdEkc === '0101') {
            if (selectedInventoryRow.ProductType === 'Fixed' || selectedInventoryRow.ProductType === 'Non-Product') {
              selectedInventoryRow.TotalPrice = +roundToDecimals(this.props.unitPrice * this.state.ocmQty * (this.props.SqftPack ? this.props.SqftPack : 1), 4).toFixed(4);
            } else {
              selectedInventoryRow.TotalPrice = +roundToDecimals(this.props.unitPrice * (!isJML ? weight : selectedInventoryRow.PackageSize_1) * this.state.ocmQty, 4).toFixed(4);
            }
          } else {
          if (selectedInventoryRow.ProductType === 'Fixed' || selectedInventoryRow.ProductType === 'Non-Product') {
            selectedInventoryRow.TotalPrice = +roundToDecimals(this.props.unitPrice * this.state.ocmQty, 4).toFixed(4);
            if (isMH && selectedInventoryRow.isGate) {
              selectedInventoryRow.TotalPrice = roundToDecimals(selectedInventoryRow.UnitPrice * selectedInventoryRow.Quantity);
            }
          } else {
            if(isGGI) {
              selectedInventoryRow.TotalPrice = +roundToDecimals(this.props.smallUnitPrice * weight * this.state.ocmQty, 4).toFixed(4);
            } else {
              selectedInventoryRow.TotalPrice = +roundToDecimals(this.props.unitPrice * (!isJML ? weight : selectedInventoryRow.PackageSize_1) * this.state.ocmQty, 4).toFixed(4);
              if (isMH && selectedInventoryRow.isGate) {
                selectedInventoryRow.TotalPrice = roundToDecimals(selectedInventoryRow.UnitPrice * selectedInventoryRow.NetWeight * selectedInventoryRow.Quantity).toFixed(4);
              }
            }
          }
        }
          selectedInventoryRow.TotalCRV = +roundTo(parseFloat(selectedInventoryRow.Quantity) * parseFloat(selectedInventoryRow.CRV), 2).toFixed(2);
          selectedInventoryRow.Weight = +this.props.weight;
          if(isSH || isSUN || isLAP) {
            selectedInventoryRow.NetWeight = +this.props.weight;
          }
          selectedInventoryRow.TotalNetWeight = roundTo(selectedInventoryRow.NetWeight * selectedInventoryRow.Quantity, 2);
          if (!isMH || (isMH && !selectedInventoryRow.isGate)) {
            selectedInventoryRow.Remark = itemNotation;
          }
          // if (isWIZ) {
            if (this.props) {
            selectedInventoryRow.ReceivedQuantity = this.props.ReceivedQuantity;
            selectedInventoryRow.ShipmentID = this.props.ShipmentID;
            selectedInventoryRow.BillablePallets = this.props.BillablePallets;
            selectedInventoryRow.RealPallets = this.props.RealPallets;
            selectedInventoryRow.BoxPerPallet = this.props.BoxPerPallet;
            selectedInventoryRow.DispatchType = this.props.DispatchType;
            selectedInventoryRow.BoxVol = this.props.BoxVol;
            selectedInventoryRow.BoxHeight = this.props.BoxHeight;
            selectedInventoryRow.BoxWidth = this.props.BoxWidth;
            selectedInventoryRow.InnerLabelQty = this.props.InnerLabelQty;
            selectedInventoryRow.OuterLabelQty = this.props.OuterLabelQty;
            selectedInventoryRow.BoxLength = this.props.BoxLength;
            selectedInventoryRow.BoxWeight = this.props.BoxWeight;
            selectedInventoryRow.PalletHeight = this.props.PalletHeight;
            selectedInventoryRow.PalletWidth = this.props.PalletWidth;
            selectedInventoryRow.PalletLength = this.props.PalletLength;
            selectedInventoryRow.PalletVol = this.props.PalletVol;
            selectedInventoryRow.PalletWeight = this.props.PalletWeight;
            selectedInventoryRow.IsOversize = this.props.IsOversize;
            selectedInventoryRow.IsOverweight = this.props.IsOverweight;
            selectedInventoryRow.PortDray = this.props.PortDray;
            selectedInventoryRow.DrayageTrucker = this.props.DrayageTrucker;
            selectedInventoryRow.Location = this.props.Location;
            selectedInventoryRow.FBACode = this.props.FBACode;
            selectedInventoryRow.PalletQuantity = this.props.PalletQuantity;

            selectedInventoryRow.Sqft = this.props.Sqft;
            selectedInventoryRow.SqftPack = this.props.SqftPack;
            selectedInventoryRow.SqftTotal = (this.props.SqftPack ? this.props.SqftPack : 0) * quantityValue;
            if (selectedInventoryRow && selectedInventoryRow.SqftTotal) {
              selectedInventoryRow.SqftTotal = selectedInventoryRow.SqftTotal.toFixed(3);
            }

            selectedInventoryRow.BoxQuantity = this.props.BoxQuantity;
            selectedInventoryRow.PieceQuantity = this.props.PieceQuantity;
            selectedInventoryRow.TotalShippingWeight = this.props.TotalShippingWeight;
            selectedInventoryRow.FBARoute = this.props.FBARoute;
            selectedInventoryRow.DimUnit = this.props.DimUnit;
            selectedInventoryRow.IsNoReturn = this.props.IsNoReturn;
            if (isVAK) {
              selectedInventoryRow.IsSpare = this.props.IsSpare;
            }
            selectedInventoryRow.IsChild = this.props.IsChild;
            // selectedInventoryRow.ParentRefNum = this.props.ParentRefNum;
            // selectedInventoryRow.IsCombo = this.props.IsCombo;

            selectedInventoryRow.CustomerBoxQty = this.props.CustomerBoxQty;
            selectedInventoryRow.OutsideLabelQty = this.props.OutsideLabelQty;
            selectedInventoryRow.InsideLabelQty = this.props.InsideLabelQty;
            selectedInventoryRow.SpecialHandling = this.props.SpecialHandling;
            selectedInventoryRow.CustomerNote = this.props.CustomerNote;


            selectedInventoryRow.WeightUnit = this.props.WeightUnit;
            selectedInventoryRow.TrailerNum = this.props.TrailerNum;
            selectedInventoryRow.POList = this.props.POList;
            selectedInventoryRow.POD = this.props.POD;
            if (isMultiWH) {
              selectedInventoryRow.Batch_id = this.state.Batch_id;
              selectedInventoryRow.BatchExpiredDate = this.state.BatchExpiredDate;
              selectedInventoryRow.BatchLocation = this.state.BatchLocation;
            }
            if (isABBLE) {
              selectedInventoryRow.ConvertUnit = 1;
            }
            // selectedInventoryRow.ContainerNum = this.props.ContainerNum;
            }
          // }
          if (isEcity) selectedInventoryRow.ProductCost = eCityItemPriceTrick(selectedInventoryRow);
        // } else {
          // this.setState({
          //   case: 'itemOutOfStock',
          //   confirmOpen: true,
          //   selectedInventoryRow: {},
          //   inStock: '',
          //   inStockWarehouse: '',
          //   purchased: '',
          //   presale: '',
          //   net_weight: '',
          //   suggestValue: '',
          // });
          // this.props.resetFormInputs();
          // return;
        // }
        const rows = [...this.state.rows];
        if (isHMM) {
          let maxPosition = 0;
          rows.forEach((row) => {
            if (row.Order > maxPosition) {
              maxPosition = row.Order;
            }
          });
          rows.push({ ...selectedInventoryRow, Order: maxPosition + 1 });
        } else {
          if (isSV || isSUN || isOLG) {
            rows.push(selectedInventoryRow);
          } else {
            rows.unshift(selectedInventoryRow);
          }
        }
        // rows.unshift(selectedInventoryRow);
        index = rows.length;
        rows.map((row, idxx) => {
          if (isSV || isSUN || isOLG) {
            row.Index = idxx+1;
          } else {
            row.Index = index;
            index--;
          }
          totalCRV = (parseFloat(row.TotalCRV) || 0) + (+roundTo(parseFloat(totalCRV), 2).toFixed(2));

          if (row.IsTaxable === true) {
            if(isHMM) {
              totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(this.state.taxValue / 100);
            } else {
              if(isHO || isJRC || isVIP) {
                if(row.IsAllTaxable === true || !this.props.salesCustomerDetails.Reseller) {
                  totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
                }
              } else {
                totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
              }
            }
          }
          if(isHMM) {
            totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
          } else {
            totalPrice += parseFloat(row.TotalPrice);
          }
          if (row.TotalNetWeight != null) {
            finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight);
          }
          finalWeight = Math.round(0.00001 + finalWeight * 100) / 100;
        });

        if (isHMM || isLMH || isSDR || isCRW || isSC || isSUN || isCPG) {
          if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
            totalTax = 0;
          }  else {
            if (SODiscount) {
              totalTax = 0;
              rows.map((row, idxx) => {
                if (row.IsTaxable === true) {
                  totalTax += ((parseFloat(row.TotalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)))) * parseFloat(this.state.taxValue / 100);
                }
              });
            }
          }
        }
        const { SODiscount, SOSavings } = this.state; // only one has value
        if ((isEKC || isSH)) {
          if (isEKC && this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
            totalTax = 0;
          } else {
            totalTax = ((parseFloat(totalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)) - Number(SOSavings ? SOSavings : 0))) * parseFloat(this.state.taxValue / 100);
          }
        }
        finalWeight = Math.round(0.00001 + finalWeight * 100) / 100;
        totalPrice = +roundToDecimals(totalPrice, 4).toFixed(4);
        totalTax = +roundTo(totalTax, 2).toFixed(2);
        totalCRV = +roundTo(totalCRV, 2).toFixed(2);
        const finalPrice = +roundTo(totalPrice * (1 - discount / 100) + totalTax + totalCRV, 2).toFixed(2);
        // finalPrice = Math.round(0.00001 + finalPrice * 100) / 100;
        this.setState({
          rows,
          editing: true,
          finalPrice,
          totalPrice,
          totalTax,
          totalCRV,
          finalWeight,
          // selectedInventoryRow: {},
          // inStock: '',
          // purchased: '',,
          // presale: '',
          // net_weight: '',
          // ship_weight: '',
          // total_weight: '',
          // suggestValue: '',
        }, () => {
          if ((isEKC || isLMH || isSDR || isCRW || isSC || isOLG || isVAK || isSH)) { this.onConfirmPercentageFee(); }
          if (!selectedInventoryRow.IsGift) {
            // this.checkForPromotions(selectedInventoryRow.ProductNum);
          }
        });
        // }
        // this.props.resetFormInputs();
        // this.setAllProductQuantity(1);
      }
    }

    findDuplicate(quantityValue) {
      const selectedInventoryRow = { ...this.state.selectedInventoryRow };
      const check = _.findIndex(this.state.rows, { ProductNum: selectedInventoryRow.ProductNum });
      const newRows = this.state.rows;
      newRows.map((r) => {
        r.isSelected = false;
      });
      if (quantityValue === undefined) {quantityValue = 0;}
      if (check > -1) {
        newRows[check].isSelected = true;
        newRows[check].Quantity = Number(newRows[check].Quantity) + Number(quantityValue);
      }
      this.props.resetFormInputs();
      this.setState({ ...this.state, rows: newRows, suggestValue: '',inStock: '',
      inStockWarehouse: '',
      inStockOnhand: '',
      purchased: '',
      presale: '',
      net_weight: '',
      ship_weight: '',
      total_weight: '', });
      this.handleFocusAutoSuggest();
    }

    renderSelectedItem() {
      return (
        <Row>
          <Col xs={3}>
            <label><Translate value="item_no" /></label>
          </Col>
          <Col xs={3}>
            <label className="col-xs-5 centerStyle">{this.state.selectedItemNumber}</label>
          </Col>
          <Col xs={3}>
            <label><Translate value="item_name" /></label>
          </Col>
          <Col xs={3}>
            <label className="col-xs-5 centerStyle">{this.state.selectedItemName}</label>
          </Col>
        </Row>
      );
    }

    formatDate(date) {
      let formattedDate = `${date.getFullYear()}-`;
      formattedDate += `${date.getMonth() + 1}-`;
      if (date.getDate() < 10) {
        formattedDate += `0${date.getDate()}T`;
      } else {
        formattedDate += `${date.getDate()}T`;
      }
      if (date.getHours() < 10) {
        formattedDate += `0${date.getHours()}:`;
      } else {
        formattedDate += `${date.getHours()}:`;
      }
      if (date.getMinutes() < 10) {
        formattedDate += `0${date.getMinutes()}:`;
      } else {
        formattedDate += `${date.getMinutes()}:`;
      }
      if (date.getSeconds < 10) {
        formattedDate += `0${date.getSeconds()}`;
      } else {
        formattedDate += date.getSeconds();
      }
      return formattedDate;
    }
    handleKeyPress = (value, event) => {
      if (event.charCode === 13) {
        event.preventDefault();
        if (value == 'unitPrice' || value == 'itemNotation') {
          if ((!isNumeric(this.props.quantityValue) || this.props.quantityValue < 0) && value !== 'quantity') {
            return;
          }
        }
        // if (value === 'quantity' && this.state.selectedInventoryRow.InStock == null) {
        //   return;
        // }
        ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
      }
    }

    handleQtyChange = () => {
      // event.preventDefault();
      if (!isSV || !this.props.salesOrderProduct) {
        return;
      }
      if (!isNumeric(this.props.quantityValue) || this.props.quantityValue < 0) {
        this.props.setSaleOrderProductValues(roundToDecimals(this.props.salesOrderProduct.Price, 4), 'salesOrderForm', this.props.salesOrderProduct);
        // this.props.setValue('salesOrderForm', 'Deliver_Customer_id', currentSalesOrder.Deliver_Customer_id);
        return;
      }

      if (this.props.quantityValue && this.props.salesOrderProduct && this.props.salesOrderProduct.PromoTier1Qty && this.props.salesOrderProduct.PromoTier2Qty) {
        if (this.props.quantityValue > 0 && this.props.quantityValue <= this.props.salesOrderProduct.PromoTier1Qty) {
          this.props.setSaleOrderProductValues(roundToDecimals(this.props.salesOrderProduct.PriceLv1, 4), 'salesOrderForm', this.props.salesOrderProduct);
        }
        else if (this.props.quantityValue > this.props.salesOrderProduct.PromoTier1Qty && this.props.quantityValue <= this.props.salesOrderProduct.PromoTier2Qty) {
          this.props.setSaleOrderProductValues(roundToDecimals(this.props.salesOrderProduct.PriceLv2, 4), 'salesOrderForm', this.props.salesOrderProduct);
        }
        else if (this.props.quantityValue > this.props.salesOrderProduct.PromoTier2Qty) {
          this.props.setSaleOrderProductValues(roundToDecimals(this.props.salesOrderProduct.PriceLv3, 4), 'salesOrderForm', this.props.salesOrderProduct);
        }
      } else {
        this.props.setSaleOrderProductValues(roundToDecimals(this.props.salesOrderProduct.Price, 4), 'salesOrderForm', this.props.salesOrderProduct);
      }

    }

    handleSqftChange = () => {
      if (!this.props.salesOrderProduct) {
        return;
      }
      if (this.props.Sqft && this.props.SqftPack && this.props.salesOrderProduct) {
        if (Number(this.props.Sqft) && Number(this.props.SqftPack)) {
          this.props.setValue('salesOrderForm', 'Quantity', Math.ceil((Number(this.props.Sqft)/Number(this.props.SqftPack)).toFixed(5)));
          // this.props.setSaleOrderProductValues(roundToDecimals(Number(this.props.Sqft)*Number(this.props.SqftPack), 4), 'salesOrderForm', this.props.salesOrderProduct);
        }
      } else {
        this.props.setValue('salesOrderForm', 'Quantity', 1);
        // this.props.setSaleOrderProductValues(roundToDecimals(this.props.salesOrderProduct.Price, 4), 'salesOrderForm', this.props.salesOrderProduct);
      }
    }

    handleSqftPackChange = () => {
      if (!this.props.salesOrderProduct) {
        return;
      }
      if (this.props.Sqft && this.props.SqftPack && this.props.salesOrderProduct) {
        if (Number(this.props.Sqft) && Number(this.props.SqftPack)) {
          this.props.setValue('salesOrderForm', 'Quantity', Math.ceil((Number(this.props.Sqft)/Number(this.props.SqftPack)).toFixed(5)));
          // this.props.setSaleOrderProductValues(roundToDecimals(Number(this.props.Sqft)*Number(this.props.SqftPack), 4), 'salesOrderForm', this.props.salesOrderProduct);
        }
      } else {
        this.props.setValue('salesOrderForm', 'Quantity', 1);
        // this.props.setSaleOrderProductValues(roundToDecimals(this.props.salesOrderProduct.Price, 4), 'salesOrderForm', this.props.salesOrderProduct);
      }
    }

    handleUnitChange = (val) => {
      if (!this.props.salesOrderProduct) {
        return;
      }
      this.props.setValue('salesOrderForm', 'UnitPrice', val);


      let discTemp = 0;
      if (val && this.state.OrigUnitPrice && this.props.salesOrderProduct) {
        if (Number(val) && Number(this.state.OrigUnitPrice)) {

          discTemp = (Number(this.state.OrigUnitPrice)-Number(val))/Number(this.state.OrigUnitPrice);
          discTemp = discTemp*100;
          this.props.setValue('salesOrderForm', 'LineDiscount', discTemp.toFixed(2));
        }
      }
    }


    handleLineDiscountChange = (val) => {
      if (!this.props.salesOrderProduct) {
        return;
      }
      this.props.setValue('salesOrderForm', 'LineDiscount', val);
      let priceTemp = 0;
      if (this.state.OrigUnitPrice && this.props.salesOrderProduct) {
        if (Number(this.state.OrigUnitPrice)) {
          priceTemp = Number(this.state.OrigUnitPrice) * (1-((val && Number(val) ? Number(val) : 0)*0.01));
          // priceTemp = Math.round(priceTemp * 1000) / 1000;
          this.props.setValue('salesOrderForm', 'UnitPrice', priceTemp.toFixed(2));
          // this.props.setSaleOrderProductValues(roundToDecimals(Number(this.props.Sqft)*Number(this.props.SqftPack), 4), 'salesOrderForm', this.props.salesOrderProduct);
        }
      }
      // else {
      //   this.props.setValue('salesOrderForm', 'Quantity', 1);
      //   // this.props.setSaleOrderProductValues(roundToDecimals(this.props.salesOrderProduct.Price, 4), 'salesOrderForm', this.props.salesOrderProduct);
      // }
    }


    handleFocusQty = () => {
      if ((isEKC || isLMH) && this.state.currentProdEkc === '0101') {
        ReactDOM.findDOMNode(this.refs.Sqft.getRenderedComponent().myInput.refs.input).focus();
        ReactDOM.findDOMNode(this.refs.Sqft.getRenderedComponent().myInput.refs.input).select();
      } else if (isABCFF) {
        ReactDOM.findDOMNode(this.refs.unitPrice.getRenderedComponent().myInput.refs.input).focus();
        ReactDOM.findDOMNode(this.refs.unitPrice.getRenderedComponent().myInput.refs.input).select();
      } else {
        ReactDOM.findDOMNode(this.refs.quantity.getRenderedComponent().myInput.refs.input).focus();
        ReactDOM.findDOMNode(this.refs.quantity.getRenderedComponent().myInput.refs.input).select();
      }
    }

    setProdNum(val) {
      this.setState({currentProdEkc: val});
    }

    setIsCombo(val) {
      this.setState({currentProdComboEkc: val});
    }

    handleKeyPressTargetInput(value, event) {
      if (event.keyCode === 13) {
        ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
      }
    }
    handleInventoryNumKeyPress(event) {
      if (event.charCode === 13) {
        if (this.state.inventories.rows.length > 0) {
          //           lastChild
          // :
          // div.react-grid-Cell__value
          // lastElementChild
          // :
          // div.react-grid-Cell__value
          // ReactDOM.findDOMNode(this["myRowNameForTest"].refs[0].refs.cell.lastChild).focus();
          const rows = this.state.inventories.rows;
          rows.map((row) => {
            row.isSelected = false;
          });
          rows[0].isSelected = true;
          const inventories = { ...this.state.inventories, rows };
          this.setState({ inventories, cellSelectEnabled: false });
          ReactDOM.findDOMNode(this.refs.testingIfThisWorks.refs.base.refs.viewPortContainer).focus();
        }
      }
    }
    handleUPKeyPress(event) {
      if (event.charCode === 13) {
        event.preventDefault();
        this.moveToSOButton.props.onClick();
        ReactDOM.findDOMNode(this.refs.inventory.getRenderedComponent().myInput.refs.input).focus();
      }
    }
    checkPermission(permission) {
      return false;
    }
    customerHeader() {
      const handleToggle = () => {
        this.setState({
          isCustomerInformationPanelFolded: !this.state.isCustomerInformationPanelFolded,
          yourOrderTableHeight: this.state.isCustomerInformationPanelFolded
            ? this.state.yourOrderTableHeight - 100
            : this.state.yourOrderTableHeight + 100,
        })
      }
      return (
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
          <h2 className="mt0"><Translate value="customer_information" /></h2>
          <div onClick={handleToggle} style={{marginRight: '4px'}}>{this.state.isCustomerInformationPanelFolded ? <i className={'fa fa-plus'} /> : <i className={'fa fa-minus'} />}</div>
        </div>
      );
    }
    inboundInformationHeader() {
      let type = "";
      if (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id') {
        type = "inbound";
      }
      if (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
        type = "outbound";
      }
      return (type==="inbound") ? (
        <div>
          <h2><Translate value="inbound_information" /></h2>
        </div>
      ) : (
        <div>
          <h2><Translate value="outbound_information" /></h2>
        </div>
      );
    }
    renderSMUnit() {
      if(isGGI) {
        return <Col xs={4} style={{ paddingLeft: '0px', paddingRight: '2px' }}>
          <Row>
            <Col xs={6} className="pr0">
              <label >
                <Translate value="small_pr" />
                <span className="dollar-sign">$$</span>
              </label>
              <Field
                name="SmallUnitPrice"
                withRef
                ref="smallUnit"
                component={InputField}
                disabled={false}
                onFocus={this.handleOnFocus}
                onKeyPress={(event) => {
                  this.handleKeyPress('itemNotation', event);
                }}
                />
            </Col>
            <Col xs={6} className="pr0">
              <label >
                <Translate value="unit" />
                <span className="dollar-sign">$$</span>
              </label>
              <Field
                name="UnitPrice"
                withRef
                ref="unitPrice"
                component={InputField}
                disabled={true}
                />
            </Col>
          </Row>
        </Col>
      } else {
        return <Col xs={(isEKC || isLMH || isSDR || isCRW || isSC || isOCM) ? 2 : 1} className="pr0">
        <label >
          <Translate value={isGFD ? 'price' : "unit"} />
          <span className="dollar-sign">$$</span>
        </label>
        <Field
          name="UnitPrice"
          withRef
          ref="unitPrice"
          component={InputField}
          disabled={(isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) || isSV || isSDR || isCRW || isSC || ((isEKC || isSDR || isCRW || isSC || isLMH) && this.state.currentProdComboEkc) || (isSUN && !checkPermissionLocal('edit_order_line_price'))}
          // normalize={normalizeFourDecimals}
          onChange={(e) => this.handleUnitChange(e.target.value)}
          onFocus={this.handleOnFocus}
          onKeyPress={(event) => {
            if (isSUN) {
              this.handleKeyPress('weight', event);
              return
            }
            if (isLMH) {
              this.handleKeyPress('LineDiscount', event);
              return
            }
            this.handleKeyPress('itemNotation', event);
          }}
        />
      </Col>
      }
    }
    generalInformationHeader() {
      return (
        <div>
          <h2><Translate value="general_info" /></h2>
        </div>
      );
    }
    containerInformationHeader() {
      return (
        <div>
          <h2><Translate value="container_info" /></h2>
        </div>
      );
    }
    pickdropInformationHeader() {
      return (
        <div>
          <h2><Translate value="pickdrop_info" /></h2>
        </div>
      );
    }
    renderSubtotal() {
      let subtotal = 0;
      if (this.state.selectedInventoryRow && (this.state.selectedInventoryRow.ProductType === 'Fixed' || this.state.selectedInventoryRow.ProductType === 'Non-Product')) {
        if (this.props.quantityValue) {
          subtotal = (this.props.quantityValue * this.props.unitPrice).toFixed((isEKC || isLMH || isSDR || isCRW || isSC) ? 4 : 2);
        }
      } else if (this.props.weight) {
        if(isGGI) {
          subtotal = (this.props.smallUnitPrice * this.props.weight * this.props.quantityValue).toFixed((isEKC || isLMH || isSDR || isCRW || isSC) ? 4 : 2);
        } else {
          subtotal = (this.props.unitPrice * this.props.weight * this.props.quantityValue).toFixed((isEKC || isLMH || isSDR || isCRW || isSC) ? 4 : 2);
        }
      }

      if ((isEKC || isLMH || isSDR || isCRW)) {
        if (this.state.selectedInventoryRow && (this.state.selectedInventoryRow.ProductType === 'Fixed' || this.state.selectedInventoryRow.ProductType === 'Non-Product')) {
          if (this.props.quantityValue && !isSDR && !isCRW && this.state.currentProdEkc === '0101' && this.props.SqftPack ) {
            subtotal = (this.props.quantityValue * this.props.unitPrice * this.props.SqftPack).toFixed((isEKC || isLMH || isSDR || isCRW || isSC) ? 4 : 2);
          } else {
            subtotal = (this.props.quantityValue * this.props.unitPrice).toFixed((isEKC || isLMH || isSDR || isCRW || isSC) ? 4 : 2);
          }
        } else if (this.props.weight) {
          subtotal = (this.props.unitPrice * this.props.weight * this.props.quantityValue).toFixed((isEKC || isLMH || isSDR || isCRW || isSC) ? 4 : 2);
        }
      }

      // if (isJML) {
      //   subtotal = (this.props.PackageSize_1 * this.props.unitPrice * this.props.quantityValue).toFixed(isEKC ? 4 : 2);
      // }
      if (isNaN(subtotal)) {
        subtotal = 0;
      }
      return (
        <Field name="Subtotal" component={DisabledInputField} placeholder={subtotal} />
      );
    }

    renderIsInternal = () => {
      const {
        salesShippingCustomerDetails,
      } = this.props;
      const isInternal = salesShippingCustomerDetails && salesShippingCustomerDetails.isInternal;
      if (!isOCM) {
        return null;
      }
      if (!salesShippingCustomerDetails) {
        return null;
      }
      return (
        <span style={{
          position: 'absolute',
          left: '197px',
          top: '1px',
          fontSize: '15px',
          fontWeight: '500',
        }}>
          Internal: {isInternal ? 'Yes' : 'No'}
        </span>
      )
    }

    renderShipVia = () => {
      if (!isGGI) return null;
      return (
        <div className="form-group">
          <label className="col-xs-3"><Translate value="ship_via" /></label>
          <div className="col-xs-8">
            <Field
              name="ShipVia"
              matchPos="any"
              component={SelectionWithProps}
              options={[{
                label: 'Customer Pickup',
                value: 'customerPickup',
              }, {
                label: 'GGI Delivery',
                value: "ggiDelivery",
              }, {
                label: '3rd Party Delivery',
                value: '3rdPartyDelivery',
              }, {
                label: 'Warehouse Transfer',
                value: 'warehouseTransfer',
              }]}
              placeholder={<span>
                <Translate value="ship_via" />
                <span className="asteriksReq" >*</span>
              </span>}
            />
          </div>
        </div>
      )
    }

    renderTruckCompany = () => {
      if (!isOCM) return null;
      let selection = [];
      if (this.props.truckCompanies) {
        _.forEach(this.props.truckCompanies, company => {
          selection.push({
            label: company.AddressName,
            value: company.CustomerDetail_id,
          })
        })
      }
      return (
        <div className="form-group">
          <label className="col-xs-3"><Translate value="truck_co" />.</label>
          <div className="col-xs-8">
            <Field
              name="Truck_CustomerDetail_id"
              // matchPos="any"
              component={SelectionWithProps}
              options={selection}
            />
          </div>
        </div>
      )
    }

    renderType = () => {
      if (isSV) {
        return <div className="form-group">
        <label className="col-xs-3"><Translate value="type" /></label>
        <div className="col-xs-8">
        <Field name="SalesOrderType" component={Selection} options={this.state.typeOptions}/>
        </div>
      </div>
      }
    }

    renderTypeRef = () => {
      if (isSV) {
        return <div className="form-group">
        <label className="col-xs-3"><Translate value="type_ref#" /></label>
        <div className="col-xs-8">
        <Field name="TypeRefNum" component={InputField} disabled={false}/>
        </div>
      </div>
      }
    }


    renderCustomerDetail() {
      const customerNameOptions = this.getCustomerNameOptions();
      const customerNumOptions = this.getCustomerNumOptions();
      const customerPhoneOptions = this.getCustomerPhoneOptions();
      const child = {}
      if(isOLG) {
        child.valueRenderer=(props) => {
          return <div>
            <span>{props.label}</span>
            <span onClick={()=>{
              // 创建一个临时的输入框来存储文本
              const input = document.createElement('input');
              input.value = props.label;
              // 将输入框添加到页面，但不显示
              document.body.appendChild(input);
              input.select(); // 选择输入框的内容
              // 执行复制命令
              document.execCommand('copy');
              // 移除临时输入框
              document.body.removeChild(input);
              alert(I18n.t('copy_success'))
            }}><em className='fa fa-copy' style={{fontSize: '10px', marginLeft: '2px', color: '#666'}}/></span>
          </div>
        }
      }
      const SelectionForCustomer = (this.props.currentSalesOrder) ? DisabledSelection : SelectionWithProps;
      let SelectionForCompanyWarehouse = SelectionForCustomer;
      if (isLAP) {
        if (this.props.currentSalesOrder && this.props.currentSalesOrder.SaleStatus === 'Open') {
          SelectionForCompanyWarehouse = SelectionWithProps;
        }
      }
      // const fieldName = (this.context.router.routes[1].path === 'salesOrders/new') ? 'CustomerDetail_id' : 'Deliver_CustomerDetail_id';
      const addressOptions = this.getAddressOptions();
      const shippingPhoneOptions = this.getShippingPhoneOptions();
      const isMobile = this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id';
      return (
        <Col xs={7} id="customer-details">
          <h4><Translate value="customer" /></h4>{this.renderIsInternal()}
          {(isEKC || isLMH || isSDR || isCRW || isESC || isSC) &&
            <Button
              id="customer-info-add-button"
              type="button"
              onClick={() => {this.openCustomerEditModal()}}
            > + </Button>
          }
          {((isEKC || isLMH || isSDR || isCRW || isSC)) &&
            <Button
              id="customer-info-add-button2"
              type="button"
              disabled={!this.props.receivingCustomer}
              onClick={() => { this.openCustomerNoteModal() }}
            > Note </Button>
          }
          <div className="form-group">
            {/* <label className="col-xs-3"><Translate value="name" /><span className="asteriksReq" >*</span> </label> */}
            <div id="customer-name-dropdown" className="col-xs-11">
             {
               isMobile ?
                <Field
                  name="Deliver_CustomerName"
                  withRef
                  ref="customer_name"
                  matchPos="any"
                  component={InputField}
                  onFocus={this.handleOnFocus}
                  disabled={true}
                  />
                :
                <Field
                  name="Deliver_Customer_id"
                  matchPos="any"
                  component={SelectionForCustomer}
                  ref="customer_name"
                  withRef
                  options={customerNameOptions}
                  placeholder={
                    <span>
                      <Translate value="name" />
                      <span className="asteriksReq" >*</span>
                    </span>
                  }
                  {...child}
                  onSelect={ value => {
                    isLAP ? this.checkPrevSODoneToday(value) : null;
                    if (isDAICHEONG || isLAP || isGGI) {
                      axios({
                        method: 'GET',
                        url: `${SALES_CUSTOMER_URL}${value.value ? value.value : value}`,
                        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                      })
                        .then(res => {
                          if(res && res.data && res.status === 200){
                            // if (res.data.Amount91 && res.data.Amount91 > 0) {
                              this.initializeSaveOverdue(res.data);
                            if (res.data.OverdueCheck && res.data.OverdueActivate && !this.state.alreadyCheckedPasscode) {
                              this.setState({overdueCheck: res.data.OverdueCheck, overdueActivate: res.data.OverdueActivate});
                              this.props.setValue('salesOrderForm', 'receivingCustomer', value ? value.value : value);
                              this.openOverdueModal(res.data);
                            } else {
                              this.props.setValue('salesOrderForm', 'receivingCustomer', value ? value.value : value);
                            }
                          }
                        }, err => {
                        })
                    } else {
                      this.props.setValue('salesOrderForm', 'receivingCustomer', value ? value.value : value);
                      this.setState({ selectedValue: value ? value.label : value });
                    }
                  }}
                  onInputKeyDown={(event) => {
                    if (event.keyCode === 13) {
                      const myField = document.getElementById('sales-auto-suggest');
                      if (myField) {
                        myField.select();
                      }
                    }
                  }}
                />
             }
            </div>
          </div>
          {isGGI && <div className="form-group">
            <label className="col-xs-3"><Translate value="cust_id" /></label>
            <div id='customer-id-dropdown' className="col-xs-8">
              <Field
                name="CustomerID"
                component={InputField}
                // onFocus={this.handleOnFocus}
                disabled={true}
              />
            </div>
          </div>}
          <div className="form-group">
            <label className="col-xs-3"><Translate value= {isGGI?'cust_no':"cust_id"} /></label>
            <div id="customer-id-dropdown" className="col-xs-8">
            {
              isMobile ?
              <Field
                name="Deliver_Customer_num"
                withRef
                // ref="quantity"
                component={InputField}
                onFocus={this.handleOnFocus}
                disabled={true}
              />
              :
              <Field
                name="Deliver_Customer_id"
                component={SelectionForCustomer}
                options={customerNumOptions}
                onInputKeyDown={(event) => {
                  if (event.keyCode === 13) {
                    const myField = document.getElementById('sales-auto-suggest');
                    if (myField) {
                      myField.select();
                    }
                  }
                }}
                matchPos="any"
                onSelect={ value => {
                  isLAP ? this.checkPrevSODoneToday(value) : null;
                  if (isDAICHEONG || isLAP || isGGI) {
                    axios({
                      method: 'GET',
                      url: `${SALES_CUSTOMER_URL}/${value.value ? value.value : value}`,
                      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                    })
                      .then(res => {
                        if(res && res.data && res.status === 200){
                          // if (res.data.Amount91 && res.data.Amount91 > 0) {
                            this.initializeSaveOverdue(res.data);
                          if (res.data.OverdueCheck && res.data.OverdueActivate && !this.state.alreadyCheckedPasscode) {
                            this.setState({overdueCheck: res.data.OverdueCheck, overdueActivate: res.data.OverdueActivate});
                            this.props.setValue('salesOrderForm', 'receivingCustomer', value ? value.value : value);
                            this.openOverdueModal(res.data);
                          } else {
                            this.props.setValue('salesOrderForm', 'receivingCustomer', value ? value.value : value);
                          }
                        }
                      }, err => {
                      })
                  } else {
                  this.props.setValue('salesOrderForm', 'receivingCustomer', value ? value.value : value);
                  }
                }}
              />
            }
            </div>
          </div>
          <div className="form-group">
            <label className="col-xs-3"><Translate value="phone" /> #</label>
            <div id="customer-phone-dropdown" className="col-xs-8">
            {
              isMobile ?
              <Field
                name="Billing.Telephone"
                withRef
                // ref="quantity"
                component={InputField}
                onFocus={this.handleOnFocus}
                disabled={true}
              />
              :
              <Field
                name="Deliver_Customer_id"
                component={SelectionForCustomer}
                options={customerPhoneOptions}
                onInputChange={(e) => {
                  this.state.enteringPhone = e;
                }}
                onInputKeyDown={(event) => {
                  if (event.keyCode === 13) {
                    const myField = document.getElementById('sales-auto-suggest');
                    if (myField) {
                      myField.select();
                    }
                  }
                }}
                matchPos="any"
                onSelect={ value => {
                  isLAP ? this.checkPrevSODoneToday(value) : null;
                  if (isDAICHEONG || isLAP || isGGI) {
                    axios({
                      method: 'GET',
                      url: `${SALES_CUSTOMER_URL}/${value.value ? value.value : value}`,
                      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                    })
                      .then(res => {
                        if(res && res.data && res.status === 200){
                          // if (res.data.Amount91 && res.data.Amount91 > 0) {
                            this.initializeSaveOverdue(res.data);
                          if (res.data.OverdueCheck && res.data.OverdueActivate && !this.state.alreadyCheckedPasscode) {
                            this.setState({overdueCheck: res.data.OverdueCheck, overdueActivate: res.data.OverdueActivate});
                            this.props.setValue('salesOrderForm', 'receivingCustomer', value ? value.value : value);
                            this.openOverdueModal(res.data);
                          } else {
                            this.props.setValue('salesOrderForm', 'receivingCustomer', value ? value.value : value);
                          }
                        }
                      }, err => {
                      })
                  } else {
                  this.props.setValue('salesOrderForm', 'receivingCustomer', value.value);
                  }
                }}
              />
            }
            </div>
          </div>
          <div>
            <div className="form-group">
              <label className="col-xs-3"><Translate value="company" /></label>
              <div id="customer-company-dropdown" className="col-xs-8">
                <Field
                  name="Company_id"
                  matchPos="any"
                  component={SelectionForCompanyWarehouse}
                  options={this.state.companyOptions}
                  onSelect={ value => {
                    this.setState({
                      warehouseOptions: [],
                    })
                    this.props.setValue('salesOrderForm', 'Company_id', value.value);
                  }}
                />
              </div>
            </div>
            <div className="form-group">
              <label className="col-xs-3"><Translate value="warehouse" /></label>
              <div className="col-xs-8">
                <Field
                  name="Pickup_Warehouse_id"
                  matchPos="any"
                  component={SelectionForCompanyWarehouse}
                  options={this.state.warehouseOptions}
                  onSelect={ value => {
                    this.props.setValue('salesOrderForm', 'Pickup_Warehouse_id', value.value);                    }}
                  />
              </div>
            </div>
            {
              isVAK &&
              <div className="form-group">
                <label className="col-xs-3"><Translate value="commercial_invoice" /></label>
                <div className="col-xs-8">
                  <Field name="CommercialInvoice" component={InputField} disabled={this.handleCommercialInvoiceDisable()}/>
                </div>
              </div>
            }
            {/* {
              isLAP && <SOConfirmationModal
              title={<p style={{height: 12}}></p>}
              isVisible={this.state.SOExistingVisible}
              onCancel={() => {
                this.setState({
                  SOExistingVisible: false
                })

              }}
              onConfirm={() => {
                this.setState({
                  SOExistingVisible: false,

                })
              }}/>
            } */}
            {this.renderType()}
            {this.renderTypeRef()}
            {this.renderShipVia()}
            {this.renderTruckCompany()}
          </div>
          {
            isFJ &&
            <div className="form-group">
              <label className="col-xs-3"><Translate value="agent" /></label>
              <div id="customer-phone-dropdown" className="col-xs-8">
                <Field name="Agent_id" matchPos="any" component={Selection} options={this.state.FJAgentOptions} />
              </div>
            </div>
          }
          {
            isSKH &&
            <div className="form-group">
              <label className="col-xs-3"><Translate value="bol" /></label>
              <div className="col-xs-8">
              {(this.props.currentSalesOrderDetail || {V_BillLadingNum:''}).V_BillLadingNum}
              </div>
            </div>
          }
        </Col>
      );
      // }
    }

    renderCustomerDetailABC() {
      let { CompanyName } = this.state;
      const customerNameOptions = this.getCustomerNameOptions();
      const customerNumOptions = this.getCustomerNumOptions();
      const customerPhoneOptions = this.getCustomerPhoneOptions();
      const SelectionForCustomer = (this.props.currentSalesOrder) ? DisabledSelection : SelectionWithProps;
      const addressOptions = this.getAddressOptions();
      const shippingPhoneOptions = this.getShippingPhoneOptions();
      const isMobile = this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id';
      return (
        <Col xs={7} id="customer-details">
          <h4><Translate value="company" /></h4>
          <div className="form-group">
            {/* <label className="col-xs-3"><Translate value="name" /><span className="asteriksReq" >*</span> </label> */}
            <div id="customer-name-dropdown" className="col-xs-11">
              <Field
                name="CompanyName"
                withRef
                ref="customer_name"
                matchPos="any"
                component={InputField}
                onFocus={this.handleOnFocus}
                disabled={true}
                />
            </div>
          </div>
          <div className="form-group">
          </div>
          <div className="form-group">
          </div>
        </Col>
      );
    }

    initializeSaveOverdue(data) {
      this.setState({
        overdueAmount: data.OverdueAmount,
        overdueTime: data.OverdueTime,
        outstandingAmount: data.Outstanding,
        overdueCredit: data.OverdueCredit,
        overdueActivate: data.OverdueActivate,
        overdueCreditLimit: data.CreditLimit,
      });
      // setTimeout(() => {
      //   document.getElementById('pcc').focus();
      // }, 100);
    }

    closeSaveOverdueModal() {
      this.setState({
        overdueSaveModalVisibility: false,
        overduePasscode: "",
      });
    }

    bypassSaveOverdueModal() {
      let {overdueData} = this.state;
      this.submitPromotionCheck(overdueData, false, false);
      this.setState({
        overdueSaveModalVisibility: false,
      });
    }

    openOverdueModal(data) {
      this.setState({
        overdueModalVisibility: true,
        selectedOverdue: data.Billing ? data.Billing.AddressName : data.Contact,
        overdueAmount: data.OverdueAmount,
        overdueTime: data.OverdueTime,
        outstandingAmount: data.Outstanding,
        overdueCredit: data.OverdueCredit,
        overdueCreditLimit: data.CreditLimit,
      });
      setTimeout(() => {
        document.getElementById('pcc').focus();
      }, 100);
    }

    closeOverdueModal() {
      if (isGGI) {
        this.props.setValue('salesOrderForm', 'CustomerID', null);
      }
      this.props.setValue('salesOrderForm', 'Deliver_Customer_id', null);
      this.props.setValue('salesOrderForm', 'receivingCustomer', null);
      this.setState({currentCustomer: null});
      this.setState({
        overdueModalVisibility: false,
        selectedOverdue: null,
        overduePasscode: "",
      });
    }

    bypassOverdueModal() {
      this.setState({
        overdueModalVisibility: false,
        selectedOverdue: null,
      });
    }

    checkTriple() {
      // let {tripleCount} = this.state;
      this.state.tripleCount += 1;
      if (this.state.tripleCount >= 3) {
        this.setState({overdueModalVisibility: false, overdueSaveModalVisibility: false});
      }
      setTimeout(() => {
        this.state.tripleCount = 0;
      }, 350);
    }

    onChangeOverduePasscode = (e) => {
      this.setState({ overduePasscode: e.target.value });
    }

    onConfirmOverdue() {
      let {overduePasscode, alreadyCheckedPasscode} = this.state;
      let data = {code: overduePasscode};
      axios
      .post(
        `${ROOT_URL}v1/sale/check_verification_code`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              "token"
            )}`,
          },
        },
      )
      .then(
        (res) => {
          this.setState({
            overdueModalVisibility: false,
            overduePasscode: "",
            selectedOverdue: null,
            // alreadyCheckedPasscode: true,
          });
        },
        (err) => {
          if (err.status === 500 || err.status === 404) {
            err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
          }
          alert(JSON.stringify(err.data));
        }
      );
    }

    onConfirmOverdue2() {
      let {overduePasscode, alreadyCheckedPasscode} = this.state;
      let data = {code: overduePasscode};
      axios
      .post(
        `${ROOT_URL}v1/sale/check_verification_code`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              "token"
            )}`,
          },
        },
      )
      .then(
        (res) => {
          this.bypassSaveOverdueModal();
          this.setState({
            // alreadyCheckedPasscode: true,
          });
        },
        (err) => {
          if (err.status === 500 || err.status === 404) {
            err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
          }
          alert(JSON.stringify(err.data));
        }
      );
    }

    onSendOverdue(approval) {
      let {selectedOverdue, overdueCredit, customerPaymentTerm, finalPriceWithPromotion, } = this.state;
      
      let OverdueCredit = overdueCredit;
      if (finalPriceWithPromotion) {
        finalPriceWithPromotion = Number(finalPriceWithPromotion);
      }
      let OrderPrice = finalPriceWithPromotion;
      
      let data = {customer: this.props.receivingCustomer, OverdueCredit, OrderPrice, Approval: approval, Company_id: this.props.selectedCompany ? this.props.selectedCompany.value : null};
      
      axios
      .post(
        `${ROOT_URL}v1/sale/get_verification_code`,
        // formData,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              "token"
            )}`,
          },
        },
      )
      .then(
        (res) => {
          alert("Passcode Sent!");
        },
        (err) => {
          if (err.status === 500 || err.status === 404) {
            err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
          }
          alert(JSON.stringify(err.data));
        }
      );
    }

    openShippingInfoFormModal = () => {
      this.setState({
        shippingInfoModalVisibility: true,
      })
    }

    closeShippingInfoFormModal = () => {
      this.setState({
        shippingInfoModalVisibility: false,
      })
    }

    renderShippingAddressSelections() {
      const customerNameOptions = this.getCustomerNameOptions();
      const shippingContactOptions = this.getShippingContactOptions();
      const shippingPhoneOptions = this.getShippingPhoneOptions();
      const shippingNameOptions = this.getShippingNameOptions();
      const addressOptions = this.getAddressOptions();
      const zipOptions = this.getZipOptions();
      const isMobile = this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id';
      const fieldName = (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'outboundOrders/new') ? 'CustomerDetail_id' : 'Deliver_CustomerDetail_id';
      const mobileSalesUserShippingAddress = this.props.initialValues ? `${this.props.initialValues.Shipping.Street} ${this.props.initialValues.Shipping.City} ${this.props.initialValues.Shipping.State} ${this.props.initialValues.Shipping.Zip}` : null;
      // if (this.props.receivingCustomer && !this.props.shipperChosen && shippingPhoneOptions.length) {
      //   this.props.setValue('salesOrderForm', fieldName, shippingPhoneOptions[0].value);
      // }
      const shippingMethodOptions = [
        {label: 'Delivery 运送', value: 'Delivery 运送'},
        {label: 'Pick up 提货', value: 'Pick up 提货'},
      ]
      const vakkerShippingMethodOptions = [
        {label: I18n.t('delivery'), value: 'Delivery'},
        {label: I18n.t('pick_up'), value: 'Pick up'},
      ]
      const renderEmailField = () => {
        if (isGGI) {
          return <div className="form-group">
          <label className="col-xs-3"><Translate value="email" /></label>
          <div className="col-xs-8">
            <Field name={'Email'} component={InputField} />
          </div>
        </div>
        }
        return null;
      }
      return (
        <Col xs={6} id="customer-details">
          <div style={{ width: '300px', display: 'flex' }}>
          {
            isMobile ?
              <h4 onDoubleClick={this.openShippingInfoFormModal} style={{ textDecoration: 'underline' }}><Translate value="shipping_information" /></h4>
              :
              <h4><Translate value="shipping_information" /></h4>
          }
          {
          (!isWIZ || !this.state.IsFBAAddress ) &&
            <Button
              id="shipping-info-add-button"
              type="button"
              onClick={() => {
                this.openShippingInfoEditModal()
              }
            }
              disabled={!this.props.receivingCustomer}
            >
              {isMobile && isVAK ? <Translate value={'edit'} /> : '+'}
              {/* <Translate value="carrier" /> */}
            </Button>
          }
          {
            (isWIZ && this.state.IsFBAAddress ) &&
              <Button
                id="shipping-info-add-button"
                type="button"
                onClick={() => {
                  this.openFBAEditModal()
                }
              }
                disabled={false}
              >
                +
              </Button>
          }
          {
            this.state.showCarrierButton &&
            <Button
              id="carrier-info-button"
              type="button"
              onClick={this.openCarrierInfoModal}
            >
              <Translate value="carrier" />
            </Button>
          }
          </div>
          {
            isWIZ &&
            <div className="form-group">
              <label className="col-xs-5">FBA Address</label>
              <div className="col-xs-7">
                <Field name="IsFBAAddress" checked={this.state.IsFBAAddress} component={CheckboxFormatter} handleOnClick={() => { this.setState({IsFBAAddress : !this.state.IsFBAAddress})}}/>
              </div>
            </div>
          }
          {
            (isWIZ && this.state.IsFBAAddress) &&
            <div>
              <div className="form-group">
                {/* <label className="col-xs-3"><Translate value="" /></label> */}
                <div id="fba-address-dropdown" className="col-xs-12">
                  <Field name="DestinationAddress" matchPos="any" component={Selection} options={this.state.FBAOptions} />
                </div>
              </div>
              <div className="form-group">
                <label className="col-xs-3"><Translate value="name" /></label>
                <div id="fba-address-dropdown" className="col-xs-9">
                  <Field name="DestinationAddress" matchPos="any" component={Selection} options={this.state.FBAOptions2} />
                </div>
              </div>
            </div>
          }
          {
            (!isMultiWH && !isABCFF && (!isWIZ || !this.state.IsFBAAddress)) &&
            <div className="form-group">
              <div id="customer-name-dropdown" className="col-xs-11">
                {
                  isMobile ?
                  <Field
                    name="Shipping.FirstName"
                    withRef
                    // ref="quantity"
                    component={InputField}
                    onFocus={this.handleOnFocus}
                    disabled={true}
                  />
                  :
                  <Field
                    name="receivingCustomer"
                    matchPos="any"
                    placeholder={
                      <span>
                        <Translate value="customer" />
                        <span className="asteriksReq">*</span>
                      </span>
                    }
                    component={SelectionWithProps}
                    options={customerNameOptions}
                  />
                }
              </div>
            </div>
          }
           <div className="form-group">
            <label className="col-xs-3"><Translate value="receiver" /></label>
            <div id="customer-name-dropdown" className="col-xs-8">
              <Field name={fieldName} matchPos="any" component={Selection} options={shippingNameOptions} />
            </div>
          </div>
          {
            (!isWIZ || !this.state.IsFBAAddress ) &&
              <div>
              {
                isMobile ?
                <div>
                  <div className="form-group">
                    <label className="col-xs-3"><Translate value="phone" /></label>
                    <div id="customer-id-dropdown" className="col-xs-8">
                      <Field
                        name="Shipping.Telephone"
                        withRef
                        // ref="quantity"
                        component={InputField}
                        onFocus={this.handleOnFocus}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-xs-3"><Translate value="address" /></label>
                    <div className="col-xs-8">
                      <input style={{width: '100%', borderRadius: '5px', padding: '4px', border: '1px solid black', backgroundColor: '#CFD8DC'}} disabled value={mobileSalesUserShippingAddress}/>
                    </div>
                  </div>
                </div>
                :
                <div>
                  <div className="form-group">
                    <label className="col-xs-3"><Translate value="phone" /></label>
                    <div id="customer-id-dropdown" className="col-xs-8">
                      <Field name={fieldName} matchPos="any" component={Selection} options={shippingPhoneOptions} />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-xs-3"><Translate value="address" /></label>
                    <div className="col-xs-8">
                      <Field name={fieldName} matchPos="any" component={Selection} options={addressOptions} />
                    </div>
                  </div>

                  {isSV &&
                   <div className="form-group">
                     <label className="col-xs-3"><Translate value="zipcode" /></label>
                     <div className="col-xs-8">
                       <Field name={fieldName} matchPos="any" component={Selection} options={zipOptions} />
                     </div>
                   </div>
                  }
                  {isSV &&
                    <div className="form-group">
                      <label className="col-xs-3">Ship Via</label>
                       <div className="col-xs-8">
                         <input
                          list="browsers" name="browser" id="browser"
                          value={this.props.ShipVia}
                          onChange={(e) => {this.updateShipVia(e)}}
                          style={{ width: '100%',height:'22px', borderRadius:'3px', border: '1px solid black' }}
                        />
                        <datalist id="browsers">
                          <option value="FEDEX (R)"/>
                          <option value="FEDEX GROUND"/>
                          <option value="FEDEX 3RD PARTY"/>
                          <option value="FEDEX COLLECT"/>
                          <option value="UPS GROUND"/>
                          <option value="UPS (R)"/>
                          <option value="UPS 3RD PARTY"/>
                          <option value="UPS COLLECT"/>
                          <option value="PARCEL POST"/>
                          <option value="PRIORITY MAIL"/>
                          <option value="TRUCKING"/>
                          <option value="PICK UP"/>
                          <option value="SEE ROUTING"/>
                          <option value="FREE FREIGHT"/>
                          <option value="CALL FOR INFO"/>
                          <option value="FREIGHT COLLECT"/>
                          <option value="POE"/>
                          <option value="FOB"/>
                        </datalist>
                       {/* <Field name="ShipVia" className="PONum-no-highlight" component={InputField} /> */}
                     </div>
                   </div>
                  }
                  {/* {isSV &&
                  <div className="form-group">
                    <label className="col-xs-4"><Translate value="ship_date" /></label>
                    <div className="col-xs-7">
                    <Field name="ShipDate" selected={this.state.prevOrderDate} component={DatePicker} />
                    </div>
                  </div>
                  }
                { isSV &&
                  <div className="form-group">
                    <label className="col-xs-4"><Translate value="cancel_date" /></label>
                    <div className="col-xs-7">
                    <Field name="CancelDate" component={DatePicker} />
                    </div>
                  </div>
                } */}
                {renderEmailField()}
                </div>
                }
                {
                isNBT &&
                  <div className="form-group">
                    <label className="col-xs-3"><Translate value="ssn" /></label>
                    <div className="col-xs-8">
                      <Field
                        name="Shipping.SSN"
                        withRef
                        component={InputField}
                        onFocus={this.handleOnFocus}
                        disabled={true}
                      />
                    </div>
                  </div>
                }
            </div>
          }
          {
            (isOLG || isVAK) && (
              <div className="form-group" style={{backgroundColor: 'inherit', display: 'flex', alignItems: 'center'}}>
                <label className="col-xs-3"><Translate value="shipping_method" /></label>
                <div className="col-xs-8">
                  <Field name="ShippingMethod" component={Selection} options={isVAK ? vakkerShippingMethodOptions : shippingMethodOptions} />
                </div>
              </div>
            )
          }
          {isSKH &&
            <div>
              <div className="form-group" style={{backgroundColor: 'inherit', display: 'flex', alignItems: 'center'}}>
                <label className="col-xs-3"><Translate value="load_id" /></label>
                <div className="col-xs-8">
                  <Field name="LoadId" className="PONum-no-highlight" component={InputField} />
                </div>
              </div>
              <div className="form-group" style={{backgroundColor: 'inherit', display: 'flex', alignItems: 'center'}}>
                <label className="col-xs-3"><Translate value="type" /></label>
                <div className="col-xs-8">
                  <Field name="Type_wmb2b" className="PONum-no-highlight" component={InputField} />
                </div>
              </div>
              <div className="form-group" style={{backgroundColor: 'inherit', display: 'flex', alignItems: 'center'}}>
                <label className="col-xs-3"><Translate value="dept" /></label>
                <div className="col-xs-8">
                  <Field name="Dept_wmb2b" className="PONum-no-highlight" component={InputField} />
                </div>
              </div>
            </div>
          }
        </Col>
      );
    }

    renderShippingAddressSelectionsABC() {
      let { ShipTo } = this.state;
      const customerNameOptions = this.getCustomerNameOptions();
      const shippingContactOptions = this.getShippingContactOptions();
      const shippingPhoneOptions = this.getShippingPhoneOptions();
      const shippingNameOptions = this.getShippingNameOptions();
      const addressOptions = this.getAddressOptions();
      const isMobile = this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id';
      const fieldName = (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'outboundOrders/new') ? 'CustomerDetail_id' : 'Deliver_CustomerDetail_id';
      const mobileSalesUserShippingAddress = this.props.initialValues ? `${this.props.initialValues.Shipping.Street} ${this.props.initialValues.Shipping.City} ${this.props.initialValues.Shipping.State} ${this.props.initialValues.Shipping.Zip}` : null;
      return (
        <Col xs={6} id="customer-details">
          <div style={{ width: '300px', display: 'flex' }}>
            <h4><Translate value="ship_to_address" /></h4>
          </div>

          <div className="form-group">
            <div id="customer-name-dropdown" className="col-xs-11">
              {
                isMobile ?
                <Field
                  name="ShipTo.Name"
                  withRef
                  // ref="quantity"
                  component={InputField}
                  onFocus={this.handleOnFocus}
                  disabled={true}
                />
                :
                <Field
                  name="receivingCustomer"
                  matchPos="any"
                  placeholder={
                    <span>
                      <Translate value="customer" />
                      <span className="asteriksReq" >*</span>
                    </span>
                  }
                  component={SelectionWithProps}
                  options={customerNameOptions}
                />
              }
            </div>
          </div>

          <div className="form-group">
            <label className="col-xs-3"><Translate value="phone" /></label>
            <div id="customer-id-dropdown" className="col-xs-8">
              {
                isMobile ?
                <Field
                  name="ShipTo.Telephone"
                  component={InputField}
                  disabled={true}
                />
                :
                <Field name={fieldName} matchPos="any" component={Selection} options={shippingPhoneOptions} />
              }
            </div>
          </div>
          <div className="form-group">
            <label className="col-xs-3"><Translate value="address" /></label>
            <div className="col-xs-8">
              {
                isMobile ?
                <input style={{width: '100%', borderRadius: '5px', padding: '4px', border: '1px solid black', backgroundColor: '#CFD8DC'}} disabled value={ShipTo.Address}/>
                :
                <Field name={fieldName} matchPos="any" component={Selection} options={addressOptions} />
              }
            </div>
          </div>
        </Col>
      );
    }

    productHeader() {
      const handleToggle = () => {
        this.setState({
          isProductInformationPanelFolded: !this.state.isProductInformationPanelFolded,
          yourOrderTableHeight: this.state.isProductInformationPanelFolded
            ? this.state.yourOrderTableHeight - 100
            : this.state.yourOrderTableHeight + 100,
        })
      }
      return (
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
          <h2><Translate value="product_information" /></h2>
          <div
            onClick={handleToggle}
            style={{marginRight: '4px', position: 'relative', zIndex: 99}}
          >{
            this.state.isProductInformationPanelFolded
            ? <i className={'fa fa-plus'} />
            : <i className={'fa fa-minus'} />
          }
          </div>
        </div>
      );
    }
    renderCustomerCredit() {
      return (
        <div>
          <h4 style={{ marginBottom: '5px' }}><Translate value="customer_credit" /></h4>
        </div>
      );
    }
    orderHeader() {
      return (
        <div>
          <h2><Translate value="your_order" /></h2>
        </div>
      );
    }

    moveFromPreviousOrderToSalesOrder() {
      const selectPreviousOrderRows = [...this.state.previousOrders.selectedRows];
      let newRows = [];
      let totalPrice = 0;
      let finalWeight = 0;
      let totalTax = 0;
      const totalCRV = 0;
      selectPreviousOrderRows.map((index) => {
        index.Batch_id = null;
        index.Batch_id_id = null;
        // check if the product already add in your order
        const check = _.findIndex(this.state.rows, { ProductNum: index.ProductNum });
        if (check === -1) {
          if(isOLG && this.state.priceObj.length > 0) {
            this.state.priceObj.map(item=>{
              if(item.id == index.Product_id) {
                newRows.push({...index, SalesOrderLine_id: null, UnitPrice: item.price});
                return
              }
            })
          } else if(isLMH) {
            newRows.push({...index, SalesOrderLine_id: null, MainId: new Date().getTime(), Pid: -1, Components: '' });
          } else {
            newRows.push({...index, SalesOrderLine_id: null});
          }
        }
      });
      if(isOLG && this.state.priceObj.length > 0) {
        this.setState({priceObj:[]})
      }
      const rows = [...this.state.rows];
      newRows.map((row) => {
        if (!isSV && !isOLG) {
          row.Quantity = 0;
          row.TotalPrice = 0;
        }
        if (isSV || isSUN || isOLG) {
          rows.push(row);
        } else {
          if (isLAP) {
            rows.unshift({
              ...row,
              CostPrice: row.CurrentCost,
              ProductCost: row.CurrentCost,
              UnitPrice: row.CurrentUnitPrice,
            })
          } else if (isGGI) {
            rows.unshift({
              ...row,
              CostPrice: row.CurrentCost,
              ProductCost: row.CurrentCost,
            })
          } else {
            rows.unshift(row);
          }
        }
      });

      let index = rows.length;
      rows.map((row, idxx) => {
        if (isSV || isSUN) {
          row.Index = idxx;
        } else if (isOLG) {
          row.Index = idxx + 1;
        } else {
          row.Index = index;
          index--;
        }
        // totalCRV = parseFloat(row.CRV) + totalCRV;
        if (row.IsTaxable === true) {
          if(isHMM) {
            totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(this.state.taxValue / 100);
          } else {
            if(isHO || isJRC || isVIP) {
              if(row.IsAllTaxable === true || !this.props.salesCustomerDetails.Reseller) {
                totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
              }
            } else {
              totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
            }
          }
        }
        if(isHMM) {
          totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
        } else {
          totalPrice += parseFloat(row.TotalPrice);
        }
        if(isLAP) {
          // sum line product cost
          let lineTotalCost = 0;
          let totalPrices = parseFloat(row.TotalPrice);
          if(!totalPrices || totalPrices == 0) {
            if(row.ProductType === 'Non-Fixed' || row.ProductType === 'Per-Pound') {
              row.TotalPrice = roundTo(parseFloat(row.UnitPrice * (row.NetWeight || 0) * (row.Quantity || 0)), 2);
            } else {
              row.TotalPrice = roundTo(parseFloat((row.Quantity || 0) * row.UnitPrice), 2);
            }
          }
          if(row.ProductType == 'Non-Fixed' || row.ProductType == 'Per-Pound') {
            lineTotalCost = (row.ProductCost || row.CurrentCost || row.CostPrice || 0) * (row.NetWeight || 0) * row.Quantity;
          } else {
            lineTotalCost = (row.ProductCost || row.CurrentCost || 0) * row.Quantity;
          }
          if(row.Quantity == 0) {
            row.Profit1 = 0;
            row.SalesMargin1 = 0;
          } else {
            row.Profit1 = roundTo(parseFloat(row.TotalPrice) - lineTotalCost, 2);
            row.SalesMargin1 = roundTo((parseFloat(row.TotalPrice) - lineTotalCost) / parseFloat(row.TotalPrice) * 100, 2);
          }
        }
        row.TotalCRV = +roundTo(row.Quantity * row.CRV, 2).toFixed(2);
        if (row.Weight != null) { finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight); }
        row.TotalNetWeight = row.TotalNetWeight;
      });

      if (isHMM || isLMH || isSDR || isCRW || isSC || isSUN || isCPG) {
        if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
          totalTax = 0;
        }  else {
          if (SODiscount) {
            totalTax = 0;
            rows.map((row, idxx) => {
              if (row.IsTaxable === true) {
                totalTax += ((parseFloat(row.TotalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)))) * parseFloat(this.state.taxValue / 100);
              }
            });
          }
        }
      }
      const { SODiscount, SOSavings } = this.state; // only one has value
      if ((isEKC || isSH)) {
        if (isEKC && this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
          totalTax = 0;
        } else {
          totalTax = ((parseFloat(totalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)) - Number(SOSavings ? SOSavings : 0))) * parseFloat(this.state.taxValue / 100);
        }
      }

      totalTax = +roundTo(totalTax, 2).toFixed(2);
      // reset selected after add
      this.handleDeselectAll();
      this.setState({
        rows,
        totalPrice,
        finalWeight,
        totalTax,
        totalCRV,
      }, () => {
        if ((isEKC || isLMH || isSDR || isCRW || isSC || isOLG || isVAK || isSH)) {
          this.onConfirmPercentageFee();
          if(isOLG) {
            let list = document.querySelector('#SalesOrderForm-dataGrid3 .react-grid-Canvas');
            list.scrollTop = list.scrollHeight
          }
        }
      });
    }

    // Quick Entry SO Number
    onChangeQuickEntry(e) {
      this.setState({ quickEntrySONum: e.target.value });
    }

    onChangeSmilingColor = (e) => {
      this.setState({ smilingColor: e.target.value });
    }

    onKeyPressQuickEntry(e) {
      const handleSuccess = (response) => {

      };
      const handleFailure = (error) => {
        this.setState({ quickEntryShowError: true });
      };
      if (e.charCode === 13) {
        this.fetchPreviousOrderBySearch(this.state.quickEntrySONum);
        // this.props.fetchQuickAccess(this.state.quickEntrySONum, handleSuccess, handleFailure);
      }
    }

    checkblah() {
      if (isABCFF) {
        if (!(this.state.frequentItems.selectedPK) || this.state.frequentItems.selectedPK.length === 0) {
          return true;
        }
      } else {
        if (!(this.state.frequentItems.selectedIndexes) || this.state.frequentItems.selectedIndexes.length === 0) {
          return true;
        }
      }
    }

    moveFromFrequentItemsToSalesOrder() {
      const frequentRows = [...this.state.frequentItems.selectedIndexes];
      if (isABCFF) {
        this.state.frequentItems.rows = this.props.customerFrequent.record;
      }
      const prevRows = [...this.state.frequentItems.rows];
      let frequentPK = [];
      if (isABCFF) {
        frequentPK = [...this.state.frequentItems.selectedPK];
      }

      const newRows = [];
      let totalPrice = 0;
      let finalWeight = 0;
      let totalTax = 0;
      const totalCRV = 0;
      let check = null;
      if (isABCFF) {
        frequentPK.map((r) => {
          prevRows.map((j, index) => {
            if (r === j.pk) {
              newRows.push(prevRows[index]);
            }
          });
        });
      } else {
        frequentRows.map((index) => {
          const check = _.findIndex(this.state.rows, { ProductNum: prevRows[index].ProductNum });
          if (check == -1) {
            if(isLMH) {
              newRows.push({...prevRows[index], MainId: new Date().getTime(), Pid: -1});
            } else {
              newRows.push(prevRows[index]);
            }
          } else if (isDSQ || isWIZ || isFJ || isJTB || isABCFF) {
            newRows.push(prevRows[index]);
          }
        });
      }

      const rows = [...this.state.rows];
      newRows.map((row) => {
        if (!isLAP) {
          row.Quantity = 0;
        }
        row.TotalPrice = 0;
        if (isDSQ || isWIZ || isFJ || isJTB || isABCFF) {
          rows.unshift({...row});
        } else {
          if (isSV || isSUN || isOLG) {
            rows.push(row);
          } else {
            if (isLAP) {
              rows.unshift({
                ...row,
                CostPrice: row.CurrentCost,
                ProductCost: row.CurrentCost,
                UnitPrice: row.CurrentUnitPrice,
                Quantity: row.Quantity,
              })
            } else {
              rows.unshift(row);
            }
          }
        }
      });
      let index = rows.length;
      rows.map((row, idxx) => {
        if (isSV || isSUN || isOLG) {
          row.Index = idxx+1;
        } else {
          row.Index = index;
          index--;
        }
        // totalCRV = parseFloat(row.CRV) + totalCRV;
        if (row.IsTaxable === true) {
          if(isHMM) {
            totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(this.state.taxValue / 100);
          } else {
            if(isHO || isJRC || isVIP) {
              if(row.IsAllTaxable === true || !this.props.salesCustomerDetails.Reseller) {
                totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
              }
            } else {
              totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
            }
          }
        }
        if(isHMM) {
          totalPrice += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
        } else {
          totalPrice += parseFloat(row.TotalPrice);
        }
        if(isLAP) {
        //   // sum line product cost
          let lineTotalCost = 0;
          let totalPrices = parseFloat(row.TotalPrice);
          if(!totalPrices || totalPrices == 0) {
            if(row.ProductType === 'Non-Fixed' || row.ProductType === 'Per-Pound') {
              row.TotalPrice = roundTo(parseFloat(row.UnitPrice * (row.NetWeight || 0) * (row.Quantity || 0)), 2);
            } else {
              row.TotalPrice = roundTo(parseFloat((row.Quantity || 0) * row.UnitPrice), 2);
            }
          }
          if(row.ProductType == 'Non-Fixed' || row.ProductType == 'Per-Pound') {
            lineTotalCost = (row.ProductCost || row.CurrentCost || row.CostPrice || 0) * (row.NetWeight || 0) * (row.Quantity || 0);
          } else {
            lineTotalCost = (row.ProductCost || row.CurrentCost || 0) * (row.Quantity || 0);
          }
          if(row.Quantity == 0) {
            row.Profit1 = 0;
            row.SalesMargin1 = 0;
          } else {
            row.Profit1 = roundTo(parseFloat(row.TotalPrice) - lineTotalCost, 2) || 0;
            row.SalesMargin1 = roundTo((parseFloat(row.TotalPrice) - lineTotalCost) / parseFloat(row.TotalPrice) * 100, 2) || 0;
          }
        }
        row.TotalCRV = +roundTo(row.Quantity * row.CRV, 2).toFixed(2);
        if (row.Weight != null) { finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight); }
        row.TotalNetWeight = row.TotalNetWeight;
      });

      if (isHMM || isLMH || isSDR || isCRW || isSC || isSUN || isCPG) {
        if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
          totalTax = 0;
        }  else {
          if (SODiscount) {
            totalTax = 0;
            rows.map((row, idxx) => {
              if (row.IsTaxable === true) {
                totalTax += ((parseFloat(row.TotalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)))) * parseFloat(this.state.taxValue / 100);
              }
            });
          }
            }
      }
      const { SODiscount, SOSavings } = this.state; // only one has value
      if ((isEKC || isSH)) {
        if (isEKC && this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
          totalTax = 0;
        } else {
          totalTax = ((parseFloat(totalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)) - Number(SOSavings ? SOSavings : 0))) * parseFloat(this.state.taxValue / 100);
        }
      }

      totalTax = +roundTo(totalTax, 2).toFixed(2);
      this.setState({
        rows, totalPrice, finalWeight, totalTax, totalCRV,
      }, () => {
        if ((isEKC || isLMH || isSDR || isCRW || isSC || isOLG  || isVAK || isSH)) {
          this.onConfirmPercentageFee();
          if(isOLG) {
            let list = document.querySelector('#SalesOrderForm-dataGrid3 .react-grid-Canvas');
            list.scrollTop = list.scrollHeight
          }
         }
      });
    }

    moveFromFavoriteItemsToSalesOrder() {
      const favoritesRows = [...this.state.favorites.selectedIndexes];
      const prevRows = [...this.state.favorites.rows];
      const newRows = [];
      let totalPrice = 0;
      let finalWeight = 0;
      let totalTax = 0;
      const totalCRV = 0;
      favoritesRows.map((index) => {
        const check = _.findIndex(this.state.rows, { ProductNum: prevRows[index].ProductNum });
        if (check == -1) {
          if(isLMH) {
            newRows.push({...prevRows[index], MainId: new Date().getTime(), Pid: -1});
          } else {
            newRows.push(prevRows[index]);
          }
        }
      });
      const rows = [...this.state.rows];
      newRows.map((row) => {
        row.Quantity = 0;
        row.TotalPrice = 0;
        if (isSV || isSUN || isOLG) {
          rows.push(row);
        } else {
          if (isLAP) {
            rows.unshift({
              ...row,
              CostPrice: row.CurrentCost,
              ProductCost: row.CurrentCost,
              UnitPrice: row.CurrentUnitPrice,
            })
          } else {
            rows.unshift(row);
          }
        }
      });
      let index = rows.length;
      rows.map((row, idxx) => {
        if (isSV || isSUN || isOLG) {
          row.Index = idxx+1;
        } else {
          row.Index = index;
          index--;
        }
        // totalCRV = parseFloat(row.CRV) + totalCRV;
        if (row.IsTaxable == true) {
          if(isHMM) {
            totalTax += parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1) * parseFloat(this.state.taxValue / 100);
          } else {
            if(isHO || isJRC || isVIP) {
              if(row.IsAllTaxable === true || !this.props.salesCustomerDetails.Reseller) {
                totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
              }
            } else {
              totalTax += parseFloat(row.TotalPrice) * parseFloat(this.state.taxValue / 100);
            }
          }
        }
        if(isHMM) {
          totalPrice = parseFloat(totalPrice) + parseFloat(row.Quantity * row.UnitPrice * row.PackageSize_1);
        } else {
          totalPrice = parseFloat(totalPrice) + parseFloat(row.TotalPrice);
        }

        if(isLAP) {
          // sum line product cost
          let lineTotalCost = 0;
          let totalPrices = parseFloat(row.TotalPrice);
          if(!totalPrices || totalPrices == 0) {
            if(row.ProductType === 'Non-Fixed' || row.ProductType === 'Per-Pound') {
              row.TotalPrice = roundTo(parseFloat(row.UnitPrice * (row.NetWeight || 0) * (row.Quantity || 0)), 2);
            } else {
              row.TotalPrice = roundTo(parseFloat((row.Quantity || 0) * row.UnitPrice), 2);
            }
          }
          if(row.ProductType == 'Non-Fixed' || row.ProductType == 'Per-Pound') {
            lineTotalCost = (row.ProductCost || row.CurrentCost || row.CostPrice || 0) * (row.NetWeight || 0) * row.Quantity;
          } else {
            lineTotalCost = (row.ProductCost || row.CurrentCost || 0) * row.Quantity;
          }
          if(row.Quantity == 0) {
            row.Profit1 = 0;
            row.SalesMargin1 = 0;
          } else {
            row.Profit1 = roundTo(parseFloat(row.TotalPrice) - lineTotalCost, 2);
            row.SalesMargin1 = roundTo((parseFloat(row.TotalPrice) - lineTotalCost) / parseFloat(row.TotalPrice) * 100, 2);
          }
        }
        row.TotalCRV = +roundTo(row.Quantity * row.CRV, 2).toFixed(2);
        if (row.Weight != null) { finalWeight = parseFloat(finalWeight) + parseFloat(row.TotalNetWeight); }
        row.TotalNetWeight = row.TotalNetWeight;
      });


      if (isHMM || isLMH || isSDR || isCRW || isSC || isSUN || isCPG) {
        if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
          totalTax = 0;
        }  else {
          if (SODiscount) {
            totalTax = 0;
            rows.map((row, idxx) => {
              if (row.IsTaxable === true) {
                totalTax += ((parseFloat(row.TotalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)))) * parseFloat(this.state.taxValue / 100);
              }
            });
          }
            }
      }
      const { SODiscount, SOSavings } = this.state; // only one has value
      if ((isEKC || isSH)) {
        if (isEKC && this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
          totalTax = 0;
        } else {
          totalTax = ((parseFloat(totalPrice) * (1 - ((SODiscount ? SODiscount : 0) / 100)) - Number(SOSavings ? SOSavings : 0))) * parseFloat(this.state.taxValue / 100);
        }
      }

      totalTax = +roundTo(totalTax, 2).toFixed(2);
      this.setState({
        rows, totalPrice, finalWeight, totalTax, totalCRV,
      }, () => {
        if ((isEKC || isLMH || isSDR || isCRW || isSC || isOLG || isVAK || isSH)) {
          this.onConfirmPercentageFee();
          if(isOLG) {
            let list = document.querySelector('#SalesOrderForm-dataGrid3 .react-grid-Canvas');
            list.scrollTop = list.scrollHeight
          }
        }
      });
    }

    /* Handle Refund Confirm */
    handleRefundConfirm() {
      const { id } = this.props.params;
      const { refundAmount, refundReason } = this.state;
      if (id) {
        this.props.requestSORefund(id, { refundAmount, refundReason });
      }
    }

    renderEditSOPermission() {
      if (!this.props.currentSalesOrder) { return; }
      return (
        <Button
          bsStyle="primary"
          onClick={this.openEditSOPermission}
        >
          <Translate value="permission" />
        </Button>
      );
    }

    renderExpressInvoice() {
      const { currentSalesOrderDetail } = this.props;
      if (!currentSalesOrderDetail || !currentSalesOrderDetail.SaleStatus) {
        return;
      }
      let buttonShouldDisable = (
        this.state.Released ||
        currentSalesOrderDetail.SaleStatus === 'Finalized' ||
        currentSalesOrderDetail.SaleStatus === 'Refunded' ||
        currentSalesOrderDetail.SaleStatus === 'Partially Refunded' ||
        currentSalesOrderDetail.SaleStatus === 'Canceled' ||
        this.state.editing ||
        (isGGI && checkPermissionLocal('disable_express_sales_invoice'))
      );
      if (isSV) {
        buttonShouldDisable = (
          this.state.Released ||
          currentSalesOrderDetail.SaleStatus === 'Finalized' ||
          currentSalesOrderDetail.SaleStatus === 'Refunded' ||
          currentSalesOrderDetail.SaleStatus === 'Partially Refunded' ||
          currentSalesOrderDetail.SaleStatus === 'Canceled' ||
          currentSalesOrderDetail.SaleStatus === 'Pending' ||
          this.state.editing
        );
      }
      let expressInvoiceText = 'express_invoice'
      const isMobile = this.context.router.routes[1].path == 'mobileSalesOrders/new' || this.context.router.routes[1].path == 'mobileSalesOrders/:id';
      if (isVAK && isMobile) {
        buttonShouldDisable = buttonShouldDisable || currentSalesOrderDetail.SaleStatus === 'Quote'
      }
      if(isVAK && (this.props.selectedCompany || {value: ''}).value == 6) {
        if(isMobile) {
          return null;
        } else {
          buttonShouldDisable = buttonShouldDisable
          || currentSalesOrderDetail.Is_Prepay
          && currentSalesOrderDetail.PrepayStatus != "ReadyToShip"
          && currentSalesOrderDetail.PrepayStatus != "PartialShip"
          if(currentSalesOrderDetail.Is_Prepay) {
            expressInvoiceText = 'ship';
          }
        }
      }
      return (
        <Button
          bsStyle="primary"
          onClick={this.openShipping}
          disabled={buttonShouldDisable}
        >
          <em className="fa fa-edit" />
          <Translate value={expressInvoiceText} />
        </Button>
      );
    }

    renderAfterSaveExpressInvoice() {
      return (
        <Button
          bsStyle="primary"
          onClick={this.openShipping}
        >
          <em className="fa fa-edit" />
          <Translate value="express_invoice" />
        </Button>
      );
    }

    renderShippingStatsEdit = () => {
      const { currentSalesOrderDetail } = this.props;
      return (
        <Button
          bsStyle="primary"
          onClick={() => this.setShippingStatsEditModalVisibility(true)}
          // disabled={!currentSalesOrderDetail || currentSalesOrderDetail.ShippingStatus === "Outbound"}
        >
          <em className="fa fa-edit" />
          <Translate value="shipping_status_edit" />
        </Button>
      );
    }
    renderDropshipButton() {
      const { currentSalesOrderDetail } = this.props;
      if (!currentSalesOrderDetail) {
        return null;
      }
      let dropShipEnabled = !currentSalesOrderDetail.TPONum && (currentSalesOrderDetail.IsRelocation || currentSalesOrderDetail.IsTransfer);
      if (isLMH || isSDR || isCRW || isSC) {
        dropShipEnabled = true;
      }
      if (isVAK) {
        dropShipEnabled = dropShipEnabled && currentSalesOrderDetail.Review_Status === 'Confirm' && currentSalesOrderDetail.Approve_Status === 'Confirm' && !currentSalesOrderDetail.IsDropship;
      }
      return (
        <Button
          bsStyle="primary"
          onClick={this.openDropship}
          disabled={!dropShipEnabled}
        >
          <em className="fa fa-plus" />
          <Translate value="dropship_so_detail" />
        </Button>
      );
    }

    renderCreateBOLButton() {
      const { currentSalesOrder } = this.props;
      if (!currentSalesOrder) {
        return null;
      }
      return (
        <Button
          bsStyle="success"
          onClick={this.openCreateBOLModal}
        >
          <em className="fa fa-plus" />
          <Translate value="bol" />
        </Button>
      );
    }

    shippingIFrameIsLoaded = () => {
      if (!this.state.shippingPdfFrameLoaded) {
        const pdfFrame = window.frames.shippingPdf;
        pdfFrame.focus();
        pdfFrame.print();
        this.setState({ shippingPdfFrameLoaded: true });
      }
    }
    renderShippingIFrame() {
      if (this.props.shippingListPDF) {
        const file = window.URL.createObjectURL(this.props.shippingListPDF);
        return (
          <iframe style={{ display: 'none' }} onLoad={this.shippingIFrameIsLoaded} id="shippingPdf" name="shippingPdf" src={file} />
        );
      }
    }

    packingIFrameIsLoaded = () => {
      if (!this.state.packingListPdfFrameLoaded) {
        const pdfFrame = window.frames.packingPdf;
        pdfFrame.focus();
        pdfFrame.print();
        this.setState({ packingListPdfFrameLoaded: true });
      }
    }
    renderPackingIFrame() {
      if (this.props.packingListPDF) {
        const file = window.URL.createObjectURL(this.props.packingListPDF);
        return (
          <iframe style={{ display: 'none' }} onLoad={this.packingIFrameIsLoaded} id="packingPdf" name="packingPdf" src={file} />
        );
      }
    }

    pickingIFrameIsLoaded = () => {
      if (!this.state.pickingListPdfFrameLoaded) {
        const pdfFrame = window.frames.pickingPdf;
        pdfFrame.focus();
        pdfFrame.print();
        this.setState({ pickingListPdfFrameLoaded: true });
      }
    }
    renderPickingIFrame() {
      if (this.props.pickingListPDF) {
        const file = window.URL.createObjectURL(this.props.pickingListPDF);
        return (
          <iframe style={{ display: 'none' }} onLoad={this.pickingIFrameIsLoaded} id="pickingPdf" name="pickingPdf" src={file} />
        );
      }
    }

    salesOrderIFrameIsLoaded = () => {
      if (!this.state.salesOrderPdfFrameLoaded) {
        const pdfFrame = window.frames.salesOrderPdf;
        pdfFrame.focus();
        pdfFrame.print();
        this.setState({ salesOrderPdfFrameLoaded: true });
      }
    }
    renderSalesOrderIFrame() {
      if (this.props.salesOrderPDF) {
        const file = window.URL.createObjectURL(this.props.salesOrderPDF);
        return (
          <iframe style={{ display: 'none' }} onLoad={this.salesOrderIFrameIsLoaded} id="salesOrderPdf" name="salesOrderPdf" src={file} />
        );
      }
    }

    salesOrderSIIFrameIsLoaded = () => {
      if (!this.state.salesOrderSIPdfFrameLoaded) {
        const pdfFrame = window.frames.salesOrderSIPdf;
        pdfFrame.focus();
        pdfFrame.print();
        this.setState({ salesOrderSIPdfFrameLoaded: true });
      }
    }
    renderSalesOrderSIIFrame() {
      if (this.props.salesOrderSIPDF) {
        const file = window.URL.createObjectURL(this.props.salesOrderSIPDF);
        return (
          <iframe style={{ display: 'none' }} onLoad={this.salesOrderSIIFrameIsLoaded} id="salesOrderSIPdf" name="salesOrderSIPdf" src={file} />
        );
      }
    }

    handlePrintFrameOnLoad = () => {
      this.setState({ refundPDFFrameLoaded: true });
    }

    renderRefundIframe() {
      const { refundPDFFrameLoaded } = this.state;
      const { refundPDF } = this.props;
      return (
        <PrintIframe
          id="refundPDF"
          loaded={refundPDFFrameLoaded}
          name="refundPDF"
          onLoad={this.handlePrintFrameOnLoad}
          pdf={refundPDF}
          title={<Translate value="print_refund_summary" />}
        />
      );
    }

    renderPrint() {
      const currentSalesOrder = this.props.currentSalesOrder;
      if (!currentSalesOrder) { return; }
      const url = `${ROOT_URL}v1/sale/printorder/${currentSalesOrder.SalesOrder_id}?Bearer=${localStorage.getItem('token')}`;
      const isQuote = currentSalesOrder.SaleStatus === 'Quote';
      return (
        <Button
          bsStyle="primary"
          type="button"
          disabled={this.state.editing || isQuote}
          onClick={() => {
            this.props.printSalesOrder(currentSalesOrder.SalesOrder_id);
          }}
        >
          <em className="fa fa-print" /><Translate value="print_so" />
        </Button>
      );
    }
    renderPrintPL() {
      const currentSalesOrder = this.props.currentSalesOrder;
      if (!currentSalesOrder) { return; }
      const picking_url = `${ROOT_URL}v1/sale/printpickinglist/${currentSalesOrder.SalesOrder_id}?Bearer=${localStorage.getItem('token')}`;
      return (
        <Button
          bsStyle="primary"
          type="button"
          disabled={this.state.editing}
          onClick={() => {
            this.props.printPickingList(currentSalesOrder.SalesOrder_id);
          }}
        >
          <em className="fa fa-print" /><Translate value="picking_list" />
        </Button>
      );
    }
    renderPrintSL() {
      const currentSalesOrder = this.props.currentSalesOrder;
      if (!currentSalesOrder) { return; }
      const shipping_url = `${ROOT_URL}v1/sale/printshippinglist/${currentSalesOrder.SalesOrder_id}?Bearer=${localStorage.getItem('token')}`;
      return (
        <Button
          bsStyle="primary"
          type="button"
          disabled={this.state.editing}
          onClick={() => {
            this.props.printShippingList(currentSalesOrder.SalesOrder_id);
          }}
        >
          <em className="fa fa-print" /><Translate value="shipping_list" />
        </Button>
      );
    }
    renderPrintPaL() {
      const currentSalesOrder = this.props.currentSalesOrder;
      if (!currentSalesOrder) { return; }
      const packing_url = `${ROOT_URL}v1/sale/printpackinglist/${currentSalesOrder.SalesOrder_id}?Bearer=${localStorage.getItem('token')}`;
      let hasInvoice = false;
      if (!isHMM || (currentSalesOrder && currentSalesOrder.InvoiceNum)) {
        hasInvoice = true;
      }
      return (
        <Button
          bsStyle="primary"
          type="button"
          disabled={!hasInvoice}
          onClick={() => {
            this.props.printPackingList(currentSalesOrder.SalesOrder_id);
          }}
        >
          <em className="fa fa-print" /><Translate value="packing_list" />
        </Button>
      );
    }
    renderFavoritesList() {
      if (this.props.favoriteListIsLoading && !this.props.favoriteListError) return <Spinner />;
      else if (this.props.favoriteListError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.favoriteListError)}</div></ContentWrapper>;

      // Parameters of the react-data-grid
      const getRows = () => Data.Selectors.getRows(this.state.favorites);
      const getSize = () => getRows().length;
      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      const onRowsSelected = (rows) => {
        const newRows = getRows();
        const selectedIndexes = this.state.favorites.selectedIndexes.concat(rows.map(r => r.rowIdx));
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = true;
        });
        const favorites = { ...this.state.favorites, rows: newRows, selectedIndexes };
        this.setState({ favorites });
      };
      const onRowsDeselected = (rows) => {
        const rowIndexes = rows.map(r => r.rowIdx);
        const newRows = [...this.state.favorites.rows];
        const selectedIndexes = this.state.favorites.selectedIndexes.filter(i => rowIndexes.indexOf(i) === -1);
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = false;
        });
        const favorites = { ...this.state.favorites, rows: newRows, selectedIndexes };
        this.setState({ favorites });
      };

      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        const favorites = { ...this.state.favorites, sortColumn, sortDirection };
        this.setState({ favorites });
      };
      const onRowSelect = (rows) => {
        const favorites = { ...this.state.favorites, selectedRows: rows };
        this.setState({ favorites });
      };
      const onRowClick = (rowIdx, row) => {
        if (rowIdx > -1) {
          if (this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') {
          this.props.fetchItemSalesHistory(this.state.currentCustomer, row.Product_id);
          }
          // this.props.fetchProductInfo(row.Product_id);
          if (isOLG || isLAP) {
            this.props.fetchSalesOrderProductByID(row.Product_id, this.state.currentCustomer, this.props.Company_id, this.props.Pickup_Warehouse_id);
          }
        }
      };
      // Custom Formatter component
      const IsEnabledFormatter = React.createClass({
        render() {
          if (this.props.value) return <span className="label label-success"><Translate value="enabled" /></span>;
          return <span className="label label-danger"><Translate value="disable" /></span>;
        },
      });
      // Inventory list pop up table columns

      const showProductCost = () => {
        if (!(isEKC || isLMH || isSDR || isCRW || isSC) && checkPermissionLocal('no_show_product_cost')) {
          return false;
        }
        if ((isEKC || isLMH || isSDR || isCRW || isSC) && checkPermissionLocal('no_show_sales_order_cost')) {
          return false;
        }
        return true;
      };

      const columns = [
        ...isOLG ? [] : [
          {
            key: 'ProductNum',
            name: <Translate value="prod_num" />,
            resizable: true,
            sortable: true,
            width: 100,
            filterable: true,
          }
        ],
        {
          key: 'RefNum',
          name: <Translate value={isOLG ? "item_no" : isVAK ? "sku" : "ref_num"} />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        },
        ...isOLG ? [] : [{
          key: 'Name',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          width: 250,
          filterable: true,
        }],
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: isOLG ? 300 : 200,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        ...isGGI ?[
          {
            key: 'SmallUnitPrice',
            name: <Translate value="small_pr" />,
            resizable: true,
            sortable: true,
            width: 80,
            filterable: true,
            editable: true,
          },
        ]:[],
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 65,
          filterable: true,
          editable: true,
        },
        ...showProductCost() ? [{
          key: 'CostPrice',
          name: <Translate value="product_cost" />,
          resizable: true,
          sortable: true,
          width: 65,
          filterable: true,
          editable: true,
        }] : [],
        {
          key: 'NetWeight',
          name: <Translate value="unit_weight" />,
          resizable: true,
          sortable: true,
          width: 65,
          filterable: true,
          editable: true,
        },
      ];
      if (isLAP && showProductCost()) {
        const costIndex = columns.findIndex(item => item.key === 'CostPrice');
        if (costIndex !== -1) {
          columns.splice(costIndex, 1, {
            key: 'CurrentCost',
            name: <Translate value="product_cost" />,
            resizable: true,
            sortable: true,
            width: 80,
            filterable: true,
            editable: true,
          });
        }
      }
      return (
        <Row>
          <Col xs={12}>
            <div className="react-table-customizer" id="SalesOrderForm-dataGrid4">
              <ReactDataGrid
                columns={columns}
                enableRowSelect={isOLG ? 'multi' : 'single'}
                minHeight={202}
                headerRowHeight={45}
                onGridSort={handleGridSort}
                onRowClick={onRowClick}
                onRowSelect={onRowSelect}
                onRowUpdated={this.handleRowUpdated}
                rowGetter={rowGetter}
                rowHeight={25}
                rowKey="Product_id"
                enableRowSelect="multi"
                rowsCount={getSize()}
                rowSelection={{
                  onRowsDeselected,
                  onRowsSelected,
                  showCheckbox: true,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
              />
            </div>
          </Col>
        </Row>
      );
    }

    renderPaymentInfo() {
      const { paymentInfo, chargeID } = this.state;
      if (!paymentInfo) {
        return (
          <ContentWrapper>
            <label><Translate value="no_payment_record" /></label>
          </ContentWrapper>
        );
      }
      return (
        <MSOPaymentInfoContainer
          info={paymentInfo}
          totalPrice={this.state.totalPrice}
          credit={this.state.creditAmount}
          Billing={this.props.currentSalesOrderDetail.Billing}
          orderID={this.props.params.id}
          openConfirmRefund={this.openConfirmRefund.bind(this)}
        />
      );
    }

    setConvertedMaxStock = (convertedMaxStock) => {
      this.setState({
        convertedMaxStock
      })
    }

    renderAutoSuggest() {
      return (
        <SalesOrderAutoSuggest
          CustomerNumber={this.state.currentCustomer}
          handleFocusQty={this.handleFocusQty}
          setProdNum={this.setProdNum}
          setIsCombo={this.setIsCombo}
          handleKeyPress={this.handleKeyPress}
          onChange={(e, { newValue }) => { this.props.clearSalesOrderFormBatches();
            this.clearInventoryInfo(); this.props.resetFormInputs(); this.setState({ suggestValue: newValue, comboQty: 1 }); }}
          SearchType={this.props.searchType}
          setAllProductQuantity={this.setAllProductQuantity}
          value={this.state.suggestValue}
          Company_id={isGGI ? this.props.Company_id : this.props.selectedCompany && this.props.selectedCompany.value}
          Pickup_Warehouse_id={this.props.Pickup_Warehouse_id}
          color={this.state.smilingColor}
          pkgTp={this.state.pkgTp}
          setConvertedMaxStock={this.setConvertedMaxStock}
          salesShippingCustomerDetails={this.props.salesShippingCustomerDetails || {}}
        />
      );
    }

    getUsers() {
      let Users = [];
      if (isSV) {
        return this.props.users.map((user) => ({
          value: user.user_id,
          label: user.FirstName,
          commission: user.Commission
        }));
      } else {
        this.props.users.map((user) => {
          Users.push({ value: user.user_id, label: user.FirstName + (isVAK ? ' ' + user.LastName + '' : '')});
        });
        return Users;
      }
    }

    getPackers() {
      const Packers = [];
      this.props.packers.map((packer) => {
        Packers.push({ value: packer.id, label: packer.name });
      });
      return Packers;
    }


    ocmRenderPickers() {
      if (this.props.usersIsLoading || (this.props.packersIsLoading && isGGI && isOLG)) return <Spinner />; // If group is loading, show a spinner.
      const Users = this.getUsers();
      const Packers = this.getPackers();
      return (
        <Field name={isOLG ? "Picker" : "Picker_User_id"} component={Selection}
          placeholder={
            isGGI && <span>
              <Translate value="picker" />
              <span className="asteriksReq" >*</span>
            </span>
          }
        options={ (isOLG || isGGI) ? Packers : Users}/>
        );
    };

    // isSV (users) || isOCM (packers)
    ocmRenderPackers() {
      if (this.props.usersIsLoading && isSV ) return <Spinner />; // If group is loading, show a spinner.
      if (this.props.packersIsLoading && isOCM ) return <Spinner />; // If group is loading, show a spinner.

      const Users = this.getUsers();
      const Packers = this.getPackers();
      return (
        <Field name="Packer" component={Selection} options={ (isOCM) ? Packers : Users}/>
      );
    };

    renderUsers() {
      if (this.props.usersIsLoading) return <Spinner />; // If group is loading, show a spinner.
      const Users = this.getUsers();
      return (
        <Field name="Sales_User_id" component={Selection} options={Users}/>
        );
    };

    renderSales = () => {
      const Users = this.getUsers();
      return (
        <div>
          <Field
            name="Sales_User_id"
            matchPos="any"
            component={SelectionWithProps}
            options={this.getUsers()}
            onSelect={ value => {
              if (value) {
                this.setState({ created_by: value.value });
                this.props.setValue('salesOrderForm', 'Commission', value.commission);
              } else {
                this.setState({ created_by: null });
                this.props.setValue('salesOrderForm', 'Commission', null);
              }
            }}
          />
        </div>
      )
    }

    renderDeliveryMethodInfo() {
      if (this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id') {
        return (
          <Col xs={12}>
            <label><Translate value="delivery_method" />:</label>
            <Button
              id="delivery-method-button"
              type="button"
              onClick={this.openDeliveryMethodModal}
            >
              <Translate value="details" />
            </Button>
          </Col>
        );
      }
      return <div style={{ margin: isChinaTown ? '0' : '105px' }} />;
    }

    renderDiscountAmount() {
      if (this.context.router.routes[1].path === 'mobileSalesOrders/:id') {
        const { discount, totalPrice } = this.state;
        const { savings } = this.props;
        /**
         * @discount is greater than 0, if the promo is a 'percent off' type
         * @discount is equal to 0, if the promo is a 'dollar off' type
         */
        const savingsValue = (parseFloat(discount) === 0)
          ? roundTo(parseFloat(savings || 0), 2).toFixed(2)
          : roundTo(parseFloat(totalPrice || 0) * (parseFloat(discount || 0) / 100), 2).toFixed(2);
        return (
          <ContentWrapper>
            <label><Translate value="disc" /><span className="dollar-sign">$</span></label>
              <Input
                type="text"
                value={savingsValue}
                disabled
              />
          </ContentWrapper>
        );
      }
      if (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
        const { SODiscount, SOSavings } = this.state;
        const savingsValue = parseFloat(SODiscount) + "%/" + roundTo(parseFloat(SOSavings || 0), 2).toFixed(2) + "$";
        return (
          <ContentWrapper>
            <label><Translate value="disc" /><span className="dollar-sign">(%/$)</span></label>
            {/* <span onDoubleClick={() => { this.openDiscountModal(); }}> */}
            <div onDoubleClick={() => {
              (isSV || isLMH || isSDR || isCRW || isSC || isSH) ? this.openDiscountModal() : this.openVerifyPasscodeDiscount()
             }} style={{ width: '65px', borderRadius: '3px', padding: '2px 5px', border: '1px solid black', backgroundColor: '#dddddd' }}>
              {/* <Input
                type="text"
                style={{color:(isOLG || isGGI) ? 'blue':'black', fontWeight:'bold'}}
                value={savingsValue}
                disabled
              /> */}
              {savingsValue}
            </div>
          </ContentWrapper>
        );
      }
     }

    handleSelect(yourOrderKey) {
      this.clearInventoryInfo();
      this.setState({
        selectedInventoryRow: {},
        inStock: '',
        inStockWarehouse: '',
        inStockOnhand: '',
        purchased: '',
        presale: '',
        net_weight: '',
        suggestValue: '',
      });
      this.props.resetFormInputs();
      switch (yourOrderKey) {
        case 1:
          this.setState({ yourOrderTableHeight: (window.innerHeight < 930) ? 345 : 345, yourOrderKey });
          break;
        default:
          this.setState({ yourOrderTableHeight: (window.innerHeight < 930) ? 200 : 200, yourOrderKey });
      }
    }

    handleSelect2(inboundInfoKey) {
      // this.clearInventoryInfo();
      // this.setState({
      //   selectedInventoryRow: {},
      //   inStock: '',
      //   purchased: '',
      //   presale: '',
      //   net_weight: '',
      //   suggestValue: '',
      // });
      // this.props.resetFormInputs();
      switch (inboundInfoKey) {
        case 1:
          this.setState({ inboundInfoKey });
          break;
        default:
          this.setState({ inboundInfoKey });
      }
    }

    handleSelect3(fjInfoKey) {
      // this.clearInventoryInfo();
      // this.setState({
      //   selectedInventoryRow: {},
      //   inStock: '',
      //   purchased: '',
      //   presale: '',
      //   net_weight: '',
      //   suggestValue: '',
      // });
      // this.props.resetFormInputs();
      switch (fjInfoKey) {
        case 1:
          this.setState({ fjInfoKey });
          break;
        default:
          this.setState({ fjInfoKey });
      }
    }

    goToNewSales = (newRoute) => {
      this.setState({
        showSOCreatedOpen: false,
        rows: [],
        Billing: {
          AddressName: '',
          Cellphone: '',
          City: '',
          CustomerDetail: '',
          Email: '',
          Fax: '',
          FirstName: '',
          IsDefault: null,
          IsDeleted: null,
          LastName: '',
          Note: '',
          Position: '',
          State: '',
          Telephone: '',
          Type: '',
          Zip: '',
          Notation: '',
        },
      }, () => {
        if (this.props.dispatchDate && this.props.prevEstDate !== this.props.dispatchDate) {
          this.props.keepEstDate({ date: this.props.dispatchDate }, newRoute);
        } else {
          this.props.keepEstDate({ date: this.state.prevEstDate }, newRoute);
        }
      });
    }

    printSI = () => {
      this.props.printSalesOrderSI(this.props.salesOrderCreated.SalesOrder_id);
    }

    textQuote = () => {
      axios
      .post(
        `${ROOT_URL}v1/sale/text_sales_order_by_order_id/${this.props.salesOrderCreated.SalesOrder_id}`,
        // formData,
        null,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              "token"
            )}`,
          },
        },
      )
      .then(
        (res) => {
          alert("Text sent!");
        },
        (err) => {
          if (err.status === 500 || err.status === 404) {
            err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
          }
          alert(JSON.stringify(err.data ? err.data : err));
        }
      );
    }

    fetchPreviousSalesOrderByIndexFromLast() {
      this.props.fetchPreviousSalesOrderByIndexFromLast(this.state.currentCustomer, this.state.salesOrderIndexFromLast);
    }

    fetchPreviousSalesOrderByCustomer(olongFlag) {
      this.props.fetchPreviousSalesOrderByCustomer(this.state.currentCustomer, this.state.fromDate, this.state.toDate, olongFlag);
    }

    fetchPreviousOrdersFromALLSalesOrder() {
      this.props.fetchPreviousOrdersFromALLSalesOrder(this.state.currentCustomer, this.state.fromDate, this.state.toDate);
    }

    fetchPreviousOrderBySearch(SONum) {
      this.props.fetchPreviousOrderBySearch(SONum, isOLG);
    }

    getPreviousSalesOrder() {
      let nextIndex = this.state.salesOrderIndexFromLast - 1;
      if (nextIndex < 1) nextIndex = 1;
      this.setState({
        salesOrderIndexFromLast: nextIndex,
      }, this.fetchPreviousSalesOrderByIndexFromLast);
    }

    getNextSalesOrder() {
      let nextIndex = this.state.salesOrderIndexFromLast + 1;
      this.setState({
        salesOrderIndexFromLast: nextIndex,
      }, this.fetchPreviousSalesOrderByIndexFromLast);
    }

    openVerifyPasscodeToCreaterSO = () => {
      this.setState({
        verifyPasscodeToCreateSOModalOpen: true,
      })
    }

    closeVerifyPasscodeToCreateSO = () => {
      this.setState({
        verifyPasscodeToCreateSOModalOpen: false
      })
    }

    handleVerifypasscodeToCreateSOClose = (confirmed) => {
      this.closeVerifyPasscodeToCreateSO();
      if(confirmed) {
        this.setState({
          customerVerified: true,
        },() => {
          this.moveToSO('move', true, true);
        });
      }
    }

    reFetchSalesCustomers = (submitData) => {
      this.closeShippingInfoEditModal();
      if (isVAK && this.context.router.routes[1].path === 'mobileSalesOrders/:id') {
        return this.reloadThePage();
      }
      const selectedSalesCustomer = this.props.receivingCustomer;
      this.props.setValue('salesOrderForm', 'receivingCustomer', '');
      this.props.fetchCustomers(() => {
        this.props.setValue('salesOrderForm', 'receivingCustomer', selectedSalesCustomer);
        if (submitData && submitData.CustomerNum) {
          this.helpSelect(submitData.CustomerNum);
        }
      })
      const fieldName = (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'outboundOrders/new') ? 'CustomerDetail_id' : 'Deliver_CustomerDetail_id';
      setTimeout(() => {
        if (this.getShippingNameOptions() && this.getShippingNameOptions().length > 0) {
          this.props.setValue('salesOrderForm', fieldName, this.getShippingNameOptions()[this.getShippingNameOptions().length-1].value);
        }
      }, 1500);
    }

    helpSelect = (CustomerNum) => {
      const customerNumOptions = this.getCustomerNumOptions();
      customerNumOptions.map((r,i) => {
        if (r.label === CustomerNum) {
          this.props.setValue('salesOrderForm', 'Deliver_Customer_id', r.value);
          this.props.setValue('salesOrderForm', 'receivingCustomer', r.value);
          this.setState({currentCustomer: r.value});
        }
      });

      // this.props.setValue('salesOrderForm', 'receivingCustomer', selectedSalesCustomer);



    }

    reFetchSalesCustomers2 = () => {
      this.props.setValue('salesOrderForm', 'receivingCustomer', '');
      let Company_id = null;
      // if (isGGI) {
      //   Company_id = this.props.Company_id;
      // }
      this.props.fetchActiveCustomers(Company_id);
    }

    reloadThePage = () => {
      const {
        currentSalesOrder,
      } = this.props;
      let route = '';
      if (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
        route = 'salesOrders';
      } else if (this.context.router.routes[1].path === 'mobileSalesOrders/new' || this.context.router.routes[1].path === 'mobileSalesOrders/:id') {
        route = 'mobileSalesOrders';
      }
      this.setShippingStatsEditModalVisibility();
      this.props.fetchSalesOrderDetail(currentSalesOrder.SalesOrder_id, route);
    }

    handleEditNotesButtonClick = () => {
      this.setNotesModalVisibility(true);
    }

    setNotesModalVisibility = (isNotesModalVisibile = false) => this.setState({ isNotesModalVisibile });
    renderNotesEditButton = () => {
      return (
          <Button
            bsStyle="primary"
            type="button"
            onClick={this.handleEditNotesButtonClick}
          >
            <em className="fa fa-pencil" /> <Translate value="edit_notes" />
          </Button>
      )
    }

    getPanelClassName = () => {
      const prefix = 'sales-order-customer-info-extendedHeight';
      if (isOCM || isSW) { return prefix + '-xlg'; }
      if(isGGI) {return prefix + '-gi'}
      if (isMultiWH) { return prefix + '-lg'; }
      if (isHMM) { return prefix; }
      if (isTN || isTQ || isNBT) { return prefix + '-md'; }
      else { return ''; }
    }

    renderPrintButtons = () => {
      const currentSalesOrder = this.props.currentSalesOrder;
      if (!currentSalesOrder) { return; }
      // const url = `${ROOT_URL}v1/sale/printorder/${currentSalesOrder.SalesOrder_id}?Bearer=${localStorage.getItem('token')}`;
      const isQuote = currentSalesOrder.SaleStatus === 'Quote';
      return (
        <DropdownButton
          bsStyle="warning"
          disabled={isQuote && !isLMH && !isSDR && !isCRW && !isSC}
          title={
            <span>
              <i className="fa fa-print" />
              <Translate value="print" />
            </span>
          }
        >
          <MenuItem onClick={() => {
            this.props.printSalesOrder(this.props.currentSalesOrder.SalesOrder_id);
          }}>
            <Translate value="sales_order" />
          </MenuItem>
          {isSV &&
            <MenuItem onClick={() => {
              this.props.printSalesOrder(this.props.currentSalesOrder.SalesOrder_id, null, true);
            }}>
              <Translate value="back_order" />
            </MenuItem>
          }
          <MenuItem onClick={() => {
              this.props.printPickingList(this.props.currentSalesOrder.SalesOrder_id, false);
            }}>
            <Translate value="picking_list" />
          </MenuItem>
          {isSV &&
            <MenuItem onClick={() => {
              this.props.printPickingList(this.props.currentSalesOrder.SalesOrder_id, true);
            }}>
              <Translate value="picking_list_location" />
            </MenuItem>
          }
          {!isSV &&
            <MenuItem onClick={() => {
                this.props.printPackingList(this.props.currentSalesOrder.SalesOrder_id);
              }}>
              <Translate value="packing_list" />
            </MenuItem>
          }
          {!isSV &&
            <MenuItem onClick={() => {
              this.props.printShippingList(this.props.currentSalesOrder.SalesOrder_id);
            }}>
              <Translate value="shipping_list" />
            </MenuItem>
          }
        </DropdownButton>
      )
    }
    renderVAKCreateButtons = () => {
      const disableCreate = !(this.props.currentSalesOrderDetail != null && ['Open', 'Packing'].includes(this.props.currentSalesOrderDetail.SaleStatus));
      return <Button
        bsStyle="primary"
        type="button"
        disabled={disableCreate}
        onClick={()=>{
          this.handleCreateClick();
        }}
      >
        <i className="fa fa-plus"/>
        <Translate value="create"/>
      </Button>
    }
    renderCreateTransferOrderButtons = () => {
      const {
        currentSalesOrderDetail
      } = this.props;
      if (isMH) return null
      if (currentSalesOrderDetail && (currentSalesOrderDetail.IsRelocation || currentSalesOrderDetail.IsTransfer)) return null;
      if (!isOCM) {
        let shouldDisabled = this.props.currentSalesOrderDetail;
        if (isVAK) {
          if (this.context.router.routes[1].path !== 'salesOrders/new') return null;
          shouldDisabled = this.state.rows.length === 0;
        }
        return (<Button
          bsStyle="success"
          type="button"
          onClick={this.props.handleSubmit((data) => {
            if (isGGI) {
              this.submitPromotionCheck(data, false, true);
              return;
            }
            this.handleFormSubmit(data, false, true)
          })}
          disabled={shouldDisabled} //revert risk high
        >
          <em className="fa fa-save" /><Translate value="create_transfer_order" />
        </Button>)
      }
      return (
        <DropdownButton
          bsStyle="success"
          disabled={currentSalesOrderDetail && (currentSalesOrderDetail.IsRelocation || currentSalesOrderDetail.IsTransfer) && currentSalesOrderDetail.TPONum}
          title={
            <span>
              <i className="fa fa-save" />
              <Translate value="create_transfer_order" />
            </span>
          }
        >
          <MenuItem onClick={this.props.handleSubmit(data => {
              this.handleFormSubmit(data, false, true, { IsRelocation: true });
          })}>
            <Translate value="relocate_same_company" />
          </MenuItem>
          <MenuItem onClick={this.props.handleSubmit(data => {
              this.handleFormSubmit(data, false, true, { IsTransfer: true });
          })}>
            <Translate value="transfer_different_company" />
          </MenuItem>
        </DropdownButton>
      )
    }

    calculateSalesOrderNetWeight = () => {
      const rows = [...this.state.rows];
      let totalNetWeight = rows.reduce((acc, curr) => {
        return acc + (curr.Quantity * curr.NetWeight)
      }, 0);
      if (isSV && totalNetWeight) {
        totalNetWeight = totalNetWeight.toFixed(2);
      }
      return totalNetWeight;
    }

    calculateSalesOrderQty = () => {
      const rows = [...this.state.rows];
      let totalQty = rows.reduce((acc, curr) => {
        return acc + curr.Quantity
      }, 0);
      return totalQty;
    }

    calculateSalesOrderShippingWeight = () => {
      const rows = [...this.state.rows];
      const totalShippingWeight = rows.reduce((acc, curr) => {
        return acc + (curr.Quantity * curr.ShippingWeight)
      }, 0);
      return totalShippingWeight;
    }

    getPackageTypeOptions() {
      let packageTypeOptions = [];
      if (this.props.packageTypesFetched) {
        this.props.packageTypesFetched.map(packageType => {
          packageTypeOptions.push({value: packageType.Simple, label: packageType.Simple})
        })
      }
      return packageTypeOptions;
    }

    checkProductPromotionQualification = () => {
      const byQuantityPromotions = _.filter(this.props.productPromotions, promotion => promotion.Method === "ByQuantity")[0];
      if (byQuantityPromotions && (this.props.quantityValue >= byQuantityPromotions.FromQty)) {
        this.setState({
          appliablePromotions: [byQuantityPromotions],
        }, () => {
          this.setApplyPromotionsModalVisibility(true);
        });
        return true;
      }
      return false;
    }

    handleNotationEnter = (event, clicked) => {
      if (event.charCode === 13 || clicked) {
        const {
          suggestValue,
          selectedInventoryRow,
        } = this.state;
        const {
          totalNeededQty,
        } = this.generateBatchRelatedInfo(this.state.selectedInventoryRow.ProductNum);
        const MaxWeightRange = selectedInventoryRow.MaxWeightRange;
        const MinWeightRange = selectedInventoryRow.MinWeightRange;
        const isOutOfStock = totalNeededQty > this.state.convertedMaxStock;
        // smilinghome want to show warning no matter if its oversaleable
        if (isSH && isOutOfStock && selectedInventoryRow.IsOverSaleable) {
          alert("Item is out of Stock");
        }
        if (isOutOfStock && !selectedInventoryRow.IsOverSaleable && !isHMM) {
          this.setState({
            case: 'itemOutOfStock',
            confirmOpen: true,
            selectedInventoryRow: {},
            inStock: '',
            inStockWarehouse: '',
            inStockOnhand: '',
            purchased: '',
            presale: '',
            net_weight: '',
            suggestValue: '',
          });
          this.props.resetFormInputs();
          return;
        }
        // if (isSUN && (this.props.weight < MinWeightRange || this.props.weight > MaxWeightRange)) {
        //   this.setState({
        //     case: 'notInWeightRange',
        //     confirmOpen: true,
        //   });
        //   return;
        // }
        if (isOCM) {
          const result = this.props.quantityValue / selectedInventoryRow.MultipleQuantityPerOrder;
          if (selectedInventoryRow.MultipleQuantityPerOrder && !Number.isInteger(result)) {
            alert(`Multiple Qty/Order is ${selectedInventoryRow.MultipleQuantityPerOrder}`);
            // return;
          }
          // if (this.checkProductPromotionQualification()) {
          //   // asking user to apply promotion
          //   return;
          // }
        }
        if (isGGI) {
          this.checkConvertProduct();
          return;
        }
        // here to skip select batch
        if (
          isSV || isDAICHEONG || isHO || isJRC || isEKC || isLMH || isSDR ||
          isCRW || isSKH || isCPG || isLAP || isSUN || isOLG || isMH || isTQ ||
          isSV || isSH || isAGD || isVIP || isCCW || isGFD || isSC || isCTP
        ) {
          this.checkMoveToSo();
          this.handleFocusAutoSuggest();
          return;
        }
        this.setMultiBatchModalVisibility(true);
      }
    }

    renderOCMPalletSize = () => {
      if (!isOCM) return null;
      const selectedInventoryRow = this.state.selectedInventoryRow;
      return (
        <Col xs={2} className="pr1" style={{width: '90px'}}>
          <label><Translate value="pallet_size" /></label>
          <Field name="Subtotal" component={DisabledInputField} placeholder={selectedInventoryRow.PalletSize} />
        </Col>
      )
    }

    renderAddBatchButton = () => {
      if (!isOCM) {
        return <Col xs={1} className="pr1" style={{width: '23px'}}>
        <div style={{height: '23px'}}></div>
        <Button
          id="product-add-button"
          bsStyle="success"
          disabled={this.state.selectedInventoryRow.Product_id == null}
          onClick={(e) => {
            this.handleNotationEnter(e, true)
          }}
        >
          +
        </Button>
      </Col>
      }
    }

    renderAddBatchButtonOCM = () => {
      if (isOCM) {
        return <Col xs={1} className="pl1">
        <div style={{height: '17px'}}></div>
        <Button
          id="product-add-button"
          bsStyle="success"
          disabled={this.state.selectedInventoryRow.Product_id == null}
          onClick={(e) => {
            this.handleNotationEnter(e, true)
          }}
        >
          +
        </Button>
      </Col>
      }
    }
    renderInventoryRow = () => {
      if (isOLG || isLAP) {
        return (
          <Row id="inventory-details">
          <Col xs={1}>
            <label className="inventory-label"><Translate value="inventory" />:</label>
          </Col>
          <Col xs={5}>
            <Row>
              <Col xs={4}>
                <label className="col-xs-6 inlineLabel"><Translate value="cmpy_stock" /><span className="colon">:</span></label>
                <span className="col-xs-6 inventory-highlight"> {this.state.inStockCompany}</span>
              </Col>
              <Col xs={4}>
                <label className="col-xs-6 inlineLabel"><Translate value="wh_stock" /><span className="colon">:</span></label>
                <span className="col-xs-6 inventory-highlight"> {this.state.inStock}</span>
              </Col>
              <Col xs={4}>
                <label className="col-xs-7 inlineLabel"><Translate value="purchased" /><span className="colon">:</span></label>
                <span className="col-xs-5 inventory-highlight"> {this.state.purchased}</span>
              </Col>
            </Row>
          </Col>
          <Col xs={6}>
            <Col xs={4}>
              <label className="col-xs-6 inlineLabel"><Translate value="presale" /><span className="colon">:</span></label>
              <span className="col-xs-6 inventory-highlight"> {this.state.presale}</span>
            </Col>
            <Col xs={4}>
              <label className="col-xs-5 inlineLabel"><Translate value="on_hand" /><span className="colon">:</span></label>
              <span className="col-xs-6 inventory-highlight"> {this.state.inStockOnhand}</span>
            </Col>
            <Col xs={4}>
              <label className="col-xs-5 inlineLabel"><Translate value="total_wt" /><span className="colon">:</span></label>
              <span className="col-xs-6 inventory-highlight"> {this.state.total_weight}</span>
            </Col>
          </Col>
        </Row>
        );
      }
      return (
        <Row id="inventory-details">
          <Col xs={1}>
            <label className="inventory-label"><Translate value="inventory" />:</label>
          </Col>
          <Col xs={5}>
            <Row>
              <Col xs={4}>
                <label className="col-xs-6 inlineLabel"><Translate value="in_stock" /><span className="colon">:</span></label>
                <span className="col-xs-6 inventory-highlight"> {this.state.inStock}</span>
              </Col>
              <Col xs={4}>
                <label className="col-xs-7 inlineLabel"><Translate value="purchased" /><span className="colon">:</span></label>
                <span className="col-xs-5 inventory-highlight"> {this.state.purchased}</span>
              </Col>
              <Col xs={4}>
                <label className="col-xs-6 inlineLabel"><Translate value="presale" /><span className="colon">:</span></label>
                <span className="col-xs-6 inventory-highlight"> {this.state.presale}</span>
              </Col>
            </Row>
          </Col>
          <Col xs={6}>
            <Col xs={4}>
              <label className="col-xs-5 inlineLabel"><Translate value="net_wt" /><span className="colon">:</span></label>
              <span className="col-xs-6 inventory-highlight"> {this.state.net_weight}</span>
            </Col>
            <Col xs={4}>
              <label className="col-xs-5 inlineLabel"><Translate value="ship_wt" /><span className="colon">:</span></label>
              <span className="col-xs-6 inventory-highlight"> {this.state.ship_weight}</span>
            </Col>
            <Col xs={4}>
              <label className="col-xs-5 inlineLabel"><Translate value="total_wt" /><span className="colon">:</span></label>
              <span className="col-xs-6 inventory-highlight"> {this.state.total_weight}</span>
            </Col>
          </Col>
        </Row>
      )
    }

    getReviewFunc = () => {
      const { SaleStatus } = this.props.currentSalesOrderDetail || this.props.salesOrderCreated;
      if (SaleStatus === 'Quote') {
        return setQuoteReview
      }
      if (SaleStatus === 'Pending') {
        return setOrderReview
      }
    }
    getApproveFunc = () => {
      const { SaleStatus } = this.props.currentSalesOrderDetail || this.props.salesOrderCreated;
      if (SaleStatus === 'Quote') {
        return setQuoteApproval;
      }
      if (SaleStatus === 'Pending') {
        return setOrderApproval;
      }
    }

    handleOnReviewClick = () => {
      this.setState({
        confirmModalVisibility: true,
        confirmModalCase: 'confirm_review',
        setConfirmCallback: () => {
          this.closeConfirmModal(() => {
            this.handleConfirmReview()
          })
        },
        setRejectCallback: () => {
          this.closeConfirmModal(() => {
            this.handleRejectReview()
          })
        }
      })
    }
    handleOnApproveClick = () => {
      this.setState({
        confirmModalVisibility: true,
        confirmModalCase: 'confirm_approve',
        setConfirmCallback: () => {
          this.closeConfirmModal(() => {
            this.handleConfirmApprove()
          })
        },
        setRejectCallback: () => {
          this.closeConfirmModal(() => {
            this.handleRejectApprove()
          })
        }
      })
    }
    handleConfirmReview = () => {
      const { SalesOrder_id } = this.props.currentSalesOrderDetail || this.props.salesOrderCreated;
      const setReview = this.getReviewFunc();
      setReview(SalesOrder_id, null, 'Confirm', response => {
        this.setState({
          confirmModalVisibility: false,
          alertModalVisibility: true,
          alertModalCase: 'review_success',
          setReviewCallback: null,
          isApproved: response === 'Approved',
          setRecheckCallback: response === 'Approved' ? null : () => {
            this.closeAlertModal(() => {
              this.handleOpenRecheck();
            })
          },
          setApproveCallback: response === 'Approved' ? null : () => {
            this.closeAlertModal(() => {
              this.handleSetApprove();
            })
          }
        })
      })
    }
    handleRejectReview = () => {
      const { SalesOrder_id } = this.props.currentSalesOrderDetail || this.props.salesOrderCreated;
      const setReview = this.getReviewFunc();
      setReview(SalesOrder_id, null, 'Reject', () => {
        this.closeConfirmModal(() => {
          this.setState({
            alertModalVisibility: true,
            alertModalCase: 'reject_review',
            setReviewCallback: null,
            setRecheckCallback: null,
            setApproveCallback: null,
          });
          // this.refreshPage();
        })
      })
    }
    handleConfirmApprove = () => {
      const { SalesOrder_id } = this.props.currentSalesOrderDetail || this.props.salesOrderCreated;
      const setApproval = this.getApproveFunc();
      setApproval(SalesOrder_id, 'Confirm', () => {
        this.setState({
          confirmModalVisibility: false,
          alertModalVisibility: true,
          alertModalCase: 'approve_success',
          isApproved: true,
          setReviewCallback: null,
          setRecheckCallback: null,
          setApproveCallback: null
        });
        // this.refreshPage();
      })
    }
    handleRejectApprove = () => {
      const { SalesOrder_id } = this.props.currentSalesOrderDetail || this.props.salesOrderCreated;
      const setApproval = this.getApproveFunc();
      setApproval(SalesOrder_id, 'Reject', () => {
        this.closeConfirmModal(() => {
          this.setState({
            alertModalVisibility: true,
            alertModalCase: 'reject_approve',
            setReviewCallback: null,
            setRecheckCallback: null,
            setApproveCallback: null,
          });
          // this.refreshPage();
        })
      })
    }
    handleSetReview = (reviewUserId = null) => {
      const { SalesOrder_id } = this.props.currentSalesOrderDetail || this.props.salesOrderCreated;
      const setReview = this.getReviewFunc();
      setReview(SalesOrder_id, reviewUserId, 'Pending', () => {
        this.setState({
          alertModalVisibility: true,
          alertModalCase: 'set_review_success',
          setReviewCallback: null,
          setRecheckCallback: null,
          setApproveCallback: null,
        });
        // this.refreshPage();
      })
    }
    handleSetApprove = () => {
      const { SalesOrder_id, SaleStatus } = this.props.currentSalesOrderDetail || this.props.salesOrderCreated;
      const {reqApproveUserId, approveUserId} = this.props;
      if (SaleStatus === 'Quote' && !reqApproveUserId || SaleStatus === 'Pending' && !approveUserId) {
        this.setState({
          confirmModalVisibility: false,
          setReviewCallback: null,
          setRecheckCallback: null,
          setApproveCallback: null,
        });
        this.refreshPage();
        return;
      }
      const setApproval = this.getApproveFunc();
      setApproval(SalesOrder_id, 'Pending', () => {
        this.setState({
          confirmModalVisibility: false,
          alertModalVisibility: true,
          alertModalCase: 'set_approve_success',
          setReviewCallback: null,
          setRecheckCallback: null,
          setApproveCallback: null,
        });
        // this.refreshPage();
      })
    }

    handleOpenRecheck = () => {
      this.setState({
        confirmModalVisibility: true,
        confirmModalCase: 'set_recheck',
        setConfirmCallback: reviewUser => {
          this.handleCloseRecheck(() => {
            this.handleSetReview(reviewUser.value);
          });
        },
        setRejectCallback: () => {
          this.handleCloseRecheck();
        }
      })
    }
    handleCloseRecheck = (callback = () => {}) => {
      this.setState({
        confirmModalVisibility: false,
        confirmModalCase: 'confirm_review',
        setConfirmCallback: null,
        setRejectCallback: null,
      }, callback)
    }
    closeAlertModal = (callback) => {
      this.setState({
        alertModalVisibility: false,
        isApproved:false,
      }, () => {
        if (callback) {
          callback();
        } else {
          this.refreshPage();
        }
      });
    }
    closeConfirmModal = (callback = () => {}) => {
      this.setState({
        confirmModalVisibility: false,
      }, callback);
    }
    closeCreateModal = (callback = () => {}) => {
      this.setState({
        createModalVisibility: false,
      }, callback);
    }
    closeRelatedComponents = (callback = () => {}) => {
      this.setState({
        relatedComponentsModalVisibility: false,
        relatedComponentsList: {...this.state.relatedComponentsList, rows: [], selectedRows: []},
        doubleClickProductMainId: '',
      }, callback);
    }
    closeNotationModal = (callback = () => {}) => {
      this.setState({
        notationModalVisibility: false,
      }, callback);
    }
    confirmCreateModal = (callback = () => {}) => {
      this.setState({
        createModalVisibility: false,
      }, callback);
      createSO(this.props.params.id);
    }
    renderSetReviewBtn = () => {
      const {SaleStatus} = this.props.currentSalesOrderDetail || this.props.salesOrderCreated;
      const {reqReviewUserId, reviewUserId} = this.props;
      let disabled = false;
      if (SaleStatus === 'Quote' && !reqReviewUserId) {
        disabled = true;
      }
      if (SaleStatus === 'Pending' && (!reviewUserId && !reqReviewUserId)) {
        disabled = true;
      }
      return (
        <Button
          bsStyle="primary"
          className="mr"
          type="button"
          disabled={disabled}
          onClick={() => {
            this.closeShowSOCreated();
            this.handleSetReview();
          }}
        >
          <em className="fa fa-eye"/>
          <Translate value="mfg_set_review"/>
        </Button>
      )
    }
    renderSetRecheckBtn = () => {
      return (
        <Button
          bsStyle="primary"
          className="mr"
          onClick={() => {
            this.closeShowSOCreated();
            this.handleOpenRecheck();
          }}>
          <em className="fa fa-eye" />
          <Translate value="mfg_set_recheck" />
        </Button>
      )
    }
    renderSetApproveBtn = () => {
      const {SaleStatus} = this.props.currentSalesOrderDetail || this.props.salesOrderCreated;
      const {approveUserId, reqApproveUserId} = this.props;
      let disabled = false;
      if (SaleStatus === 'Quote' && !reqApproveUserId) {
        disabled = true;
      }
      if (SaleStatus === 'Pending' && !approveUserId) {
        disabled = true;
      }
      return (
        <Button
          bsStyle="primary"
          className="mr"
          disabled={disabled}
          onClick={() => {
            this.closeShowSOCreated();
            this.handleSetApprove();
          }}
        >
          <em className="fa fa-eye" />
          <Translate value="mfg_set_approve" />
        </Button>
      )
    }
    renderTextQuote = () => {
      // const { SalesOrder_id, SaleStatus } = this.props.currentSalesOrderDetail || this.props.salesOrderCreated;
      const { clickedInvoice } = this.state;
      if (!clickedInvoice) {
          return (
        <Button bsStyle="success" onClick={() => { this.textQuote(); }} type="button" >
          <Translate value="text_quote" />
        </Button>
      )
      }
    }
    renderExtraButtonsOnSaveConfirm = () => {
      const { SalesOrder_id, Req_Review_Status, Req_Approve_Status, Review_Status, Approve_Status, SaleStatus } = this.props.currentSalesOrderDetail || this.props.salesOrderCreated;
      if (SaleStatus === 'Quote') {
        if (SalesOrder_id && Req_Review_Status !== 'Pending' && Req_Review_Status !== 'Confirm') {
          return this.renderSetReviewBtn();
        } else if(SalesOrder_id && Req_Review_Status === 'Confirm' && Req_Approve_Status !== 'Pending' && Req_Approve_Status !== 'Confirm') {
          return (
            <span>
              {this.renderSetRecheckBtn()}
              {this.renderSetApproveBtn()}
            </span>
          )
        }
      }
      if (SaleStatus === 'Pending') {
        if (SalesOrder_id && Review_Status !== 'Pending' && Review_Status !== 'Confirm') {
          return this.renderSetReviewBtn();
        } else if (SalesOrder_id && Review_Status === 'Confirm' && Approve_Status !== 'Pending' && Approve_Status !== 'Confirm') {
          return (
            <span>
              {this.renderSetRecheckBtn()}
              {this.renderSetApproveBtn()}
            </span>
          )
        }
      }
      return;
    }

    renderRollingGate = () => {
      if (isMH) {
        //className="tab-products-table sales-order-freq-products"
        return <Tab eventKey={5} title={'Rolling Gate'}>
          <Row>
            <Col xs={4}>
              <div className="form-group">
                <label className="col-xs-3"><Translate value="dim_w_l" />:</label>
                <div className="col-xs-3">
                  <Field name="gate_w" component={InputField} />
                </div>
                <div className="col-xs-1" style={{ textAlign: 'center' }}>
                  X
                </div>
                <div className="col-xs-3">
                  <Field name="gate_l" component={InputField} />
                </div>
                <div className="col-xs-1" style={{ textAlign: 'center' }}>
                  (in)
                </div>
              </div>
            </Col>
            <Col xs={4}>
              <div className="form-group">
                <label className="col-xs-2"><Translate value="motor" />:</label>
                <div className="col-xs-4">
                  <Field name="gate_motor" component={Selection} options={[{ label: 'Small', value: 'Small' }, { label: 'Large', value: 'Large' }]}/>
                </div>
                <label className="col-xs-1"><Translate value="qty" />:</label>
                <div className="col-xs-4">
                  <Field name="gate_quantity" component={InputField} />
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <div className="form-group">
                <label className="col-xs-3"><Translate value="roller_shutter" />:</label>
                <div className="col-xs-8">
                  <Field name="gate_shutter" component={Selection} options={[{ label: '3 Inch', value: 3 }, { label: '4 Inch', value: 4 }]}/>
                </div>
              </div>
            </Col>
            <Col xs={4}>
              <div className="form-group">
                <label className="col-xs-2"><Translate value="lock" />:</label>
                <div className="col-xs-4">
                  <Field name="gate_lock" component={Selection} options={[{ label: 'Yes', value: true }, { label: 'No', value: false }]}/>
                </div>
                <label className="col-xs-1"><Translate value="qty" />:</label>
                <div className="col-xs-4">
                  <Field name="gate_quantity_lock" component={InputField} disabled={!this.props.gate_lock || !this.props.gate_lock.value} />
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <div className="form-group">
                <label className="col-xs-3"><Translate value="reel" />:</label>
                <div className="col-xs-8">
                  <Field name="gate_reel" component={Selection} options={[{ label: 'Small', value: 'Small' }, { label: 'Large', value: 'Large' }]}/>
                </div>
              </div>
            </Col>
            <Col xs={4}>
              <div className="form-group">
                <label className="col-xs-3"><Translate value="roller_chain" />:</label>
                <div className="col-xs-8">
                  <Field name="gate_roller_chain" component={Selection} options={[{ label: 'Yes', value: true }, { label: 'No', value: false }]}/>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <div className="form-group">
                <label className="col-xs-3"><Translate value="guide_track" />:</label>
                <div className="col-xs-8">
                  <Field name="gate_guide_track" component={Selection} options={[{ label: 'Thin', value: 'Thin' }, { label: 'Thick', value: 'Thick' }]}/>
                </div>
              </div>
            </Col>
            <Col xs={4}>
              <div className="form-group">
                <label className="col-xs-3"><Translate value="whole_door" />:</label>
                <div className="col-xs-8">
                  <Field name="IsWholeDoor" component={Selection} options={[{ label: 'Yes', value: true }, { label: 'No', value: false }]}/>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <div className="form-group">
                <label className="col-xs-3"><Translate value="bottom_beam" />:</label>
                <div className="col-xs-8">
                  <Field name="gate_bottom_beam" component={Selection} options={[{ label: 'Yes', value: true }, { label: 'No', value: false }]}/>
                </div>
              </div>
            </Col>
          </Row>
          {/* <Field name="CPONum" component={InputField} />
          <Field name="Sales_User_id" component={Selection} options={Users}/> */}
          <Row>
            <Col xs={4}>
              <Button
                bsStyle="primary"
                type="button"
                onClick={this.props.handleSubmit(form => {
                  const payload = {
                    customer_id: getObjectValue(this.props.customerChosen),
                    gate_length: parseInt(form.gate_l),
                    gate_width: parseInt(form.gate_w),
                    roller_shutter_size: getObjectValue(form.gate_shutter),
                    reel_size: getObjectValue(form.gate_reel),
                    guide_track: getObjectValue(form.gate_guide_track),
                    bottom_beam: getObjectValue(form.gate_bottom_beam),
                    motor_size: getObjectValue(form.gate_motor),
                    motor_qty: parseInt(form.gate_quantity),
                    lock_qty: parseInt(form.gate_quantity_lock),
                    roller_chain: getObjectValue(form.gate_roller_chain),
                    IsWholeDoor: getObjectValue(form.IsWholeDoor),
                  };
                  const success = (data) => {
                    if (!data.length) {
                      alert('no related parts found');
                      return;
                    }
                    data.forEach(product => {
                      this.setState({
                        selectedInventoryRow: {
                          ...product,
                          isGate: true,
                        },
                        ocmQty: product.Quantity,
                      }, () => {
                        this.moveToSO2();
                      })
                    });
                    alert('Adding gate parts')
                  }
                  this.props.fetchRollingGate(payload, success);
                })}
                style={{ width: '100%' }}
              >
                <Translate value="submit" />
              </Button>
            </Col>
          </Row>
      </Tab>
      }
    }
    render() {
      let dispNetWeight = 0.00;
      let dispQty = 0;
      let dispShippingWeight = 0.00;
      if (this.props.currentSalesOrder && this.props.currentSalesOrder.FinalNetWeight) {
        dispNetWeight = (Number(this.props.currentSalesOrder.FinalNetWeight)).toFixed(2);
      }
      if (!this.props.currentSalesOrder) {
        dispNetWeight = this.calculateSalesOrderNetWeight();
        dispShippingWeight = this.calculateSalesOrderShippingWeight();
      }
      dispQty = this.calculateSalesOrderQty();
      if (this.props.currentSalesOrder && this.props.currentSalesOrder.FinalShippingWeight) {
        dispShippingWeight = (Number(this.props.currentSalesOrder.FinalShippingWeight)).toFixed(2);
      }
      const createDialogInventoryStyle = {
        height: '700px',
        width: '1000px',
        marginLeft: '-28%',
        marginTop: '-20%',
      };
      const createDialogShippingStyle = {
        height: '760px',
        width: window.innerWidth * 4 / 5,
        marginLeft: '-35%',
        marginTop: '-22%',
        top: '60%'
      };
      let maxDate = new Date();
      if (this.props.createTime) {
        maxDate = new Date(this.props.createTime);
      }
      let minDate = new Date();
      if (this.props.orderDate) {
        minDate = new Date(this.props.orderDate);
      }
      let route = null;
      let newRoute = null;
      let breadcrumbTitle = null;
      if(isLAP && this.props.from && this.props.from == 'dashboard') {
        route = '/dashboard';
      } else if (this.context.router.routes[1].path == 'salesOrders/new' || this.context.router.routes[1].path == 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
        route = '/salesOrders';
        if ((isEKC || isLMH || isSDR || isCRW || isSC) && this.state.isSaveToInvoice === true) {
          // route = '/salesInvoice';
          route = '/salesOrders';
        }
        newRoute = '/salesOrders/new';
        breadcrumbTitle = 'sales_orders';
      } else if (this.context.router.routes[1].path == 'mobileSalesOrders/new' || this.context.router.routes[1].path == 'mobileSalesOrders/:id') {
        route = '/mobileSalesOrders';
        newRoute = '/mobilSalesOrders/new';
        breadcrumbTitle = 'mobile_sales_orders';
      }
      const selectInventoryInformation = (<Translate value="select_inventory_information" />);
      const confirmAction = (<Translate value="confirm_action" />);
      const openSalesOrder = (<Translate value="open_sales_order" />);
      const customerSalesHistory = (<Translate value="customer_sales_history" />);
      const existingDetailTitle = (<Translate value="existing_detail" />);
      const salesHistory = (<Translate value="sales_history" />);
      const {
        handleSubmit, submitting, pristine, isEditing, isCreating,
      } = this.props;
      const allInventoryProducts = (<Translate value="all_products" />);
      const customerInformation = (<Translate value="customer_info" />);
      const orderInformation = (<Translate value="order_info" />);
      const generalInformation = (<Translate value="general" />);
      const pickdropInformation = (<Translate value="pickdrop" />);
      const frequentProducts = (<Translate value="frequent_products" />);
      const inboundProducts = (<Translate value="inbound_products" />);
      const previousOrderList = (<Translate value="previous_orders" />);
      const SODetails = (<Translate value={(isWIZ || isJTB || isDSQ || isFJ || isABCFF) ? "details" : "so_details"} />);
      const CheckoutInfo = (<Translate value="payment_info" />);
      const changeTax = (<Translate value="choose_tax_rate" />);
      const changeDiscountTitle = (<Translate value="change_discount_rates" />);
      const changeWeight = (<Translate value="change_ship_weight" />);
      const changeEmployeeNoteTitle = (<Translate value="change_employee_note" />);
      const changeCarrierInfo = (<Translate value="change_carrier_info" />);
      const changeDeliveryFeeTitle = (<Translate value="change_delivery_fee" />);
      const editSOPermission = (<Translate value="permission_for_editing_price_and_quantity" />);
      const confirmRefund = (<Translate value="msg_confirm_refund_order" />);
      const passcodeConfirm = (<Translate value="passcode_confirm" />);
      const favoriteList = (<Translate value="favorites_list" />);
      const ModalHeader = (<Translate value="your_sales_order_has_been_saved" />);
      const expressInvoiceHeader = (<Translate value="sales_order_express_invoice" />);
      const customerNote = (<Translate value="cust" />);
      const employeeNote = (<Translate value="emp" />);
      const routeNote = (<Translate value="route" />);
      const prefilledNote = (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Notation) ? this.props.salesCustomerDetails.Notation : '';
      let activeBreadcrumb = this.state.salesOrderNumber ? 'edit_sales_order' : 'create_sales_order';
      if (isWIZ || isJTB || isDSQ || isFJ || isABCFF) {
        if (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
          activeBreadcrumb = this.state.salesOrderNumber ? 'edit_outbound_order' : 'create_outbound_order';
        } else {
          activeBreadcrumb = this.state.salesOrderNumber ? 'edit_inbound_order' : 'create_inbound_order';
        }
      }
      const currentDate = new Date();
      const tomorrow = currentDate;

      const showProductCost = () => {
        if (!(isEKC || isLMH || isSDR || isCRW || isSC) && checkPermissionLocal('no_show_product_cost')) {
          return false;
        }
        if ((isEKC || isLMH || isSDR || isCRW || isSC) && checkPermissionLocal('no_show_sales_order_cost')) {
          return false;
        }
        return true;
      };

      const jtbReceiveTypeOptions = [
        {label: "Unit", value: "unit"},
        {label: "Container", value: "container"},
      ];

      const jtbReceiveUnitOptions = [
        {label: "pallet", value: "pallet"},
        {label: "box", value: "box"},
        {label: "piece", value: "piece"},
      ];

      const jtbDropshipTypeOptions = [
        {label: "By Weight", value: "weight"},
        {label: "By Piece", value: "piece"},
      ];

      const jtbContainerSizeOptions = [
        {label: "20HQ", value: "20HQ"},
        {label: "40HQ", value: "40HQ"},
      ];

      const jtbOrderTypeOptions = [
        {label: "FBA", value: "FBA"},
        {label: "Drop Shipping", value: "Drop Shipping"},
      ];

      const abcffContainerSizeOptions = [
        {label: "20'", value: "20'"},
        {label: "40'", value: "40'"},
        {label: "40' HC", value: "40' HC"},
        {label: "45'", value: "45'"},
      ];

      const timeOptions = [
        {label: "00:00", value: "00:00"}, {label: "01:00", value: "01:00"},
        {label: "02:00", value: "02:00"}, {label: "03:00", value: "03:00"},
        {label: "04:00", value: "04:00"}, {label: "05:00", value: "05:00"},
        {label: "06:00", value: "06:00"}, {label: "07:00", value: "07:00"},
        {label: "08:00", value: "08:00"}, {label: "09:00", value: "09:00"},
        {label: "10:00", value: "10:00"}, {label: "11:00", value: "11:00"},
        {label: "12:00", value: "12:00"}, {label: "13:00", value: "13:00"},
        {label: "14:00", value: "14:00"}, {label: "15:00", value: "15:00"},
        {label: "16:00", value: "16:00"}, {label: "17:00", value: "17:00"},
        {label: "18:00", value: "18:00"}, {label: "19:00", value: "19:00"},
        {label: "20:00", value: "20:00"}, {label: "21:00", value: "21:00"},
        {label: "22:00", value: "22:00"}, {label: "23:00", value: "23:00"},
      ];

      const channelOptions = [
        {label: "Kohl's B2B", value: "Kohl's B2B"},
        {label: "Belk's B2B", value: "Belk's B2B"},
        {label: "Others", value: "Others"},
      ];
      const shippingMethodOptions = [
        {label: 'Delivery', value: 'Delivery'},
        {label: 'Will Call', value: 'Will Call'},
      ]

      tomorrow.setDate(tomorrow.getDate() + 1);
      const createDialogStyle = {
        width: '600px',
        marginLeft: '-15%',
      };
      let weightDialogStyle = {
        width: '500px',
        height: '550px',
        marginLeft: '-15%',
      };
      const createDiscountDialogStyle = {
        width: '450px',
        height: '200px',
        marginLeft: '-10%'
      }
      const createWeightDialogStyle = {
        width: '500px',
        height: '300px',
        marginLeft: '-10%'
      }
      const createNoteDialogStyle = {
        width: '500px',
        height: '280px',
        marginLeft: '-10%',
        // userSelect: 'none'
      }
      const changeCarrierInfoStyle = {
        width: '500px',
        height: '390px',
        marginLeft: '-10%'
      }
      const changeFBAStyle = {
        width: '500px',
        height: '350px',
        marginLeft: '-10%'
      }
      const ShippingInfoConfirmModalStyle = {
        width: '500px',
        height: '200px',
        marginLeft: '-10%'
      }
      const BatchesModal2Style = {
        width: '600px',
        height: '200px',
        marginLeft: '-10%'
      }
      const MultiBatchStyle ={
        width: '690px',
        height: '500px',
        marginLeft: '-10%'
      }
      const changeDeliveryDialogStyle = {
        width: '450px',
        height: '230px',
        marginLeft: '-10%'
      }
      const createDeliveryModalDialogStyle = {
        width: '500px',
        marginLeft: '-10%'
      }
      const olgBorderStyle = {
        border: '1px solid black',
        paddingLeft: '4px',
        borderRadius:'4px',
      }
      const confirmDialogStyle = {
        width: '500px',
        height: '200px',
        marginLeft: '-15%'
      }
      const componentsDialogStyle = {
        width: '700px',
        height: '415px',
        marginLeft: '-15%'
      }
      const notationModalStyle = {
        width: '500px',
        height: '316px',
        marginLeft: '-15%'
      }
      // currentSalesOrderDetail
      const { Shipping, Billing, ShipTo } = this.state;

      if (this.props.detailIsLoading && !this.props.detailError) return <ContentWrapper><br />...<Translate value="reading_data" /></ContentWrapper>;
      else if (this.props.detailError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>;
      // const finalPrice = (this.state.finalPrice).toFixed(2);
      const { discount, finalPrice, totalPrice, totalCRV, totalTax, taxValue } = this.state;
      const { savings } = this.props;

      let totalTaxWithPromotion = calculateTax(this.state.rows, discount, (parseFloat(taxValue) / 100));
      // let finalPriceWithPromotion = 0;
      if ((isMyumyu || isAFG || isWecom || isAFM || isEcity) && this.props.currentSalesOrder && this.props.currentSalesOrder.SONum && (this.props.currentSalesOrder.SONum.charAt(0) === 'M')) {
        if (this.props.currentSalesOrder && this.props.currentSalesOrder.GrandTotal) {
          this.state.finalPriceWithPromotion = this.props.currentSalesOrder.FinalPrice;
        }
      } else {
        // this.state.finalPriceWithPromotion = calculateSavings(discount, (savings || 0), totalPrice, totalCRV, totalTaxWithPromotion, this.state.delivery);
        // this.state.finalPriceWithPromotion = calculateSavings(discount, (savings || 0), totalPrice, totalCRV, totalTax, this.state.delivery) - this.state.creditAmount;
        if (this.props.currentSalesOrderDetail && this.props.currentSalesOrderDetail.Payment_Information) {
          this.state.finalPriceWithPromotion = calculateSavings(discount, (savings || 0), totalPrice, totalCRV, totalTax, this.state.delivery) - this.state.creditAmount - this.state.shareCreditAmount + (!(isEKC || isLMH || isSDR || isCRW || isSC || isOLG || isVAK) ? this.state.fee : this.state.transFee) + this.state.handlingFee;
        } else if (this.props.currentSalesOrderDetail && !this.props.currentSalesOrderDetail.Payment_Information) {
          // this.state.finalPriceWithPromotion = this.props.currentSalesOrder.GrandTotal - this.state.creditAmount;
          this.state.finalPriceWithPromotion = calculateSavings(discount, (savings || 0), totalPrice, totalCRV, totalTax, this.state.delivery) - this.state.creditAmount - this.state.shareCreditAmount + (!(isEKC || isLMH || isSDR || isCRW || isSC || isOLG || isVAK) ? this.state.fee : this.state.transFee) + this.state.handlingFee;
        }
      }
      if (this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'salesOrders/:id' || this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') {
        if (Number(this.state.SODiscount) > 0) {
          if (isEKC || isLMH || isSDR || isCRW || isSC || isHMM || isSUN || isCPG || isSH) {
            if (!isSH && this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
              totalTaxWithPromotion = 0;
            } else {
              totalTaxWithPromotion = 0;
              this.state.rows.map((row, idxx) => {
                if (row.IsTaxable === true) {
                  totalTaxWithPromotion += ((parseFloat(row.TotalPrice) * (1 - ((this.state.SODiscount ? this.state.SODiscount : 0) / 100)))) * parseFloat(taxValue / 100);
                }
              });
              // totalTaxWithPromotion = (parseFloat(totalPrice) * (1 - (this.state.SODiscount / 100))) * parseFloat(this.state.taxValue / 100);
            }
          } else {
            totalTaxWithPromotion = (totalTax-(totalTax*(Number(this.state.SODiscount)/100)));
          }
          if(isVAK) {
            this.state.finalPriceWithPromotion = Number(totalPrice) - (Number(totalPrice)*(Number(this.state.SODiscount)/100)) + totalTaxWithPromotion + this.state.delivery + this.state.transFee;
          } else {
            this.state.finalPriceWithPromotion = Number(totalPrice) - (Number(totalPrice)*(Number(this.state.SODiscount)/100)) + totalTaxWithPromotion + this.state.delivery;
          }
        } else if (Number(this.state.SODiscount) === 0 && Number(this.state.SOSavings) > 0) {
          if (isEKC || isLMH || isSDR || isCRW || isSC || isHMM || isSUN || isCPG) {
            if (this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
              totalTaxWithPromotion = 0;
            }
          } else {
            totalTaxWithPromotion = totalTax;
          }
          this.state.finalPriceWithPromotion = Number(totalPrice) - Number(this.state.SOSavings) + Number(totalTaxWithPromotion) + Number(this.state.delivery) + (!(isEKC || isOLG || isVAK) ? Number(this.state.fee) : this.state.transFee) + Number(this.state.handlingFee);
        } else {
          if ((isEKC || isLMH || isSDR || isCRW || isSC || isHMM || isSUN || isCPG) && this.props.salesCustomerDetails && this.props.salesCustomerDetails.Reseller) {
            totalTaxWithPromotion = 0;
          } else {
            totalTaxWithPromotion = totalTax;
          }
          this.state.finalPriceWithPromotion = Number(totalPrice) + Number(totalTaxWithPromotion) + this.state.delivery + (!(isEKC || isLMH || isSDR || isCRW || isSC || isOLG || isVAK) ? this.state.fee : this.state.transFee) + this.state.handlingFee;
        }
        totalTaxWithPromotion = roundTo(totalTaxWithPromotion, 2).toFixed(2);

        this.state.finalPriceWithPromotion = Number(this.state.finalPriceWithPromotion).toFixed(2);
        if (isSH && this.state.ccOrigin) {
          let ccFee = roundTo(Number(this.state.finalPriceWithPromotion * this.state.ccOrigin), 2).toFixed(2);
          this.state.finalPriceWithPromotion = Number(this.state.finalPriceWithPromotion) + Number(ccFee);
          this.state.ccFee = ccFee;
        }
      }

      if (this.state && this.state.totalCRV > 0) {
        this.state.finalPriceWithPromotion = parseFloat(this.state.finalPriceWithPromotion) + parseFloat(this.state.totalCRV);
      }

      // if (this.state && this.state.handlingFee > 0) {
      //   this.state.finalPriceWithPromotion = parseFloat(this.state.finalPriceWithPromotion) + parseFloat(this.state.handlingFee);
      // }
      //
      // if (this.state && this.state.transFee > 0) {
      //   this.state.finalPriceWithPromotion = parseFloat(this.state.finalPriceWithPromotion) + parseFloat(this.state.transFee);
      // }

      if (this.state && this.state.finalPriceWithPromotion > 0) {
        this.state.finalPriceWithPromotion = Number(this.state.finalPriceWithPromotion).toFixed(2);
      }
      const isMobile = this.context.router.routes[1].path == 'mobileSalesOrders/new' || this.context.router.routes[1].path == 'mobileSalesOrders/:id';
      if (isVAK && isMobile) {
        if (this.state.ShippingSubtotal > 0) {
          this.state.finalPriceWithPromotion = Number(this.state.finalPriceWithPromotion) + parseFloat(this.state.ShippingSubtotal);
        }
        if (this.state.EstimatedTax > 0) {
          this.state.finalPriceWithPromotion = Number(this.state.finalPriceWithPromotion) + parseFloat(this.state.EstimatedTax);
        }
      }

      let showPickUpAddress = false;
      if (this.props.ShipVia) {
        const ShipVia = this.props.ShipVia.value || this.props.ShipVia;
        if (ShipVia === 'ggiDelivery' || ShipVia === '3rdPartyDelivery') {
          showPickUpAddress = true;
        }
      }

      let weightLabel = <label><Translate value="weight" /></label>;
      let WeightInputComponent = DisabledInputField;
      if(isSH || isSUN || isLAP || isOLG) {
        WeightInputComponent = InputField;
      }

      const { customerRoutes } = this.state;
      let weekArray = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
      let routeArray = customerRoutes.map(c => c.Day);
      const weekClass = weekArray.filter(r => !routeArray.includes(r));
      const {
        isReqReviewer,
        isReqApprover,
        isReviewer,
        isApprover,
        Req_Review_Status,
        Req_Approve_Status,
        Review_Status,
        Approve_Status,
        Req_Review_User_id,
        Req_Approve_User_id,
        Review_User_id,
        Approve_User_id,
        SaleStatus,
      } = this.props.currentSalesOrderDetail || this.props.salesOrderCreated;
      const isQuoteStep = this.context.router.routes[1].path === 'salesOrders/new' ? true : SaleStatus === 'Quote';
      const isPendingStep = SaleStatus === 'Pending';
      const isEzgo = (this.props.selectedCompany || {value: ''}).value == 6

      const renderTotalQty = () => {
        let totalQty = 0;
        this.state.rows.forEach((product) => totalQty += Number(product.Quantity));
        return totalQty;
      }
      const SONumberInput = this.props.currentSalesOrderDetail != null && (this.props.currentSalesOrderDetail.SaleStatus === 'Open' || this.props.currentSalesOrderDetail.SaleStatus === 'Packing')
        ? InputField : DisabledInputField;
      return (
      //---------------
      // Begin HTML
      //---------------
        <ContentWrapper>
          <form autoComplete="off" method="get" action="#" onSubmit={handleSubmit(formProps => {
            this.handleFormSubmit(formProps)
          })} >
            <Breadcrumb style={this.state.crumbStyle}>
              <Breadcrumb.Item>
                <Translate value="sales_management" />
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to={route}><Translate value={(isWIZ || isJTB || isDSQ || isFJ) ? "orders" : "sales_orders"} /></Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item active="true">
                <Translate value={activeBreadcrumb} />
              </Breadcrumb.Item>
            </Breadcrumb>
            <ButtonToolbar id="breadcrumbButtonGroup">
              {(!isSV && !isCPG && !isLMH && !isSDR && !isCRW && !isSC && !isDAICHEONG && !isOLG && !isSH && !isVIP && !isGFD) && this.renderCreateTransferOrderButtons()}
              {
                (isEKC || isLMH || isSDR || isCRW || isSC || isCTP) &&
                <Button
                bsStyle="success"
                type="button"
                onClick={handleSubmit((data) => {
                  if (isGGI) {
                    this.submitPromotionCheck(data, false, false);
                    return;
                  }
                  this.handleFormSubmit(data, false, false, 'invoice');
                  this.setState({
                    isSaveToInvoice: true,
                  });
                })}
                disabled={this.handleSaveDisable() || this.props.salesOrderIsCreating} //revert risk high
                // disabled={((this.state.rows.length === 0) || (this.state.Released) || (this.props.salesOrderIsCreating))}
              >
                <em className="fa fa-save" /><Translate value="save_to_invoice" />
              </Button>
              }
              {isVAK && !this.props.currentSalesOrderDetail && <Button
                bsStyle="success"
                type="button"
                onClick={handleSubmit((data) => {
                  this.handleFormSubmit(data, true, false);
                })}
                disabled={this.handleSaveDisable() || this.props.salesOrderIsCreating} //revert risk high
                // disabled={((this.state.rows.length === 0) || (this.state.Released) || (this.props.salesOrderIsCreating))}
              >
                <em className="fa fa-save" /><Translate value={"save_to_quote"} />
              </Button>}
              <Button
                bsStyle="primary"
                type="button"
                onClick={handleSubmit((data) => {
                  if (isGGI) {
                    // if ((this.state.overdueCredit || this.state.overdueCredit === 0) && (Number(this.state.finalPriceWithPromotion) > Number(this.state.overdueCredit))) {
                    if (this.state.overdueActivate && !this.state.alreadyCheckedPasscode && (this.state.overdueCredit || this.state.overdueCredit === 0) &&(Number(this.state.finalPriceWithPromotion) > Number(this.state.overdueCredit))) {
                      this.submitOverdueCheck(data);
                    } else {
                    this.submitPromotionCheck(data, false, false);
                    }
                    return;
                  }
                  this.handleFormSubmit(data, false, false);
                  this.setState({
                    isSaveToInvoice: false,
                  });
                })}
                disabled={this.handleSaveDisable() || this.props.salesOrderIsCreating} //revert risk high
                // disabled={((this.state.rows.length === 0) || (this.state.Released) || (this.props.salesOrderIsCreating))}
              >
                <em className="fa fa-save" /><Translate value={(isEKC || isLMH || isSDR || isCTP) ? "save_to_quote" : "save"} />
              </Button>
              {
                isVAK && isQuoteStep &&
                <Button
                  bsStyle="primary"
                  type="button"
                  disabled={!(isReqReviewer && Req_Review_Status === 'Pending' && checkPermission('req_review_sales_order'))}
                  onClick={this.handleOnReviewClick}
                >
                  <i className="fa fa-eye"/>
                  <Translate value="mfg_review"/>
                </Button>
              }
              {
                isVAK && isQuoteStep &&
                <Button
                  bsStyle="primary"
                  type="button"
                  disabled={!(isReqApprover && Req_Approve_Status === 'Pending' && checkPermission('req_approve_sales_order'))}
                  onClick={this.handleOnApproveClick}
                >
                  <i className="fa fa-eye"/>
                  <Translate value="approval"/>
                </Button>
              }
              {
                isVAK && isPendingStep &&
                <Button
                  bsStyle="primary"
                  type="button"
                  disabled={!(isReviewer && Review_Status === 'Pending' && checkPermission('review_sales_order'))}
                  onClick={this.handleOnReviewClick}
                >
                  <i className="fa fa-eye"/>
                  <Translate value="mfg_review"/>
                </Button>
              }
              {
                isVAK && isPendingStep &&
                <Button
                  bsStyle="primary"
                  type="button"
                  disabled={!(isApprover && Approve_Status === 'Pending' && checkPermission('approve_sales_order'))}
                  onClick={this.handleOnApproveClick}
                >
                  <i className="fa fa-eye"/>
                  <Translate value="approval"/>
                </Button>
              }
              {
                (!isABCFF) &&
                <Button
                  bsStyle="primary"
                  type="button"
                  onClick={this.openHistory}
                  disabled={(this.state.currentCustomer === null)}
                >
                  <Translate value="customer_sales_history" />
                </Button>
              }
              <Button
                bsStyle="primary"
                type="button"
                onClick={() => this.setPromotionsModalVisibility(true)}
                // disabled={(this.state.currentCustomer === null)}
              >
                <Translate value="promotions" />
              </Button>
              {/* this.renderEditSOPermission() */}
              {isABC && this.renderShippingStatsEdit()}
              {(!isFJ && !isJTB && !isESC && !isABCFF) && this.renderExpressInvoice()}
              {(isFJ && this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') && this.renderExpressInvoice()}
              {(!isWIZ && !isABCFF && !isSH) && this.renderDropshipButton()}
              {isVAK && this.renderVAKCreateButtons()}
              {/* {isWIZ && this.renderCreateBOLButton()} */}
              {this.renderPrintButtons()}
              {/* {this.renderPrint()}
              {this.renderPrintPL()}
              {this.renderPrintPaL()}
              {this.renderPrintSL()} */}
              <Button
                bsStyle="danger"
                type="button"
                onClick={() => { this.context.router.push(route); }}
              >
                <em className="fa fa-close" />
                <Translate value="cancel" />
              </Button>
            </ButtonToolbar>
            <Grid id="sales-order-form">
              {/* Row Wrapper */}
              <Row>
                <Col xs={10}>
                  {/* Customer Information */}
                  { !(isDSQ || isWIZ || isFJ || isJTB || isMAG || isABCFF) &&
                  <Row>
                    {this.customerHeader()}
                    <fieldset
                      className={`form-horizontal ${this.state.isCustomerInformationPanelFolded ? 'folded' : ''}`}
                      style={{minHeight: '250px', maxHeight: '280px'}}
                    >
                      <Panel
                        id={isVAK ? "vak-sales-order-customer-info" : `sales-order-customer-info${isOLG ? ' olg-customer-name-scroll' : ''}`}
                        className={ this.getPanelClassName() }
                      >
                        <Row>
                          <Col xs={6}>
                            {/* Customer Details */}
                            {!isABC && this.renderCustomerDetail()}
                            {isABC && this.renderCustomerDetailABC()}

                            {/* Billing Information */}
                            {
                              !isTN &&
                              <Col xs={5} id="billing-info">
                                <h4><Translate value="billing_information" /></h4>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="contact" /></label>
                                  {!Billing && <label className="col-xs-9"><Translate value="please_select_a_customer" /> </label>}
                                  {Billing &&
                                  <div className="col-xs-9" style={{paddingLeft: '3px'}}>
                                    {Billing.FirstName} {Billing.LastName}
                                  </div> }
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="phone" /></label>
                                  {Billing &&
                                  <div className="col-xs-9" style={{paddingLeft: '3px'}}>
                                    {(isSV && Billing.Telephone && Billing.Telephone.length === 10) ? Billing.Telephone.substring(0,3) + "-" + Billing.Telephone.substring(3,6) + "-" + Billing.Telephone.substring(6,11) : Billing.Telephone}
                                  </div> }
                                </div>
                                <div className="form-group mb0">
                                  <label className="col-xs-3"><Translate value="address" /></label>
                                  {Billing &&
                                  <div className="col-xs-9" style={{paddingLeft: '3px'}}>
                                    <div>{Billing.Street}</div>
                                    <div>
                                      {Billing.City}{ Billing.City ? ',' : null } {Billing.State} {Billing.Zip}
                                    </div>
                                  </div>}
                                </div>
                                {isVAK && !isMobile && isEzgo &&
                                <div className="form-group mb0 row-top30">
                                  <label className="col-xs-3"><Translate value="prepay" />:</label>
                                  <Col xs={8}>
                                    <Field name="Is_Prepay" component={Checkbox} />
                                  </Col>
                                </div>
                                }
                                {isVAK && !isMobile && isEzgo &&
                                <div className="form-group mb0">
                                  <label className="col-xs-5"><Translate value="sync_to_QB" />:</label>
                                  <Col xs={7}>
                                    <Field name="Is_SynQB" component={Checkbox}/>
                                  </Col>
                                </div>
                                }
                                {isSKH && <div className="form-group mb0">
                                  <label className="col-xs-3"><Translate value="ao" /></label>
                                  <div className="col-xs-9" style={{paddingLeft: '3px'}}>
                                    {(this.props.currentSalesOrderDetail || {AppointNum:''}).AppointNum}
                                  </div>
                                </div>}
                                {isSKH && <div className="form-group mb0">
                                  <label className="col-xs-3"><Translate value="scac" /></label>
                                  <div className="col-xs-9" style={{paddingLeft: '3px'}}>
                                    {(this.props.currentSalesOrderDetail || {CarrierCode:''}).CarrierCode}
                                  </div>
                                </div>}
                                {isSKH && <div className="form-group mb0">
                                  <label className="col-xs-3"><Translate value="Transfer" /></label>
                                  <div className="col-xs-9" style={{paddingLeft: '3px'}}>
                                    {(this.props.currentSalesOrderDetail || {TransMethod:''}).TransMethod}
                                  </div>
                                </div>}
                                {
                                  showPickUpAddress && (
                                    <div className="form-group">
                                      <label className="col-xs-12" id="pickup-address"><Translate value="pick_up_address" />:</label>
                                      <textarea
                                        style={{
                                          minHeight: '80px',
                                          marginLeft: '5px',
                                          marginTOP: '5px',
                                          display: 'absolute',
                                          borderRadius: '5px',
                                          padding: '4px',
                                          border: '1px solid black',
                                        }}
                                        value={this.state.PickAddress}
                                        onChange={({ target }) => this.setState({ PickAddress: target.value })}
                                      />
                                    </div>
                                  )
                                }
                              </Col>
                            }
                            {
                              isTN &&
                              <Col xs={5} id="billing-info-tn">
                                <h4><Translate value="order_information" /></h4>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="cpo_num" /></label>
                                  <div className="col-xs-8">
                                    <Field name="PONum" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value={isOLG ? "item_no" : "ref_num"} /></label>
                                  <div className="col-xs-8">
                                    <Field name="RefNum" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="order_type" /></label>
                                  <div className="col-xs-8">
                                    <Field name="Type" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="client" /></label>
                                  <div className="col-xs-8">
                                    <Field name="ClientCustName" component={InputField} />
                                  </div>
                                </div>
                              </Col>
                            }
                            {/* End Billing Information */}
                          </Col>
                          <Col xs={6}>
                            {!isABC && this.renderShippingAddressSelections()}
                            {isABC && this.renderShippingAddressSelectionsABC()}
                            {/* Sales Order Dates */}
                            <Col xs={6} id="so-dates">
                              <h4><Translate value={(isWIZ || isJTB || isDSQ || isFJ || isABCFF) ? "order_dates" : "sales_order_dates"} /></h4>
                              <div className="form-group">
                                <label className="col-xs-4"><Translate value="ordered" /></label>
                                <div className="col-xs-8">
                                  <Field name="OrderDate" selected={this.state.prevOrderDate} component={DatePicker} />
                                </div>
                              </div>
                              {
                                (!isUSPride && !isDSQ && !isWIZ && !isFJ && !isJTB && !isLE && !isSV && !isABCFF) && (
                                  <div className="form-group" style={{backgroundColor: isChinaTown ? '#FFECB3' : 'inherit', display: 'flex', alignItems: 'center'}}>
                                    {!(isTN || isLAP) && <label className="col-xs-4" style={{color: isChinaTown ? 'red' : 'black'}}><Translate value="est_delivery" /></label>}
                                    {isTN && <label className="col-xs-4"><Translate value="ship_date" /></label>}
                                    {isLAP && <label className="col-xs-4">ETD</label>}
                                    <div className="col-xs-8">
                                      <Field name="DispatchDate" selected={this.state.prevEstDate} component={DatePicker} />
                                    </div>
                                  </div>
                                )
                              }
                              {
                                false && (
                                  <div className="form-group" style={{backgroundColor: isChinaTown ? '#FFECB3' : 'inherit', display: 'flex', alignItems: 'center'}}>
                                    <label className="col-xs-4" style={{color: 'black'}}><Translate value="etd" /></label>
                                    <div className="col-xs-8">
                                      <Field name="ETDate" component={DatePicker} selected={this.state.ETDate} />
                                    </div>
                                  </div>
                                )
                              }
                              {
                                isLE && (
                                  <div className="form-group" style={{backgroundColor: isChinaTown ? '#FFECB3' : 'inherit', display: 'flex', alignItems: 'center'}}>
                                    <label className="col-xs-4" style={{color: isChinaTown ? 'red' : 'black'}}><Translate value="est_delivery" /></label>
                                    <div className="col-xs-8">
                                      <Field name="DispatchDate" selected={this.state.prevEstDate} component={DatePicker} className={weekClass} />
                                    </div>
                                  </div>
                                )
                              }
                              {
                                isLAP && (
                                  <div className="form-group" style={{backgroundColor: 'inherit', display: 'flex', alignItems: 'center'}}>
                                    <label className="col-xs-4"><Translate value="shipping" /></label>
                                    <div id="customer-name-dropdown" className="col-xs-8">
                                      <Field name="ShippingMethod" component={Selection} options={shippingMethodOptions} />
                                    </div>
                                  </div>
                                )
                              }
                              {
                                (isMultiWH && !isLE && !isSV && !isLAP) && (
                                  <div className="form-group" style={{backgroundColor: 'inherit', display: 'flex', alignItems: 'center'}}>
                                    <label className="col-xs-4"><Translate value="ship_start" /></label>
                                    <div id="customer-name-dropdown" className="col-xs-8">
                                      <Field name="DispatchStartTime" component={Selection} options={timeOptions} />
                                    </div>
                                  </div>
                                )
                              }
                              {
                                (isMultiWH && !isLE && !isSV && !isLAP) && (
                                  <div className="form-group" style={{backgroundColor: 'inherit', display: 'flex', alignItems: 'center'}}>
                                    <label className="col-xs-4"><Translate value="ship_end" /></label>
                                    <div id="customer-name-dropdown" className="col-xs-8">
                                      <Field name="DispatchEndTime" component={Selection} options={timeOptions}/>
                                    </div>
                                  </div>
                                )
                              }
                              {
                                isVAK &&
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="tracking_num"/></label>
                                  <div className="col-xs-8">
                                    <Field name="delivery_tracking_num" className="PONum-no-highlight" component={InputField} />
                                  </div>
                                </div>
                              }
                              {
                                (!isLE && !isSKH) &&
                                <div className="form-group" style={{backgroundColor: 'inherit', display: 'flex', alignItems: 'center'}}>
                                  <label className="col-xs-4"><Translate value="picker" /></label>
                                  <div className="col-xs-8">
                                    {this.ocmRenderPickers()}
                                  </div>
                                </div>
                              }
                              {
                                isSV || isOCM &&
                                 <div className="form-group" style={{backgroundColor: 'inherit', display: 'flex', alignItems: 'center'}}>
                                   <label className="col-xs-4"><Translate value="packer" /></label>
                                   <div className="col-xs-8">
                                     {this.ocmRenderPackers()}
                                   </div>
                                 </div>
                              }
                              {
                                isSKH &&
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="channel" /></label>
                                    <div className="col-xs-8">
                                      <Field name="Channel" component={Selection} options={channelOptions} />
                                    </div>
                                </div>
                              }
                              {
                                !isLE &&
                                <div className="form-group">
                                  <label className="col-xs-4">CPO</label>
                                  <div className="col-xs-8">
                                    <Field name="PONum" className="PONum-no-highlight" component={InputField} />
                                  </div>
                                </div>
                              }
                              {(isSV || isSW) &&
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="ship_date" /></label>
                                  <div className="col-xs-7">
                                  <Field name="ShipDate" selected={this.state.prevOrderDate} component={DatePicker} />
                                  </div>
                                </div>
                              }
                              { isSV &&
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="cancel_date" /></label>
                                  <div className="col-xs-7">
                                  <Field name="CancelDate" component={DatePicker} />
                                  </div>
                                </div>
                              }
                              {
                                (isFung) && (
                                  <div className="form-group" style={{backgroundColor: isChinaTown ? '#FFECB3' : 'inherit', display: 'flex', alignItems: 'center'}}>
                                    <label className="col-xs-4"><Translate value="po_num" /></label>
                                    <div className="col-xs-8">
                                      <Field name="PONum" className="PONum-no-highlight" component={ InputField }/>
                                    </div>
                                  </div>
                                )
                              }
                              {
                                (isTN || isUSPride) &&
                                  <div className="form-group">
                                    <label className="col-xs-4"><Translate value="ship_by" /></label>
                                    <div className="col-xs-8">
                                      <Field name="ShipByDate" selected={this.state.prevEstDate} component={DatePicker} />
                                    </div>
                                  </div>
                              }
                              {
                                isDHC &&
                                  <div className="form-group">
                                    <label className="col-xs-4"><Translate value="seller" /></label>
                                    <div className="col-xs-8">
                                      {this.renderUsers()}
                                    </div>
                                  </div>
                              }
                              {
                                isBobaLife &&
                                  <div className="form-group">
                                    <label className="col-xs-4"><Translate value="is_no_reduce" /></label>
                                    <Field name="IsNoReduce" disabled={this.props.currentSalesOrder} checked={this.state.IsNoReduce} component={CheckboxFormatter} handleOnClick={() => { this.setState({IsNoReduce : !this.state.IsNoReduce})}}/>
                                  </div>
                              }
                              {
                                isChinaTown &&
                                  <div className="form-group">
                                    <label className="col-xs-4"><Translate value="shipping_method" /></label>
                                    <Field name="ShippingMethod" component={PickShippingMethod}/>
                                  </div>
                              }
                              {/* {
                                isTQ &&
                                <div>
                                  <div className="form-group">
                                    <label className="col-xs-3"><Translate value="company" /></label>
                                    <div className="col-xs-9">
                                      <Field
                                        name="Company_id"
                                        component={Selection}
                                        options={this.state.companyOptions}/>
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-3"><Translate value="cust_po" /></label>
                                    <div className="col-xs-9">
                                      <Field className="PONum-no-highlight" name="PONum" component={InputField} />
                                    </div>
                                  </div>
                                </div>
                              } */}
                              {isABC && this.renderNotesEditButton()}
                            </Col> {/* End Sales Order Dates */}
                          </Col>
                        </Row> {/* Customer Details */}
                      </Panel>
                    </fieldset>
                  </Row>
                }
                { (isDSQ || isWIZ || isFJ || isJTB || isMAG || isABCFF) &&
                  <Row>
                    { !isMAG && this.inboundInformationHeader()}
                    { isMAG && <h2><Translate value="order_information" /></h2>}
                    <fieldset className="form-horizontal">
                    <Tabs activeKey={this.state.inboundInfoKey} justified onSelect={this.handleSelect2}>
                      <Tab eventKey={1} title={customerInformation} >
                        <Row style={{minHeight: '150px'}}>
                          <Col xs={6} style={{minHeight: '150px'}}>
                            {/* Customer Details */}
                            {!isABC && this.renderCustomerDetail()}
                            {isABC && this.renderCustomerDetailABC()}
                            {/* Billing Information */}
                            {
                              !isTN &&
                              <Col xs={5} id="billing-info">
                                <h4><Translate value="billing_information" /></h4>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="contact" /></label>
                                  {!Billing && <label className="col-xs-9"><Translate value="please_select_a_customer" /> </label>}
                                  {Billing &&
                                  <div className="col-xs-9">
                                    {Billing.FirstName}{Billing.LastName}
                                  </div> }
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="phone" /></label>
                                  {
                                    Billing &&
                                    <div className="col-xs-9">
                                      {Billing.Telephone}
                                    </div>
                                  }
                                </div>
                                <div className="form-group mb0">
                                  <label className="col-xs-3"><Translate value="address" /></label>
                                  {
                                    Billing &&
                                    <div className="col-xs-9">
                                      <div>{Billing.Street}</div>
                                      <div>
                                        {Billing.City}{ Billing.City ? ',' : null } {Billing.State} {Billing.Zip}
                                      </div>
                                    </div>
                                  }
                                </div>
                              </Col>
                            }
                            {/* End Billing Information */}
                          </Col>
                          <Col xs={6}>
                            {!isABC && this.renderShippingAddressSelections()}
                            {isABC && this.renderShippingAddressSelectionsABC()}
                            {/* Sales Order Dates */}
                            <Col xs={6} id="so-dates">
                              <h4><Translate value={(isWIZ || isJTB || isDSQ || isFJ || isABCFF) ? "order_dates" : "sales_order_dates"} /></h4>
                              <div className="form-group">
                                <label className="col-xs-4"><Translate value="ordered" /></label>
                                <div className="col-xs-8">
                                  <Field name="OrderDate" selected={this.state.prevEstDate} component={DatePicker} />
                                </div>
                              </div>
                              {
                                (!isUSPride && !isDSQ && !isWIZ && !isFJ && !isJTB && !isABCFF) && (
                                  <div className="form-group">
                                    {!isTN && <label className="col-xs-4"><Translate value="est_delivery" /></label>}
                                    {isTN && <label className="col-xs-4"><Translate value="ship_date" /></label>}
                                    <div className="col-xs-8">
                                      <Field name="DispatchDate" selected={this.state.prevEstDate} component={DatePicker} />
                                    </div>
                                  </div>
                                )
                              }
                              {isABC && this.renderNotesEditButton()}
                              {
                                (isTN || isUSPride) &&
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="ship_by" /></label>
                                  <div className="col-xs-8">
                                    <Field name="ShipByDate" selected={this.state.prevEstDate} component={DatePicker} />
                                  </div>
                                </div>
                              }
                              {
                                isDHC && <div className="form-group">
                                  <label className="col-xs-4"><Translate value="seller" /></label>
                                  <div className="col-xs-8">
                                    {this.renderUsers()}
                                  </div>
                                </div>
                              }
                              {
                                isBobaLife &&
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="is_no_reduce" /></label>
                                  <Field
                                    name="IsNoReduce"
                                    disabled={this.props.currentSalesOrder}
                                    checked={this.state.IsNoReduce}
                                    component={CheckboxFormatter}
                                    handleOnClick={() => { this.setState({IsNoReduce : !this.state.IsNoReduce})}}
                                  />
                                </div>
                              }
                            </Col> {/* End Sales Order Dates */}
                          </Col>
                        </Row> {/* Customer Details */}
                        {/* </Panel> */}
                      </Tab>
                        {
                          (isMAG && false) &&
                          <Tab eventKey={2} title={("Container Info")} >
                            <Row>
                              <Col xs={6}>
                                <Col xs={5}>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="container_num" /></label>
                                  <div className="col-xs-7">
                                    <Field name="cntrNum" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="bol_num" /></label>
                                  <div className="col-xs-7">
                                    <Field name="bolNum" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="shipping_line" /></label>
                                  <div className="col-xs-7">
                                    <Field name="shipping_line" component={InputField} />
                                  </div>
                                </div>
                                {/* <div className="form-group">
                                  <label className="col-xs-5"><Translate value="appointment_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="AppointmentDate" component={DatePicker} />
                                  </div>
                                </div> */}
                                </Col>
                                <Col xs={6} style={{paddingLeft: '50px'}}>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="container_size" /></label>
                                  <div className="col-xs-7">
                                    <Field name="size" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="cargo_weight" /></label>
                                  <div className="col-xs-7">
                                    <Field name="cargo_weight" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="terminal" /></label>
                                  <div className="col-xs-7">
                                    <Field name="terminal" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="note" /></label>
                                  <div className="col-xs-7">
                                    <Field name="mag_note" component={InputField} />
                                  </div>
                                </div>

                                </Col>
                              </Col>
                              <Col xs={6}>
                              <Col xs={5}>
                                {/* <div className="form-group">
                                  <label className="col-xs-5"><Translate value="return_empty" /></label>
                                    <div className="col-xs-7">
                                      <Field name="IsReturnEmpty" component={Checkbox} />
                                    </div>
                                </div> */}
                              </Col>
                              <Col xs={6} style={{paddingLeft: '50px'}}>
                                {/* <div className="form-group">
                                  <label className="col-xs-5"><Translate value="storage_out" /></label>
                                  <div className="col-xs-7">
                                    <Field name="StorageOutDate" component={DatePicker} />
                                  </div>
                                </div> */}
                              </Col>
                              </Col>
                            </Row>
                          </Tab>
                        }

                        {/* DRIVER_NAME1 =  models.CharField(max_length=50,null=True, blank=True)
                        MOVING_DATE1 = models.DateTimeField(null=True, blank=True)
                        TYPE_OF_MOVE1 = models.CharField(max_length=20,null=True, blank=True)
                        MOVING_FROM1 = models.CharField(max_length=200,null=True, blank=True)
                        MOVING_TO1 = models.CharField(max_length=200,null=True, blank=True) */}
                        {/* {
                          isMAG &&
                          <Tab eventKey={3} title={("Move Info")} >
                            <Row>
                            <Col xs={2} style={{textAlign: 'right'}}>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="driver" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DRIVER_NAME1" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="driver" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DRIVER_NAME2" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="driver" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DRIVER_NAME3" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="driver" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DRIVER_NAME4" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="driver" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DRIVER_NAME5" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="driver" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DRIVER_NAME6" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="driver" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DRIVER_NAME7" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="driver" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DRIVER_NAME8" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="driver" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DRIVER_NAME9" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="driver" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DRIVER_NAME10" component={InputField} />
                                  </div>
                                </div>
                                </Col>
                                <Col xs={2} style={{textAlign: 'right'}}>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="MOVING_DATE1" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="MOVING_DATE2" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="MOVING_DATE3" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="MOVING_DATE4" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="MOVING_DATE5" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="MOVING_DATE6" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="MOVING_DATE7" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="MOVING_DATE8" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="MOVING_DATE9" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="MOVING_DATE10" component={InputField} />
                                  </div>
                                </div>
                                </Col>

                                <Col xs={2} style={{textAlign: 'right'}}>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_type" /></label>
                                  <div className="col-xs-7">
                                    <Field name="TYPE_OF_MOVE1" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_type" /></label>
                                  <div className="col-xs-7">
                                    <Field name="TYPE_OF_MOVE2" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_type" /></label>
                                  <div className="col-xs-7">
                                    <Field name="TYPE_OF_MOVE3" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_type" /></label>
                                  <div className="col-xs-7">
                                    <Field name="TYPE_OF_MOVE4" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_type" /></label>
                                  <div className="col-xs-7">
                                    <Field name="TYPE_OF_MOVE5" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_type" /></label>
                                  <div className="col-xs-7">
                                    <Field name="TYPE_OF_MOVE6" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_type" /></label>
                                  <div className="col-xs-7">
                                    <Field name="TYPE_OF_MOVE7" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_type" /></label>
                                  <div className="col-xs-7">
                                    <Field name="TYPE_OF_MOVE8" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_type" /></label>
                                  <div className="col-xs-7">
                                    <Field name="TYPE_OF_MOVE9" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="move_type" /></label>
                                  <div className="col-xs-7">
                                    <Field name="TYPE_OF_MOVE10" component={InputField} />
                                  </div>
                                </div>
                                </Col>
                                <Col xs={3} style={{textAlign: 'right'}}>
                              <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_from" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_FROM1" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_from" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_FROM2" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_from" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_FROM3" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_from" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_FROM4" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_from" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_FROM5" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_from" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_FROM6" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_from" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_FROM7" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_from" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_FROM8" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_from" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_FROM9" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_from" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_FROM10" component={InputField} />
                                  </div>
                                </div>
                              </Col>
                              <Col xs={3} style={{textAlign: 'right'}}>
                              <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_to" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_TO1" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_to" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_TO2" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_to" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_TO3" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_to" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_TO4" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_to" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_TO5" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_to" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_TO6" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_to" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_TO7" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_to" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_TO8" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_to" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_TO9" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-4"><Translate value="move_to" /></label>
                                  <div className="col-xs-8">
                                    <Field name="MOVING_TO10" component={InputField} />
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </Tab>
                        } */}

                        {
                          isDSQ &&
                          <Tab eventKey={2} title={orderInformation} >
                            <Row>
                              <Col xs={6}>
                                <Col xs={5}>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="DSQ_ID" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DSQID" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="appointment_time" /></label>
                                  <div className="col-xs-7">
                                    <Field name="Appointment" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="appointment_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="AppointmentDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-xs-5"><Translate value="isa_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ISANum" component={InputField} />
                                    </div>
                                  </div>
                                {/* <div className="form-group">
                                  <label className="col-xs-5"><Translate value="order_pallet_qty" /></label>
                                  <div className="col-xs-7">
                                    <Field name="OrderPalletQty" component={InputField} />
                                  </div>
                                </div> */}
                                </Col>
                                <Col xs={6} style={{paddingLeft: '50px'}}>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ContainerNum" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="carrier" /></label>
                                    <div className="col-xs-7">
                                      <Field name="Carrier" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="destination" /></label>
                                    <div className="col-xs-7">
                                      <Field name="DeliverTo" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="port" /></label>
                                    <div className="col-xs-7">
                                      <Field name="Port" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="LF_Date" /></label>
                                    <div className="col-xs-7">
                                      <Field name="LFDate" component={DatePicker} />
                                    </div>
                                  </div>
                                  {/* <div className="form-group">
                                    <label className="col-xs-5"><Translate value="trailer_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="TrailerNum" component={InputField} />
                                    </div>
                                  </div> */}
                                </Col>
                              </Col>
                              <Col xs={6}>
                                <Col xs={5}>
                                <div className="form-group">
                                    <label className="col-xs-5"><Translate value="total_pallets" /></label>
                                    <div className="col-xs-7">
                                      <Field name="OrderPalletQty" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">Direct Ship</label>
                                    <div className="col-xs-7">
                                      <Field name="IsDirectShip" component={Checkbox} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">DO</label>
                                    <div className="col-xs-7">
                                      <Field name="IsDO" component={Checkbox} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">BOL</label>
                                    <div className="col-xs-7">
                                      <Field name="IsBOL" component={Checkbox} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">POD</label>
                                    <div className="col-xs-7">
                                      <Field name="IsPOD" component={Checkbox} />
                                    </div>
                                  </div>
                                {/* <div className="form-group">
                                  <label className="col-xs-5"><Translate value="deliver_to" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DeliverTo" component={InputField} />
                                  </div>
                                </div> */}
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="return_empty" /></label>
                                      <div className="col-xs-7">
                                        <Field name="IsReturnEmpty" component={Checkbox} />
                                      </div>
                                  </div>
                                {/* <div className="form-group">
                                  <label className="col-xs-5"><Translate value="fba_route" /></label>
                                  <div className="col-xs-7">
                                    <Field name="FBARoute" component={InputField} />
                                  </div>
                                </div> */}
                              </Col>
                              <Col xs={6} style={{paddingLeft: '50px'}}>
                              <div className="form-group">
                                    <label className="col-xs-5"><Translate value="trucking_co" /></label>
                                    <div className="col-xs-7">
                                      <Field name="TruckingCo" component={InputField} />
                                    </div>
                                  </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="arrival" /></label>
                                  <div className="col-xs-7">
                                    <Field name="ArrivalDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="return" /></label>
                                  <div className="col-xs-7">
                                    <Field name="ReturnDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="storage_in" /></label>
                                  <div className="col-xs-7">
                                    <Field name="StorageInDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="storage_out" /></label>
                                  <div className="col-xs-7">
                                    <Field name="StorageOutDate" component={DatePicker} />
                                  </div>
                                </div>
                              </Col>
                              </Col>
                            </Row>
                          </Tab>
                        }
                        {
                          isJTB &&
                          <Tab eventKey={2} title={orderInformation}>
                            <Row>
                              <Col xs={6}>
                                <Col xs={5}>
                                {
                                  (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') &&
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="order_type" /></label>
                                    <div className="col-xs-7">
                                    <Field name="OrderType" component={Selection} options={jtbOrderTypeOptions}/>
                                      {/* <Field name="OrderType" component={InputField} /> */}
                                    </div>
                                  </div>
                                }
                                {
                                  (this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') &&
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="receive_type" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ReceiveType" component={Selection} options={jtbReceiveTypeOptions}/>
                                    </div>
                                  </div>
                                }
                                {
                                  (this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') &&
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="receive_unit" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ReceiveUnit" component={Selection} options={jtbReceiveUnitOptions}/>
                                    </div>
                                  </div>
                                }
                                {
                                  (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') &&
                                  <div className="form-group">
                                    <label className="col-xs-5" style={{color: this.state.dropShipWarning ? 'red' : 'black'}}><Translate value="dropship_type" /></label>
                                    <div className="col-xs-7">
                                      <Field name="DropshipType" component={Selection} options={jtbDropshipTypeOptions}/>
                                    </div>
                                  </div>
                                }
                                 <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ContainerNum" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container_size" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ContainerSize" component={Selection} options={jtbContainerSizeOptions}/>
                                    </div>
                                  </div>
                                  {/* <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ContainerNum" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container_size" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ContainerSize" component={Selection} options={jtbContainerSizeOptions}/>
                                    </div>
                                  </div> */}
                                </Col>
                                <Col xs={6} style={{paddingLeft: '50px'}}>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="fba_route" /></label>
                                    <div className="col-xs-7">
                                      <Field name="FBARoute" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="carrier" /></label>
                                    <div className="col-xs-7">
                                      <Field name="Carrier" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="port" /></label>
                                    <div className="col-xs-7">
                                      <Field name="Port" component={InputField} />
                                    </div>
                                  </div>
                                  {/* <div className="form-group">
                                  <label className="col-xs-5"><Translate value="LF_Date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="LFDate" component={DatePicker} />
                                  </div>
                                </div> */}
                                  <div className="form-group">
                                    <label className="col-xs-5">BOL</label>
                                    <div className="col-xs-7">
                                      <Field name="BOL" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">POD</label>
                                    <div className="col-xs-7">
                                      <Field name="POD" component={InputField} />
                                    </div>
                                  </div>
                                </Col>
                              </Col>
                              <Col xs={6}>
                                <Col xs={5}>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="appointment" /></label>
                                    <div className="col-xs-7">
                                      <Field name="Appointment" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="trucking_co" /></label>
                                    <div className="col-xs-7">
                                      <Field name="TruckingCo" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="deliver_to" /></label>
                                    <div className="col-xs-7">
                                      <Field name="DeliverTo" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="return_empty" /></label>
                                    <div className="col-xs-7">
                                      <Field name="IsReturnEmpty" component={Checkbox} />
                                    </div>
                                  </div>
                                </Col>
                                <Col xs={6} style={{paddingLeft: '50px'}}>
                                  <div className="form-group">
                                      <label className="col-xs-5"><Translate value="arrival" /></label>
                                      <div className="col-xs-7">
                                        <Field name="ArrivalDate" component={DatePicker} />
                                      </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="return" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ReturnDate" component={DatePicker} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="storage_in" /></label>
                                    <div className="col-xs-7">
                                      <Field name="StorageInDate" component={DatePicker} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="storage_out" /></label>
                                    <div className="col-xs-7">
                                      <Field name="StorageOutDate" component={DatePicker} />
                                    </div>
                                  </div>
                                </Col>
                              </Col>
                            </Row>
                          </Tab>
                        }
                        {
                          (isABCFF) &&
                          <Tab eventKey={2} title={orderInformation} >
                            <Row>
                              <Col xs={6}>
                                <Col xs={5}>
                                <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ContainerNum" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container_size" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ContainerSize" component={Selection} options={abcffContainerSizeOptions}/>
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="isa_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ISANum" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                  <label className="col-xs-5"><Translate value="cpo_num" /></label>
                                  <div className="col-xs-7">
                                    <Field name="CPONum" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="ref_num" /></label>
                                  <div className="col-xs-7">
                                    <Field name="RefNum" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="tracking_num" /></label>
                                  <div className="col-xs-7">
                                    <Field name="TrackingNum" component={InputField} />
                                  </div>
                                </div>
                                  {/* <div className="form-group">
                                    <label className="col-xs-5"><Translate value="vendor_style" /></label>
                                    <div className="col-xs-7">
                                      <Field name="VendorStyleNum" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">TJX Style</label>
                                    <div className="col-xs-7">
                                      <Field name="TJXStyleNum" component={InputField} />
                                    </div>
                                  </div>  */}
                                </Col>
                                <Col xs={6} style={{paddingLeft: '50px'}}>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="appointment_time" /></label>
                                  <div className="col-xs-7">
                                    <Field name="Appointment" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="appointment_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="AppointmentDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="carrier" /></label>
                                  <div className="col-xs-7">
                                    <Field name="Carrier" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="destination" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DeliverTo" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="port" /></label>
                                  <div className="col-xs-7">
                                    <Field name="Port" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="LF_Date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="LFDate" component={DatePicker} />
                                  </div>
                                </div>
                                  {/* <div className="form-group">
                                    <label className="col-xs-5"><Translate value="trailer_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="TrailerNum" component={InputField} />
                                    </div>
                                  </div> */}
                                </Col>
                              </Col>
                              <Col xs={6}>
                                <Col xs={5}>
                                <div className="form-group">
                                    <label className="col-xs-5"><Translate value="total_pallets" /></label>
                                    <div className="col-xs-7">
                                      <Field name="OrderPalletQty" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">Direct Ship</label>
                                    <div className="col-xs-7">
                                      <Field name="IsDirectShip" component={Checkbox} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">DO</label>
                                    <div className="col-xs-7">
                                      <Field name="IsDO" component={Checkbox} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">BOL</label>
                                    <div className="col-xs-7">
                                      <Field name="IsBOL" component={Checkbox} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5">POD</label>
                                    <div className="col-xs-7">
                                      <Field name="IsPOD" component={Checkbox} />
                                    </div>
                                  </div>
                                {/* <div className="form-group">
                                  <label className="col-xs-5"><Translate value="deliver_to" /></label>
                                  <div className="col-xs-7">
                                    <Field name="DeliverTo" component={InputField} />
                                  </div>
                                </div> */}
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="return_empty" /></label>
                                      <div className="col-xs-7">
                                        <Field name="IsReturnEmpty" component={Checkbox} />
                                      </div>
                                  </div>
                                {/* <div className="form-group">
                                  <label className="col-xs-5"><Translate value="fba_route" /></label>
                                  <div className="col-xs-7">
                                    <Field name="FBARoute" component={InputField} />
                                  </div>
                                </div> */}
                              </Col>
                              <Col xs={6} style={{paddingLeft: '50px'}}>
                              <div className="form-group">
                                    <label className="col-xs-5"><Translate value="trucking_co" /></label>
                                    <div className="col-xs-7">
                                      <Field name="TruckingCo" component={InputField} />
                                    </div>
                                  </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="arrival" /></label>
                                  <div className="col-xs-7">
                                    <Field name="ArrivalDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="return" /></label>
                                  <div className="col-xs-7">
                                    <Field name="ReturnDate" component={DatePicker} />
                                  </div>
                                </div>
                                {
                                  !(this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') &&
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="storage_in" /></label>
                                    <div className="col-xs-7">
                                      <Field name="StorageInDate" component={DatePicker} />
                                    </div>
                                  </div>
                                }
                                {
                                  (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') &&
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="storage_out" /></label>
                                    <div className="col-xs-7">
                                      <Field name="StorageOutDate" component={DatePicker} />
                                    </div>
                                  </div>
                                }
                              </Col>
                              </Col>
                            </Row>
                          </Tab>
                        }
                        {
                          (isWIZ && !(this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id')) &&
                          <Tab eventKey={2} title={orderInformation} >
                            <Row>
                              <Col xs={6}>
                                <Col xs={5}>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ContainerNum" component={InputField} />
                                    </div>
                                  </div>
                                </Col>
                                {/* <Col xs={1}></Col> */}
                                <Col xs={6} style={{paddingLeft: '50px'}}>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="trailer" /></label>
                                    <div className="col-xs-7">
                                      <Field name="Trailer" component={InputField} />
                                    </div>
                                  </div>
                                </Col>
                              </Col>
                              <Col xs={6}>
                                <Col xs={5}>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="isa_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ISANum" component={InputField} />
                                    </div>
                                  </div>
                                </Col>
                                <Col xs={6} style={{paddingLeft: '50px'}}>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="dl_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="DLNum" component={InputField} />
                                    </div>
                                  </div>
                                </Col>
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={6}>
                                <Col xs={5}>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container_size" /></label>
                                    <div className="col-xs-7">
                                      {/* <Field name="ContainerSize" component={InputField} /> */}
                                      <Field name="ContainerSize" component={Selection} options={this.state.containerSizeOptions}/>
                                    </div>
                                  </div>
                                </Col>
                                <Col xs={6} style={{ paddingLeft: '50px' }}></Col>
                              </Col>
                              <Col xs={6}>
                                <Col xs={10}>
                                  <div className="form-group">
                                    <label className="col-xs-3">ISA Notation</label>
                                    <div className="col-xs-9">
                                      <Field name="ISANote" component="Textarea" className="form-control" />
                                    </div>
                                  </div>
                                </Col>
                              </Col>
                            </Row>
                        </Tab>
                      }
                      {
                          (isWIZ && (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id')) &&
                          <Tab eventKey={2} title={orderInformation} >
                            <Row>
                              <Col xs={6}>
                              <Col xs={5}>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="trucker" /></label>
                                    <div className="col-xs-7">
                                      <Field name="Trucker" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                  <label className="col-xs-5"><Translate value="release_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="ReleaseDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="ready_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="ReadyDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-5"><Translate value="outbound_date" /></label>
                                  <div className="col-xs-7">
                                    <Field name="OutboundDate" component={DatePicker} />
                                  </div>
                                </div>
                                </Col>
                                <Col xs={5}>
                                <div className="form-group">
                                    <label className="col-xs-5"><Translate value="isa_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ISANum" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="shipment_id" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ShipmentID" component={InputField} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="destination" /></label>
                                    <div className="col-xs-7">
                                      <Field name="Destination" component={InputField} />
                                    </div>
                                  </div>
                                  {/* <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ContainerNum" component={InputField} />
                                    </div>
                                  </div>
                                </Col>
                                <Col xs={6} style={{paddingLeft: '50px'}}>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="trailer" /></label>
                                    <div className="col-xs-7">
                                      <Field name="Trailer" component={InputField} />
                                    </div>
                                  </div> */}
                                </Col>
                              </Col>
                              <Col xs={6}>
                                <Col xs={5}>
                                  {/* <div className="form-group">
                                    <label className="col-xs-5"><Translate value="isa_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ISANum" component={InputField} />
                                    </div>
                                  </div>   */}
                                </Col>
                                <Col xs={6} style={{paddingLeft: '50px'}}>
                                  {/* <div className="form-group">
                                    <label className="col-xs-5"><Translate value="dl_num" /></label>
                                    <div className="col-xs-7">
                                      <Field name="DLNum" component={InputField} />
                                    </div>
                                  </div>   */}
                                </Col>
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={6}>
                                {/* <Col xs={5}>
                                  <div className="form-group">
                                    <label className="col-xs-5"><Translate value="container_size" /></label>
                                    <div className="col-xs-7">
                                      <Field name="ContainerSize" component={Selection} options={this.state.containerSizeOptions}/>
                                    </div>
                                  </div>
                                </Col>
                                <Col xs={6} style={{ paddingLeft: '50px' }}></Col> */}
                              </Col>
                              <Col xs={6}>
                                {/* <Col xs={10}>
                                  <div className="form-group">
                                    <label className="col-xs-3">ISA Notation</label>
                                    <div className="col-xs-9">
                                      <Field name="ISANote" component="Textarea" className="form-control" />
                                    </div>
                                  </div>
                                </Col> */}
                              </Col>
                            </Row>
                        </Tab>
                      }
                        {/* {
                          isFJ &&
                        <Tab eventKey={2} title={orderInformation} >
                          <Row>
                            <Col xs={6} style={{paddingRight: '25px'}}>
                              <Col xs={12}>
                              <div className="form-group">
                                  <label className="col-xs-3"><Translate value="ext_invoice" /></label>
                                  <div className="col-xs-9">
                                    <Field name="ExtInvoiceNum" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="broker" /></label>
                                  <div className="col-xs-9">
                                    <Field name="Broker" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="truckload" /></label>
                                  <div className="col-xs-9">
                                    <Field name="Truckload" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="truck_num" /></label>
                                  <div className="col-xs-9">
                                    <Field name="TruckNum" component={InputField} />
                                  </div>
                                </div>
                              </Col>
                            </Col>
                            <Col xs={6} style={{paddingLeft: '25px'}}>
                              <Col xs={12}>
                              <div className="form-group">
                                  <label className="col-xs-3"><Translate value="dispatch" /></label>
                                  <div className="col-xs-9">
                                    <Field name="Dispatch" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="detention_rate" /></label>
                                  <div className="col-xs-9">
                                    <Field name="DetentionRate" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="lumper_fee" /></label>
                                  <div className="col-xs-9">
                                    <Field name="LumperFee" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="pallet_space" /></label>
                                  <div className="col-xs-9">
                                    <Field name="PalletSpace" component={InputField} />
                                  </div>
                                </div>
                              </Col>
                            </Col>
                          </Row>
                        </Tab>
                            }
                            {isFJ &&
                        <Tab eventKey={3} title={pickdropInformation} >
                          <Row>
                            <Col xs={6} style={{paddingRight: '25px'}}>
                              <Col xs={12}>
                              <div className="form-group">
                                  <label className="col-xs-3"><Translate value="pickup_driver" /></label>
                                  <div className="col-xs-9">
                                    <Field name="PickupDriver" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="pickup_trailer" /></label>
                                  <div className="col-xs-9">
                                    <Field name="PickupTrailerNum" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="pickup_date" /></label>
                                  <div className="col-xs-4">
                                    <Field name="PickupDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="pickup_time" /></label>
                                  <div className="col-xs-9">
                                    <Field name="PickupTime" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="pickup_city" /></label>
                                  <div className="col-xs-9">
                                    <Field name="PickupCity" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="pickup_state" /></label>
                                  <div className="col-xs-9">
                                    <Field name="PickupState" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="pickup_appt" /></label>
                                  <div className="col-xs-9">
                                    <Field name="PickupAppt" component={InputField} />
                                  </div>
                                </div>
                              </Col>
                            </Col>
                            <Col xs={6} style={{paddingLeft: '25px'}}>
                            <Col xs={12}>
                              <div className="form-group">
                                  <label className="col-xs-3"><Translate value="dropoff_driver" /></label>
                                  <div className="col-xs-9">
                                    <Field name="DropoffDriver" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="dropoff_trailer" /></label>
                                  <div className="col-xs-9">
                                    <Field name="DropoffTrailerNum" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="dropoff_date" /></label>
                                  <div className="col-xs-4">
                                    <Field name="DropoffDate" component={DatePicker} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="dropoff_time" /></label>
                                  <div className="col-xs-9">
                                    <Field name="DropoffTime" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="dropoff_city" /></label>
                                  <div className="col-xs-9">
                                    <Field name="DropoffCity" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="dropoff_state" /></label>
                                  <div className="col-xs-9">
                                    <Field name="DropoffState" component={InputField} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="col-xs-3"><Translate value="dropoff_appt" /></label>
                                  <div className="col-xs-9">
                                    <Field name="DropoffAppt" component={InputField} />
                                  </div>
                                </div>
                              </Col>
                            </Col>
                          </Row>
                        </Tab>
                            } */}
                    </Tabs>
                    </fieldset>
                  </Row>
                }
                {
                  isMAG &&
                  <Row>
                    {this.containerInformationHeader()}
                    <fieldset className="form-horizontal">
                    <Tabs activeKey={this.state.fjInfoKey} justified onSelect={this.handleSelect3}>
                      <Tab eventKey={1} title={orderInformation} >
                        <Row>
                          <Col xs={6} style={{paddingRight: '25px'}}>
                            <Col xs={12}>
                            <div className="form-group">
                                <label className="col-xs-3"><Translate value="status" /></label>
                                <div className="col-xs-9">
                                <Field name="SaleStatus" matchPos="any" component={Selection} options={this.state.magStatusOptions} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="delivery_address" /></label>
                                <div className="col-xs-9">
                                  <Field name="delivery_address" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3">ETA</label>
                                <div className="col-xs-9">
                                  <Field name="delivery_eta" component={DatePicker} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="container_num" /></label>
                                <div className="col-xs-9">
                                  <Field name="cntrNum" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3">BOL Num</label>
                                <div className="col-xs-9">
                                  <Field name="bolNum" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="terminal" /></label>
                                <div className="col-xs-9">
                                <Field name="terminal" matchPos="any" component={Selection} options={this.state.magTerminalOptions} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3">LFD</label>
                                <div className="col-xs-9">
                                  <Field name="delivery_lfd" component={DatePicker} />
                                </div>
                              </div>
                              {/* <div className="form-group">
                                <label className="col-xs-3">HOLD (Select)</label>
                                <div className="col-xs-9">
                                  <Field name="DeliveryStatus" component={InputField} />
                                </div>
                              </div> */}
                              <div className="form-group">
                                <label className="col-xs-3">HOLD (Select)</label>
                                <div className="col-xs-3">
                                <Field name="mag2FREIGHT_HOLD" checked={this.state.mag2FREIGHT_HOLD} component={CheckboxFormatter} handleOnClick={() => { this.setState({mag2FREIGHT_HOLD : !this.state.mag2FREIGHT_HOLD})}}/>
                                <span>Freight Hold</span>
                                </div>
                                <div className="col-xs-3">
                                <Field name="mag2CUSTOM_HOLD" checked={this.state.mag2CUSTOM_HOLD} component={CheckboxFormatter} handleOnClick={() => { this.setState({mag2CUSTOM_HOLD : !this.state.mag2CUSTOM_HOLD})}}/>
                                <span>Custom Hold</span>
                                </div>
                                <div className="col-xs-3">
                                <Field name="mag2PIERPASS_HOLD" checked={this.state.mag2PIERPASS_HOLD} component={CheckboxFormatter} handleOnClick={() => { this.setState({mag2PIERPASS_HOLD : !this.state.mag2PIERPASS_HOLD})}}/>
                                <span>Pierpass Hold</span>
                                </div>
                              </div>

                              <div className="form-group">
                                <label className="col-xs-3"></label>
                                <div className="col-xs-3">
                                <Field name="mag2EXAM" checked={this.state.mag2EXAM} component={CheckboxFormatter} handleOnClick={() => { this.setState({mag2EXAM : !this.state.mag2EXAM})}}/>
                                <span>Exam</span>
                                </div>
                                <div className="col-xs-3">
                                <Field name="mag2CLOSED_AREA" checked={this.state.mag2CLOSED_AREA} component={CheckboxFormatter} handleOnClick={() => { this.setState({mag2CLOSED_AREA : !this.state.mag2CLOSED_AREA})}}/>
                                <span>Closed Area</span>
                                </div>
                              </div>

                              <div className="form-group">
                                <label className="col-xs-3">HOLD (Other)</label>
                                <div className="col-xs-9">
                                  <Field name="DeliveryStatusOther" component={InputField} />
                                </div>
                              </div>
                            </Col>
                          </Col>
                          <Col xs={6} style={{paddingLeft: '25px'}}>
                            <Col xs={12}>
                            <div className="form-group">
                            <label className="col-xs-3"><Translate value="cntr_location" /></label>
                                <div className="col-xs-9">
                                  <Field name="cntrLocation" component={InputField} />
                                </div>
                              </div>
                            {/* <div className="form-group">
                                <label className="col-xs-3">Note (Select)</label>
                                <div className="col-xs-9">
                                <Field name="mag_note" matchPos="any" component={Selection} options={this.state.magNoteOptions} />
                                </div>
                              </div> */}
                              <div className="form-group">
                                <label className="col-xs-3">Note (Select)</label>
                                <div className="col-xs-3">
                                <Field name="magDryrun" checked={this.state.magDryrun} component={CheckboxFormatter} handleOnClick={() => { this.setState({magDryrun : !this.state.magDryrun})}}/>
                                <span>Dryrun</span>
                                </div>
                                <div className="col-xs-3">
                                <Field name="magOffhire" checked={this.state.magOffhire} component={CheckboxFormatter} handleOnClick={() => { this.setState({magOffhire : !this.state.magOffhire})}}/>
                                <span>Offhire</span>
                                </div>
                                <div className="col-xs-3">
                                <Field name="magExtraStop" checked={this.state.magExtraStop} component={CheckboxFormatter} handleOnClick={() => { this.setState({magExtraStop : !this.state.magExtraStop})}}/>
                                <span>Extra Stop</span>
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"></label>
                                <div className="col-xs-3">
                                <Field name="magExam" checked={this.state.magExam} component={CheckboxFormatter} handleOnClick={() => { this.setState({magExam : !this.state.magExam})}}/>
                                <span>Exam</span>
                                </div>
                                <div className="col-xs-3">
                                <Field name="magExtraDelivery" checked={this.state.magExtraDelivery} component={CheckboxFormatter} handleOnClick={() => { this.setState({magExtraDelivery : !this.state.magExtraDelivery})}}/>
                                <span>Extra Delivery</span>
                                </div>
                                <div className="col-xs-3">
                                <Field name="magStorage" checked={this.state.magStorage} component={CheckboxFormatter} handleOnClick={() => { this.setState({magStorage : !this.state.magStorage})}}/>
                                <span>Storage</span>
                                </div>
                              </div>

                              <div className="form-group">
                                <label className="col-xs-3"></label>
                                <div className="col-xs-3">
                                <Field name="magBobtailFee" checked={this.state.magBobtailFee} component={CheckboxFormatter} handleOnClick={() => { this.setState({magBobtailFee : !this.state.magBobtailFee})}}/>
                                <span>Bobtail Fee</span>
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3">Note (Other)</label>
                                <div className="col-xs-9">
                                <Field name="mag_note_other" component={InputField} />
                                </div>
                              </div>
                                <div className="form-group">
                                <label className="col-xs-3"><Translate value="size" /></label>
                                <div className="col-xs-9">
                                <Field name="size" matchPos="any" component={Selection} options={this.state.magSizeOptions} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="shipping_line" /></label>
                                <div className="col-xs-9">
                                <Field name="shipping_line" matchPos="any" component={Selection} options={this.state.magShippingLineOptions} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="cargo_weight" /></label>
                                <div className="col-xs-9">
                                  <Field name="cargo_weight" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="contact_person" /></label>
                                <div className="col-xs-9">
                                  <Field name="contact_person" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="contact_email" /></label>
                                <div className="col-xs-9">
                                  <Field name="contact_email" component={InputField} />
                                </div>
                              </div>
                            </Col>
                          </Col>
                        </Row>
                      </Tab>
                    </Tabs>
                    </fieldset>
                  </Row>
                }
                {
                  isFJ &&
                  <Row>
                    {this.generalInformationHeader()}
                    <fieldset className="form-horizontal">
                    <Tabs activeKey={this.state.fjInfoKey} justified onSelect={this.handleSelect3}>
                      <Tab eventKey={1} title={orderInformation} >
                      {
                        (this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') &&
                        <Row>
                          <Col xs={6} style={{paddingRight: '25px'}}>
                            <Col xs={12}>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="container" /></label>
                                <div className="col-xs-9">
                                  <Field name="ContainerNum" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="carrier" /></label>
                                <div className="col-xs-9">
                                <Field name="Carrier" matchPos="any" component={Selection} options={this.state.fjCarrierOptions} />
                                </div>
                              </div>
                              {/* <div className="form-group">
                                <label className="col-xs-3"><Translate value="ext_invoice" /></label>
                                <div className="col-xs-9">
                                  <Field name="ExtInvoiceNum" component={InputField} />
                                </div>
                              </div> */}
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="broker" /></label>
                                <div className="col-xs-9">
                                  <Field name="Broker" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="truckload" /></label>
                                <div className="col-xs-9">
                                  <Field name="Truckload" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="truck_num" /></label>
                                <div className="col-xs-9">
                                  <Field name="TruckNum" component={InputField} />
                                </div>
                              </div>
                            </Col>
                          </Col>
                          <Col xs={6} style={{paddingLeft: '25px'}}>
                            <Col xs={12}>
                            <div className="form-group">
                                <label className="col-xs-3"><Translate value="ext_invoice" /></label>
                                <div className="col-xs-9">
                                  <Field name="ExtInvoiceNum" component={InputField} />
                                </div>
                              </div>
                            <div className="form-group">
                                <label className="col-xs-3"><Translate value="dispatch" /></label>
                                <div className="col-xs-9">
                                  <Field name="Dispatch" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="detention_rate" /></label>
                                <div className="col-xs-9">
                                  <Field name="DetentionRate" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="lumper_fee" /></label>
                                <div className="col-xs-9">
                                  <Field name="LumperFee" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="pallet_space" /></label>
                                <div className="col-xs-9">
                                  <Field name="PalletSpace" component={InputField} />
                                </div>
                              </div>
                            </Col>
                          </Col>
                        </Row>
                      }
                      {
                        (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') &&
                        <Row>
                          <Col xs={6} style={{paddingRight: '25px'}}>
                            <Col xs={12}>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="container" /></label>
                                <div className="col-xs-9">
                                  <Field name="ContainerNum" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="ext_invoice" /></label>
                                <div className="col-xs-9">
                                  <Field name="ExtInvoiceNum" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="broker" /></label>
                                <div className="col-xs-9">
                                  <Field name="Broker" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="truckload" /></label>
                                <div className="col-xs-9">
                                  <Field name="Truckload" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="truck_num" /></label>
                                <div className="col-xs-9">
                                  <Field name="TruckNum" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="carrier" /></label>
                                <div className="col-xs-9">
                                  <Field name="Carrier" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="trailer_num" /></label>
                                <div className="col-xs-9">
                                  <Field name="TrailerNum" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="orders" /></label>
                                <div className="col-xs-9">
                                  <Field name="OrdersStuff" component={InputField} />
                                </div>
                              </div>
                            </Col>
                          </Col>
                          <Col xs={6} style={{paddingLeft: '25px'}}>
                            <Col xs={12}>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="dispatch" /></label>
                                <div className="col-xs-9">
                                  <Field name="Dispatch" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="detention_rate" /></label>
                                <div className="col-xs-9">
                                  <Field name="DetentionRate" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="lumper_fee" /></label>
                                <div className="col-xs-9">
                                  <Field name="LumperFee" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="pallet_space" /></label>
                                <div className="col-xs-9">
                                  <Field name="PalletSpace" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="deliver_by_date" /></label>
                                <div className="col-xs-9">
                                  <Field name="DeliverByDate" component={DatePicker} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="deliver_by_time" /></label>
                                <div className="col-xs-9">
                                  <Field name="DeliverByTime" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3">BOL</label>
                                <div className="col-xs-9">
                                  <Field name="IsBOL" component={Checkbox} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3">Seal</label>
                                <div className="col-xs-9">
                                  <Field name="IsSeal" component={Checkbox} />
                                </div>
                              </div>
                            </Col>
                          </Col>
                        </Row>
                      }
                      </Tab>
                      {
                      (this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') &&
                      // true &&
                      <Tab eventKey={2} title={pickdropInformation} >
                        <Row>
                          <Col xs={6} style={{paddingRight: '25px'}}>
                            <Col xs={12}>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="pickup_driver" /></label>
                                <div className="col-xs-9">
                                  <Field name="PickupDriver" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="pickup_trailer" /></label>
                                <div className="col-xs-9">
                                  <Field name="PickupTrailerNum" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="pickup_date" /></label>
                                <div className="col-xs-4">
                                  <Field name="PickupDate" component={DatePicker} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="pickup_time" /></label>
                                <div className="col-xs-9">
                                  <Field name="PickupTime" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="pickup_street" /></label>
                                <div className="col-xs-9">
                                  <Field name="PickupStreet" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="pickup_zip" /></label>
                                <div className="col-xs-9">
                                  <Field name="PickupZip" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="pickup_city" /></label>
                                <div className="col-xs-9">
                                  <Field name="PickupCity" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="pickup_state" /></label>
                                <div className="col-xs-5">
                                  {/* <Field name="PickupState" component={InputField} /> */}
                                  <Field name="PickupState" component={Selection} options={this.state.stateOptions}/>
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="pickup_appt" /></label>
                                <div className="col-xs-9">
                                  <Field name="PickupAppt" component={InputField} />
                                </div>
                              </div>
                            </Col>
                          </Col>
                          <Col xs={6} style={{paddingLeft: '25px'}}>
                            <Col xs={12}>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="dropoff_driver" /></label>
                                <div className="col-xs-9">
                                  <Field name="DropoffDriver" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="dropoff_trailer" /></label>
                                <div className="col-xs-9">
                                  <Field name="DropoffTrailerNum" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="dropoff_date" /></label>
                                <div className="col-xs-4">
                                  <Field name="DropoffDate" component={DatePicker} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="dropoff_time" /></label>
                                <div className="col-xs-9">
                                  <Field name="DropoffTime" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="dropoff_street" /></label>
                                <div className="col-xs-9">
                                  <Field name="DropoffStreet" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="dropoff_zip" /></label>
                                <div className="col-xs-9">
                                  <Field name="DropoffZip" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="dropoff_city" /></label>
                                <div className="col-xs-9">
                                  <Field name="DropoffCity" component={InputField} />
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="dropoff_state" /></label>
                                <div className="col-xs-5">
                                  {/* <Field name="DropoffState" component={InputField} /> */}
                                  <Field name="DropoffState" component={Selection} options={this.state.stateOptions}/>
                                </div>
                              </div>
                              <div className="form-group">
                                <label className="col-xs-3"><Translate value="dropoff_appt" /></label>
                                <div className="col-xs-9">
                                  <Field name="DropoffAppt" component={InputField} />
                                </div>
                              </div>
                            </Col>
                          </Col>
                        </Row>
                      </Tab>
                      }
                    </Tabs>
                    </fieldset>
                  </Row>
                }
                {
                  ((!isMAG && !isABCFF) && !(this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id')) &&
                  <Row>
                    {this.productHeader()}
                    <fieldset
                      className={`form-horizontal ${this.state.isProductInformationPanelFolded ? 'folded' : ''}`}
                      style={{minHeight: (isLAP && this.state.yourOrderKey === 2) ? '460px' : '150px', maxHeight: (isLAP && this.state.yourOrderKey === 2) ? '500px' : '400px'}}
                    >
                      <Tabs activeKey={this.state.yourOrderKey} justified onSelect={this.handleSelect}>
                        <Tab eventKey={1} title={allInventoryProducts}>
                          <Row>
                            <Col xs={12}>
                              {isSH && <Row>
                                <Col xs={2} className="pr0">
                                  <label><Translate value="color_filter" /></label>
                                  <Input
                                      style={{width: '150px', borderRadius: '5px', marginLeft:'7px', border: '1px solid gray'}}
                                      type="text"
                                      onChange={this.onChangeSmilingColor}
                                      value={this.state.smilingColor}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                  <label><Translate value="package_type_filter" /></label>
                                  <Select
                                    className='testSelect'
                                    options={this.getPackageTypeOptions()}
                                    onChange={(pkgTp)=>{
                                      this.setState({pkgTp})
                                    }}
                                    matchPos={"center"}
                                    matchProp={'label'}
                                    value={this.state.pkgTp}
                                  />
                                </Col>
                              </Row>
                              }
                              <Row>
                                <Col xs={5}>
                                  <Field name="searchType" component={RenderTypeRadios} />
                                  {/* <Field name="ProductInformation" component={InputField} ref="productSearch" withRef={true} onFocus={this.handleOnFocus} onKeyPress={(event) => {this.openShowInventory(event)}}/> */}
                                  {this.renderAutoSuggest()}
                                </Col>
                                <Col xs={7} id="product-search-outputs">
                                { isSV &&
                                  <Col xs={2} className="pr1" style={{width: '90px'}}>
                                      <Col xs={12} className="pr1" style={{display: 'flex', justifyContent: 'center'}}>
                                    <label>
                                      <Translate value="is_child" />
                                    </label>
                                    </Col>
                                    <Col xs={12} className="pr1" style={{display: 'flex', justifyContent: 'center'}}>
                                    <Field name="IsChild" component={Checkbox} />
                                    </Col>
                                  </Col>
                                }

                                { (!isSV && !isEKC && !isLMH && !isSDR && !isCRW && !isTQ && !isSC) &&
                                  <Col xs={2} className="pr1" style={{width: '90px'}}>
                                    <Col xs={12} className="pr1" style={{display: 'flex', justifyContent: 'center'}}>
                                      <label>
                                        <Translate value="no_return" />
                                      </label>
                                    </Col>
                                    <Col xs={12} className="pr1" style={{display: 'flex', justifyContent: 'center'}}>
                                      <Field name="IsNoReturn" component={Checkbox} />
                                    </Col>
                                  </Col>
                                }
                                {
                                  isVAK && <Col xs={1} className="pr1" style={{width: '90px'}}>
                                    <Col xs={12} className="pr1" style={{display: 'flex', justifyContent: 'center'}}>
                                      <label>
                                        <Translate value="is_spare" />
                                      </label>
                                    </Col>
                                    <Col xs={12} className="pr1" style={{display: 'flex', justifyContent: 'center'}}>
                                      <Field name="IsSpare" component={Checkbox} />
                                    </Col>
                                  </Col>
                                }
                                {((isEKC || isLMH) && this.state.currentProdEkc === '0101') &&
                                  <Col xs={isMultiWH ? 2 : 2} className="pr0">
                                    <label >
                                      ft<sup>2</sup>
                                    </label>
                                    <Field
                                      name="Sqft"
                                      withRef
                                      ref="Sqft"
                                      disabled={(this.state.currentProdEkc !== '0101')}
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onChange={this.handleSqftChange()}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('SqftPack', event);
                                      }}
                                    />
                                  </Col>
                                }
                                {((isEKC || isLMH) && this.state.currentProdEkc === '0101') &&
                                  <Col xs={isMultiWH ? 2 : 2} className="pr0">
                                    <label >
                                    ft<sup>2</sup>/Pk
                                    </label>
                                    <Field
                                      name="SqftPack"
                                      withRef
                                      ref="SqftPack"
                                      component={InputField}
                                      disabled={(this.state.currentProdEkc !== '0101')}
                                      onFocus={this.handleOnFocus}
                                      onChange={this.handleSqftPackChange()}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                        this.handleKeyPress('unitPrice', event);
                                      }}
                                    />
                                  </Col>
                                }
                                    <Col xs={isMultiWH ? 1 : 2} className={(isEKC || isLMH || isSDR || isCRW || isSC) ? "pr0" : "pr1"}>
                                      <label >
                                        <Translate value={((isEKC || isLMH) && this.state.currentProdEkc === '0101') ? "qty(Pk)" : isGFD ? "case" : "qty"} />
                                      </label>
                                      <Field
                                        name="Quantity"
                                        withRef
                                        ref="quantity"
                                        disabled={(isEKC || isLMH) && this.state.currentProdEkc === '0101'}
                                        component={InputField}
                                        onFocus={this.handleOnFocus}
                                        onChange={this.handleQtyChange()}
                                        onKeyPress={(event) => {
                                          if (!this.state.selectedInventoryRow) {
                                            return;
                                          }
                                          if ((isHMM && !checkPermissionLocal('hmm_so_change_unit_price')) || (isSUN && !checkPermissionLocal('edit_order_line_price'))) {
                                            this.handleKeyPress('itemNotation', event);
                                          } else if (isSV || isSDR || isCRW || isSC) {
                                            this.handleKeyPress('itemNotation', event);
                                          } else if ((isEKC || isLMH || isSDR || isCRW || isSC) && this.state.currentProdComboEkc) {
                                            this.handleKeyPress('itemNotation', event);
                                          } else if(isGGI) {
                                            this.handleKeyPress('smallUnit', event);
                                          } else {
                                            this.handleKeyPress('unitPrice', event);
                                          }
                                        }}
                                        placeholder="must be > 0"
                                      />
                                    </Col>
                                      {isLMH &&
                                        <Col xs={1} className="pr0" style={{ marginLeft: '5px', marginRight: '5px' }}>
                                          <Row>
                                            <Col xs={12}>
                                              <label ><Translate value="orig_price" /></label>
                                            </Col>
                                            <Field name="OrigUnitPrice" component={DisabledInputField} placeholder={this.state.OrigUnitPrice} />
                                          </Row>
                                        </Col>
                                      }
                                    {this.renderSMUnit()}
                                      {isLMH && //wtf
                                        <Col xs={1} className="pr0" style={{ marginLeft: '5px', marginRight: '8px' }}>
                                          <Row>
                                            <Col xs={12}>
                                              <label ><Translate value="discount_p" /></label>
                                            </Col>
                                            <Field
                                              name="LineDiscount"
                                              withRef
                                              ref="LineDiscount"
                                              disabled={false}
                                              component={InputField}
                                              onFocus={this.handleOnFocus}
                                              onChange={(e) => this.handleLineDiscountChange(e.target.value)}
                                              onKeyPress={(event) => {
                                                // if (!this.state.selectedInventoryRow) {
                                                //   return;
                                                // }
                                                this.handleKeyPress('itemNotation', event);
                                              }}
                                              // placeholder="must be > 0"
                                            />
                                          </Row>
                                        </Col>
                                      }
                                  {
                                    !(isEKC || isLMH || isSDR || isCRW || isSC || isVAK || isSH) &&
                                    <Col xs={1} className="pr0">
                                      {weightLabel}
                                      <Field
                                        name="Weight"
                                        withRef
                                        ref="weight"
                                        component={WeightInputComponent}
                                        onFocus={this.handleOnFocus}
                                        onKeyPress={(event) => {
                                          if (event.charCode === 13) {
                                            if (isSUN) {
                                              this.handleKeyPress('itemNotation', event);
                                              return
                                            }
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }

                                            if (isABCFF) {
                                              this.handleKeyPress('UnitQuantity', event);
                                            } else {
                                              this.handleFocusAutoSuggest();
                                              this.checkMoveToSo();
                                            }
                                          }
                                        }}
                                      />
                                    </Col>
                                  }
                                  {
                                    // break point
                                    showProductCost() && <Col xs={2}>
                                      <label><Translate value={isLAP ? "last_cost" : "cost"} /></label>
                                      <span className="dollar-sign">$$</span>
                                      <Field
                                        name={isHMM ? "" : (isSV ? "BaseCost" : "ProductCost")}
                                        withRef
                                        ref="ProductCost"
                                        component={DisabledInputField}
                                        onFocus={this.handleOnFocus}
                                        onKeyPress={(event) => {
                                          if (event.charCode === 13) {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                            this.handleFocusAutoSuggest();
                                            this.checkMoveToSo();
                                          }
                                        }}
                                      />
                                    </Col>
                                  }
                                  <Col xs={2} className="pr0" style={{ marginLeft: '5px', marginRight: '5px' }}>
                                    <Row>
                                      <Col xs={12}>
                                        <label ><Translate value="subtotal" /></label>
                                      </Col>
                                      {this.renderSubtotal()}
                                    </Row>
                                  </Col>
                                  <Col xs={2}>
                                    <label><Translate value="notation" /></label>
                                    <Field
                                      name="itemNotation"
                                      withRef
                                      ref="itemNotation"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        this.handleNotationEnter(event)
                                      }}
                                    />
                                  </Col>
                                  {this.renderAddBatchButton()}
                                </Col>
                                <Col xs={5}>
                                </Col>
                                <Col xs={7}>
                                  {this.renderOCMPalletSize()}
                                  {this.renderAddBatchButtonOCM()}
                                </Col>
                              </Row>
                              {
                              false &&
                              <Row>
                                <Col xs={6}>
                                </Col>
                                <Col xs={6}>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="pallet_qty" />
                                    </label>
                                    <Field
                                      name="PalletQuantity"
                                      withRef
                                      ref="PalletQuantity"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('BoxQuantity', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="box_qty" />
                                    </label>
                                    <Field
                                      name="BoxQuantity"
                                      withRef
                                      ref="BoxQuantity"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                        this.handleKeyPress('PieceQuantity', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="piece_qty" />
                                    </label>
                                    <Field
                                      name="PieceQuantity"
                                      withRef
                                      ref="PieceQuantity"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (event.charCode === 13) {
                                          if (!this.state.selectedInventoryRow) {
                                            return;
                                          }
                                          this.handleFocusAutoSuggest();
                                          this.checkMoveToSo();
                                        }
                                      }}
                                    />
                                  </Col>
                                </Col>
                              </Row>
                              }
                              {
                              (isDSQ || isABCFF) &&
                              <Row>
                                <Col xs={6}>
                                  <Col xs={2} className="pr1">
                                    <label >
                                      FBA Code
                                    </label>
                                    <Field
                                      name="FBACode"
                                      withRef
                                      ref="FBACode"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('FBARoute', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      FBA Route
                                    </label>
                                    <Field
                                      name="FBARoute"
                                      withRef
                                      ref="FBARoute"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('TrailerNum', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      Trailer
                                    </label>
                                    <Field
                                      name="TrailerNum"
                                      withRef
                                      ref="TrailerNum"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('POList', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      PO List
                                    </label>
                                    <Field
                                      name="POList"
                                      withRef
                                      ref="POList"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('POD', event);
                                      }}
                                    />
                                  </Col>
                                  {/* <Col xs={2} className="pr0">
                                    <label >
                                      POD
                                    </label>
                                    <Field
                                      name="POD"
                                      withRef
                                      ref="POD"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('DimUnit', event);
                                      }}
                                    />
                                  </Col> */}
                                  <Col xs={2} className="pr0" style={{paddingLeft: '20px'}}>
                                    <label style={{width: '100%'}}>
                                      <Translate value="POD" />
                                    </label>
                                    <Field name="POD" component={Checkbox} />
                                  </Col>

                                  <Col xs={2} className="pr0">
                                    <label >
                                      Dim Unit
                                    </label>
                                    <Field
                                      name="DimUnit"
                                      withRef
                                      ref="DimUnit"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('quantity', event);
                                      }}
                                    />
                                  </Col>
                                </Col>
                                <Col xs={6}>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="box_qty" />
                                    </label>
                                    <Field
                                      name="Quantity"
                                      withRef
                                      ref="quantity"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('BoxLength', event);
                                      }}
                                      placeholder="must be > 0"
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label >
                                      Box L
                                    </label>
                                    <Field
                                      name="BoxLength"
                                      withRef
                                      ref="BoxLength"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('BoxWidth', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label style={{minWidth: '40px'}}>
                                      Box W
                                    </label>
                                    <Field
                                      name="BoxWidth"
                                      withRef
                                      ref="BoxWidth"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('BoxHeight', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label >
                                      Box H
                                    </label>
                                    <Field
                                      name="BoxHeight"
                                      withRef
                                      ref="BoxHeight"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('BoxVol', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      Box CBM
                                    </label>
                                    <Field
                                      name="BoxVol"
                                      withRef
                                      ref="BoxVol"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('BoxWeight', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="box_weight" />
                                    </label>
                                    <Field
                                      name="BoxWeight"
                                      withRef
                                      ref="BoxWeight"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                        this.handleKeyPress('WeightUnit', event);
                                      }}
                                    />
                                  </Col>

                                  <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="weight_unit" />
                                    </label>
                                    <Field
                                      name="WeightUnit"
                                      withRef
                                      ref="WeightUnit"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                        this.handleKeyPress('PalletQuantity', event);
                                      }}
                                    />
                                  </Col>
                                </Col>
                                </Row>
                              }
                              {
                              (isDSQ || isABCFF) &&
                              <Row>
                                <Col xs={6}>
                                </Col>
                                <Col xs={6}>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="plt_qty" />
                                    </label>
                                    <Field
                                      name="PalletQuantity"
                                      withRef
                                      ref="PalletQuantity"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('PalletLength', event);
                                      }}
                                      // placeholder="must be > 0"
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label >
                                      Plt L
                                    </label>
                                    <Field
                                      name="PalletLength"
                                      withRef
                                      ref="PalletLength"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('PalletWidth', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label >
                                      Plt W
                                    </label>
                                    <Field
                                      name="PalletWidth"
                                      withRef
                                      ref="PalletWidth"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('PalletHeight', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label >
                                      Plt H
                                    </label>
                                    <Field
                                      name="PalletHeight"
                                      withRef
                                      ref="PalletHeight"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                        this.handleKeyPress('PalletVol', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      Plt CBM
                                    </label>
                                    <Field
                                      name="PalletVol"
                                      withRef
                                      ref="PalletVol"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('PalletWeight', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="plt_weight" />
                                    </label>
                                    <Field
                                      name="PalletWeight"
                                      withRef
                                      ref="PalletWeight"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (event.charCode === 13) {
                                          if (!this.state.selectedInventoryRow) {
                                            return;
                                          }
                                          if (isABCFF) {
                                            this.handleKeyPress('CantonNum', event);
                                            // this.handleKeyPress('UnitQuantity', event);
                                          } else {
                                            this.handleFocusAutoSuggest();
                                            this.checkMoveToSo();
                                          }
                                        }
                                      }}
                                    />
                                  </Col>
                                  {/* <Col xs={2} className="pr0">
                                    <label style={{width: '100%'}}>
                                      <Translate value="oversize" />
                                    </label>
                                    <Field name="IsOversize" component={Checkbox} />
                                  </Col> */}
                                  {/* <Col xs={2} className="pr0">
                                    <label style={{width: '100%'}}>
                                      <Translate value="overweight" />
                                    </label>
                                    <Field name="IsOverweight" component={Checkbox} />
                                  </Col> */}
                                  {
                                    !(isABCFF) &&
                                    <Col xs={1} className="pr0">
                                      <div style={{height: '12px'}}></div>
                                      <Button
                                        id="product-add-button"
                                        bsStyle="success"
                                        onClick={() => {
                                          this.checkMoveToSo();
                                        }}
                                      >
                                        +
                                      </Button>
                                    </Col>
                                  }
                                </Col>
                              </Row>
                              }
                              {
                              (isABCFF) &&
                              <Row>
                                <Col xs={6}>
                                </Col>
                                <Col xs={6}>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="unit_qty" />
                                    </label>
                                    <Field
                                      name="UnitQuantity"
                                      withRef
                                      ref="UnitQuantity"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('UnitLength', event);
                                      }}
                                      // placeholder="must be > 0"
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label >
                                      Unt L
                                    </label>
                                    <Field
                                      name="UnitLength"
                                      withRef
                                      ref="UnitLength"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('UnitWidth', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label >
                                      Unt W
                                    </label>
                                    <Field
                                      name="UnitWidth"
                                      withRef
                                      ref="UnitWidth"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('UnitHeight', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                    <label >
                                      Unt H
                                    </label>
                                    <Field
                                      name="UnitHeight"
                                      withRef
                                      ref="UnitHeight"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('UnitVol', event);
                                      }}
                                    />
                                  </Col>
                                  <Col xs={2} className="pr0">
                                    <label >
                                      Unt CBM
                                    </label>
                                    <Field
                                      name="UnitVol"
                                      withRef
                                      ref="UnitVol"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('CantonNum', event);
                                      }}
                                    />
                                  </Col>
                                  {/* <Col xs={2} className="pr0">
                                    <label >
                                      <Translate value="plt_weight" />
                                    </label>
                                    <Field
                                      name="PalletWeight"
                                      withRef
                                      ref="PalletWeight"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (event.charCode === 13) {
                                          if (!this.state.selectedInventoryRow) {
                                            return;
                                          }
                                          if (isABCFF) {
                                            this.handleKeyPress('CantonNum', event);
                                          } else {
                                          this.handleFocusAutoSuggest();
                                          this.checkMoveToSo();
                                          }
                                        }
                                        }}
                                    />
                                  </Col> */}
                                  {/* <Col xs={2} className="pr0">
                                    <label style={{width: '100%'}}>
                                      <Translate value="oversize" />
                                    </label>
                                    <Field name="IsOversize" component={Checkbox} />
                                  </Col> */}
                                  {/* <Col xs={2} className="pr0">
                                    <label style={{width: '100%'}}>
                                      <Translate value="overweight" />
                                    </label>
                                    <Field name="IsOverweight" component={Checkbox} />
                                  </Col> */}

                                </Col>
                              </Row>
                              }
                              {
                              (isABCFF) &&
                              <Row>
                                 <Col xs={4}>
                                </Col>
                                <Col xs={8}>
                                {/* <Col xs={2} className="pl0">
                                    <label >
                                      <Translate value="total_units" />
                                    </label>
                                    <Field
                                      name="TotalUnits"
                                      withRef
                                      ref="TotalUnits"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('StoreReady', event);
                                      }}
                                      // placeholder="must be > 0"
                                    />
                                  </Col> */}
                                  <Col xs={2} className="pr0">
                                  <label style={{width: '100%'}}>
                                    <Translate value="stackable" />
                                    </label>
                                    <Field name="PalletStackable" component={Checkbox} />
                                    {/* <Field
                                      name="StoreReady"
                                      withRef
                                      ref="StoreReady"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('Preticketed', event);
                                      }}
                                      // placeholder="must be > 0"
                                    /> */}
                                  </Col>

                                  <Col xs={2} className="pr0">
                                  <label style={{width: '100%'}}>
                                    <Translate value="store_ready" />
                                    </label>
                                    <Field name="StoreReady" component={Checkbox} />
                                    {/* <Field
                                      name="StoreReady"
                                      withRef
                                      ref="StoreReady"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('Preticketed', event);
                                      }}
                                      // placeholder="must be > 0"
                                    /> */}
                                  </Col>
                                  <Col xs={2} className="pl0">
                                  <label style={{width: '100%'}}>
                                    <Translate value="preticketed" />
                                    </label>
                                    <Field name="Preticketed" component={Checkbox} />
                                    {/* <Field
                                      name="Preticketed"
                                      withRef
                                      ref="Preticketed"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('CantonNum', event);
                                      }}
                                      // placeholder="must be > 0"
                                    /> */}
                                  </Col>
                                  <Col xs={2} className="pl0">
                                    <label >
                                    Canton #
                                    </label>
                                    <Field
                                      name="CantonNum"
                                      withRef
                                      ref="CantonNum"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (!this.state.selectedInventoryRow) {
                                          return;
                                        }
                                          this.handleKeyPress('OriginCountry', event);
                                      }}
                                      // placeholder="must be > 0"
                                    />
                                  </Col>
                                  <Col xs={3} className="pl0">
                                    <label >
                                    <Translate value="origin_country" />
                                    </label>
                                    <Field
                                      name="OriginCountry"
                                      withRef
                                      ref="OriginCountry"
                                      component={InputField}
                                      onFocus={this.handleOnFocus}
                                      onKeyPress={(event) => {
                                        if (event.charCode === 13) {
                                          if (!this.state.selectedInventoryRow) {
                                            return;
                                          }
                                          this.handleFocusAutoSuggest();
                                          this.checkMoveToSo();
                                        }
                                      }}
                                      // placeholder="must be > 0"
                                    />
                                  </Col>
                                  <Col xs={1} className="pr0">
                                      <div style={{height: '12px'}}></div>
                                      <Button
                                        id="product-add-button"
                                        bsStyle="success"
                                        onClick={() => {
                                          this.checkMoveToSo();
                                        }}
                                      >
                                        +
                                      </Button>
                                    </Col>

                                </Col>

                              </Row>
                              }
                              {
                                isWIZ &&
                                  <Row>
                                    <Col xs={6}>
                                      <Col xs={2} className="pr1">
                                        {/* <label><Translate value="rcvd_qty" /></label> */}
                                        <label><Translate value="customer_qty" /></label>
                                        <Field
                                          name="ReceivedQuantity"
                                          withRef
                                          ref="ReceivedQuantity"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('ShipmentID', event);
                                          }}
                                        />
                                      </Col>
                                      <Col xs={2} className="pr0">
                                        <label><Translate value="cust_note" /></label>
                                        <Field
                                          name="ShipmentID"
                                          withRef
                                          ref="ShipmentID"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('DispatchType', event);
                                          }}
                                        />
                                      </Col>
                                      <Col xs={2} className="pr0">
                                        <label>WH Note</label>
                                        <Field
                                          name="DispatchType"
                                          withRef
                                          ref="DispatchType"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('PalletQuantity', event);
                                          }}
                                        />
                                      </Col>
                                      <Col xs={2} className="pr0">
                                        <label><Translate value="billable_plts" /></label>
                                        <Field
                                          name="BillablePallets"
                                          withRef
                                          ref="BillablePallets"
                                          component={InputField}
                                          disabled={true}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('PalletQuantity', event);
                                          }}
                                        />
                                      </Col>
                                      <Col xs={2} className="pr0">
                                        <label><Translate value="real_plts" /></label>
                                        <Field
                                          name="PalletQuantity"
                                          withRef
                                          ref="PalletQuantity"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('BoxPerPallet', event);
                                          }}
                                        />
                                      </Col>
                                      <Col xs={2} className="pr0">
                                        <label><Translate value="box_per_plt" /></label>
                                        <Field
                                          name="BoxPerPallet"
                                          withRef
                                          ref="BoxPerPallet"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('BoxLength', event);
                                          }}
                                        />
                                      </Col>
                                    </Col>

                                    <Col xs={6}>
                                    <Col xs={1} className="pr0">
                                        <label>Box L</label>
                                        <Field
                                          name="BoxLength"
                                          withRef
                                          ref="BoxLength"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('BoxWidth', event);
                                          }}
                                        />
                                      </Col>
                                      <Col xs={1} className="pr0">
                                        <label>Box W</label>
                                        <Field
                                          name="BoxWidth"
                                          withRef
                                          ref="BoxWidth"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('BoxHeight', event);
                                          }}
                                        />
                                      </Col>
                                      <Col xs={1} className="pr0">
                                        <label>Box H</label>
                                        <Field
                                          name="BoxHeight"
                                          withRef
                                          ref="BoxHeight"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) { return; }
                                            this.handleKeyPress('BoxVol', event);
                                          }}
                                        />
                                      </Col>
                                      <Col xs={2} className="pr0">
                                        <label>
                                          <Translate value="box_vol" />
                                        </label>
                                        <Field
                                          name="BoxVol"
                                          withRef
                                          ref="BoxVol"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('BoxWeight', event);
                                          }}
                                        />
                                      </Col>
                                      <Col xs={2} className="pr0">
                                        <label>
                                          <Translate value="box_weight" />
                                        </label>
                                        <Field
                                          name="BoxWeight"
                                          withRef
                                          ref="BoxWeight"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('PalletWeight', event);
                                          }}
                                        />
                                      </Col>
                                      {/* <Col xs={1} className="pr0">
                                        <label>Plt L</label>
                                        <Field
                                          name="PalletLength"
                                          withRef
                                          ref="PalletLength"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                            this.handleKeyPress('PalletWidth', event);
                                          }}
                                        />
                                      </Col>
                                      <Col xs={1} className="pr0">
                                        <label>Plt W</label>
                                        <Field
                                          name="PalletWidth"
                                          withRef
                                          ref="PalletWidth"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('PalletHeight', event);
                                          }}
                                        />
                                      </Col>
                                      <Col xs={1} className="pr0">
                                        <label >Plt H</label>
                                        <Field
                                          name="PalletHeight"
                                          withRef
                                          ref="PalletHeight"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('PalletVol', event);
                                          }}
                                        />
                                      </Col>
                                      <Col xs={2} className="pr0">
                                        <label >
                                          <Translate value="plt_vol" />
                                        </label>
                                        <Field
                                          name="PalletVol"
                                          withRef
                                          ref="PalletVol"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                              this.handleKeyPress('PalletWeight', event);
                                          }}
                                        />
                                      </Col> */}
                                      <Col xs={2} className="pr0">
                                        <label >
                                          <Translate value="plt_weight" />
                                        </label>
                                        <Field
                                          name="PalletWeight"
                                          withRef
                                          ref="PalletWeight"
                                          component={InputField}
                                          onFocus={this.handleOnFocus}
                                          onKeyPress={(event) => {
                                            if (!this.state.selectedInventoryRow) {
                                              return;
                                            }
                                            this.handleKeyPress('PortDray', event);
                                          }}
                                        />
                                      </Col>
                                      {/* <Col xs={2} className="pr0">
                                        <label style={{width: '100%'}}>
                                          <Translate value="oversize" />
                                        </label>
                                        <Field name="IsOversize" component={Checkbox} />
                                      </Col> */}
                                      {/* <Col xs={2} className="pr0">
                                        <label style={{width: '100%'}}>
                                          <Translate value="overweight" />
                                        </label>
                                        <Field name="IsOverweight" component={Checkbox} />
                                      </Col> */}
                                      {/* <Col xs={1} className="pr1">
                                      <div style={{height: '12px'}}></div>
                                      <Button
                                            id="product-add-button"
                                            bsStyle="success"
                                            onClick={() => {
                                              this.checkMoveToSo();
                                            }
                                          }
                                          >
                                            +
                                        </Button>
                                      </Col> */}
                                    </Col>
                                  </Row>
                              }
                              {
                                isWIZ &&
                                <Row>
                                  <Col xs={6}>
                                    <Col xs={2} className="pr1">
                                      <label >
                                        <Translate value="port_dray" />
                                      </label>
                                      <Field
                                        name="PortDray"
                                        withRef
                                        ref="PortDray"
                                        component={InputField}
                                        onFocus={this.handleOnFocus}
                                        onKeyPress={(event) => {
                                          if (!this.state.selectedInventoryRow) {
                                          return;
                                          }
                                          this.handleKeyPress('DrayageTrucker', event);
                                        }}
                                      />
                                    </Col>
                                    <Col xs={2}>
                                      <label >
                                        <Translate value="dray_trucker" />
                                      </label>
                                      <Field
                                        name="DrayageTrucker"
                                        withRef
                                        ref="DrayageTrucker"
                                        component={InputField}
                                        onFocus={this.handleOnFocus}
                                        onKeyPress={(event) => {
                                          if (!this.state.selectedInventoryRow) {
                                          return;
                                          }
                                          this.handleKeyPress('Location', event);
                                        }}
                                      />
                                    </Col>
                                    <Col xs={2}>
                                      <label >
                                        <Translate value="location" />
                                      </label>
                                      <Field
                                        name="Location"
                                        withRef
                                        ref="Location"
                                        component={InputField}
                                        onFocus={this.handleOnFocus}
                                        onKeyPress={(event) => {
                                        if (event.charCode === 13) {
                                          if (!this.state.selectedInventoryRow) {
                                            return;
                                          }
                                          this.handleFocusAutoSuggest();
                                          this.checkMoveToSo();
                                        }
                                        }}
                                      />
                                    </Col>
                                    <Col xs={1} className="pr1">
                                      <div style={{height: '12px'}}></div>
                                      <Button
                                        id="product-add-button"
                                        bsStyle="success"
                                        onClick={() => {
                                          this.checkMoveToSo();
                                        }}
                                      >
                                        +
                                      </Button>
                                    </Col>
                                  </Col>
                                  <Col xs={6}>
                                  </Col>
                                </Row>
                              }
                            </Col>
                          </Row>
                          {/* Inventory Details */}
                          { (!isChinaTown && !isFJ) &&
                          <Row id="inventory-details">
                            <Col xs={1}>
                              <label className="inventory-label"><Translate value="inventory" />:</label>
                            </Col>
                            <Col xs={5}>
                              <Row>
                                <Col xs={4}>
                                  <label className="col-xs-6 inlineLabel"><Translate value="cmpy_stock" /><span className="colon">:</span></label>
                                  <span className="col-xs-6 inventory-highlight"> {this.state.InStockCompany}</span>
                                </Col>
                                <Col xs={4}>
                                  <label className="col-xs-6 inlineLabel"><Translate value="wh_stock" /><span className="colon">:</span></label>
                                  <span className="col-xs-6 inventory-highlight"> {this.state.InStock}</span>
                                </Col>
                                <Col xs={4}>
                                  <label className="col-xs-6 inlineLabel"><Translate value={isVAK ? "so_usable" : "on_hand"} /><span className="colon">:</span></label>
                                  <span className="col-xs-6 inventory-highlight"> {this.state.inStockOnhand}</span>
                                </Col>
                                {/* <Col xs={4}>
                                  <label className="col-xs-6 inlineLabel"><Translate value="presale" /><span className="colon">:</span></label>
                                  <span className="col-xs-6 inventory-highlight"> {this.state.presale}</span>
                                </Col> */}
                              </Row>
                            </Col>
                            <Col xs={6}>
                              <Col xs={4}>
                                <label className="col-xs-7 inlineLabel"><Translate value={isVAK ? "so_purchased" : "purchased"} /><span className="colon">:</span></label>
                                <span className="col-xs-5 inventory-highlight"> {this.state.purchased}</span>
                              </Col>
                              <Col xs={4}>
                                <label className="col-xs-5 inlineLabel"><Translate value="presale" /><span className="colon">:</span></label>
                                <span className="col-xs-6 inventory-highlight"> {this.state.presale}</span>
                              </Col>
                              {/* <Col xs={4}>
                                <label className="col-xs-5 inlineLabel"><Translate value="net_wt" /><span className="colon">:</span></label>
                                <span className="col-xs-6 inventory-highlight"> {this.state.net_weight}</span>
                              </Col> */}
                              {/* <Col xs={4}>
                                <label className="col-xs-5 inlineLabel"><Translate value="ship_wt" /><span className="colon">:</span></label>
                                <span className="col-xs-6 inventory-highlight"> {this.state.ship_weight}</span>
                              </Col> */}
                              {
                                (isLMH || isSDR || isCRW || isSC) &&
                                <Col xs={4}>
                                  <label className="col-xs-6 inlineLabel">Stock(LMH)<span className="colon">:</span></label>
                                  <span className="col-xs-6 inventory-highlight"> {this.state.InStockMain}</span>
                                </Col>
                              }
                              {
                                !(isLMH || isSDR || isCRW || isSC) &&
                                <Col xs={4}>
                                  <label className="col-xs-5 inlineLabel"><Translate value="total_wt" /><span className="colon">:</span></label>
                                  <span className="col-xs-6 inventory-highlight"> {this.state.total_weight}</span>
                                </Col>
                              }
                            </Col>
                          </Row>
                          }
                          { (isGGI || isVAK || isCTP) &&
                          <Row id="levelPrice-details" className='levels-row'>
                            <Col xs={1}>
                              <label className="inventory-label"><Translate value="levels" />:</label>
                            </Col>
                            <Col xs={5}>
                              <Row>
                                <Col xs={4}>
                                  <label className="col-xs-6 inlineLabel"><Translate value="level_1" /><span className="colon">:</span></label>
                                  <span className="col-xs-6 inventory-highlight"> {this.state.level1}</span>
                                </Col>
                                <Col xs={4}>
                                  <label className="col-xs-6 inlineLabel"><Translate value="level_2" /><span className="colon">:</span></label>
                                  <span className="col-xs-6 inventory-highlight"> {this.state.level2}</span>
                                </Col>
                                <Col xs={4}>
                                  <label className="col-xs-6 inlineLabel"><Translate value="level_3" /><span className="colon">:</span></label>
                                  <span className="col-xs-6 inventory-highlight"> {this.state.level3}</span>
                                </Col>

                              </Row>
                            </Col>
                            <Col xs={6}>
                              <Col xs={4}>
                                <label className="col-xs-7 inlineLabel"><Translate value="level_4" /><span className="colon">:</span></label>
                                <span className="col-xs-5 inventory-highlight"> {this.state.level4}</span>
                              </Col>
                              <Col xs={4}>
                                <label className="col-xs-5 inlineLabel"><Translate value="level_5" /><span className="colon">:</span></label>
                                <span className="col-xs-6 inventory-highlight"> {this.state.level5}</span>
                              </Col>
                                <Col xs={4}>
                                  <label className="col-xs-5 inlineLabel"><Translate value="ref_price" /><span className="colon">:</span></label>
                                  <span className="col-xs-6 inventory-highlight"> {this.state.levelRefPrice}</span>
                                </Col>
                            </Col>
                          </Row>
                          }
                          { isChinaTown &&
                            <Row id="inventory-details" style={{fontSize: '15px'}}>
                              <Col xs={1}>
                                <label className="inventory-label-china"><Translate value="inventory" />:</label>
                              </Col>
                              <Col xs={5}>
                                <Row>
                                  <Col xs={4} className="pr1">
                                    <label className="col-xs-6 inlineLabel"><Translate value="in_stock" /><span className="colon">:</span></label>
                                    <span className="col-xs-6 inventory-highlight-china"> {this.state.inStock}</span>
                                  </Col>
                                  <Col xs={4} className="pr1">
                                    <label className="col-xs-7 inlineLabel"><Translate value="purchased" /><span className="colon">:</span></label>
                                    <span className="col-xs-5 inventory-highlight-china"> {this.state.purchased}</span>
                                  </Col>
                                  <Col xs={4} className="pr1">
                                    <label className="col-xs-6 inlineLabel"><Translate value="presale" /><span className="colon">:</span></label>
                                    <span className="col-xs-6 inventory-highlight-china"> {this.state.presale}</span>
                                  </Col>
                                </Row>
                              </Col>
                              <Col xs={6}>
                                <Col xs={4} className="pr1">
                                  <label className="col-xs-5 inlineLabel"><Translate value="net_wt" /><span className="colon">:</span></label>
                                  <span className="col-xs-6 inventory-highlight-china"> {this.state.net_weight}</span>
                                </Col>
                                <Col xs={4} className="pr1">
                                  <label className="col-xs-5 inlineLabel"><Translate value="ship_wt" /><span className="colon">:</span></label>
                                  <span className="col-xs-6 inventory-highlight-china"> {this.state.ship_weight}</span>
                                </Col>
                                <Col xs={4} className="pr1">
                                  <label className="col-xs-5 inlineLabel"><Translate value="total_wt" /><span className="colon">:</span></label>
                                  <span className="col-xs-6 inventory-highlight-china"> {this.state.total_weight}</span>
                                </Col>
                              </Col>
                            </Row>
                          }
                          {
                            isEcity && (
                            <Row id="inventory-details">
                              <Col xs={1}>
                                <label className="inventory-label"><Translate value="last_sale" />:</label>
                              </Col>
                              <Col xs={5}>
                                <Row>
                                  <Col xs={4}>
                                    <label className="col-xs-6 inlineLabel"><Translate value="price" /><span className="colon">:</span></label>
                                    <span className="col-xs-6 inventory-highlight"> {this.state.salesItemHistory[0] && this.state.salesItemHistory[0].UnitPrice}</span>
                                  </Col>
                                  <Col xs={5}>
                                    <label className="col-xs-7 inlineLabel" style={{ width: '60px'}}><Translate value="date" /><span className="colon">:</span></label>
                                    <span className="col-xs-5 inventory-highlight" style={{ width: '80px'}}> {this.state.salesItemHistory[0] && this.state.salesItemHistory[0].Date}</span>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>)
                          }
                        </Tab>
                        {this.renderRollingGate()}
                        {
                          !(isDSQ || isWIZ || isFJ || isJTB || isABCFF) &&
                          <Tab eventKey={2} title={frequentProducts} style={{height: isLAP ? '400px' : 'inherit'}}>
                            <div className="tab-products-table sales-order-freq-products">
                              <Button className="btn btn-primary position" disabled={(!(this.state.frequentItems.selectedIndexes) || this.state.frequentItems.selectedIndexes.length === 0)} onClick={() => { this.moveFromFrequentItemsToSalesOrder(); }}><em className="fa fa-plus" /></Button>
                              {this.renderFrequent()}
                            </div>
                          </Tab>
                        }
                        <Tab eventKey={3} title={previousOrderList}>
                          <div className="tab-products-table" style={{...(isOLG || isLAP) ? {height: '280px'} : {}}}>
                            <Row>
                              <Col xs={8} style={{ marginTop: '-12px', paddingBottom: '13px', zIndex: '1' }}>
                                <Button
                                  className="btn btn-primary"
                                  onClick={this.handleShowAll}
                                >
                                  <Translate value="show_from_all_orders" />
                                </Button>
                                <Button
                                  className="btn btn-primary"
                                  style={{ marginLeft: '5px' }}
                                  onClick={this.handleSelectAll}
                                >
                                  <Translate value="select_all" />
                                </Button>
                                <Button
                                  className="btn btn-primary"
                                  bsStyle="danger"
                                  style={{ marginLeft: '5px' }}
                                  onClick={this.handleDeselectAll}
                                >
                                  <Translate value="deselect_all" />
                                </Button>
                                <Button
                                  className="btn btn-primary"
                                  style={{ marginLeft: '5px' }}
                                  disabled={
                                    !isLAP ? (!(this.state.previousOrders.selectedIndexes) || this.state.previousOrders.selectedIndexes.length === 0) :
                                    (!(this.state.previousOrders.selectedIndexes) || this.state.previousOrders.selectedIndexes.length === 0 || this.state.previousOrders.rows.filter(item => item.IsDeleted).length > 0)
                                  }
                                  onClick={() => { this.moveFromPreviousOrderToSalesOrder(); }}
                                >
                                  <em className="fa fa-plus" />
                                </Button>
                                <input
                                  style={{width: '150px', borderRadius: '5px', marginLeft:'5px', border: '1px solid black'}}
                                  type="text"
                                  onChange={e => { this.onChangeQuickEntry(e); }}
                                  onKeyPress={e => { this.onKeyPressQuickEntry(e); }}
                                  value={this.state.quickEntrySONum}
                                  placeholder={isSV ? "CPO/Order No. " : isOLG ? I18n.t('si_no') : I18n.t('order_num')}
                                />
                                {
                                  this.state.quickEntryShowError &&
                                  <span style={{ marginLeft: '3px', color: 'red' }}>
                                    <Translate value="so_not_found" />
                                  </span>
                                }
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={3}>
                                {this.renderPreviousSOs()}
                              </Col>
                              <Col xs={9} style={{ marginTop: '-18px' }}>
                                {this.renderPreviousOrders()}
                              </Col>
                            </Row>
                            {
                              (isOLG || isLAP) && !this.props.previousOrdersIsLoading &&
                              this.renderInventoryRow()
                            }
                          </div>
                        </Tab>
                        {
                          !(isDSQ || isWIZ || isFJ || isJTB || isABCFF) &&
                          <Tab eventKey={4} title={favoriteList}>
                            <div className="tab-products-table">
                              <Button
                                bsStyle="primary"
                                disabled={(!(this.state.favorites.selectedIndexes) || this.state.favorites.selectedIndexes.length == 0)}
                                onClick={() => {
                                  this.moveFromFavoriteItemsToSalesOrder();
                                }}
                              >
                                <em className="fa fa-plus" />
                              </Button>
                              {this.renderFavoritesList()}
                              {
                                (isOLG || isLAP) &&
                                this.renderInventoryRow()
                              }
                            </div>
                          </Tab>
                        }
                      </Tabs>
                    </fieldset>
                  </Row>
                }
                {
                  (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') &&
                  <Row>
                  {this.productHeader()}
                    <fieldset
                      className={`form-horizontal ${this.state.isProductInformationPanelFolded ? 'folded' : ''}`}
                      style={{minHeight: '200px', maxHeight: '400px'}}
                    >
                      <Tabs activeKey={this.state.yourOrderKey} justified onSelect={this.handleSelect}>
                        <Tab eventKey={1} title={inboundProducts}>
                          <div className="tab-products-table sales-order-freq-products">
                            <Button className="btn btn-primary position" disabled={this.checkblah()} onClick={() => { this.moveFromFrequentItemsToSalesOrder(); }}><em className="fa fa-plus" /></Button>
                            {/* (!(this.state.frequentItems.selectedIndexes) || this.state.frequentItems.selectedIndexes.length === 0) */}
                            {this.renderInboundProducts()}
                          </div>
                        </Tab>
                      </Tabs>
                    </fieldset>
                  </Row>
                }
                {
                  !isMAG &&
                  <Row>
                    {!isFJ && this.orderHeader()}
                    <fieldset className="form-horizontal">
                      <Panel>
                        <div>
                          <ButtonToolbar>
                          { isSUN &&<Button
                              bsStyle="success"
                              type="button"
                              style={{ float: 'right' }}
                              onClick={() => {
                                 this.setState({ hideCol : !this.state.hideCol })
                              }}
                            >
                              <Translate value={this.state.hideCol ? "show" : "hide"} />
                            </Button>
                          }
                          {(isSW || isSH) && <div style={{ float: 'right', alignItems: 'center', display:'flex' }}>
                            {isSH && <Button
                              bsStyle="primary"
                              type="button"
                              style={{ float: 'right' }}
                              onClick={() => {
                                let rows = this.state.rows.map(row => ({...row, PickedQuantity: 0}))
                                 this.setState({ rows });
                              }}
                            >
                              <Translate value='reset_picked_qty' />
                            </Button>}
                              <label className="row-count">
                                <Translate value="total_qty" />
                                :&nbsp;
                                <span className="font-color-orange" id="row-count-equation">
                                  {renderTotalQty()}
                                </span>
                              </label>
                            </div>
                          }
                          </ButtonToolbar>
                        </div>
                        {this.renderTable()}
                      </Panel>
                    </fieldset>
                  </Row>
                }
                {
                  isVAK && <OrderRequests disabled={this.props.activeIdx === null}/>
                }
              </Col>
                {/* SO Details Pane */}
                <Col xs={2} className={`sales-order-details-panel ${isVAK && isMobile ? 'vak-mobile' : ''}`} style={{marginTop: isFJ ? '11px' : '0px'}}>
                  <Tabs defaultActiveKey={1} justified className="tab-width-fix">
                    <Tab eventKey={1} title={SODetails} className="so-details-tab">
                      {
                        isChinaTown && //chinatest
                      <Row className="customer-specific-price-details">
                        <Col xs={6}>
                          <label><Translate value="ref" /></label>
                                : <span className="dollar-sign">$</span>{this.state.RefPrice ? this.state.RefPrice.toFixed(2) : '--'}
                        </Col>
                        <Col xs={6}>
                          <label><Translate value="lowest" /></label>
                                : <span className="dollar-sign">$</span>{this.state.LowestSalePrice ? this.state.LowestSalePrice.toFixed(2) : '--'}
                        </Col>
                          <Col xs={6}>
                            <label><Translate value="Lv1" /></label>
                                : <span className="dollar-sign">$</span>{this.state.PriceLv1 ? this.state.PriceLv1.toFixed(2) : '--'}
                          </Col>
                          <Col xs={6}>
                          <label><Translate value="Lv2" /></label>
                              : <span className="dollar-sign">$</span>{this.state.PriceLv2 ? this.state.PriceLv2.toFixed(2) : '--'}
                          </Col>
                          <Col xs={6}>
                          <label><Translate value="Lv3" /></label>
                              : <span className="dollar-sign">$</span>{this.state.PriceLv3 ? this.state.PriceLv3.toFixed(2) : '--'}
                          </Col>
                          <Col xs={6}>
                          <label><Translate value="Lv4" /></label>
                              : <span className="dollar-sign">$</span>{this.state.PriceLv4 ? this.state.PriceLv4.toFixed(2) : '--'}
                          </Col>
                          <Col xs={6}>
                          <label><Translate value="Lv5" /></label>
                              : <span className="dollar-sign">$</span>{this.state.PriceLv5 ? this.state.PriceLv5.toFixed(2) : '--'}
                          </Col>
                        {
                          isJML &&
                          <div>
                          <Col xs={4}>
                            <label><Translate value="payment_term_short" />:</label>
                          </Col>
                          <Col xs={8}>
                            <Field name="PaymentTerm_id" component={Selection} options={this.state.paymentTermOptions}/>
                          </Col>
                          </div>
                        }
                        {this.renderDeliveryMethodInfo()}
                      </Row>
                      }
                      {
                        !isChinaTown &&
                        <Row className="sales-order-number">
                          <Col xs={3}>
                            <label><Translate value={(isWIZ || isJTB || isDSQ || isFJ || isABCFF) ? "order_no" : "so_no"} /></label>
                          </Col>
                          <Col xs={9}>
                            <Field
                              name="SONum"
                              component={SONumberInput}
                              placeholder={this.state.salesOrderNumber}
                            />
                          </Col>
                        </Row>
                      }
                    {/*
                      <Row className="sales-order-number">
                        <Col xs={3}>
                          <label><Translate value="sales" /></label>
                        </Col>
                        <Col xs={9}>{this.ocmRenderPickers()}</Col>
                      </Row>
                    */}
                      {
                        !isChinaTown &&
                        <Row className="sales-order-number">
                          <Row style={{ marginBottom: '0px', paddingLeft: '8px'}}>
                            <Col xs={3}>
                              <label><Translate value={isSV ? "sales#1" : "sales"} />: </label>
                            </Col>
                            <Col xs={9}>
                              {this.renderSales()}
                            </Col>
                          </Row>
                        </Row>
                      }
                    {
                      !isChinaTown &&
                      <Row className="sales-order-number">
                        {isSV &&
                          <div>
                            <Row style={{ marginBottom: '6px', paddingLeft: '8px'}}>
                              <Col xs={3}>
                                <label><Translate value="comm#1" />:</label>
                              </Col>
                              <Col xs={9}>
                                <Field name="Commission" component={InputField} />
                              </Col>
                            </Row>
                            <Row style={{ marginBottom: '6px', paddingLeft: '8px'}}>
                              <Col xs={3}>
                                <label><Translate value="sales#2" />:</label>
                              </Col>
                              <Col xs={9}>
                                <Field
                                  name="Sales_User_id2"
                                  matchPos="any"
                                  component={SelectionWithProps}
                                  options={this.getUsers()}
                                  onSelect={ value => {
                                    if (value) {
                                      this.setState({ created_by2: value.value });
                                      this.props.setValue('salesOrderForm', 'Commission2', value.commission);
                                    } else {
                                      this.setState({ created_by2: null });
                                      this.props.setValue('salesOrderForm', 'Commission2', null);
                                    }
                                  }}
                                />
                              </Col>
                            </Row>
                            <Row style={{ marginBottom: '6px', paddingLeft: '8px'}}>
                              <Col xs={3}>
                                <label><Translate value="comm#2" />: </label>
                              </Col>
                              <Col xs={9}>
                                <Field name="Commission2" component={InputField} />
                              </Col>
                            </Row>
                          </div>
                        }
                        {isVAK && isQuoteStep && <div>
                          <Col xs={4}>
                            <label><Translate value="reviewer"/>:</label>
                          </Col>
                          <Col xs={8}>
                            <Field name="Req_Review_User_id" component={Selection} options={this.getUsers()} disabled={(Req_Review_Status === 'Pending' || Req_Review_Status === 'Confirm') && Req_Review_User_id}/>
                          </Col>
                        </div>}
                        {isVAK && isQuoteStep && <div>
                          <Col xs={4}>
                            <label><Translate value="approver"/>:</label>
                          </Col>
                          <Col xs={8}>
                            <Field name="Req_Approve_User_id" component={Selection} options={this.getUsers()} disabled={(Req_Approve_Status === 'Pending' || Req_Approve_Status === 'Confirm') && Req_Approve_User_id}/>
                          </Col>
                        </div>}
                        {isVAK && !isQuoteStep && <div>
                          <Col xs={4}>
                            <label><Translate value="reviewer"/>:</label>
                          </Col>
                          <Col xs={8}>
                            <Field name="Review_User_id" component={Selection} options={this.getUsers()}  disabled={(Review_Status === 'Pending' || Review_Status === 'Confirm') && Review_User_id}/>
                          </Col>
                        </div>}
                        {isVAK && !isQuoteStep && <div>
                          <Col xs={4}>
                            <label><Translate value="approver"/>:</label>
                          </Col>
                          <Col xs={8}>
                            <Field name="Approve_User_id" component={Selection} options={this.getUsers()} disabled={(Approve_Status === 'Pending' || Approve_Status === 'Confirm') && Approve_User_id}/>
                          </Col>
                        </div>}
                        <Col xs={12}>
                          <label><Translate value="created_by"/></label>
                          : {this.state.creator}
                        </Col>
                        <Col xs={12}>
                          <label><Translate value="modified_last_by"/></label>
                          : {this.state.modified_by}
                        </Col>
                        {!isHMM &&
                          <Col xs={12}>
                            <label><Translate value="customer_price_level" /></label>
                                : {this.state.customerPriceLevel}
                          </Col>
                        }
                        {
                          !(isJML || isSV) &&
                          <Col xs={12}>
                            <label><Translate value="payment_term" /></label>
                              : {this.state.customerPaymentTerm}
                          </Col>
                        }
                        {
                          (isJML || isSV) &&
                          <div>
                            <Col xs={4}>
                              <label><Translate value="payment_term_short" />:</label>
                            </Col>
                            <Col xs={8}>
                              <Field name="PaymentTerm_id" component={Selection} options={this.state.paymentTermOptions}/>
                            </Col>
                          </div>
                        }
                        {this.renderDeliveryMethodInfo()}
                      </Row>
                    }
                    {
                      !isChinaTown &&
                      <Row className="sale-pricing-details">
                        <Col xs={(isOLG || isVAK) ? 6 : 4} style={{ padding: '0px'}}>
                          {/* <label><Translate value="disc" />%</label>
                          <Field
                              name="Discount"
                              component={InputField}
                              onChange={this.handleDiscountChange}
                            /> */}
                          { this.renderDiscountAmount() }
                        </Col>
                        <Col xs={(isOLG || isVAK) ? 6 : 4} style={{ paddingRight: '0px' }}>
                          <label><Translate value="tax" /><span className="dollar-sign">$</span></label>
                          <div onDoubleClick={() => { this.openChangeTax() }} style={{ width: '55px', borderRadius: '3px', padding: '2px 5px', border: '1px solid black', backgroundColor: '#dddddd' }}>
                            {parseFloat(totalTaxWithPromotion).toFixed(2)}
                          </div>

                          {/* <span onDoubleClick={() => { this.openChangeTax(); }}><Field name="Tax" isBlue= {(isGGI || isOLG)}
                          component={DisabledInputField} placeholder=parseFloat(totalTaxWithPromotion).toFixed(2) /></span> */}
                        </Col>
                        {
                          !(isEKC || isLMH || isSDR || isCRW || isSC || isOLG || isVAK) &&
                          <Col xs={4} style={{ paddingRight: '0px' }}>
                            <label><Translate value="CRV" /><span className="dollar-sign">$</span></label>
                            <div style={{ width: '55px', borderRadius: '3px', padding: '2px 5px', border: '1px solid black', backgroundColor: '#dddddd' }}>
                              {/* {parseFloat(totalTaxWithPromotion).toFixed(2)} */}
                              {(this.state.totalCRV).toFixed(2)}
                            </div>
                            {/* <Field name="CRV" component={DisabledInputField} placeholder={(this.state.totalCRV).toFixed(2)} /> */}
                          </Col>
                        }
                      </Row>
                    }
                    {
                      !isChinaTown &&
                      <Row className="sale-details-output">
                        {
                          (isMyumyu || isAFG || isRivera || isWecom || isDHC || isAFM || isEcity || isMultiWH) &&
                          <Col xs={12}>
                            <Row className="pricing-highlight">
                              <Col xs={6}>
                                <label><Translate value="delivery" /><span className="dollar-sign">$$</span>:</label>
                              </Col>
                              <Col xs={6}>
                                <div onDoubleClick={() => { this.openDeliveryFee(); }} style={isOLG ? olgBorderStyle : null}>
                                  <label style={{color: (isOLG || isGGI) ? 'blue':'black', fontWeight:'bold'}}><span className="dollar-sign">$</span>{(this.state.delivery).toFixed(2)}</label>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        }
                        <Col xs={12}>
                          <Row className="pricing-highlight">
                            <Col xs={6}>
                              <label><Translate value="order" /><span className="dollar-sign">$$</span>:</label>
                            </Col>
                            <Col xs={6}>
                              <label><span className="dollar-sign">$</span>{(this.state.totalPrice).toFixed(2)}</label>
                            </Col>
                          </Row>
                        </Col>
                        {
                          (isEKC || isLMH || isSDR || isCRW || isSC) &&
                          <Col xs={12}>
                            <Row className="pricing-highlight">
                              <Col xs={6}>
                                <label><Translate value="handling_fee" /><span className="dollar-sign"></span>:</label>
                              </Col>
                              <Col xs={6}>
                              <div onDoubleClick={() => { this.openHandlingFee(); }} >
                                <label><span className="dollar-sign">$</span>{(this.state.handlingFee ? this.state.handlingFee : 0).toFixed(2)}</label>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        }
                        {
                          (isEKC || isLMH || isOLG || isVAK) &&
                          <Col xs={12}>
                            <Row className="pricing-highlight">
                              <Col xs={6}>
                                <label><Translate value="transaction_fee" /><span>&nbsp;%</span>:</label>
                              </Col>
                              <Col xs={6}>
                              <div onDoubleClick={() => { this.openPercentageFee(); }} style={isOLG ? olgBorderStyle : null}>
                                <label style={{color:'blue'}}>{this.state.percentageFee ? this.state.percentageFee : 0}<span>%</span></label>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        }
                        {
                          isSH &&
                          <Col xs={12}>
                            <Row className="pricing-highlight">
                              <Col xs={6}>
                                <label><Translate value="c_c" /><span>&nbsp;%</span>:</label>
                              </Col>
                              <Col xs={6}>
                              <div onDoubleClick={() => { this.openCCFee(); }}>
                                <label>{this.state.ccFee ? this.state.ccFee : 0}({ this.state.ccOrigin ? (this.state.ccOrigin * 100) : 0}<span>)%</span></label>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        }
                        {!(isEKC || isLMH || isSDR || isCRW || isSC || isOLG || isVAK || isSH) &&
                          <Col xs={12}>
                            <Row className="pricing-highlight">
                              <Col xs={6}>
                                <label><Translate value="transaction_fee" /><span className="dollar-sign">$$</span>:</label>
                              </Col>
                              <Col xs={6}>
                              <div onDoubleClick={() => { console.log("none") }} >
                                <label><span className="dollar-sign">$</span>{(this.state.fee ? this.state.fee : 0).toFixed(2)}</label>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        }
                        {(isEKC || isLMH || isSDR || isCRW || isSC || isOLG || isVAK) &&
                          <Col xs={12}>
                            <Row className="pricing-highlight">
                              <Col xs={6}>
                                <label><Translate value="transaction_fee" /><span className="dollar-sign">$$</span>:</label>
                              </Col>
                              <Col xs={6}>
                              <div onDoubleClick={() => { console.log("none"); }} >
                                <label><span className="dollar-sign">$</span>{(this.state.transFee ? this.state.transFee : 0).toFixed(2)}</label>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        }
                        {
                          (this.state.creditAmount > 0) &&
                          <Col xs={12}>
                            <Row className="pricing-highlight">
                              <Col xs={6}>
                                <label><Translate value="credit" /><span className="dollar-sign">$$</span>:</label>
                              </Col>
                              <Col xs={6}>
                                <label>
                                  {/* {
                                  (this.state.creditAmount > 0) &&
                                  <span>-</span>
                                } */}
                                  <span style={{ paddingLeft: '0px' }} className="dollar-sign">-$</span>
                                  {this.state.creditAmount}
                                </label>
                              </Col>
                            </Row>
                          </Col>
                        }
                        {
                          (this.state.shareCreditAmount > 0) &&
                          <Col xs={12}>
                            <Row className="pricing-highlight">
                              <Col xs={6}>
                                <label><Translate value="share" /><span className="dollar-sign">$$</span>:</label>
                              </Col>
                              <Col xs={6}>
                                <label>
                                  <span style={{ paddingLeft: '0px' }} className="dollar-sign">-$</span>
                                  {this.state.shareCreditAmount}
                                </label>
                              </Col>
                            </Row>
                          </Col>
                        }
                        {
                          isVAK && isMobile && <Col xs={12}>
                            <Row className="pricing-highlight">
                              <Col xs={6}>
                                <label><Translate value="ship_subtotal" /><span className="dollar-sign">$$</span>:</label>
                              </Col>
                              <Col xs={6}>
                                <label><span className="dollar-sign">$</span>{parseFloat((this.state.ShippingSubtotal)).toFixed(2)}</label>
                              </Col>
                            </Row>
                          </Col>
                        }
                        {
                          isVAK && isMobile && <Col xs={12}>
                            <Row className="pricing-highlight">
                              <Col xs={6}>
                                <label><Translate value="est_tax" /><span className="dollar-sign">$$</span>:</label>
                              </Col>
                              <Col xs={6}>
                                <label><span className="dollar-sign">$</span>{parseFloat((this.state.EstimatedTax)).toFixed(2)}</label>
                              </Col>
                            </Row>
                          </Col>
                        }
                        <Col xs={12}>
                          <Row className="pricing-highlight">
                            <Col xs={6}>
                              <label><Translate value="final" /><span className="dollar-sign">$$</span>:</label>
                            </Col>
                            <Col xs={6}>
                              <label><span className="dollar-sign">$</span>{parseFloat((this.state.finalPriceWithPromotion)).toFixed(2)}</label>
                            </Col>
                          </Row>
                        </Col>
                        {
                          !isHMM &&
                          <div>
                            <Col xs={6}>
                              <label><Translate value="net_wt" />:</label>
                            </Col>
                            <Col xs={6}>
                              <label>{dispNetWeight} lb</label>
                            </Col>
                            <Col xs={6}>
                              <label><Translate value="ship_wt" />:</label>
                            </Col>
                            {/* <Col xs={3}>
                          <span onDoubleClick={() => { this.openChangeWeight(); }}><Field name="ShippingWeight" component={DisabledInputField} placeholder={dispShippingWeight}/></span>
                        </Col>
                        <Col xs={1} style={{padding:'0px'}}>
                          <span style={{fontWeight: '550'}}>lb</span>
                        </Col> */}
                            <Col xs={6}>
                              <div onDoubleClick={() => { this.openChangeWeight(); }} style={isOLG ? olgBorderStyle : null}>
                                <label style={{ color: 'blue' }}>{dispShippingWeight}</label>
                                <span style={{ fontWeight: '550' }}> lb</span>
                              </div>
                            </Col>
                            {isGGI && <div>
                              <Col xs={6}>
                                <label><Translate value="total_qty" />:</label>
                              </Col>
                              <Col xs={6}>
                                <label>{dispQty}</label>
                              </Col></div>}
                          </div>
                        }
                      </Row>
                    }
                    {
                      (!isWIZ && !isDSQ && !isFJ && !isJTB && !isABCFF) &&
                      <Row className="sale-history-details" style={{ 'margin-top': '0' }}>
                        <Col xs={12}>
                          <h4 style={{ marginBottom: '5px', color: (isOLG || isGGI || isDAICHEONG)?'blue':'black', fontWeight:'bold'}}
                            onDoubleClick={()=>{
                              if(!isOLG && !isGGI && !isDAICHEONG) {
                                return
                              }
                              this.openSalesHistory()
                            }}>
                            <Translate value="sales_history" />
                          </h4>
                          {/* {this.state.productHistoryLabel} */}
                          {this.renderItemHistory()}
                        </Col>
                      </Row>
                    }
                    {
                      isLAP &&
                      <Row className="sale-history-details" style={{ 'margin-top': '0' }}>
                        <Col xs={12}>
                          <h4 style={{ marginBottom: '5px', fontWeight:'bold'}}>
                            <Translate value="purchase_history" />
                          </h4>
                          {this.renderPurchaseHistory()}
                        </Col>
                      </Row>
                    }
                    {
                      isChinaTown &&
                      <Row className="sales-order-number">
                        <Col xs={3}>
                          <label style={{marginBottom: '0px'}}><Translate value="so_no" /></label>
                        </Col>
                        <Col xs={9}>
                          <Field
                            name="SONum"
                            component={SONumberInput}
                            placeholder={this.state.salesOrderNumber}
                          />
                        </Col>
                      </Row>
                    }
                    {
                      isChinaTown &&
                      <Row className="customer-specific-price-details">
                        <Col xs={12}>
                          <label><Translate value="created_by" /></label>
                                : {this.state.created_by}
                        </Col>
                        <Col xs={12}>
                          <label><Translate value="modified_last_by" /></label>
                                : {this.state.modified_by}
                        </Col>
                        {!isHMM &&
                          <Col xs={12}>
                            <label><Translate value="customer_price_level" /></label>
                                : {this.state.customerPriceLevel}
                          </Col>
                        }
                        {
                          !isJML &&
                          <Col xs={12}>
                          <label><Translate value="payment_term" /></label>
                              : {this.state.customerPaymentTerm}
                          </Col>
                        }
                        {
                          isJML &&
                          <div>
                          <Col xs={4}>
                            <label><Translate value="payment_term_short" />:</label>
                          </Col>
                          <Col xs={8}>
                            <Field name="PaymentTerm_id" component={Selection} options={this.state.paymentTermOptions}/>
                          </Col>
                          </div>
                        }
                        {this.renderDeliveryMethodInfo()}
                      </Row>
                    }
                    {/* {
                      isChinaTown &&
                      <Row className="sale-details-output"  style={{marginTop: isChinaTown ? '0px' : '5px'}}>
                        <Col xs={12}>
                          <Row className="pricing-highlight">
                            <Col xs={6}>
                              <label><Translate value="order" /><span className="dollar-sign">$$</span>:</label>
                            </Col>
                            <Col xs={6}>
                              <label><span className="dollar-sign">$</span>{(this.state.totalPrice).toFixed(2)}</label>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={12}>
                          <Row className="pricing-highlight">
                            <Col xs={6}>
                              <label><Translate value="final" /><span className="dollar-sign">$$</span>:</label>
                            </Col>
                            <Col xs={6}>
                              <label><span className="dollar-sign">$</span>{parseFloat((this.state.finalPriceWithPromotion)).toFixed(2)}</label>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={12}>
                          <div style={{marginBottom: '10px'}}></div>
                        </Col>
                      </Row>
                    } */}
                    {
                      !isChinaTown &&
                      <Row className="customer-credit-details" style={{ 'margin-top': '0' }}>
                        <Col xs={12}>
                          {this.renderCustomerCredit()}
                        </Col>
                        <Col xs={6} style={{ color: 'red' }}>
                          <label>00-30 <Translate value="days" />:</label>
                        </Col>
                        <Col xs={6} style={{ color: 'red' }}>
                          <span className="dollar-sign">$</span>{(this.state.Amount00_30).toFixed(2)}
                        </Col>
                        <Col xs={6} style={{ color: 'red' }}>
                          <label>30-60 <Translate value="days" />:</label>
                        </Col>
                        <Col xs={6} style={{ color: 'red' }}>
                          <span className="dollar-sign">$</span>{(this.state.Amount31_60).toFixed(2)}
                        </Col>
                        <Col xs={6} style={{ color: 'red' }}>
                          <label>60-90 <Translate value="days" />:</label>
                        </Col>
                        <Col xs={6} style={{ color: 'red' }}>
                          <span className="dollar-sign">$</span>{(this.state.Amount61_90).toFixed(2)}
                        </Col>
                        <Col xs={6} style={{ color: 'red' }}>
                          <label>90+ <Translate value="days" />:</label>
                        </Col>
                        <Col xs={6} style={{ color: 'red' }}>
                          <span className="dollar-sign">$</span>{(this.state.Amount91).toFixed(2)}
                        </Col>
                        <Col xs={6}>
                          <label><Translate value="last_month" />:</label>
                        </Col>
                        <Col xs={6}>
                          <span className="dollar-sign">$</span>
                        </Col>
                        <Col xs={6}>
                          <label><Translate value="unpaid" />:</label>
                        </Col>
                        <Col xs={6}>
                          <span className="dollar-sign">$</span>
                        </Col>
                        <Col xs={6}>
                          <label><Translate value="credit_limit" />:</label>
                        </Col>
                        <Col xs={6}>
                          <span className="dollar-sign"></span>{this.state.CreditLimit}
                        </Col>
                        <Col xs={6}>
                          <label><Translate value="description" />:</label>
                        </Col>
                        <Col xs={6}>
                          <span className="dollar-sign"></span>{this.state.PaymentTermDesc}
                        </Col>
                        <Col xs={6}>
                          <label><Translate value="credit"/>: <Translate value={this.props.salesCustomerDetails && this.props.salesCustomerDetails.CreditStatus ?
                            this.props.salesCustomerDetails.CreditStatus : ''} /></label>
                        </Col>
                      </Row>
                      }
                      {
                        !isChinaTown &&
                        <Row className="customer-note">
                          <Col xs={12} style={{ 'padding-left': '0' }}>
                            <Tabs justified className="notations" defaultActiveKey={(isSV && this.state.employeeNoteDisplay) ? 2 : 1} >
                              <Tab eventKey={1} title={customerNote} >
                                <Field id="cust-note" name="Notation" maxLength={150} component="Textarea" className="form-control" style={{ minHeight: '75px' }}/>
                              </Tab>
                              <Tab eventKey={2} title={employeeNote}>
                                {/* <span onDoubleClick={() => { */}
                                {/*   this.openEmployeeNote(); */}
                                {/* }}> */}
                                {/*   <Input */}
                                {/*     type="text" */}
                                {/*     value={this.state.employeeNoteDisplay} */}
                                {/*     disabled */}
                                {/*   /> */}
                                {/* </span> */}
                                {
                                  isEzgo && location.href.split('/').pop() === 'new' ?
                                  <Field id="emp-note" name="EmployeeNote" maxLength={150} component="Textarea" className="form-control" style={{ minHeight: '75px' }}/> :
                                  <div onDoubleClick={() => {
                                    this.openEmployeeNote();
                                  }} style={{
                                    width: '100%',
                                    height: '24px',
                                    borderRadius: '3px',
                                    padding: '2px 5px',
                                    border: '1px solid #555555',
                                    backgroundColor: isEzgo ? 'white' : '#CFD8DC'
                                  }}>
                                    {this.state.employeeNoteDisplay}
                                  </div>
                                }
                              </Tab>
                              <Tab eventKey={3} title={routeNote}>
                                <Field id="route-note" name="RouteNote" maxLength={150} component={InputField}/>
                              </Tab>
                            </Tabs>
                          </Col>
                        </Row>
                      }
                    </Tab>
                    <Tab eventKey={2} title={CheckoutInfo} className="check-out-info-tab">
                      { this.renderPaymentInfo() }
                      <Row className="note-input-field">
                        <Col xs={12}>
                          <div>
                            <h4><Translate value="note" /></h4>
                          </div>
                        </Col>
                        <Col xs={12}>
                          <Field name="Note" component="Textarea" className="form-control" style={{ minHeight: '130px' }}/>
                        </Col>
                      </Row>
                      {isVAK && <ActionTimeline num={this.props.currentSalesOrderDetail !== null && this.props.currentSalesOrderDetail.SONum || 'new'} module={'so'}/>}
                    </Tab>
                  </Tabs>
                </Col> {/* End SO Details Pane */}
              </Row> {/* End Row Wrapper */}
            </Grid>
            <Notes isVisible={this.state.isNotesModalVisibile} setModalVisibility={this.setNotesModalVisibility} />
            <ShippingStatusEditModal
              isVisible={this.state.shippingStatusEditModalVisible}
              onClose={this.setShippingStatsEditModalVisibility}
              currentSalesOrderDetail={this.props.currentSalesOrderDetail}
              reloadThePage={this.reloadThePage}
            />
            <PromotionAddingModal
              isVisible={this.state.isPromotionAddingAlertModalVisible}
              onClose={this.setPromotionAddingAlertModalVisibility}
              onConfirm={isGGI ? this.handlePromotionAddConfirmClickGGI : this.handlePromotionAddConfirmClick}
              productPromotions={this.props.productPromotions}
            />

            <SkyLightStateless dialogStyles={ShippingInfoConfirmModalStyle} isVisible={this.state.shippingInfoConfirmModalVisibility} onCloseClicked={() => { this.closeShippinggInfoConfirmModal(); }} title={<Translate value="shipping_info_confirmation"/>}>
              <ShippingInfoConfirmModal
                salesShippingCustomerDetails={this.props.salesShippingCustomerDetails || {}}
                CustomerDetail_id={(this.context.router.routes[1].path === 'salesOrders/new' || this.context.router.routes[1].path === 'outboundOrders/new') ? this.props.shipperChosen  : this.props.Deliver_CustomerDetail_id}
                handleReturnClick={() => this.closeShippinggInfoConfirmModal(false)}
                handleSaveClick={handleSubmit(form => this.handleFormSubmit(form))}
              />
            </SkyLightStateless>

            <SkyLightStateless dialogStyles={BatchesModal2Style} isVisible={this.state.isBatchesModal2Visible} onCloseClicked={() => { this.setBatchesModal2Visibility(); }} title={<Translate value="edit_batch"/>}>
              <BatchesModal2
                setBatchesModal2Visibility={this.setBatchesModal2Visibility}
                batchesInfo={this.props.batchesInfo}
                lineBatchId={this.state.lineBatchId}
                lineBatchIdx={this.state.lineBatchIdx}
                lineBatchRows={this.state.lineBatchRows}
                onEditBatch={this.onEditBatch}
              />
            </SkyLightStateless>

            <SkyLightStateless dialogStyles={MultiBatchStyle} isVisible={this.state.isMultiBatchVisible} onCloseClicked={() => { this.setMultiBatchModalVisibility(); }} title={<Translate value="assign_batch"/>}>
              <OcmMultiBatch
                setMultiBatchModalVisibility={this.setMultiBatchModalVisibility}
                batchesInfo={this.props.batchesInfo}
                onSelectedMultiBatch={this.handleMultiBatchSelectConfirm}
                selectedInventoryRow={this.state.selectedInventoryRow}
                quantityValue={this.props.quantityValue}
                rows={this.state.rows}
                generateBatchRelatedInfo={this.generateBatchRelatedInfo}
                // Sales_Order_Lines={this.props.currentSalesOrderDetail && this.props.currentSalesOrderDetail.Sales_Order_Lines}
                // lineBatchId={this.state.lineBatchId}
                // lineBatchIdx={this.state.lineBatchIdx}
                // lineBatchRows={this.state.lineBatchRows}
                // onEditBatch={this.onEditBatch}
              />
            </SkyLightStateless>

            <BatchesModal
              setModalVisibility={this.setBatchesModalVisibility}
              isVisible={this.state.isBatchesModalVisible}
              batchesInfo={this.props.batchesInfo}
              onSelectedBatch={this.onSelectedBatch}
              salesOrderProduct={this.props.salesOrderProduct}
            />
            <PromotionsModal
              setModalVisibility={this.setPromotionsModalVisibility}
              isVisible={this.state.isPromotionsModalVisible}
              selectedCompany={this.props.selectedCompany}
            />
            <ApplyPromotionsModal
              setModalVisibility={this.setApplyPromotionsModalVisibility}
              isVisible={this.state.isApplyPromotionsModalVisible}
              appliablePromotions={this.state.appliablePromotions}
              applyAndSave={this.applyAndSave}
              notApplyAndSave={this.notApplyAndSave}
            />
            <ApplyPromotionsModal2
              setModalVisibility={this.setApplyPromotionsModalVisibility2}
              isVisible={this.state.isApplyPromotionsModal2Visible}
              appliablePromotions={this.props.productPromotions}
              applyAndSave={(isLMH || isSDR || isCRW || isSC || isOLG) ? this.applyAndSave2lmh : isGGI ? this.applyAndSave2ggi : this.applyAndSave2}
              notApplyAndSave={this.notApplyAndSave2}
            />
            <ApplyPromotionsModal3
              setModalVisibility={this.setApplyPromotionsModalVisibility3}
              isVisible={this.state.isApplyPromotionsModal3Visible}
              appliablePromotions={this.state.applyPromotionList}
              applyAndSave={this.applyPromotionOLG}
              notApplyAndSave={this.notApplyAndSave2}
            />
            <UnqualifyProductPromotionModal
              setModalVisibility={this.setUnqualifiedPromotionModalVisibility}
              isVisible={this.state.isUnqualifiedPromotionModalVisible}
              appliablePromotions={this.props.productPromotions}
              applyAndSave={this.applyAndSave3}
              notApplyAndSave={this.notApplyAndSave3}
            />
          </form>
          {this.renderShippingIFrame()}
          {this.renderPackingIFrame()}
          {this.renderPickingIFrame()}
          {this.renderSalesOrderIFrame()}
          {this.renderSalesOrderSIIFrame()}
          {this.renderRefundIframe()}
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.historyOpen} onCloseClicked={() => { this.closeHistory(); }} title={customerSalesHistory}>
            {this.renderHistory()}
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.SOExistingVisible} onCloseClicked={() => { this.handleSOexistCancel() }} title={existingDetailTitle}>
            {this.renderSOExistListModal()}
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.salesHistoryOpen} onCloseClicked={() => { this.closeSalesHistory(); }} title={salesHistory}>
            {this.renderSalesHistory()}
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.openOrderOpen} onCloseClicked={() => { this.setState({ openOrderOpen: false }); }} title={openSalesOrder}>
            {this.renderOpenOrder()}
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={createDialogInventoryStyle}
            isVisible={this.state.showInventoryOpen}
            onCloseClicked={() => {
              this.closeShowInventory('productSearch');
            }}
            title={selectInventoryInformation}
          >
            <SalesInventoryInfo
              Customer_id={this.state.currentCustomer}
              SearchType={this.props.searchType}
              SearchValue={this.props.searchValue}
              closeShowInventory={this.closeShowInventory}
              selectInventoryInfo={this.selectInventoryInfo}
              setSaleRowValue={this.props.setSaleRowValue}
              setAllProductQuantity={this.setAllProductQuantity}
            />
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.confirmOpen} onCloseClicked={() => { this.closeConfirm(); }} title={confirmAction}>
            <ConfirmActionModal
              case={this.state.case}
              closeC={this.closeConfirm}
              caseAction={() => {
                if ((isSUN || isTU) && this.state.case === "addingDuplicate") {
                  this.handleDuplicateConfirm();
                  return;
                }
                if (isSV && this.state.case === "addingDuplicate") {
                  this.moveToSO();
                  return;
                }
                if (this.state.case === "notInWeightRange") {
                  if (!isABCFF && !isSH && !isCCW) {
                    this.setMultiBatchModalVisibility(true);
                  }
                  return
                }
                (isHO || isJRC || isEKC || isLMH || isSDR || isCRW || isSC || isSKH || isCPG || isLAP || isOLG || isMH || isTQ || isVIP ) ? 
                  this.moveToSO('move') : this.handleConfirmLowestSalesPrice()
              }}
              zeroArray={this.state.quantityZero}
              lowestSalePrice={this.state.selectedInventoryRow.LowestSalePrice}
              currentPrice={isGGI ?this.props.smallUnitPrice : this.props.unitPrice}
              rowEdited={this.state.RowBeingEdited}
              newPrice={this.state.newPrice}
              expAr={this.state.expAr}
              expiredConfirm={this.handleGGIOpenModal}
              updatePrice={this.handleUpdatePrice}
              ocmOpenModal={this.handleOcmOpenModal}
              selectedInventoryRow={this.state.selectedInventoryRow}
            />
          </SkyLightStateless>
          <div className="remove-close-skylight">
            <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.showSOCreatedOpen} title={ModalHeader}>
              <br /><br />
              <Row className="centerStyle">
                <h4><Translate value="your_so_no_period_is" /> {(this.props.salesOrderCreated && this.props.salesOrderCreated.SONum) || this.props.soNum}</h4>
              </Row>
              <br />
              <Row className="centerStyle"><h4><Translate value="msg_ask_if_stay_on_current_page" />?</h4></Row>
              <br /><br />
              <Row className="centerStyle">
                <Button bsStyle="primary" className="mr" onClick={(event) => { this.refreshPage(event); }} type="button" ><Translate value="yes" /></Button>
                {
                  (this.context.router.routes[1].path === 'outboundOrders/new' || this.context.router.routes[1].path === 'outboundOrders/:id') &&
                  <Button bsStyle="danger" className="mr" onClick={() => { this.context.router.push("/outboundOrders"); }} type="button" ><Translate value="no" /></Button>
                }
                {
                  (this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') &&
                  <Button bsStyle="danger" className="mr" onClick={() => { this.context.router.push(route); }} type="button" ><Translate value="no" /></Button>
                }
                {
                  (this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') &&
                  <Button bsStyle="success" className="mr" onClick={() => { this.goToNewSales(newRoute); }} type="button" ><Translate value="new_so" /></Button>
                }
                {
                  (isFung && this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') &&
                  <Button bsStyle="success" onClick={() => { this.printSI(); }} type="button" ><Translate value="print_si" /></Button>
                }
                {
                  ((isSDR || isCRW || isSC) && this.context.router.routes[1].path !== 'outboundOrders/new' && this.context.router.routes[1].path !== 'outboundOrders/:id') &&
                  // <Button bsStyle="success" onClick={() => { this.textQuote(); }} type="button" ><Translate value="text_quote" /></Button>
                  this.renderTextQuote()
                }
                {
                  isVAK && this.renderExtraButtonsOnSaveConfirm()
                }
                {
                  isOLG && this.renderAfterSaveExpressInvoice()
                }
                {
                  isOLG &&
                  <Button bsStyle="warning" className="mr" style={{marginLeft: '5px'}} onClick={() => { this.props.printPackingList(this.props.currentSalesOrder && this.props.currentSalesOrder.SalesOrder_id || this.props.salesOrderCreated && this.props.salesOrderCreated.SalesOrder_id); }} type="button" ><Translate value="print_packing_list" /></Button>
                }
              </Row>
            </SkyLightStateless>
          </div>

          <div id="sales-shipping-modal">
            <SkyLightStateless dialogStyles={createDialogShippingStyle} isVisible={this.state.showShippingOpen} onCloseClicked={this.closeShipping} title={expressInvoiceHeader}>
              <SalesShippingModal
                rows={this.state.rows}
                currentSalesOrder={isOLG ? (this.props.currentSalesOrder || this.props.salesOrderCreated) : this.props.currentSalesOrder}
                InvoiceNum={this.props.currentSalesOrderDetail && this.props.currentSalesOrderDetail.InvoiceNum}
                selectedCompany={this.props.selectedCompany}
              />
            </SkyLightStateless>
          </div>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.changeTaxOpen} onCloseClicked={() => { this.closeChangeTax(); }} title={changeTax}>
            <TaxSelectionModal taxRateOptions={this.getTaxRateOptions()} taxValue={this.state.taxValue} onChange={(isLMH || isSDR || isCRW || isSC) ? this.handleTaxValueChange2 : this.handleTaxValueChange} />
          </SkyLightStateless>

          <SkyLightStateless dialogStyles={createDiscountDialogStyle} isVisible={this.state.changeDiscountOpen} onCloseClicked={() => { this.closeDiscountModal(); }} title={changeDiscountTitle}>
            <DiscountChangeModal SODiscount={this.state.SODiscount} SOSavings={this.state.SOSavings} onDiscountSavingsConfirm={this.onDiscountSavingsConfirm} />
          </SkyLightStateless>

          <SkyLightStateless
            dialogStyles={weightDialogStyle}
            isVisible={this.state.setWeightOpen}
            onCloseClicked={() => {
              this.closeSetWeight();
            }}
            title="Set Product Weights"
          >
            <SetWeightModal
              closeC={this.closeSetWeight}
              keepLoaded={this.keepLoaded}
              totalLoaded={this.state.totalLoaded}
              rowChosen={this.state.rowChosen}
              returnTotalWeight={this.returnTotalWeight.bind(this)}
              invoice
              setWeights={this.setWeights}
              currentWeights={this.state.currentWeights}
              editedRow={this.state.editedRow}
            />
          </SkyLightStateless>

          <SkyLightStateless dialogStyles={createWeightDialogStyle} isVisible={this.state.changeWeightOpen} onCloseClicked={() => { this.closeChangeWeight(); }} title={changeWeight}>
            <WeightChangeModal finalShippingWeight={this.state.finalShippingWeight} onClickButton={() => { this.onChangeWeightSubmit(); }} onChange={this.onShippingWeightChange}/>
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createNoteDialogStyle} isVisible={this.state.changeEmployeeNoteOpen} onCloseClicked={() => { this.closeEmployeeNote(); }} title={changeEmployeeNoteTitle}>
            <div>
              <Row className="centerStyle">
                <div style={{ width: '80%' }}>
                  <Input
                    type="textarea"
                    rows={5}
                    onChange={this.onChangeEmployeeNote}
                    value={this.state.employeeNoteText}
                  />
                </div>
              </Row>
              <Row className="centerStyle">
                <Button
                  bsStyle="success"
                  onClick={() => { this.onSubmitEmployeeNote(); }}
                >
                  <Translate value="save" />
                </Button>
              </Row>
            </div>
          </SkyLightStateless>

          <SkyLightStateless dialogStyles={createNoteDialogStyle} isVisible={this.state.overdueModalVisibility} onCloseClicked={() => { this.closeOverdueModal(); }} title={(isLAP || isGGI) ? "Warning" : "Passcode Required"}>
            {!(isLAP) &&
              <div>
                <Row className="centerStyle">
                  {
                    !(isGGI) &&
                    <div style={{ padding: '0px 10px', fontSize: "14px", marginBottom: '10px' }}>
                      {/* Selected Customer {this.state.selectedOverdue} has unpaid overdue invoices. Need Passcode to <span onDoubleClick={()=>{this.setState({overdueModalVisibility: false})}}>continue</span> order. */}
                      Selected Customer {this.state.selectedOverdue} has unpaid overdue invoices. Need Passcode <span onClick={() => { this.checkTriple(); }}>to</span> continue order.
                      {/* (over ${this.state.overdueAmount} or {this.state.overdueTime} days) */}
                    </div>
                  }
                  {
                    isGGI &&
                    <div style={{ padding: '0px 10px', fontSize: "14px", marginBottom: '10px', marginTop: '10px' }}>
                      {/* Selected Customer <span style={{ fontWeight: 'bold' }}>{this.state.selectedOverdue}</span> has insufficient credit (<span style={{ fontWeight: 'bold' }}>{  (this.state.overdueCredit || this.state.overdueCredit === 0) ? (Number(this.state.overdueCredit) < 0 ? '-$' + (Number(this.state.overdueCredit)*-1) : '$' + this.state.overdueCredit) : 'Unlimited' }</span>) or has unpaid balance past payment term (<span style={{ fontWeight: 'bold' }}>{this.state.customerPaymentTerm}</span>). Need Passcode <span onClick={() => { this.checkTriple(); }}>to</span> continue order. */}
                      Selected Customer <span style={{ fontWeight: 'bold' }}>{this.state.selectedOverdue}</span> has insufficient credit (<span style={{ fontWeight: 'bold' }}>{Number(this.state.overdueCredit) < 0 ? '-$' + (Number(this.state.overdueCredit)*-1) : '$' + this.state.overdueCredit }</span>) or has unpaid balance past payment term (<span style={{ fontWeight: 'bold' }}>{this.state.customerPaymentTerm}</span>). Need Passcode <span onClick={() => { this.checkTriple(); }}>to</span> continue order.
                    </div>
                  }
                </Row>
                <Row className="centerStyle">
                  <div style={{ width: '50%' }}>
                    {/* <input type="password" autoComplete='new-password' value={this.state.overduePasscode} onChange={(e) => this.onChangeOverduePasscode(e)} style={{ border: '1px solid black', borderRadius: '4px', padding: '10px' }} /> */}
                    <Input
                      // type="password"
                      type="text"
                      id="pcc"
                      // autoComplete="new-password"
                      onChange={this.onChangeOverduePasscode}
                      value={this.state.overduePasscode}
                    />
                  </div>
                </Row>
                <Row className="centerStyle">
                  <Button
                    bsStyle="success"
                    onClick={() => { this.onConfirmOverdue(); }}
                  >
                    <Translate value="confirm" />
                  </Button>
                  <Button
                    bsStyle="success"
                    style={{ marginLeft: '5px' }}
                    onClick={() => { this.onSendOverdue("CustomerApproval"); }}
                  >
                    <Translate value="send_passcode" />
                  </Button>
                  <Button
                    bsStyle="danger"
                    style={{ marginLeft: '5px' }}
                    onClick={() => { this.closeOverdueModal(); }}
                  >
                    <Translate value="cancel" />
                  </Button>
                </Row>
              </div>
            }
            {(isLAP) &&
              <div>
                <Row className="centerStyle">
                  {isLAP &&
                                    <div style={{ padding: '0px 10px', fontSize: "14px", marginBottom: '10px', marginTop: '10px' }}>
                                    {/* Selected Customer {this.state.selectedOverdue} has unpaid overdue invoices. Need Passcode to <span onDoubleClick={()=>{this.setState({overdueModalVisibility: false})}}>continue</span> order. */}
                                    Selected Customer <span style={{fontWeight: 'bold'}}>{this.state.selectedOverdue}</span> has unpaid overdue balance of <span style={{fontWeight: 'bold'}}>${this.state.outstandingAmount}</span>. Do you want to continue?
                                    {/* (over ${this.state.overdueAmount} or {this.state.overdueTime} days) */}
                                  </div>
                  }
                </Row>
                <Row className="centerStyle">
                  <Button
                    bsStyle="success"
                    onClick={() => { this.bypassOverdueModal(); }}
                  >
                    <Translate value="continue" />
                  </Button>
                  <Button
                    bsStyle="danger"
                    style={{ marginLeft: '5px' }}
                    onClick={() => { this.closeOverdueModal(); }}
                  >
                    <Translate value="cancel" />
                  </Button>
                </Row>
              </div>
            }
          </SkyLightStateless>

          <SkyLightStateless dialogStyles={createNoteDialogStyle} isVisible={this.state.overdueSaveModalVisibility} onCloseClicked={() => { this.closeSaveOverdueModal(); }} title={(isLAP || isGGI) ? "Warning" : "Passcode Required"}>
              <div>
                <Row className="centerStyle">
                                    <div style={{ padding: '0px 10px', fontSize: "14px", marginBottom: '10px', marginTop: '10px' }}>
                                    {/* Selected Customer {this.state.selectedOverdue} has unpaid overdue invoices. Need Passcode to <span onDoubleClick={()=>{this.setState({overdueModalVisibility: false})}}>continue</span> order. */}
                                    Order amount <span style={{fontWeight: 'bold'}}>${this.state.finalPriceWithPromotion}</span> will exceed the customer's available credit of <span style={{fontWeight: 'bold'}}>${this.state.overdueCredit}</span>. Need Passcode <span onClick={() => { this.checkTriple(); }}>to</span> continue order.
                                    {/* (over ${this.state.overdueAmount} or {this.state.overdueTime} days) */}
                                  </div>
                </Row>
                <Row className="centerStyle">
                  <div style={{ width: '50%' }}>
                    {/* <input type="password" autoComplete='new-password' value={this.state.overduePasscode} onChange={(e) => this.onChangeOverduePasscode(e)} style={{ border: '1px solid black', borderRadius: '4px', padding: '10px' }} /> */}
                    <Input
                      // type="password"
                      type="text"
                      id="pcc"
                      // autoComplete="new-password"
                      onChange={this.onChangeOverduePasscode}
                      value={this.state.overduePasscode}
                    />
                  </div>
                </Row>
                <Row className="centerStyle">
                  <Button
                    bsStyle="success"
                    onClick={() => { this.onConfirmOverdue2(); }}
                  >
                    <Translate value="confirm" />
                  </Button>
                  <Button
                    bsStyle="success"
                    style={{ marginLeft: '5px' }}
                    onClick={() => { this.onSendOverdue("OrderApproval"); }}
                  >
                    <Translate value="send_passcode" />
                  </Button>
                  <Button
                    bsStyle="danger"
                    style={{ marginLeft: '5px' }}
                    onClick={() => { this.closeSaveOverdueModal(); }}
                  >
                    <Translate value="cancel" />
                  </Button>
                </Row>
                {/* <Row className="centerStyle">
                  <Button
                    bsStyle="success"
                    onClick={() => { this.bypassSaveOverdueModal(); }}
                  >
                    <Translate value="continue" />
                  </Button>
                  <Button
                    bsStyle="danger"
                    style={{ marginLeft: '5px' }}
                    onClick={() => { this.closeSaveOverdueModal(); }}
                  >
                    <Translate value="cancel" />
                  </Button>
                </Row> */}
              </div>
          </SkyLightStateless>

          <SkyLightStateless dialogStyles={changeDeliveryDialogStyle} isVisible={this.state.changeDeliveryFeeOpen} onCloseClicked={() => { this.closeDeliveryFee(); }} title={changeDeliveryFeeTitle}>
            <div>
              <Row className="centerStyle" style ={{ marginTop: '30px' }}>
                <div style={{ width: '60%' }}>
                  <Input
                    type="number"
                    onChange={this.onChangeDeliveryFee}
                    value={this.state.deliveryFeeEdit}
                  />
                </div>
              </Row>
              <Row className="centerStyle">
                <Button
                  bsStyle="success"
                  onClick={() => { this.onConfirmDeliveryFee(); }}
                >
                  <Translate value="confirm" />
                </Button>
              </Row>
            </div>
          </SkyLightStateless>

          <SkyLightStateless dialogStyles={changeDeliveryDialogStyle} isVisible={this.state.changeTransFeeOpen} onCloseClicked={() => { this.closeTransFee(); }} title={"Transaction Fee ($)"}>
            <div>
              <Row className="centerStyle" style ={{ marginTop: '30px' }}>
                <div style={{ width: '60%' }}>
                  <Input
                    type="number"
                    onChange={this.onChangeTransFee}
                    value={this.state.transFeeEdit}
                  />
                </div>
              </Row>
              <Row className="centerStyle">
                <Button
                  bsStyle="success"
                  onClick={() => { this.onConfirmTransFee(); }}
                >
                  <Translate value="confirm" />
                </Button>
              </Row>
            </div>
          </SkyLightStateless>

          <SkyLightStateless dialogStyles={changeDeliveryDialogStyle} isVisible={this.state.changeHandlingFeeOpen} onCloseClicked={() => { this.closeHandlingFee(); }} title={<Translate value="handling_fee" />}>
            <div>
              <Row className="centerStyle" style ={{ marginTop: '30px' }}>
                <div style={{ width: '60%' }}>
                  <Input
                    type="number"
                    onChange={this.onChangeHandlingFee}
                    value={this.state.handlingFeeEdit}
                  />
                </div>
              </Row>
              <Row className="centerStyle">
                <Button
                  bsStyle="success"
                  onClick={() => { this.onConfirmHandlingFee(); }}
                >
                  <Translate value="confirm" />
                </Button>
              </Row>
            </div>
          </SkyLightStateless>

          <SkyLightStateless dialogStyles={changeDeliveryDialogStyle} isVisible={this.state.changePercentageFeeOpen} onCloseClicked={() => { this.closePercentageFee(); }} title={"Transaction Fee (%)"}>
            <div>
              <Row className="centerStyle" style ={{ marginTop: '30px' }}>
                <div style={{ width: '60%' }}>
                  <Input
                    type="number"
                    onChange={this.onChangePercentageFee}
                    value={this.state.percentageFeeEdit}
                  />
                </div>
              </Row>
              <Row className="centerStyle">
                <Button
                  bsStyle="success"
                  onClick={() => { this.onConfirmPercentageFee(); }}
                >
                  <Translate value="confirm" />
                </Button>
              </Row>
            </div>
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={changeDeliveryDialogStyle} isVisible={this.state.changeCCOpen} onCloseClicked={() => { this.closeCCFee(); }} title={"CC Fee (%)"}>
            <div>
              <div style ={{ marginTop: '30px',display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'center' }}>
                <div style={{width: '20%'}}>
                  <label>
                    <input
                    type="radio"
                    name='ccFee'
                    id='ccFee1'
                    value='0.015'
                    onChange={()=>{
                      this.setState({ccEdit: '0.015'})
                    }}
                    checked={this.state.ccEdit == "0.015"}
                    />
                    <Translate value="cc15" />
                  </label>
                </div>
                <div style={{width: '20%'}}>
                  <label>
                    <input
                    type="radio"
                    name='ccFee'
                    id='ccFee2'
                    value='0.03'
                    onChange={()=>{
                      this.setState({ccEdit: '0.03'})
                    }}
                    checked={this.state.ccEdit == "0.03"}
                    />
                    <Translate value="3%" />
                  </label>
                </div>
                <div style={{width: '20%'}}>
                  <label>
                    <input
                    type="radio"
                    name='ccFee'
                    id='ccFee3'
                    value='0'
                    onChange={()=>{
                      this.setState({ccEdit: '0'})
                    }}
                    checked={this.state.ccEdit == "0"}
                    />
                    <Translate value="0%" />
                  </label>
                </div>
              </div>
              <Row className="centerStyle">
                <Button
                  bsStyle="success"
                  onClick={() => { this.onConfirmCcFee(); }}
                >
                  <Translate value="confirm" />
                </Button>
              </Row>
            </div>
          </SkyLightStateless>

          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.editSOPermissionOpen} onCloseClicked={() => { this.closeEditSOPermission(); }} title={editSOPermission}>
            <ConfirmActionModal
              case={this.state.case}
              checkPermission={this.props.checkPermission}
              checkPermissionSuccess={this.props.checkPermissionSuccess}
            />
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.confirmRefundOpen} onCloseClicked={this.closeConfirmRefund.bind(this)} title={confirmRefund}>
            <ConfirmActionModal
              case={this.state.case}
              closeConfirmRefund={this.closeConfirmRefund.bind(this)}
              handleRefundConfirm={this.handleRefundConfirm.bind(this)}
              checkPermission={this.props.checkPermission}
              checkPermissionSuccess={this.props.checkPermissionSuccess}
              />
              </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.verifyPasscodeOpen}
            onCloseClicked={this.closeVerifyPasscode} title={passcodeConfirm}
          >
            <VerifyPasscodeModal
              text={<Translate value="price_range_warning" />}
              closeConfirm={this.handleVerifyPasscodeClose}
            />
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.verifyPasscodeToCreateSOModalOpen}
            onCloseClicked={this.closeVerifyPasscodeToCreateSO}
            title={passcodeConfirm}
          >
            <VerifyPasscodeModal
              text={<Translate value="credit_limit_payment_term_warning" />}
              closeConfirm={this.handleVerifypasscodeToCreateSOClose}
            />
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={createDeliveryModalDialogStyle}
            isVisible={this.state.deliveryMethodModalOpen}
            onCloseClicked={this.closeDeliveryMethodModal}
            title={`Delivery Method: ${this.state.ShippingMethod}`}
          >
            <DeliveryMethodModal
              info={this.state.shipping}
            />
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={changeCarrierInfoStyle} isVisible={this.state.carrierInfoModalOpen} onCloseClicked={() => { this.closeCarrierInfoModal(); }} title={changeCarrierInfo}>
            <div>
              <CarrierInfoModal
                salesOrderId={this.props.params.id}
                fetchCarrierInfo={this.props.fetchCarrierInfo}
                postCarrierInfo={this.props.postCarrierInfo}
                closeCarrierInfoModal={this.closeCarrierInfoModal}
              />
            </div>
          </SkyLightStateless>

          <SkyLightStateless dialogStyles={changeCarrierInfoStyle} isVisible={this.state.shippingInfoEditModalVisibility} onCloseClicked={() => { this.closeShippingInfoEditModal(); }} title={isMobile && isVAK ? <Translate value="edit_shipping_address" /> : <Translate value="add_shipping_address" />}>
            <ShippingAddressEditmodal
              isEdit={isMobile && isVAK}
              deliverCustomerDetail={this.props.Deliver_CustomerDetail_id}
              receivingCustomer={this.props.receivingCustomer}
              salesCustomerDetails={this.props.salesCustomerDetails}
              reFetchSalesCustomers={this.reFetchSalesCustomers}
            />
          </SkyLightStateless>

          <SkyLightStateless dialogStyles={changeCarrierInfoStyle} isVisible={this.state.customerEditModalVisibility} onCloseClicked={() => { this.closeCustomerEditModal(); }} title={<Translate value="add_customer" />}>
            <CustomerCreateModal
              enteringPhone={this.state.enteringPhone}
              reFetchSalesCustomers={this.reFetchSalesCustomers}
              Company_id={this.props.selectedCompany}
              closeCustomerEditModal={this.closeCustomerEditModal}
            />
          </SkyLightStateless>

          <SkyLightStateless dialogStyles={changeCarrierInfoStyle} isVisible={this.state.customerNoteModalVisibility} onCloseClicked={() => { this.closeCustomerNoteModal(); }} title={<Translate value="customer_note" />}>
          <div>
              <Row style ={{ marginTop: '30px' }}>
                <div style={{ marginBottom: '20px', width: '100%', whiteSpace: 'pre-wrap', padding: '0px 15px', fontSize: '13px' }}>
                {/* <textarea
                    style={{
                      minHeight: '80px',
                      // marginLeft: '5px',
                      // marginTOP: '5px',
                      // display: 'absolute',
                      borderRadius: '5px',
                      padding: '4px',
                      border: '1px solid black',
                    }}
                    value={this.props.salesCustomerDetails ? this.props.salesCustomerDetails.Notation : ""}
                    onChange={({ target }) => console.log("test")}
                  /> */}
                  {this.props.salesCustomerDetails ? this.props.salesCustomerDetails.Notation : ""}
                </div>
              </Row>
              <Row className="centerStyle">
              <Button
                  bsStyle="danger"
                  onClick={() => { this.closeCustomerNoteModal(); }}
                >
                  <Translate value="close" />
                </Button>
                </Row>
            </div>
          </SkyLightStateless>

          <SkyLightStateless dialogStyles={changeFBAStyle} isVisible={this.state.fbaEditModalVisibility} onCloseClicked={() => { this.closeFBAEditModal(); }} title={'Add FBA Address'}>
            <FBAAddressEditModal
              closeFBAEditModal={this.closeFBAEditModal}
              modalFetchFBA={this.modalFetchFBA}
              // receivingCustomer={this.props.receivingCustomer}
              // salesCustomerDetails={this.props.salesCustomerDetails}
              // reFetchSalesCustomers={this.reFetchSalesCustomers}
            />
          </SkyLightStateless>

          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.verifyPasscodeOpenDiscount}
            onCloseClicked={this.closeVerifyPasscodeDiscount} title={passcodeConfirm}
          >
            <VerifyPasscodeModal
              text={<Translate value="price_range_warning" />}
              closeConfirm={this.handleVerifyPasscodeCloseDiscount}
            />
          </SkyLightStateless>

          <DropshipModal
            visible={this.state.isDropshipOpen}
            onClose={this.closeDropship}
            salesOrderId={this.props.params.id}
            handleCreatePOSuccess={() => {
              this.closeDropship();
              this.refreshPage();
            }}
          />
          <ShippingInfoFormModal
            isVisible={this.state.shippingInfoModalVisibility}
            onClose={this.closeShippingInfoFormModal}
            initialValues={this.props.initialValues}
          />
          <SkyLightStateless
            dialogStyles={confirmDialogStyle}
            isVisible={this.state.alertModalVisibility}
            onCloseClicked={() => this.closeAlertModal()}
          >
            <ConfirmActionModal
              case={this.state.alertModalCase}
              onConfirm={() => this.closeAlertModal()}
              isApproved={this.state.isApproved}
              onSetRecheck={this.state.setRecheckCallback}
              onSetApprove={this.state.setApproveCallback}
            />
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={confirmDialogStyle}
            isVisible={this.state.confirmModalVisibility}
            onCloseClicked={() => this.closeConfirmModal()}
          >
            <ConfirmActionModal
              case={this.state.confirmModalCase}
              userOptions={this.getUsers()}
              onConfirm={this.state.setConfirmCallback}
              onReject={this.state.setRejectCallback}
              onCancel={() => this.closeConfirmModal()}
            />
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={confirmDialogStyle}
            isVisible={this.state.createModalVisibility}
            onCloseClicked={() => this.closeCreateModal()}
          >
            <div style={{display: 'flex', justifyContent: 'center', padding: '28px 16px', fontSize: "14px"}}>
              {(this.props.selectedCompany || {value: ''}).value == 1 ?
                <Translate value="so_create_mfg_or_pr"/>
                : <span><Translate value="so_create_pr"/></span>
              }
            </div>
            <Row className="centerStyle">
              <Button
                bsStyle="success"
                onClick={() => { this.closeCreateModal(); createSO(this.props.params.id); }}
              >
                <Translate value="confirm" />
              </Button>
              <Button
                bsStyle="danger"
                style={{ marginLeft: '5px' }}
                onClick={() => this.closeCreateModal()}
              >
                <Translate value="cancel" />
              </Button>
            </Row>
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={componentsDialogStyle} isVisible={this.state.relatedComponentsModalVisibility} title={<Translate value="related_component" />} onCloseClicked={() => {
            this.closeRelatedComponents()
          }}>
            {this.renderRelatedComponents()}
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={notationModalStyle} isVisible={this.state.notationModalVisibility} title={<Translate value="notation" />} onCloseClicked={() => {
            this.closeNotationModal()
          }}>
            {this.renderNotation()}
          </SkyLightStateless>
        </ContentWrapper>
      //---------------
      // End HTML
      //---------------
      );
    }
}

export default withRouter(SalesOrderForm);

let PickShippingMethod = props => {
  return (
    <div className="form-group">
      <div className="col-xs-4 text-nowrap">
        <input
          {...props.input}
          type="radio"
          value="Delivery"
          checked={props.input.value === "Delivery"}
        />
        <Translate value="delivery"/>
      </div>
      <div className="col-xs-3 text-nowrap">
        <input
          {...props.input}
          type="radio"
          value="Pickup"
          checked={props.input.value === "Pickup"}
        />
        <Translate value="pickup"/>
      </div>
    </div>
  )
}

let RenderTypeRadios = props => (
  <div className="form-group" id="search-product-by">
  {
  !isMultiWH &&
    <label className="col-xs-4 search-by-max-width">
      <Translate value="search_by" />
    </label>
  }
    {!isOLG && <label className="col" style={{ paddingRight: '5px' }}>
      <input
        {...props.input}
        style={{ marginRight: '3px' }}
        type="radio"
        value="ProductNum"
        checked={props.input.value === 'ProductNum'}
      />
      <Translate value="prod_num" />
    </label>}
    <label className="col" style={{ paddingRight: '5px' }}>
      <input
        {...props.input}
        style={{ marginRight: '3px' }}
        type="radio"
        value="RefNum"
        checked={props.input.value === 'RefNum'}
      />
      <Translate value={isOLG ? "item_no" : isVAK ? "sku" : "ref_num"} />
    </label>
    <label className="col" style={{ paddingRight: '5px' }}>
      <input
        {...props.input}
        style={{ marginRight: '3px' }}
        type="radio"
        value="Name"
        checked={props.input.value === 'Name'}
      />
      <Translate value="name" />
    </label>
    <label className="col" style={{ paddingRight: '5px' }}>
      <input
        {...props.input}
        style={{ marginRight: '3px' }}
        type="radio"
        value="Description"
        checked={props.input.value === 'Description'}
      />
      <Translate value="desc" />
    </label>
    <label className="col" style={{ paddingRight: '5px' }}>
      <input
        {...props.input}
        style={{ marginRight: '3px' }}
        type="radio"
        value="Barcode"
        checked={props.input.value === 'Barcode'}
      />
      <Translate value="barcode" />
    </label>
    <label className="col" style={{ paddingRight: '5px' }}>
      <input
        {...props.input}
        style={{ marginRight: '3px' }}
        type="radio"
        value="GeneralNum"
        checked={props.input.value === 'GeneralNum'}
      />
      <Translate value="general_no" />
    </label>
  </div>
);



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/salesOrderForm.jsx